// @ts-check
/* GENERATED FILE - Edit the source JSON file and run I18n code generation to update */
const L = "ar";
const P = new Intl.PluralRules(L);
const O = new Intl.PluralRules(L, { type: "ordinal" });
/**@type{import("./types").Translations}*/
export default {
  apps: {
    admin: {
      common: {
        accept: "قبول",
        apply: "تطبيق",
        acceptPayment: "قبول",
        addSingle: "أضف موظف واحد",
        aed: "درهم إماراتي",
        aiAssistant: "المساعد الذكي",
        approve: "الموافقة",
        areYouSure: "هل أنت متأكد؟",
        back: "العودة",
        benefits: "المزايا",
        bulkUpload: "رفع بيانات الموظفين",
        bulkUpdate: "تحديث جماعي",
        cancel: "إلغاء",
        changesSavedSuccessfully: "تم حفظ التغييرات بنجاح",
        clear: "مسح",
        clearAll: "مسح الكل",
        companies: "الشركات",
        company: "الشركة",
        confirm: "تأكيد",
        continue: "متابعة",
        copiedToClipboard: "تم النسخ إلى الحافظة",
        create: "إنشاء",
        currencies: { AED: "د.إ.", EUR: "ي.و", GBP: "£", USD: "د.أ" },
        data: {
          notFound: (name) => `لم يتم العثور على ${name}`,
          noResultsFor: (query) => `لم يتم العثور على نتائج لـ \"${query}\"`,
          noRecords: "لا توجد سجلات متاحة",
          searchPlaceholder: (name) => `بحث ${name}...`,
        },
        dashboard: "لوحة التحكم",
        date: (d) =>
          `${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
        monthYear: (d) =>
          `${d.toLocaleString(L, { month: "long", year: "numeric" })}`,
        dateMonthShort: (d) => `${d.toLocaleString(L, { month: "short" })}`,
        dateInvalid: "تنسيق التاريخ خاطئ",
        dateMax: "لا يمكن أن يتجاوز التاريخ الحد الأقصى المسموح به",
        dateRangePicker: "اختر نطاق التاريخ",
        ordinalDayOfMonth: (day) => `${`اليوم ${day} من الشهر`}`,
        original: "الأصلي",
        defaultRequired: "مطلوب",
        customAttributeRequired: (attributeName) =>
          `يرجى تقديم ${attributeName}`,
        delete: "حذف",
        discard: "تجاهل",
        dismiss: "تجاهل",
        versionHistory: "عرض الإصدارات السابقة",
        download: "تحميل",
        dragAndDrop: "او سحب و وضع الملف ",
        edit: "تعديل",
        actions: "الإجراءات",
        email: "البريد الإلكتروني",
        employee: "الموظف",
        employees: "الموظفون",
        errorGeneric: "حدث خطأ. حاول إعادة تحميل الصفحة.",
        editing: "تعديل",
        save: "حفظ",
        import: "استيراد",
        export: "تصدير",
        exportFailed: "فشل التصدير. يرجى المحاولة مرة أخرى.",
        exportExcel: "إكسل (XLS)",
        csv: "CSV",
        exportCsv: "تحميل CSV",
        file: "الملف",
        fileInvalidType: "نوع الملف غير صالح",
        fileTooLarge: "الملف كبير جدا",
        fileTooSmall: "الملف صغير جدا",
        filters: "عمليات التصفية ",
        fullName: ({ first, last }) => `${first} ${last}`,
        greet: (name) => `${{ ["null"]: `اهلا، ${name}!` }[name] ?? `اهلا!`}`,
        helpEmail: "help@aurem.ae",
        hubName: (companyName) => ` مركز ${companyName}`,
        insert: "إدراج",
        insertLink: "إدراج رابط",
        invite: "دعوة",
        ipp: "نظام التقاعد الدولي",
        iUnderstand: "فهمت / عُلم ",
        label: "العنوان",
        linkUrl: "الرابط",
        loading: "جار التحميل...",
        markAsResolved: "وضع علامة كمحلول",
        name: "الاسم",
        needHelp: "هل تحتاج إلى مساعدة؟",
        next: "التالي",
        no: "لا",
        noDocuments: "لا توجد مستندات متاحة",
        noResult: "لم يتم العثور على نتائج",
        notNow: "ليس الآن",
        optional: "اختياري",
        payments: "المدفوعات",
        percentOfSalary: (p) => `${p}% من الراتب`,
        recentSearch: "عمليات البحث الأخيرة",
        reject: "رفض",
        rejectPayment: "رفض",
        remove: "حذف ",
        resendCode: "إعادة إرسال الرمز",
        resendInvitations: "أعد الدعوة",
        review: "مراجعة",
        reviewPayments: "مراجعة المدفوعات",
        revert: "التراجع",
        roles: "الصلاحيات",
        userRoles: "أدوار المستخدمين",
        saveAndClose: "حفظ وإغلاق",
        saveChanges: "حفظ التغييرات",
        search: "البحث",
        seeDetails: "عرض التفاصيل",
        select: "اختيار",
        selected: (count) => `تم اختيار ${count.toLocaleString(L, {})}`,
        sendInvite: "دعوة",
        signOut: "تسجيل الخروج",
        status: "الحالة",
        employeeStatus: {
          active: "نشط",
          inactive: "غير نشط",
          invited: "مدعو",
          notInvited: "غير مدعو",
        },
        submit: "إرسال",
        supportEmail: "support@aurem.ae",
        tagline: "توفيرات ثروة أوريم",
        tooManyFiles: (amount) => `تجاوز حد الملف (${amount})`,
        type: "النوع",
        upload: "انقر هنا لتحميل",
        users: "المستخدمون",
        viewAll: "الاطلاع على الكل",
        voluntary: "صناديق لمكافأة نهاية الخدمة",
        Xdays: (count) =>
          `${{ [1]: `يوم واحد`, [2]: `يومين` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${count} أيام` })[P.select(count)] ?? `${count} يوم`}`,
        XformatEmployeeCount: (count) =>
          `${count} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `موظف` })[P.select(count)] ?? `موظفين`}`,
        yes: "نعم",
        relativeTime: {
          justNow: "الآن",
          now: "الآن",
          minutesAgo: (minutes) =>
            `${{ [1]: `منذ دقيقة واحدة`, [2]: `منذ دقيقتين` }[minutes] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `منذ ${minutes} دقائق`, ["many"]: `منذ ${minutes} دقيقة` })[P.select(minutes)] ?? `منذ ${minutes} دقيقة`}`,
          hoursAgo: (hours) =>
            `${{ [1]: `منذ ساعة واحدة`, [2]: `منذ ساعتين` }[hours] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `منذ ${hours} ساعات`, ["many"]: `منذ ${hours} ساعة` })[P.select(hours)] ?? `منذ ${hours} ساعة`}`,
          daysAgo: (days) =>
            `${{ [1]: `منذ يوم واحد`, [2]: `منذ يومين` }[days] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `منذ ${days} أيام`, ["many"]: `منذ ${days} يوماً` })[P.select(days)] ?? `منذ ${days} يوم`}`,
          inMinutes: (minutes) =>
            `${{ [1]: `خلال دقيقة واحدة`, [2]: `خلال دقيقتين` }[minutes] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `خلال ${minutes} دقائق`, ["many"]: `خلال ${minutes} دقيقة` })[P.select(minutes)] ?? `خلال ${minutes} دقيقة`}`,
          inHours: (hours) =>
            `${{ [1]: `خلال ساعة واحدة`, [2]: `خلال ساعتين` }[hours] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `خلال ${hours} ساعات`, ["many"]: `خلال ${hours} ساعة` })[P.select(hours)] ?? `خلال ${hours} ساعة`}`,
          inDays: (days) =>
            `${{ [1]: `خلال يوم واحد`, [2]: `خلال يومين` }[days] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `خلال ${days} أيام`, ["many"]: `خلال ${days} يوماً` })[P.select(days)] ?? `خلال ${days} يوم`}`,
        },
        view: "عرض",
        nextStep: "الخطوة التالية",
        goBack: "الرجوع",
        stepsCompleted: "خطوات مكتملة",
        finish: "إنهاء",
        or: "أو",
        contactSupport: "تواصل مع الدعم",
        responses: (count) =>
          `${{ [0]: `لا توجد ردود`, [1]: `رد واحد` }[count] ?? `${count} ردود`}`,
        permissionAlert:
          "تحتاج إلى صلاحيات إضافية لعرض هذا المحتوى. يرجى التواصل مع المسؤول لطلب الوصول.",
        employeeNotFound: "الموظف غير موجود",
        submitted: "تم الإرسال",
        pending: "قيد الانتظار",
        formSubmitted: "تم إرسال النموذج",
        reset: "إعادة تعيين",
        applyFilters: "تطبيق عوامل التصفية",
        saveAndContinue: "حفظ ومتابعة",
        notFound: "لم يتم العثور على نتائج",
        noResultsFor: (search) => `لم يتم العثور على نتائج لـ ${search}`,
        inCompany: (company) => `في ${company}`,
        commaSeparatedValues: "قيم مفصولة بفاصلة (.csv)",
        exportWithAi: "تصدير بالذكاء الاصطناعي",
        exportSelectRowsTooltip: "حدد صفًا واحدًا أو أكثر للتصدير",
        microsoftExcel: "مايكروسوفت إكسل (.xlsx)",
        bulkAdjustmentsImportStarted: "بدأ تحميل التعديلات المجمعة",
        bulkAdjustmentsImportCompleted: "اكتمل استيراد التعديلات المجمعة",
        bulkAdjustmentsImportFailed: "فشل استيراد التعديلات المجمعة",
        bulkAdjustmentsImportTimeout:
          "استيراد التعديلات المجمعة يستغرق وقتاً أطول من المتوقع. يرجى المراجعة لاحقاً.",
        bulkAdjustmentsImportBelowZero: ({ employee, category }) =>
          `سيؤدي الاستيراد إلى رصيد سلبي للموظف ${employee} في الفئة ${category}.`,
        unverified: "غير مُوثَّق",
        viewTask: "عرض المهمة",
        viewWorkflowRun: "عرض تشغيل سير العمل",
        relatedRecords: {
          title: "السجلات ذات الصلة",
          marketOrders: "أوامر التداول في السوق",
          payments: "المدفوعات",
        },
      },
      globalSearch: {
        idle: {
          title: "ابدأ البحث",
          text: "أدخل كلمة مفتاحية أعلاه للعثور على الموظفين أو الشركات.",
        },
        noResults: {
          title: "لم يتم العثور على نتائج",
          text: "حاول تعديل مصطلحات البحث للعثور على ما تبحث عنه.",
        },
      },
      language: { en: "الإنجليزية", ar: "العربية" },
      cookie: {
        description:
          "نحن نستخدم ملفات تعريف الارتباط لتحسين تجربتك في التصفح. من خلال الاستمرار في استخدام موقعنا، فإنك توافق على استخدامنا لملفات تعريف الارتباط.",
      },
      countryCombobox: {
        add: "إضافة معلومات التقرير الضريبي",
        cta: "انتقل إلى الإعدادات",
        dropdownLabel: "بلد الإقامة الضريبية",
        dropdownLabelOptional: "بلد الإقامة الضريبية (اختياري)",
        empty: "لم يتم العثور على نتائج",
        error: "يجب ملء كل من بلد الضريبة ورقم الضريبة أو تركهما فارغين معًا",
        inputLabel: "رقم المرجع الضريبي",
        inputLabelOptional: "رقم المرجع الضريبي (اختياري)",
        select: "اختر الدولة",
        noSelection: "لا يوجد اختيار",
        title: "التقرير الضريبي",
      },
      healing: {
        date: {
          corrected:
            "تم تحديث التاريخ تلقائيًا إلى التنسيق اليوم/الشهر/السنة. إذا كان هذا غير صحيح، يرجى تعديل الملف وتحميله مرة أخرى.",
        },
        decimal: {
          corrected:
            "تم تحديث الرقم إلى التنسيق 10000.00، إذا كان هذا غير صحيح، يرجى تعديل الملف وتحميله مرة أخرى.",
        },
        employmentStatus: {
          corrected: "تم تحديث حالة التوظيف إلى التنسيق المطلوب.",
        },
        gender: { corrected: "تم تحديث الجنس إلى التنسيق المطلوب." },
      },
      modal: {
        continue: "متابعة",
        description:
          "أنت قادر على الانتقال بعيدًا عن هذه الصفحة. سيتم فقد أي بيانات غير محفوظة",
        stay: "انتظر ",
      },
      pagination: { resultsPerPage: "نتائج لكل صفحة", to: "إلى", of: "من" },
      navBar: {
        companies: "الشركات",
        controls: "الإعدادات",
        funds: "رؤى",
        holdings: "المخزونات",
        marketOrders: "أوامر التداول في السوق",
        menu: "القائمة",
        more: "المزيد",
        tasks: "المهام",
        payments: "المدفوعات",
        personalSettings: "الإعدادات الشخصية",
        support: "الدعم",
        requests: "الطلبات",
        users: "المستخدمون",
        internal: "داخلي",
        products: "المنتجات",
        forms: "نماذج",
        inactiveCurrency:
          "تبديل العملة غير متاح في الوقت الحالي بسبب مشكلات فنية.",
        chatDropdown: { addNewChat: "محادثة جديدة", history: "السجل" },
        subNavBar: {
          accessAndRestrictions: "الوصول والقيود",
          automations: "التلقائيات",
          fees: "الرسوم",
          paymentCategories: "فئات الدفع",
          payments: "المدفوعات",
          setup: "الإعداد",
          lookAndFeel: "المظهر والإحساس",
          contentManagement: "إدارة المحتوى",
          customFields: "الحقول المخصصة",
          developer: "مطور",
          internal: "داخلي",
          compliance: "امتثال",
          tasks: {
            page: {
              title: "المهام",
              kyb: "KYB ( عرف عملك )",
              kyc: "KYC ( عرف عميلك )",
              payments: "المدفوعات",
              ["company-payments"]: "مدفوعات الشركة",
              ["refund-payments"]: "مدفوعات الاسترداد",
              ["distribution-payments"]: "مدفوعات التوزيع",
              ["fee-payments"]: "مدفوعات الرسوم",
              ["market-orders"]: "أوامر التداول في السوق",
              ["product-assignment"]: "الاشتراكات",
              corrections: "تصحيحات",
              roles: "الصلاحيات",
              description: "الوصف",
              paymentTasks: "مهام المدفوعات",
              saveChanges: "حفظ التغييرات",
            },
            description: {
              en: "الإنجليزية",
              ar: "العربية",
              variablesTooltip: "استخدم هذا لإدراج متغيرات في الوصف",
              variables: "المتغيرات",
            },
            escalation: {
              title: "التصعيد",
              escalationInactive: "التصعيد غير مفعل",
              escalationAfterDays: (days) => `التصعيد بعد ${days} يوم`,
              notifyEscalationRecipients: "إخطار مستلم التصعيد بعد:",
              numberOfDays: (day) =>
                `${{ [1]: `يوم واحد` }[day] ?? `${day} أيام`}`,
              enableEscalation: "تفعيل التصعيد",
              reminderDays: "أيام التذكير",
              reminderDaysDescription:
                "تُحتسب من يوم إنشاء المهمة. الأيام قبل التصعيد ترسل تذكيرًا وديًا، والأيام بعده ترسل متابعة حازمة.",
              dayOfEscalation: "يوم التصعيد",
              dayNumber: (day) => `اليوم ${day}`,
              escalatesOn: "يتم التصعيد في",
              noReminders: "لم يتم اختيار أي تذكير",
            },
            descriptionVariables: {
              assignee_name: "اسم المسؤول",
              reviewer_name: "اسم المراجع",
              escalation_recipient_name: "اسم مستلم التصعيد",
              issue_date: "تاريخ الإصدار",
              due_date: "تاريخ الاستحقاق",
              current_date: "التاريخ الحالي",
              current_year: "السنة الحالية",
              unknown: "متغير",
              amount: "المبلغ",
              fund_name: "اسم المنصب",
              benefit_name: "اسم الفائدة",
              employee_name: "اسم الموظف",
            },
            config: {
              openRoles: "المسؤول",
              openRolesDescription: "من يتم تعيينه للمهمة عندما تكون مفتوحة",
              inReviewRoles: "المراجع",
              inReviewRolesDescription:
                "من يراجع ويتصرف في المهمة عندما تكون قيد المراجعة",
              escalation: "المستلم",
              escalationDescription: "من يتم إخطاره عند تصعيد المهمة",
              readonlyRoles: "الصلاحيات القرائية",
              readonlyRolesDescription: "من يمكنه فقط عرض المهمة",
              noRoles: "لا يوجد صلاحيات",
            },
            variablesDrawer: {
              title: "المتغيرات",
              description: "انقر على متغير لإدراجه في موضع المؤشر.",
              searchPlaceholder: "البحث في المتغيرات...",
              names: "الأسماء",
              dates: "التواريخ",
              emptySearch: "لا توجد متغيرات تطابق بحثك.",
            },
          },
          activities: "سجل النشاطات",
          branding: "الهوية البصرية",
          companySettings: "إعدادات الشركة",
          emails: "البريد الإلكتروني",
          featuresAndProducts: "المنتجات",
          textEditor: "محرر النصوص",
          documents: "الوثائق",
          passwords: "كلمات المرور",
          workflows: "سير العمل",
          data: "البيانات",
          supportTools: "أدوات الدعم",
          roles: "الأدوار",
          activity: "النشاط",
        },
        dropdownMenu: { addCompany: "تسجيل شركة جديدة" },
        configTools: {
          sidebar: {
            accessAndRestrictions: "الوصول والقيود",
            automations: "التلقائيات",
            configureBrand: "تكوين علامتك التجارية",
            customizeFormFields: "تخصيص حقول النموذج",
            uploadDocuments: "تحميل مستنداتك",
            chooseProducts: "اختر منتجاتك",
            digitalExperience: "التجربة الرقمية",
          },
        },
        insights: "الرؤى",
        chats: "المحادثات",
        activity: "النشاط",
      },
      notifications: {
        title: "الإشعارات",
        readAll: "تعيين الكل كمقروء",
        deleteAll: "حذف الكل",
        empty: "لا توجد إشعارات",
        markAsRead: "تعيين كمقروء",
      },
      internalResources: {
        attachmentRunRecord: {
          title: "تشغيلات المرفقات",
          columns: {
            runId: "معرف التشغيل",
            nodeId: "معرف العقدة",
            itemIndex: "فهرس العنصر",
            entityType: "نوع الكيان",
            entityId: "معرف الكيان",
            entityDetails: "تفاصيل الكيان",
            fileId: "معرف المرفق",
            fileFilename: "اسم الملف",
            fileSize: "حجم الملف",
            file: "الملف",
            createdAt: "تاريخ الإنشاء",
          },
          openFile: "فتح الملف في علامة تبويب جديدة",
          filters: {
            runId: "معرف التشغيل",
            runIdPlaceholder: "التصفية حسب معرف التشغيل",
          },
        },
        auditTrail: {
          title: "سجل التدقيق",
          columns: {
            event: "الحدث",
            resourceType: "المورد",
            resourceId: "معرف المورد",
            object: "اللقطة",
            diff: "الفرق",
            userId: "المستخدم",
            createdAt: "التوقيت",
          },
        },
        chatThread: {
          title: "سلاسل المحادثات",
          columns: {
            title: "العنوان",
            description: "الوصف",
            starred: "مميز",
            messages: "الرسائل",
            userId: "المستخدم",
            createdAt: "تاريخ الإنشاء",
            lastMessageAt: "آخر رسالة",
          },
        },
        emailLog: {
          title: "سجلات البريد الإلكتروني",
          columns: {
            to: "المستلم",
            subject: "الموضوع",
            template: "القالب",
            from: "من",
            bcc: "نسخة مخفية",
            body: "المحتوى",
            createdAt: "تاريخ الإرسال",
          },
        },
        employeeInvitation: {
          title: "دعوات الموظفين",
          columns: {
            email: "البريد الإلكتروني",
            employeeId: "الموظف",
            companyId: "الشركة",
            inviterUserId: "تمت الدعوة بواسطة",
            createdAt: "تاريخ الإنشاء",
          },
        },
        llmAuditLog: {
          title: "سجلات تدقيق LLM",
          columns: {
            modelName: "النموذج",
            success: "الحالة",
            runId: "معرف التشغيل",
            nodeId: "العقدة",
            turnCount: "الأدوار",
            totalDurationMs: "المدة",
            conversationHistory: "الرسائل",
            finalOutput: "المخرجات",
            errorMessage: "الخطأ",
            userId: "المستخدم",
            createdAt: "التوقيت",
          },
        },
        dataImportJob: {
          title: "استيراد البيانات",
          columns: {
            status: "الحالة",
            handlerKey: "المعالج",
            uploadId: "معرف التحميل",
            progress: "التقدم",
            lastError: "آخر خطأ",
            finishedAt: "انتهى في",
            createdAt: "بدأ في",
          },
        },
        outboundLog: {
          title: "سجلات الإرسال",
          columns: {
            connector: "الموصل",
            status: "الحالة",
            endpoint: "نقطة النهاية",
            destination: "الوجهة",
            entityType: "نوع الكيان",
            entityId: "معرف الكيان",
            retryCount: "المحاولات",
            error: "الخطأ",
            data: "البيانات",
            response: "الاستجابة",
            createdAt: "تاريخ الإنشاء",
          },
        },
        supportToolLog: {
          title: "سجلات أدوات الدعم",
          columns: {
            action: "الإجراء",
            category: "الفئة",
            user: "المستخدم",
            entityType: "نوع الكيان",
            entityId: "معرف الكيان",
            inputParams: "معاملات الإدخال",
            success: "ناجح",
            errorMessage: "الخطأ",
            createdAt: "تاريخ الإنشاء",
          },
        },
        workflowRun: {
          title: "تشغيلات سير العمل",
          columns: {
            id: "معرف التشغيل",
            workflowName: "سير العمل",
            version: "الإصدار",
            scope: "النطاق",
            scopedTo: "مرتبط بـ",
            status: "الحالة",
            workflowVersionId: "إصدار سير العمل",
            lastNode: "آخر عقدة",
            createdAt: "تاريخ الإنشاء",
          },
          filters: { status: "الحالة", allStatuses: "كل الحالات" },
          statuses: {
            created: "تم الإنشاء",
            running: "قيد التشغيل",
            pending: "قيد الانتظار",
            completed: "مكتمل",
            failed: "فشل",
            exited: "خرج",
          },
          sources: { config: "تم التشغيل من إعداد سير العمل" },
          events: {
            started: "بدأ",
            pending: "قيد الانتظار",
            completed: "مكتمل",
            completedWithErrors: "مكتمل مع أخطاء",
            failed: "فشل",
            skipped: "تم التخطي",
            exited: "خرج",
          },
          detail: {
            title: "تفاصيل التشغيل",
            titleWithWorkflow: (workflow) => `تفاصيل التشغيل - ${workflow}`,
            run: "مدخلات التشغيل",
            events: "الأحداث",
            resetNode: "إعادة التشغيل من هنا",
            resetNodeSubmit: "إعادة تشغيل سير العمل",
            resetNodeConfirmTitle: "إعادة تشغيل سير العمل من هذه العقدة؟",
            resetNodeConfirmDescription: (nodeId) =>
              `سيؤدي هذا إلى إلغاء أحداث ${nodeId} وكل ما يليها، ثم إعادة تشغيل سير العمل من تلك العقدة. ستُشغَّل جميع العقد اللاحقة مرة أخرى.`,
            resetNodePaymentWarning: (count) =>
              `${{ [1]: `أنشأت هذه العقدة بالفعل دفعة واحدة. قد تؤدي إعادة التشغيل إلى إنشاء نسخة مكررة، ولن يتم عكس الدفعة الحالية.` }[count] ?? `أنشأت هذه العقدة بالفعل ${count} دفعات. قد تؤدي إعادة التشغيل إلى إنشاء نسخ مكررة، ولن يتم عكس الدفعات الحالية.`}`,
            resetNodeMarketOrderWarning: (count) =>
              `${{ [1]: `أنشأت هذه العقدة بالفعل أمر سوق واحدًا. قد تؤدي إعادة التشغيل إلى إنشاء نسخة مكررة، ولن يتم عكس الأمر الحالي.` }[count] ?? `أنشأت هذه العقدة بالفعل ${count} أوامر سوق. قد تؤدي إعادة التشغيل إلى إنشاء نسخ مكررة، ولن يتم عكس الأوامر الحالية.`}`,
            resetNodeConfirmPrompt: (nodeId) => `اكتب ${nodeId} للتأكيد`,
            resetNodeSuccess: "تمت إعادة تشغيل سير العمل من العقدة",
            resetNodeError: "فشل في إعادة تشغيل سير العمل من هذه العقدة",
            input: "مدخلات العقدة",
            output: "مخرجات العقدة",
            meta: "بيانات تعريف العقدة",
            error: "الخطأ",
            code: "الكود",
            refreshEvents: "تحديث الأحداث",
            noEvents: "لا توجد أحداث للعقد بعد.",
            orderNewest: "من الأحدث إلى الأقدم",
            orderOldest: "من الأقدم إلى الأحدث",
            viewFull: "عرض كامل",
            generatedPayments: "المدفوعات المُنشأة",
            generatedMarketOrders: "أوامر السوق المُنشأة",
            blockedBy: "محجوب بواسطة",
            expandAll: "توسيع الكل",
            collapseAll: "طي الكل",
            continueTimer: "المتابعة الآن",
            continueTimerConfirmTitle: "متابعة هذا المؤقّت الآن؟",
            continueTimerConfirmDescription: (nodeId) =>
              `سيؤدي هذا إلى تخطّي مدة الانتظار المتبقية لـ ${nodeId} ومتابعة سير العمل فورًا إلى العقدة التالية.`,
            continueTimerSuccess: "تمت متابعة المؤقّت",
            continueTimerError: "فشل في متابعة المؤقّت",
            continueRun: "متابعة",
            continueRunConfirmTitle: "متابعة هذا التشغيل؟",
            continueRunConfirmDescription:
              "سيؤدي هذا إلى إعادة إرسال إشارة إلى Temporal باستخدام مدخلات التشغيل المحفوظة وتنفيذ سير العمل من البداية.",
            continueRunSuccess: "تمت متابعة تشغيل سير العمل",
            continueRunError: "فشل في متابعة تشغيل سير العمل",
            exitRun: "إنهاء",
            exitRunConfirmTitle: "إنهاء هذا التشغيل؟",
            exitRunConfirmDescription:
              'سيؤدي هذا إلى وضع علامة "منتهٍ" على التشغيل دون تنفيذ أي من عقده. ولا يمكن متابعته بعد ذلك.',
            exitRunSuccess: "تم إنهاء تشغيل سير العمل",
            exitRunError: "فشل في إنهاء تشغيل سير العمل",
            viewAttachmentRuns: "عرض تشغيلات المرفقات",
          },
        },
      },
      pages: {
        benefits: {
          assignEmployees: {
            missingDetails:
              "بعض الموظفين لديهم تفاصيل مفقودة. تأكد من ملء جميع التفاصيل للمتابعة في تعيينهم لهذه الميزة",
            missingDetailsFor: ({ key, value }) =>
              `${key} مفقود لـ ${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `لا يوجد موظفين`, ["one"]: `موظف واحد`, ["two"]: `موظفين`, ["few"]: `${value} موظفين`, ["many"]: `${value} موظف` })[P.select(value)] ?? `${value} موظف`}`,
          },
          id: {
            employeeFilters: {
              last3Months: "آخر 3 أشهر",
              last6Months: "آخر 6 أشهر",
              lastMonth: "الشهر الماضي",
              thisYear: "هذا العام",
            },
          },
        },
        companies: {
          companyId: {
            details: {
              security: {
                page: {
                  addDomain: "إضافة الاختصاص ",
                  assertionConsumerServiceUrl: {
                    hint: "أدخل هذا في تكوين SAML لموفر الهوية الخاص بك.",
                    label: "عنوان URL لخدمة استهلاك الزعم (ACS)",
                  },
                  domain: {
                    edit: "تعديل الاختصاص ",
                    hint: "ادخل الاختصاص الذي ترغب في التحقق منه ",
                    label: "اختصاص ",
                    placeholder: "ادخل الاختصاص  ",
                    regenerateTxtRecord: "أعد توليد سجل TXT",
                    required: "اسم الاختصاص مطلوب ",
                    verificationFailed:
                      "فشل التحقق من الاختصاص, يرجى المحاولة مرة أخرى لاحقاً ",
                    verificationSucceeded: "نجح التحقق من الاختصاص ",
                    verified: "تم التحقق من الاختصاص ",
                    verify: "التحقق من الاختصاص  ",
                  },
                  domainVerificationHeading: "التحقق من النطاق",
                  downloadCertificate: "تحميل الشهادة",
                  enable: {
                    description:
                      "السماح للموظفين المدعوين باستخدام البريد الإلكتروني المسجل على معرّف موثوق من تسجيل الدخول عبر نظام SAML SSO",
                    heading: "تفعيل نظام SAML SSO",
                  },
                  fileMetadataType: "تحميل ملف XML للبيانات الوصفية",
                  fileMetadataTypeSubtitle: "قم بتحميل ملف بيانات IdP الخاص بك",
                  identityProviderUrl: {
                    hint: "أدخل عنوان URL للبيانات الوصفية المقدمة من مزود الهوية الخاص بك",
                    label: "عنوان URL لبيانات التعريف لموفر الهوية",
                    placeholder: "https://",
                    required: "عنوان URL لموفر الهوية هو حقل مطلوب",
                    updateSucceeded: "تم تحديث عنوان URL لموفر الهوية.",
                  },
                  instructionsPart1: "أضف السجل TXT التالي إلى DNS ل",
                  instructionsPart2: "الاختصاص ",
                  metadata: {
                    hint: "استخدم هذا الرابط لتكوين موفر الهوية (IdP) الخاص بك بشكل أسرع",
                    label: "عنوان URL لللبيانات الوصفية لمزود الخدمة (SP)",
                  },
                  metadataFile: {
                    required: "ملف بيانات IdP هو حقل مطلوب",
                    requirements: "ملف XML (بحد أقصى 2MB)",
                  },
                  ssoConfigurationDescription:
                    "قم بتكوين SAML SSO لمساحة العمل الخاصة بك مع موفر الهوية (IdP) الخاص بك",
                  ssoConfigurationHeading: "تكوين SAML SSO",
                  ssoHeading: "نظام تسجيل الدخول الموحد SAML",
                  urlMetadataType: "رابط إلى ملف XML للبيانات الوصفية",
                  urlMetadataTypeSubtitle:
                    "أدخل عنوان URL العام للبيانات الوصفية SAML IdP الخاصة بك",
                },
              },
              trading: {
                page: {
                  bankLocation: {
                    label: "بلد البنك",
                    required: "مطلوب موقع البنك",
                  },
                  bankName: { label: "اسم البنك", required: "اسم البنك مطلوب" },
                  iban: {
                    label: "رقم الحساب المصرفي الدولي IBAN",
                    required: "رقم الحساب المصرفي الدولي IBAN مطلوب",
                  },
                  success: "تم تحديث تفاصيل البنك",
                  title: "تفاصيل البنك",
                },
              },
              billingDetails: {
                page: {
                  bankDetails: {
                    title: "تفاصيل البنك",
                    success: "تم تحديث تفاصيل البنك",
                  },
                  billingInfo: {
                    title: "معلومات الفواتير",
                    success: "تم تحديث معلومات الفواتير",
                  },
                  bankLocation: {
                    label: "بلد البنك",
                    required: "بلد البنك مطلوب",
                  },
                  bankName: { label: "اسم البنك", required: "اسم البنك مطلوب" },
                  iban: {
                    label: "رقم الحساب المصرفي الدولي IBAN",
                    required: "رقم الحساب المصرفي الدولي IBAN مطلوب",
                  },
                  swift: { label: "SWIFT / BIC" },
                  accountName: { label: "اسم الحساب" },
                  branchName: { label: "اسم الفرع" },
                  branchAddress: { label: "عنوان الفرع" },
                  trn: { label: "الرقم الضريبي (TRN)" },
                  billingAddress: { label: "عنوان الفواتير" },
                },
              },
              verification: {
                page: {
                  completedView: {
                    heading: "تم إتمام التحقق",
                    subHeading: "تم التحقق من شركتك بنجاح",
                  },
                  approvedDocuments: {
                    title: "اعرف عملك (KYB)",
                    downloadDocument: "تحميل المستند",
                    unknownFile: "ملف غير معروف",
                    tabs: {
                      companyDocuments: "مستندات الشركة",
                      signatoryDocuments: "مستندات المفوضين",
                    },
                  },
                  unnamedSignatory: "مفوض غير مسمى",
                  signatoryNameLabel: "اسم المفوض",
                  documentFallback: (number) => `المستند ${number}`,
                  controls: {
                    compliance: {
                      companyStatus: {
                        backToDashboard: "العودة إلى لوحة التحكم",
                      },
                    },
                  },
                  stepCard: {
                    title: "ابدأ عملية التحقق",
                    stepsCompleted: ({ completed, total }) =>
                      `${completed}/${total} خطوات مكتملة`,
                    whatYouNeed: "ما ستحتاجه",
                    companyDocumentsPrefix: "مستندات تسجيل الشركة",
                    signatoryList: "قائمة جميع المفوضين بالتوقيع",
                    signatoryDocumentsPrefix: "مستندات تعريف المفوضين",
                    startVerification: "بدء التحقق",
                  },
                  stepper: {
                    steps: {
                      start: "ابدأ التحقق",
                      companyDocuments: "تحميل مستندات الشركة",
                      signatoryDocuments: "تحميل مستندات المفوضين",
                    },
                    addSignatory: "إضافة مفوض",
                    documentUploaded: "تم تحميل المستند",
                    documentRemoved: "تم إزالة المستند",
                    emptySignatories: {
                      title: "لم تتم إضافة مفوضين",
                      description:
                        "أضف المفوضين الذين يمكنهم التوقيع نيابة عن الشركة",
                    },
                    validation: {
                      signatoryNameRequired: "اسم المفوض مطلوب",
                      documentRequired: "يجب تحميل المستند المطلوب",
                    },
                  },
                  uploadAdditionalDocuments: { title: "تحميل مستندات إضافية" },
                  resubmitCompanyDocuments: {
                    title: "إعادة تقديم مستندات الشركة",
                  },
                  resubmitSignatoryDocuments: {
                    title: "إعادة تقديم مستندات المفوضين",
                  },
                  downloadDocument: "تحميل المستند",
                },
              },
              overview: {
                page: {
                  edit: { companyUpdated: "تم تحديث بيانات الشركة" },
                  title: "إعدادات الشركة",
                  registeredOn: "تاريخ التسجيل",
                  employees: "الموظفون",
                  activeBenefit: "ميزة نشطة",
                  companyInformation: {
                    title: "معلومات الشركة",
                    companyName: {
                      label: "اسم الشركة",
                      required: "يرجى تقديم اسم الشركة",
                    },
                    registeredUnder: {
                      label: "جهة الترخيص",
                      required: "يرجى تقديم جهة الترخيص",
                    },
                    tradeLicenseNumber: {
                      label: "رقم الرخصة التجارية",
                      required: "يرجى تقديم رقم الرخصة التجارية",
                    },
                    address: {
                      label: "العنوان",
                      required: "يرجى تقديم العنوان",
                    },
                  },
                  registeredAddress: {
                    title: "العنوان المسجل",
                    address: "العنوان",
                    emirate: "الإمارة",
                    placeholder: "اختر الإمارة",
                    required: "يرجى تقديم عنوان الشركة",
                    options: [
                      { label: "أبو ظبي", value: "AbuDhabi" },
                      { label: "عجمان", value: "Ajman" },
                      { label: "دبي", value: "Dubai" },
                      { label: "الفجيرة", value: "Fujairah" },
                      { label: "رأس الخيمة", value: "RasAlKhaimah" },
                      { label: "الشارقة", value: "Sharjah" },
                      { label: "أم القيوين", value: "UmmAlQuwain" },
                    ],
                  },
                  taxResidence: {
                    title: "الإقامة الضريبية",
                    country: "دولة الإقامة الضريبية",
                    taxReferenceNumber: "رقم التعريف الضريبي",
                  },
                  new: {
                    companyInfo: "معلومات الشركة",
                    registeredAddress: { label: "العنوان المسجل" },
                    additionalDetails: "تفاصيل إضافية",
                    taxResidence: "مكان الإقامة الضريبية",
                  },
                  details: {
                    tabTitle: {
                      overview: "لمحة عامة",
                      security: "الأمن",
                      verification: "التحقق",
                      trading: "تفاصيل البنك",
                      billingDetails: "تفاصيل الفواتير",
                      documents: "الوثائق",
                      taxInformation: "معلومات الضريبة",
                      fees: "الرسوم",
                    },
                  },
                  company: {
                    form: {
                      info: {
                        registeredUnder: {
                          required: "الرجاء اختيار هيئة الترخيص",
                        },
                        name: { required: "يرجى تقديم اسم الشركة" },
                        tradeLicenseNumber: {
                          required: "الرجاء إدخال رقم الرخصة التجارية",
                        },
                        website: { required: "يرجى تقديم موقع الويب" },
                        onShore: { inputRequired: "يرجى إدخال رقم صحيح" },
                      },
                      address: {
                        address: { required: "يرجى إدخال عنوان" },
                        emirate: { required: "الرجاء اختيار إمارة" },
                      },
                    },
                  },
                },
              },
              fees: {
                overview: {
                  heading: "نظرة عامة",
                  totalPaid: "إجمالي الرسوم المدفوعة حتى الآن",
                  lastPaidOn: (date) => `آخر دفعة في ${date}`,
                  lastUpdated: "آخر تحديث الآن",
                  upcomingPayment: "الدفعة القادمة",
                  dueIn: ({ days, date }) =>
                    `مستحقة خلال ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `يوم ${days}` })[P.select(days)] ?? `${days} أيام`} (${date})`,
                },
                yourFees: {
                  heading: "رسومك",
                  feeName: "رسوم المشاركة",
                  feeDescription:
                    "وصف الرسوم يظهر هنا. محسوبة كنسبة مئوية من الأصول لجميع الكيانات المرتبطة",
                  active: "نشط",
                  paidYearly: "تُدفع سنوياً",
                },
                history: { heading: "سجل الرسوم" },
                filters: {
                  pending: "قيد الانتظار",
                  completed: "مكتمل",
                  export: "تصدير",
                  exportReceipts: "تصدير الإيصالات كملف .zip",
                  exportInvoices: "تصدير الفواتير كملف .zip",
                },
                table: {
                  columns: {
                    status: "الحالة",
                    fee: "الرسوم",
                    totalAmount: "المبلغ الإجمالي",
                    dateDue: "تاريخ الاستحقاق",
                    dateCompleted: "تاريخ الإتمام",
                  },
                  status: {
                    pending: "قيد الانتظار",
                    processed: "تمت المعالجة",
                    failed: "فشل",
                  },
                  actions: {
                    menu: "الإجراءات",
                    downloadReceipt: "تحميل الإيصال",
                    downloadInvoice: "تحميل الفاتورة",
                    receiptTooltip: "سيتم إنشاء إيصال بمجرد إجراء الدفع",
                  },
                  empty: {
                    title: "لا توجد رسوم",
                    text: "ستظهر سجلات الرسوم هنا عند معالجة المدفوعات.",
                  },
                },
              },
            },
            dashboard: {
              overview: {
                page: {
                  actionItems: {
                    actionsThatNeedAttentionAppearHere:
                      "المهام التي تتطلب إجراءات إضافية ستظهر هنا",
                    tradingAccount: {
                      add: "املأ تفاصيلك البنكية",
                      cta: "أضف التفاصيل",
                    },
                    viewAllPayments: (count) =>
                      `عرض ${{ [1]: `1 دفعة أخرى` }[count] ?? `${count} دفعات أخرى`}`,
                    viewMore: (count) =>
                      `عرض ${{ [1]: `1 أكثر`, [2]: `2 أكثر` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${count} أكثر`, ["many"]: `${count} أكثر` })[P.select(count)] ?? `${count} أكثر`}`,
                    approveAll: "الموافقة على الكل",
                    employeesWithNewSubscriptions:
                      "الموظفون الذين اشتركوا حديثًا",
                    headingV2: "قائمة الإجراءات",
                    inviteAllEmployees: "دعوة جميع الموظفين",
                    inviteAllEmployeesDescription:
                      "هذا يعني أنهم سيتمكنون من تنزيل التطبيق والتسجيل واستخدام المزايا التي قمت بإعدادها له.",
                    inviteByBenefit: "دعوة بنظام المكافآت",
                    inviteByBenefits: {
                      heading: "دعوة الموظفين حسب المزايا",
                      type: "النوع",
                      uninivtedEmployees: "الموظفون غير المدعوين",
                    },
                    payNow: "ادفع الآن",
                    pensionPayment: {
                      due: ({ pensionName, daysCount, date }) =>
                        `الدفع مستحق لـ ${pensionName} خلال ${daysCount} (${date})`,
                      overdue: "الدفع متأخر",
                      rejected: (pensionName) => `الدفع مستحق ل ${pensionName}`,
                      tooltipDue: (date) =>
                        `من الضروري أن تقوم بالدفع قبل ${date}. قد تتعرض شركتك للغرامات والعقوبات إذا لم تقم بالدفع في الوقت المحدد.`,
                      tooltipOverdue: (date) =>
                        `كان من المفترض أن يتم الدفع في ${date}. قد تتعرض شركتك للغرامات والعقوبات إذا لم تقم بالدفع الآن.`,
                    },
                    reviewNow: "راجع الآن",
                    subscriptionDue: ({ daysCount, date }) =>
                      `الدفع للاشتراك مستحق خلال ${daysCount.toLocaleString(L, {})} يوم (${date})`,
                    uninvitedEmployees: "الموظفون الذين لم يتم دعوتهم بعد",
                    viewRequests: "عرض الطلبات",
                    youAreAllCaughtUp: "لا توجد إجراءات معلقة",
                    verificationSectionTitle: "التحقق",
                    verificationAlert: {
                      title: "التحقق مطلوب.",
                      description: "أكمل وثائقك للوصول إلى جميع ميزات المنصة.",
                      buttonText: "رفع الوثائق",
                    },
                    bankDetailsSectionTitle: "بيانات البنك",
                    taxDetailsSectionTitle: "بيانات الضرائب",
                    fatca: {
                      title: "معلومات ضريبية مطلوبة وفقاً لقانون فاتكا",
                      cta: "إكمال نموذج فاتكا",
                    },
                    paymentsSectionTitle: "المدفوعات",
                    employeesSectionTitle: "الموظفون",
                    paymentsOverdue: (count) =>
                      `${{ [1]: `دفعة واحدة متأخرة`, [2]: `دفعتان متأخرتان` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${count} دفعات متأخرة`, ["many"]: `${count} دفعة متأخرة` })[P.select(count)] ?? `${count} دفعة متأخرة`}`,
                    paymentsUpcoming: (count) =>
                      `${{ [1]: `دفعة واحدة معلّقة`, [2]: `دفعتان معلّقتان` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${count} دفعات معلّقة`, ["many"]: `${count} دفعة معلّقة` })[P.select(count)] ?? `${count} دفعة معلّقة`}`,
                    paymentsRejected: (count) =>
                      `${{ [1]: `دفعة واحدة مرفوضة`, [2]: `دفعتان مرفوضتان` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${count} دفعات مرفوضة`, ["many"]: `${count} دفعة مرفوضة` })[P.select(count)] ?? `${count} دفعة مرفوضة`}`,
                    paymentPenaltyWarning:
                      "قد تتعرض للغرامات والعقوبات إذا لم تقم بالدفع الآن.",
                    paymentOverdueByDays: ({ amount, days }) =>
                      `${amount} متأخر بـ ${{ [1]: `يوم واحد`, [2]: `يومين` }[days] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${days} أيام`, ["many"]: `${days} يوماً` })[P.select(days)] ?? `${days} يوم`}`,
                    paymentDueInDays: ({ amount, days }) =>
                      `${amount} مستحق خلال ${{ [1]: `يوم واحد`, [2]: `يومين` }[days] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${days} أيام`, ["many"]: `${days} يوماً` })[P.select(days)] ?? `${days} يوم`}`,
                    paymentRejectedForBenefit: ({ amount, benefitName }) =>
                      `${amount} مرفوض لـ ${benefitName}`,
                    newSubscriptionRequests: (count) =>
                      `${{ [1]: `طلب اشتراك جديد واحد`, [2]: `طلبا اشتراك جديدان` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${count} طلبات اشتراك جديدة`, ["many"]: `${count} طلب اشتراك جديد` })[P.select(count)] ?? `${count} طلب اشتراك جديد`}`,
                    employeesToInvite: (count) =>
                      `${{ [1]: `موظف واحد للدعوة`, [2]: `موظفان للدعوة` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${count} موظفين للدعوة`, ["many"]: `${count} موظفاً للدعوة` })[P.select(count)] ?? `${count} موظف للدعوة`}`,
                    employeesNotRegistered: (count) =>
                      `${{ [1]: `موظف واحد تم إضافته ولكن لم يتم تسجيله بعد`, [2]: `موظفان تم إضافتهما ولكن لم يتم تسجيلهما بعد` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `${count} موظفين تم إضافتهم ولكن لم يتم تسجيلهم بعد`, ["many"]: `${count} موظفاً تم إضافتهم ولكن لم يتم تسجيلهم بعد` })[P.select(count)] ?? `${count} موظف تم إضافتهم ولكن لم يتم تسجيلهم بعد`}`,
                  },
                  insights: {
                    basicSubscriptions: "الاشتراكات الأساسية",
                    heading: "معلومات",
                    invitedEmployees: "الموظفون الذين تمت دعوتهم",
                    noDataDescription:
                      "استمر في استخدام المنصة للاطلاع على معلومات حول مؤسستك",
                    onboardingEngagement: "بيانات التفاعل في مرحلة المشاركة",
                    registeredEmployees: "المسجلون",
                    total: "المبلغ الإجمالي (الشهر الماضي)",
                    totalSubscriptions: "إجمالي الاشتراكات",
                    voluntarySubscription: "الاشتراكات الطوعية",
                  },
                  verificationStatusCard: {
                    body: {
                      Approved: {
                        cta: "رفض",
                        description:
                          "تم التحقق من شركتك بنجاح. يمكنك الآن الوصول إلى جميع الميزات.",
                        title: "تم التحقق",
                      },
                      DocumentsInReview: {
                        cta: "عرض الوثائق المقدمة",
                        description:
                          "مستنداتك قيد المراجعة. سنقوم بإعلامك عند الانتهاء من المراجعة",
                        title: "قيد المراجعة",
                      },
                      DocumentsRequired: {
                        cta: "بدء التحقق",
                        description:
                          "بدأ التحقق الخاص بك لتتمكن من الوصول إلى مكافآت نهاية الخدمة",
                        title: "مطلوب",
                      },
                      DocumentsRetry: {
                        cta: "رد مع المعلومات",
                        description:
                          "بناءً على المعلومات المقدمة، نحتاج إلى معلومات إضافية للتحقق من نشاطك التجاري.",
                        title: "تم طلب التعديلات",
                      },
                      Rejected: { cta: "", description: "", title: "" },
                      SignatoryRequired: {
                        cta: "",
                        description: "",
                        title: "",
                      },
                      WaitingForSignature: {
                        cta: "",
                        description: "",
                        title: "",
                      },
                    },
                    heading: "حالة التحقق",
                  },
                  list: {
                    inviteEmployee: {
                      error: {
                        both: "يجب أن تكون الشركة مُصدقة ومُشتركة لتنفيذ هذا الإجراء.",
                        clickHereTo: "انقر هنا ل",
                        verify: "تحقق",
                        subscribe: "اشترك",
                        unverified: "يجب التحقق من الشركة لتنفيذ هذا الإجراء.",
                        unsubscribed:
                          "يجب أن تكون الشركة مشتركة لتنفيذ هذا الإجراء.",
                        bankingDetailsRequired:
                          "معلومات الحساب البنكي للشركة مطلوبة لتنفيذ هذا الإجراء.",
                      },
                    },
                  },
                  setupChecklist: {
                    title: "ابدأ الآن",
                    progressText: ({ completed, total }) =>
                      `${completed}/${total} مهمة مكتملة`,
                    verifyBusiness: "تحقق من عملك",
                    verifyBusinessDescription:
                      "التحقق من العمل مطلوب قبل أن تتمكن من معالجة المدفوعات أو إدارة المعاملات المالية.",
                    verifyBusinessInProgress: "التحقق من العمل قيد التقدم",
                    verifyBusinessInProgressDescription: "يتم مراجعة مستنداتك",
                    verifyBusinessRejected: "تم رفض التحقق من العمل",
                    verifyBusinessRejectedDescription:
                      "لا يمكن التحقق من الوثائق. اتصل بالمسؤول للحصول على مزيد من المعلومات.",
                    verifyBusinessRejectedResubmit:
                      "تم رفض التحقق من العمل - مطلوب إعادة التقديم",
                    verifyBusinessRejectedResubmitDescription:
                      "لا يمكن التحقق من الوثائق. يرجى إعادة تقديم وثائق العمل الصحيحة.",
                    verifyBusinessTooltip:
                      "هناك حاجة إلى أذونات إضافية لهذه المهمة. اتصل بالمسؤول للحصول على الوصول.",
                    uploadEmployees: "رفع بيانات موظفيك",
                    setupBenefits: "إعداد مزايا الشركة",
                    fillTaxReporting:
                      "املأ تفاصيل تقارير الضرائب الخاصة بالشركة",
                    fillBillingDetails: "أدخل تفاصيل الفواتير الخاصة بالشركة",
                    inviteAdmins: "ادعُ المديرين",
                    doLater: "سأفعل هذا لاحقاً",
                  },
                  helpCenter: {
                    feelingLost: "هل تشعر أنك تائه؟",
                    description:
                      "استكشف المقالات المتعمقة والأسئلة الشائعة في مركز المساعدة الخاص بنا.",
                  },
                  welcomeDialog: {
                    title: (name) =>
                      `${{ ["null"]: `مرحباً!` }[name] ?? `مرحباً، ${name}!`}`,
                    description: (platformName) =>
                      `مرحباً بك في ${platformName}. هل أنت مستعد للاستكشاف؟`,
                    tourButton: "أرني المكان",
                    imageAlt: "مرحباً بك في لوحة التحكم",
                  },
                  tour: {
                    steps: {
                      first: {
                        title: "ابدأ في إعداد منصتك الجديدة",
                        description:
                          "أكمل هذه المهام لفتح مجموعة الميزات الكاملة وابدأ اطلاق المزايا.",
                      },
                      personalSettings: {
                        title: "الإعدادات الشخصية",
                        description:
                          "الوصول إلى إعداداتك الشخصية لتحديث تفاصيلك الشخصية وإعدادات الأمان.",
                      },
                      languagePreferences: {
                        title: "تفضيلات اللغة",
                        description: "اختر لغتك الاساسية.",
                      },
                      search: {
                        title: "ابحث عن المعلومات التي تحتاجها",
                        description:
                          "ابحث في المنصة عن معلومات الشركة والموظفين بسهولة.",
                      },
                      employees: {
                        title: "إدارة موظفيك",
                        description:
                          "تصفح وأضف أو حدث معلومات الموظفين والحالة وتعيينات المزايا كلها في مكان واحد.",
                      },
                      benefits: {
                        title: "إدارة منتجات الشركة",
                        description:
                          "إعداد وعرض وإدارة منتجات شركتك في الوقت الفعلي.",
                      },
                      payments: {
                        title: "إدارة مدفوعات الشركة",
                        description:
                          "عرض وتتبع وإجراء جميع المدفوعات الخاصة بك هنا - بمعلومات مفصلة ورؤى.",
                      },
                      requests: {
                        title: "إدارة الطلبات",
                        description:
                          "مراجعة وموافقة وتتبع طلبات الموظفين الخاصة بك.",
                      },
                      activity: {
                        title: "عرض النشاط الأخير",
                        description:
                          "عرض جميع الإجراءات والتحديثات الأخيرة في حساب شركتك لتتبع التغييرات المهمة.",
                      },
                      settings: {
                        title: "إدارة معلومات الشركة",
                        description:
                          "الوصول إلى وإدارة المعلومات الأساسية لشركتك، بما في ذلك تفاصيل التسجيل والعنوان والإقامة الضريبية، كلها في مكان واحد.",
                      },
                      actionItems: {
                        title: "أكمل عناصر العمل الخاصة بك",
                        description:
                          "المهام التي تتطلب انتباهك و/أو إجراءك ستظهر هنا مع مرور الوقت.",
                      },
                    },
                    navigation: {
                      back: "رجوع",
                      next: "التالي",
                      finishTour: "إنهاء الجولة",
                      stepCounter: ({ currentStep, steps }) =>
                        `${currentStep} من ${steps}`,
                      gotIt: "فهمت",
                    },
                  },
                  manageEmployees: "إدارة الموظفين",
                  manageBenefits: "إدارة المزايا",
                  managePayments: "إدارة المدفوعات",
                  pillars: {
                    employees: {
                      label: "الموظفون",
                      enrolled: (count) =>
                        `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `${count} مسجلين`, ["one"]: `مسجل واحد`, ["two"]: `مسجلان`, ["few"]: `${count} مسجلين`, ["many"]: `${count} مسجلاً` })[P.select(count)] ?? `${count} مسجل`}`,
                    },
                    contributions: {
                      label: "المساهمات القادمة",
                      notScheduled: "لم يتم تحديد جدول الرواتب",
                    },
                    payments: {
                      label: "المدفوعات المتأخرة",
                      daysLate: (count) =>
                        `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `لا يوجد تأخير`, ["one"]: `متأخرة يومًا واحدًا`, ["two"]: `متأخرة يومين`, ["few"]: `متأخرة ${count} أيام`, ["many"]: `متأخرة ${count} يومًا` })[P.select(count)] ?? `متأخرة ${count} يوم`}`,
                      noneOverdue: "جميع المدفوعات محدّثة",
                    },
                    holdings: {
                      label: "الحيازات",
                      noHoldings: "لا توجد حيازات بعد",
                      noPerformance: "لا توجد بيانات أداء بعد",
                    },
                    vsLastMonth: (d) => `${d} مقارنة بالشهر الماضي`,
                    lastUpdatedAt: (time) => `آخر تحديث في ${time}`,
                  },
                  latestTasks: {
                    title: "أحدث المهام",
                    openCount: (count) =>
                      `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `${count} مفتوحة`, ["one"]: `مهمة واحدة مفتوحة`, ["two"]: `مهمتان مفتوحتان`, ["few"]: `${count} مهام مفتوحة`, ["many"]: `${count} مهمة مفتوحة` })[P.select(count)] ?? `${count} مهمة مفتوحة`}`,
                    seeMore: "عرض المزيد",
                    empty: {
                      title: "لا يوجد ما يتطلب انتباهك",
                      description: "ستظهر المهام الجديدة هنا عند ورودها.",
                    },
                  },
                  contributionVolume: {
                    title: "إجمالي الاشتراكات",
                    ranges: {
                      threeMonths: "3 أشهر",
                      sixMonths: "6 أشهر",
                      oneYear: "سنة",
                      yearToDate: "منذ بداية العام",
                    },
                    subtitle: {
                      threeMonths: "المسدد خلال آخر 3 أشهر",
                      sixMonths: "المسدد خلال آخر 6 أشهر",
                      oneYear: "المسدد خلال آخر 12 شهرًا",
                      yearToDate: "المسدد منذ بداية العام",
                    },
                    series: {
                      basic: "أساسية",
                      additional: "إضافية",
                      voluntary: "اختيارية",
                      lumpSum: "مبلغ مقطوع",
                      other: "أخرى",
                    },
                    combined: "الإجمالي",
                    lastUpdatedAt: (time) => `آخر تحديث في ${time}`,
                    share: (d) =>
                      `${d.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })} من الإجمالي`,
                    empty: {
                      title: "لا توجد مساهمات بعد",
                      description: "ستظهر المساهمات هنا بمجرد تسوية أول دفعة.",
                    },
                  },
                  paymentTracker: {
                    title: "متتبع الدفع والاستثمار",
                    steps: {
                      created: "تم إنشاء الدفعة",
                      approval: "قيد الموافقة",
                      marketOrderExecution: "تنفيذ أمر السوق",
                      completed: "مكتملة",
                    },
                    hints: {
                      created: "في انتظار السداد من شركتك.",
                      approval: "في انتظار الموافقة قبل استثمار المبلغ.",
                      marketOrderExecution:
                        "جارٍ شراء الوحدات لموظفيك. يستغرق ذلك عادةً من يوم إلى يومي عمل.",
                      completed: "تمت إضافة الوحدات إلى حيازات موظفيك.",
                    },
                    receipt: "الإيصال",
                    empty: {
                      lastSettled: "لا توجد دفعة قيد التنفيذ حتى الآن.",
                      noPayments: "لم يتم تنفيذ أي دفعة مساهمة بعد.",
                    },
                    summary: ({ amount, d }) =>
                      `${amount} · ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                  },
                  feeInvoicing: {
                    title: "الرسوم والفواتير",
                    allInvoices: "كل الفواتير",
                    tile: {
                      paidOn: (d) =>
                        `مدفوعة · ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      paid: "مدفوعة",
                      dueOn: (d) =>
                        `مستحقة في ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      overdueOn: (d) =>
                        `متأخرة منذ ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      outstanding: "غير مدفوعة",
                    },
                    outstanding: {
                      heading: ({ reference, amount, d }) =>
                        `${reference} · ${amount} مستحقة في ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      overdueHeading: ({ reference, amount, d }) =>
                        `${reference} · ${amount} متأخرة منذ ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                      invoices: (n) =>
                        `${{ [1]: `فاتورة واحدة` }[n] ?? `${n} فواتير`}`,
                      payNow: "ادفع الآن",
                    },
                    allPaid: "تم دفع كل الفواتير",
                    allPaidNext: (d) =>
                      `تم دفع كل الفواتير · الفاتورة القادمة في ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
                  },
                  holdingsSummary: {
                    title: "ملخص الحيازات",
                    subtitle: "ما يملكه موظفوك، حسب الصندوق وفئة الأسهم",
                    breakdownTitle: "التفصيل حسب الصندوق وفئة الأسهم",
                    splitTitle: "بقيادة صاحب العمل مقابل بقيادة الموظف",
                    percent: (p) =>
                      `${p.toLocaleString(L, { style: "percent", signDisplay: "exceptZero", minimumFractionDigits: 1, maximumFractionDigits: 1 })}`,
                    trend: ({ p, a }) => `${p} · ${a} مقارنة بالشهر الماضي`,
                    meta: {
                      employees: (n) =>
                        `${{ [1]: `موظف واحد` }[n] ?? `${n} موظفين`}`,
                      funds: (n) =>
                        `${{ [1]: `صندوق واحد` }[n] ?? `${n} صناديق`}`,
                      shareClasses: (n) =>
                        `${{ [1]: `فئة أسهم واحدة` }[n] ?? `${n} فئات أسهم`}`,
                    },
                    columns: {
                      fund: "الصندوق / فئة الأسهم",
                      risk: "المخاطر",
                      units: "الوحدات المملوكة",
                      nav: "صافي قيمة الوحدة",
                      marketValue: "القيمة السوقية",
                      return: "العائد (منذ بداية العام)",
                      employees: "الموظفون",
                    },
                    units: (u) => `${u} وحدة`,
                    employees: (n) =>
                      `${{ [1]: `موظف واحد` }[n] ?? `${n} موظفين`}`,
                    shareClassUnknown: "فئة الأسهم غير متوفرة",
                    totalRow: "إجمالي المحفظة",
                    buckets: {
                      employerLed: "بقيادة صاحب العمل (مكافأة نهاية الخدمة)",
                      employeeLed: "بقيادة الموظف (اختياري)",
                    },
                    bucketShare: (p) =>
                      `${p.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })} من الإجمالي`,
                    bucketContributions: (a) =>
                      `المساهمات منذ بداية العام: ${a}`,
                    bucketReturn: (p) => `عائد ${p}`,
                    empty: {
                      title: "لا توجد استثمارات بعد",
                      description:
                        "تظهر حيازات الصناديق هنا بعد استثمار أول مساهمة.",
                    },
                    viewPortfolio: "عرض المحفظة",
                    lastUpdatedAt: (time) => `آخر تحديث في ${time}`,
                  },
                  employeeOverview: {
                    title: "نظرة عامة على الموظفين",
                    addEmployee: "إضافة موظف",
                    invite: {
                      action: (count) =>
                        `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `دعوة الجميع (${count})`, ["one"]: `دعوة الجميع (1)`, ["two"]: `دعوة الجميع (2)`, ["few"]: `دعوة الجميع (${count})`, ["many"]: `دعوة الجميع (${count})` })[P.select(count)] ?? `دعوة الجميع (${count})`}`,
                      confirmTitle: "دعوة الموظفين",
                      confirmDescription: (count) =>
                        `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `سيتلقى ${count} موظف دعوة إلى البوابة. ومن سبق دعوته سيصله تذكير.`, ["one"]: `سيتلقى موظف واحد دعوة إلى البوابة. ومن سبق دعوته سيصله تذكير.`, ["two"]: `سيتلقى موظفان دعوة إلى البوابة. ومن سبق دعوته سيصله تذكير.`, ["few"]: `سيتلقى ${count} موظفين دعوة إلى البوابة. ومن سبق دعوته سيصله تذكير.`, ["many"]: `سيتلقى ${count} موظفًا دعوة إلى البوابة. ومن سبق دعوته سيصله تذكير.` })[P.select(count)] ?? `سيتلقى ${count} موظف دعوة إلى البوابة. ومن سبق دعوته سيصله تذكير.`}`,
                      started: "جارٍ إرسال الدعوات",
                    },
                    chips: {
                      total: {
                        label: "إجمالي الموظفين",
                        hint: (count) =>
                          `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `لا يوجد منضمون جدد هذا الشهر`, ["one"]: `انضم موظف واحد هذا الشهر`, ["two"]: `انضم موظفان هذا الشهر`, ["few"]: `انضم ${count} موظفين هذا الشهر`, ["many"]: `انضم ${count} موظفًا هذا الشهر` })[P.select(count)] ?? `انضم ${count} موظف هذا الشهر`}`,
                      },
                      enrolled: {
                        label: "المسجلون",
                        hint: "يساهمون في إحدى المزايا",
                      },
                      pendingInvite: {
                        label: "دعوة معلقة",
                        hint: "لم يتم قبول الدعوة بعد",
                      },
                      notInvited: {
                        label: "لم تتم دعوتهم بعد",
                        hint: "بانتظار الوصول إلى البوابة",
                      },
                    },
                    enrollment: {
                      title: "التسجيل حسب المنتج",
                      portal: {
                        label: "التسجيل في البوابة",
                        detail: ({ count, total }) =>
                          `${count} مسجل من ${total} موظف`,
                      },
                      eosb: {
                        label: "مكافأة نهاية الخدمة",
                        detail: ({ count, total }) =>
                          `${count} مسجل من ${total} موظف`,
                      },
                      voluntary: {
                        label: "الادخار التطوعي",
                        detail: ({ count, total }) =>
                          `${count} مساهم من ${total} مسجل`,
                      },
                    },
                    tenure: {
                      title: "توزيع مدة الخدمة",
                      underOneYear: "أقل من سنة",
                      oneToThreeYears: "1-3 سنوات",
                      threeToSevenYears: "3-7 سنوات",
                      sevenToTenYears: "7-10 سنوات",
                      tenYearsOrMore: "10+ سنوات",
                      bandCount: ({ count, percent }) =>
                        `${count} (${percent}%)`,
                      average: (d) => `متوسط مدة الخدمة: ${d} سنة`,
                    },
                    lastUpdatedAt: (time) => `آخر تحديث في ${time}`,
                  },
                },
              },
              activity: {
                page: {
                  eventLogs: {
                    heading: "أحدث الأنشطة",
                    viewAll: "عرض النشاط الكُلي ",
                    emptyState:
                      "لا يوجد نشاط بعد! سيظهر سجل النشاط هنا كلما استمريت في استخدام المنصة.",
                    errorState:
                      "لم نتمكن من جلب سجلات النشاط الخاصة بك في الوقت الحالي. يرجى تحديث الصفحة أو التحقق مرة أخرى قريباً.",
                  },
                },
              },
            },
            employees: {
              new: {
                page: {
                  create: "أضف موظف",
                  error: "فشل في إنشاء موظف",
                  success: "تم إنشاء الموظف بنجاح",
                  creating: "يجري الإنشاء...",
                  createEmployee: "إضافة موظف",
                  willAddToBenefits: {
                    back: "الرجوع",
                    confirm: "تأكيد وتعيين",
                    description: (الاسم) =>
                      `استنادًا إلى تفاصيل توظيفهم، سيتم تعيين ${الاسم} تلقائيًا إلى المزايا الحالية التالية:`,
                    title: (count) =>
                      `${{ [1]: `إضافة الموظف إلى الميزة` }[count] ?? `إضافة الموظف إلى المزايا`}`,
                  },
                  form: {
                    details: {
                      heading: "تفاصيل العمل",
                      subheading: "لكي تسير الأمور بسلاسة",
                    },
                    personal: {
                      subheading: "لنبدأ بالأساسيات",
                      heading: "المعلومات الشخصية",
                    },
                    contact: {
                      subheading: "طريقة للتواصل معهم",
                      heading: "الاتصال",
                    },
                    additionalDetails: { heading: "تفاصيل إضافية" },
                  },
                  avs: "صناديق  اورم لمكافأة نهاية الخدمة",
                },
              },
              employeeId: {
                benefits: {
                  page: {
                    name: "اسم نظام المكافآت",
                    status: "الحالة",
                    totalContribution: "المساهمة الكلية",
                    type: "النوع",
                    title: "نظام المكافآت",
                    benefitStatus: { active: "نشط", inactive: "غير نشط" },
                  },
                },
                products: {
                  page: {
                    name: "اسم المنتج",
                    status: "الحالة",
                    totalContributed: "إجمالي المساهمات",
                    currentValue: "القيمة الحالية",
                    monthlyContribution: "المساهمة الأساسية الشهرية",
                    type: "النوع",
                    title: "المنتجات",
                    productStatus: { active: "نشط", inactive: "غير نشط" },
                  },
                  details: {
                    properties: {
                      type: "النوع",
                      totalContributed: "إجمالي المساهمات",
                      currentValue: "القيمة الحالية",
                      enrolled: "الانضمام",
                      ended: "الانتهاء",
                      monthlyContribution: "المساهمة الأساسية الشهرية",
                    },
                    grid: {
                      date: "التاريخ",
                      contributionMonth: "شهر المساهمة",
                      category: "الفئة",
                      amount: "المبلغ",
                      status: "الحالة",
                      adjusted: "معدل",
                    },
                    footer: {
                      totalContributedSettled: "إجمالي المساهمات (المسددة)",
                    },
                    noItems: {
                      title: "لا توجد مساهمات حتى الآن",
                      text: "ستظهر المساهمات هنا بعد إتمام الدفعات لهذه المنفعة.",
                    },
                  },
                },
                beneficiaries: {
                  page: {
                    noNominees: {
                      heading: (employeeName) =>
                        `${employeeName} اختار اتباع الشريعة الإسلامية.`,
                      message: "لم يتم ترشيح أي مستفيدين.",
                    },
                    nominees: {
                      heading: ({ employeeName, beneficiaryCount }) =>
                        `${employeeName} اختار ترشيح ${{ [1]: `مستفيد واحد` }[beneficiaryCount] ?? `${beneficiaryCount.toLocaleString(L, {})} مستفيدين`}.`,
                    },
                    details: {
                      relation: "صلة القرابة بالموظف",
                      dateOfBirth: "تاريخ الميلاد",
                      mobileNumber: "رقم الهاتف",
                      email: "البريد الإلكتروني الشخصي (اختياري)",
                      passportNumber: "رقم جواز السفر (اختياري)",
                      percentAllotted: "النسبة المئوية من الأموال المخصصة",
                      relationship: {
                        spouse: "زوج/زوجة",
                        child: "طفل",
                        parent: "والد/والدة",
                        sibling: "أخ/أخت",
                        other: "آخر",
                      },
                    },
                    form: {
                      firstName: {
                        label: "الاسم الأول",
                        placeholder: "الاسم الأول",
                      },
                      lastName: {
                        label: "الاسم الأخير",
                        placeholder: "الاسم الأخير",
                      },
                      relationship: {
                        label: "صلة القرابة بالموظف",
                        placeholder: "اختر صلة القرابة",
                      },
                      dateOfBirth: { label: "تاريخ الولادة" },
                      phone: {
                        label: "رقم الهاتف",
                        placeholder: "أدخل رقم الهاتف",
                      },
                      percentAllocated: {
                        label: "النسبة المئوية المخصصة",
                        placeholder: "أدخل النسبة المئوية المخصصة",
                      },
                    },
                  },
                },
                personalDetails: {
                  page: {
                    headline: "الموظفون / تفاصيل الموظف",
                    navigation: {
                      personalDetails: "التفاصيل الشخصية",
                      employmentDetails: "تفاصيل العمل",
                      benefits: "المزايا",
                      beneficiaries: "المستفيدون",
                    },
                    benefitsChange: {
                      addedAndRemoved: {
                        added: "تمت الإضافة إلى المزايا الجديدة",
                        description: "سيتم تحديث مزايا هذا الموظف",
                        removed: "تم الحذف من المزايا",
                        title:
                          "تمت الإضافة إلى المزايا الجديدة، تم الحذف من المزايا القديمة",
                      },
                      addedOnly: {
                        description:
                          "سيتم إضافة هذا الموظف إلى المزايا التالية",
                        title: "تمت الإضافة إلى المزايا الجديدة",
                      },
                      noChange: {
                        description: "لا يزال الموظف تابعاً للمزايا الحالية",
                        title: "لا تغيير في المزايا",
                      },
                      removedOnly: {
                        description: "سيتم حذف هذا الموظف من المزايا التالية",
                        title: "الحذف من المزايا",
                      },
                    },
                    changesMayAffectBenefits: {
                      description:
                        "قد يؤثر تغيير تفاصيل العمل على نظام المكافآت الذي ينتمي إليه الموظف، حيث قد يناسب معايير نظام مكافآت مختلف.",
                      title: "قد تؤثر التغييرات على مزايا الموظف",
                    },
                    error: "فشل في تعديل معلومات الموظف",
                    success: "تم تعديل بيانات الموظف بنجاح",
                    form: {
                      additionalDetails: { heading: "تفاصيل إضافية" },
                      address: {
                        label: "العنوان",
                        placeholder: "أدخل العنوان",
                      },
                      basicSalary: {
                        error: "يجب أن يكون الراتب الأساسي رقمًا",
                        hint: "الراتب الأساسي الذي يتم احتساب مكافأة نهاية الخدمة عليه",
                        label: "الراتب الأساسي الشهري",
                        placeholder: "الراتب الأساسي الشهري",
                        required: "الراتب الأساسي مطلوب",
                      },
                      branch: {
                        hint: "",
                        label: "المدينة / الفرع (اختياري)",
                        placeholder: "المدينة/الفرع",
                      },
                      contact: { heading: "الاتصال" },
                      dateOfBirth: {
                        label: "تاريخ الولادة",
                        lessThan15Years: "يجب أن يكون الموظف على الأقل 15 سنة",
                      },
                      department: {
                        hint: "",
                        label: "القسم (اختياري)",
                        placeholder: "القسم",
                      },
                      details: { heading: "تفاصيل العمل" },
                      email: {
                        hint: "هذا هو عنوان البريد الإلكتروني الذي سيتلقى الموظفون من خلاله الدعوة للوصول إلى التطبيق",
                        label: "البريد الإلكتروني للعمل",
                        placeholder: "البريد الإلكتروني للعمل",
                      },
                      nationalId: {
                        label: "بطاقة الهوية الإماراتية",
                        placeholder: "xxx-xxxx-xxxxxxx-x",
                        required: "الهوية الإماراتية مطلوبة",
                      },
                      employeeIdNumber: {
                        hint: "",
                        label: "رقم هوية الموظف (اختياري)",
                        placeholder: "رقم الموظف",
                      },
                      employerID: { label: "معرف صاحب العمل" },
                      employmentStatus: {
                        label: "حالة التوظيف",
                        placeholder: "حدد حالة التوظيف",
                      },
                      endDate: {
                        hint: "نستخدم هذا لبدء عملية الإنهاء",
                        label: "تاريخ انتهاء العمل",
                      },
                      firstName: {
                        hint: "يجب أن يتطابق مع البطاقة التعريفية الحكومية الخاصه بهم ",
                        label: "الاسم الأول",
                        placeholder: "الاسم الأول",
                        required: "الاسم الأول مطلوب",
                      },
                      fullSalary: {
                        error: "يجب أن يكون الراتب رقمًا",
                        hint: "التعويض الكلي في نهاية الشهر بما في ذلك المخصصات",
                        label: "الراتب الشهري",
                        placeholder: "الراتب الشهري بالدرهم الإماراتي",
                        required: "الراتب الشهري مطلوب",
                      },
                      gender: { label: "الجنس", placeholder: "اختر الجنس" },
                      iban: {
                        hint: "هذا هو حساب راتب الموظف الذي يتم من خلاله تحويل مدفوعات نهاية الخدمة",
                        label: "رقم الحساب المصرفي الدولي IBAN",
                        placeholder: "AE07 0331 2345 6789 0123 456",
                      },
                      jobTitle: {
                        hint: "هذا يسهل عليك ترتيب وفلترة الموظفين لاحقا.",
                        label: "المسمى الوظيفي",
                        placeholder: "المسمى الوظيفي",
                      },
                      labourId: {
                        error:
                          "يجب أن يكون الرقم التعريفي لوزارة العمل - رقماً",
                        hint: "هذا هو الرقم التعريفي للموظف المكون من 14 رقماً على البطاقة التعريفية لوزارة العمل",
                        label: "البطاقة التعريفية لوزارة العمل ",
                        placeholder: "xxxxxxxxxxxxxx",
                      },
                      lastName: {
                        hint: "يشمل جميع الأسماء الوسطى والأخيرة",
                        label: "الاسم الأخير",
                        placeholder: "الاسم الأخير",
                        required: "الاسم الأخير مطلوب",
                      },
                      level: {
                        hint: "",
                        label: "المستوى (اختياري)",
                        placeholder: "المستوى",
                      },
                      nationality: {
                        label: "الجنسية",
                        placeholder: "اختر الجنسية",
                      },
                      employment: { heading: "بيانات التوظيف" },
                      passport: {
                        label: "جواز السفر",
                        placeholder: "رقم الجواز",
                      },
                      personal: {
                        heading: "البيانات الشخصية",
                        workEmail: "البريد الإلكتروني للعمل",
                      },
                      phone: {
                        error: "يجب أن يتضمن رقم الهاتف رمز الدولة وأرقام فقط",
                        hint: "يجب أن يتضمن رقم الهاتف رمز الدولة",
                        label: "رقم الهاتف",
                        placeholder: "أدخل رقم الهاتف",
                      },
                      startDate: {
                        hint: "لحساب مكافأة نهاية الخدمة المستحقة لهم",
                        label: "بداية العمل",
                        required: "بداية العمل - مطلوب ",
                      },
                      workPermitExpiryDate: {
                        label: "تاريخ انتهاء تصريح العمل (اختياري)",
                      },
                      workPermitNumber: {
                        hint: "",
                        label: "رقم تصريح العمل (اختياري)",
                        placeholder: "xxxxxxxx",
                      },
                    },
                    employeeStatus: {
                      contract: "عقد",
                      temporary: "مؤقت",
                      permenant: "دائم",
                    },
                    list: {
                      grid: {
                        employeeStatus: {
                          active: "نشط",
                          inactive: "غير نشط",
                          invited: "مدعو",
                          notInvited: "غير مدعو",
                        },
                        skilledType: "ماهر",
                        unskilledType: "غير ماهر",
                        name: "الاسم",
                        title: "العنوان",
                        department: "القسم",
                        level: "المستوى",
                        benefits: "المزايا",
                        status: "الحالة",
                        skill: "Skill",
                        type: "النوع",
                        salaryRange: "نطاق الراتب",
                        report: "تقرير الموظفين",
                      },
                      headline: "الموظفون",
                      importInProgress:
                        "نحن نقوم باستيراد الموظفين الذين قمت بتحميلهم. تحقق مرة أخرى خلال بضع دقائق لرؤيتهم هنا",
                      updateInProgress:
                        "نحن نقوم بتحديث الموظفين. تحقق مرة أخرى خلال بضع دقائق لرؤية التحديثات",
                      updateEmployees: "تحديث الموظفين",
                      mohreSync: "تزامن الموظفين مع وزارة العمل",
                      addEmployees: "إضافة الموظفين",
                      noRecords: {
                        noRecordsTitle: "لم يتم إضافة موظفين بعد.",
                        noRecordsContent:
                          "قم بدعوة الموظفين وابدأ في إعداد المزايا المصممة خصيصًا لهم.",
                      },
                    },
                    gender: { male: "ذكر", female: "انثى" },
                  },
                },
                page: {
                  exportAllEmployeesDialog: {
                    title: "تحديث بيانات الموظفين",
                    step1: {
                      number: "١",
                      title: "تصدير جميع الموظفين",
                      action: "تصدير",
                    },
                    step2: {
                      number: "٢",
                      title: "ملء البيانات المفقودة",
                      description:
                        "في الملف المصدر، قم بتحديث و/أو ملء البيانات المفقودة.",
                    },
                    step3: {
                      number: "٣",
                      title: "حفظ واستيراد",
                      description: "احفظ الملف وأعد استيراده هنا.",
                    },
                  },
                  importCsvFile: "استيراد الملف",
                  employeeStatus: {
                    contract: "عقد",
                    temporary: "مؤقت",
                    permenant: "دائم",
                  },
                  form: {
                    fullSalary: {
                      required: "الراتب الشهري مطلوب",
                      error: "يجب أن يكون الراتب رقمًا",
                      label: "الراتب الشهري",
                      hint: "التعويض الكلي في نهاية الشهر بما في ذلك المخصصات",
                      placeholder: "الراتب الشهري بالدرهم الإماراتي",
                    },
                    labourId: {
                      error: "يجب أن يكون الرقم التعريفي لوزارة العمل - رقماً",
                      label: "البطاقة التعريفية لوزارة العمل ",
                      hint: "هذا هو الرقم التعريفي للموظف المكون من 14 رقماً على البطاقة التعريفية لوزارة العمل",
                      placeholder: "xxxxxxxxxxxxxx",
                    },
                    employment: { heading: "تفاصيل التوظيف" },
                    workEmail: {
                      label: "البريد الإلكتروني للعمل",
                      placeholder: "البريد الإلكتروني للعمل",
                    },
                    employmentStatus: {
                      label: "حالة التوظيف",
                      placeholder: "حدد حالة التوظيف",
                    },
                    workPermitExpiryDate: {
                      label: "تاريخ انتهاء تصريح العمل (اختياري)",
                    },
                    employeeIdNumber: {
                      label: "رقم هوية الموظف (اختياري)",
                      hint: "",
                      placeholder: "رقم الموظف",
                    },
                    jobTitle: {
                      label: "المسمى الوظيفي",
                      hint: "هذا يسهل عليك ترتيب وفلترة الموظفين لاحقا.",
                      placeholder: "المسمى الوظيفي",
                    },
                    department: {
                      label: "القسم",
                      hint: "",
                      placeholder: "القسم",
                    },
                    level: {
                      label: "المستوى",
                      hint: "",
                      placeholder: "المستوى",
                    },
                    branch: {
                      label: "المدينة / الفرع (اختياري)",
                      hint: "",
                      placeholder: "المدينة/الفرع",
                    },
                    iban: {
                      label: "رقم الحساب المصرفي الدولي IBAN",
                      hint: "هذا هو حساب راتب الموظف الذي يتم من خلاله تحويل مدفوعات نهاية الخدمة",
                      placeholder: "AE07 0331 2345 6789 0123 456",
                    },
                    contact: { heading: "تفاصيل الاتصال" },
                    personal: { heading: "تفاصيل شخصية" },
                    addressLine1: {
                      label: "العنوان",
                      placeholder: "أدخل العنوان",
                    },
                    addressLine2: {
                      label: "العنوان - السطر الثاني",
                      placeholder: "أدخل العنوان - السطر الثاني",
                    },
                    city: {
                      label: "المدينة / البلدة",
                      placeholder: "أدخل اسم المدينة / البلدة",
                    },
                    state: {
                      label: "الولاية / المقاطعة / الإقليم",
                      placeholder: "أدخل الولاية / المقاطعة / الإقليم",
                    },
                    postalCode: {
                      label: "الرمز البريدي",
                      placeholder: "أدخل الرمز البريدي",
                    },
                    country: { label: "الدولة", placeholder: "اختر الدولة" },
                    phone: {
                      error: "يجب أن يتضمن رقم الهاتف رمز الدولة وأرقام فقط",
                      label: "رقم الهاتف",
                      hint: "يجب أن يتضمن رقم الهاتف رمز الدولة",
                      placeholder: "أدخل رقم الهاتف",
                    },
                    email: {
                      label: "البريد الإلكتروني للعمل",
                      hint: "هذا هو عنوان البريد الإلكتروني الذي سيتلقى الموظفون من خلاله الدعوة للوصول إلى التطبيق",
                      placeholder: "البريد الإلكتروني للعمل",
                    },
                    address: { label: "العنوان", placeholder: "أدخل العنوان" },
                    startDate: {
                      required: "بداية العمل - مطلوب ",
                      label: "بداية العمل",
                      hint: "لحساب مكافأة نهاية الخدمة المستحقة لهم",
                    },
                    basicSalary: {
                      required: "الراتب الأساسي مطلوب",
                      error: "يجب أن يكون الراتب الأساسي رقمًا",
                      label: "الراتب الأساسي الشهري",
                      hint: "الراتب الأساسي الذي يتم احتساب مكافأة نهاية الخدمة عليه",
                      placeholder: "الراتب الأساسي الشهري بالدرهم الإماراتي",
                    },
                    endDate: {
                      label: "نهاية العمل",
                      hint: "نستخدم هذا لبدء عملية الإنهاء",
                    },
                    workPermitNumber: {
                      label: "رقم تصريح العمل",
                      hint: "",
                      placeholder: "xxxxxxxx",
                    },
                    employerID: { label: "معرف صاحب العمل" },
                    nationalId: {
                      placeholder: "xxx-xxxx-xxxxxxx-x",
                      label: "بطاقة الهوية الإماراتية",
                    },
                    firstName: {
                      required: "الاسم الأول مطلوب",
                      label: "الاسم الأول",
                      hint: "يجب أن يتطابق مع البطاقة التعريفية الحكومية الخاصه بهم ",
                      placeholder: "الاسم الأول",
                    },
                    lastName: {
                      required: "الاسم الأخير مطلوب",
                      label: "الاسم الأخير",
                      hint: "يشمل جميع الأسماء الوسطى والأخيرة",
                      placeholder: "الاسم الأخير",
                    },
                    gender: { label: "الجنس", placeholder: "اختر الجنس" },
                    dateOfBirth: {
                      label: "تاريخ الولادة",
                      lessThan15Years: "يجب أن يكون الموظف على الأقل 15 سنة",
                    },
                    nationality: {
                      label: "الجنسية",
                      placeholder: "اختر الجنسية",
                      required: "الجنسية مطلوبة",
                    },
                    passport: {
                      label: "جواز السفر",
                      placeholder: "رقم الجواز",
                    },
                    relationship: {
                      label: "صلة القرابة بالموظف",
                      placeholder: "اختر صلة القرابة",
                      description: "اختر صلة القرابة بين المُرشح والموظف",
                    },
                    percentAllocated: {
                      label: "النسبة المئوية المخصصة",
                      placeholder: "أدخل النسبة المئوية المخصصة",
                      description: "أدخل النسبة المئوية المخصصة للمُرشح",
                    },
                  },
                  changesMayAffectBenefits: {
                    title: "قد تؤثر التغييرات على مزايا الموظف",
                    description:
                      "قد يؤثر تغيير تفاصيل العمل على نظام المكافآت الذي ينتمي إليه الموظف، حيث قد يناسب معايير نظام مكافآت مختلف.",
                  },
                  confirmEndDateChange: {
                    title: "تأكيد تغيير تاريخ الانتهاء",
                    description:
                      "سيؤثر تغيير تاريخ انتهاء هذا الموظف على حساب مستحقاته وأهليته. الموظفون الذين خدموا أقل من عام لن يحصلوا على مكافأة نهاية الخدمة.",
                    confirmButtonText: "تأكيد التغيير",
                  },
                  benefitsChange: {
                    addedAndRemoved: {
                      title:
                        "تمت الإضافة إلى المزايا الجديدة، تم الحذف من المزايا القديمة",
                      description: "سيتم تحديث مزايا هذا الموظف",
                      added: "تمت الإضافة إلى المزايا الجديدة",
                      removed: "تم الحذف من المزايا",
                    },
                    addedOnly: {
                      title: "تمت الإضافة إلى المزايا الجديدة",
                      description: "سيتم إضافة هذا الموظف إلى المزايا التالية",
                    },
                    removedOnly: {
                      title: "الحذف من المزايا",
                      description: "سيتم حذف هذا الموظف من المزايا التالية",
                    },
                    noChange: {
                      title: "لا تغيير في المزايا",
                      description: "لا يزال الموظف تابعاً للمزايا الحالية",
                    },
                  },
                  navigation: {
                    personalDetails: "التفاصيل الشخصية",
                    benefits: "المزايا",
                    products: "المنتجات",
                    employmentDetails: "تفاصيل التوظيف",
                    beneficiaries: "المستفيدون",
                  },
                  headline: "الموظفون / تفاصيل الموظف",
                  list: {
                    exportAllEmployees: "تعديل بيانات الموظفين",
                    grid: {
                      employeeStatus: {
                        active: "نشط",
                        inactive: "غير نشط",
                        invited: "مدعو",
                        notInvited: "غير مدعو",
                      },
                      skilledType: "ماهر",
                      unskilledType: "غير ماهر",
                    },
                  },
                  gender: { male: "ذكر", female: "انثى" },
                  benefitStatus: { active: "نشط", inactive: "غير نشط" },
                  error: "فشل في تعديل معلومات الموظف",
                  success: "تم تعديل بيانات الموظف بنجاح",
                },
              },
              page: {
                mohreImport: {
                  heading: "يتم حالياً استيراد بيانات موظفيك.",
                  description:
                    "قد يستغرق هذا بضع دقائق حسب عدد الموظفين في الشركة. يرجى المراجعة مرة أخرى قريباً.",
                  syncingAlert:
                    "يتم مزامنة موظفيك. قد يستغرق هذا بضع دقائق حسب عدد الموظفين في الشركة.",
                },
                list: {
                  editEmployees: "تعديل بيانات الموظفين",
                  manageEmployees: "إدارة الموظفين",
                  updateEmployeeDetails: "تحديث تفاصيل الموظفين",
                  dataEditorBannerText:
                    "سيتم تخطي الصفوف التي تحتوي على أخطاء ولن يتم إنشاؤها.",
                  sendInvitation: "إرسال الدعوات",
                  inviteEmployee: {
                    invitedEmployee: "الموظف مدعو",
                    invitedEmployees:
                      "تمت دعوة الموظفين الذين لديهم بريد إلكتروني خاص بالعمل فقط",
                  },
                  department: "القسم",
                  level: "المستوى",
                  minSalary: "الحد الأدنى للراتب",
                  maxSalary: "الحد الأقصى للراتب",
                  status: "الحالة",
                  product: "المنتج",
                  noProduct: "بدون منتج",
                  active: "نشط",
                  notStarted: "لم يبدأ",
                  former: "سابق",
                  invited: "تمت الدعوة",
                  notInvited: "لم تتم الدعوة",
                  exportAllEmployeesDialog: {
                    title: "تحديث بيانات الموظفين",
                    step1: {
                      number: "١",
                      title: "تصدير جميع الموظفين",
                      action: "تصدير",
                    },
                    step2: {
                      number: "٢",
                      title: "ملء البيانات المفقودة",
                      description:
                        "في الملف المصدر، قم بتحديث و/أو ملء البيانات المفقودة.",
                    },
                    step3: {
                      number: "٣",
                      title: "حفظ واستيراد",
                      description: "احفظ الملف وأعد استيراده هنا.",
                    },
                  },
                  importInProgress:
                    "نحن نقوم باستيراد الموظفين الذين قمت بتحميلهم. تحقق مرة أخرى خلال بضع دقائق لرؤيتهم هنا",
                  employeesUploaded: "تم رفع جميع الموظفين",
                  invitationSent: "تم إرسال الدعوة",
                  invitationsSent: "تم إرسال الدعوات",
                  skilledType: "ماهر",
                  unskilledType: "غير ماهر",
                  table: {
                    status: "الحالة",
                    skill: "المهارة",
                    name: "الاسم",
                    title: "الوظيفة",
                    department: "القسم",
                    level: "المستوى",
                    dateJoined: "تاريخ الانضمام",
                    tenure: "مدة الخدمة",
                    benefits: "المزايا",
                    products: "المنتجات",
                    noneAssigned: "لا يوجد منتج مخصص",
                    type: "النوع",
                    invite: "دعوة",
                    syncEmployeesWithMohre:
                      "مزامنة الموظفين مع وزارة الموارد البشرية",
                    mohreSyncStarted:
                      "تم بدء المزامنة مع وزارة الموارد البشرية. قد يستغرق هذا بعض الوقت.",
                    emptyState: {
                      noItems: {
                        title: "لا يوجد موظفون متاحون",
                        text: "أضف موظفين لتظهر هنا.",
                      },
                      filtersApplied: {
                        title: "لا يوجد موظفون يطابقون فلاترك",
                        text: "قم بتعديل الفلاتر أو مسحها لرؤية الموظفين المتاحين.",
                      },
                    },
                  },
                },
                bulkBenefitsChange: {
                  addedAndRemoved: {
                    title:
                      "تمت الإضافة إلى المزايا الجديدة، تم الحذف من المزايا القديمة",
                    description: "سيتم تحديث مزايا هذا الموظف (الموظفين)",
                    added: ({ employeesCount, benefitsCount }) =>
                      `${employeesCount.toLocaleString(L, {})} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `موظف` })[P.select(employeesCount)] ?? `موظفين`} تم اضافتهم إلي ${benefitsCount.toLocaleString(L, {})} نظم مزايا`,
                    removed: ({ employeesCount, benefitsCount }) =>
                      `${employeesCount.toLocaleString(L, {})} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `موظف` })[P.select(employeesCount)] ?? `موظفين`} تم حذفهم من ${benefitsCount.toLocaleString(L, {})} نظم مزايا`,
                  },
                  addedOnly: {
                    title: "تمت الإضافة إلى المزايا ",
                    description: "سيتم إضافة الموظف (الموظفين) إلى المزايا",
                    added: ({ employeesCount, benefitsCount }) =>
                      `${employeesCount.toLocaleString(L, {})} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `موظف` })[P.select(employeesCount)] ?? `موظفين`} تم اضافتهم إلي ${benefitsCount.toLocaleString(L, {})} نظم مزايا`,
                  },
                  removedOnly: {
                    title: "الحذف من المزايا",
                    description: "سيتم حذف الموظف (الموظفين) من المزايا",
                    removed: ({ employeesCount, benefitsCount }) =>
                      `${employeesCount.toLocaleString(L, {})} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `موظف` })[P.select(employeesCount)] ?? `موظفين`} تم حذفهم من ${benefitsCount.toLocaleString(L, {})} نظم مزايا`,
                  },
                  noChange: {
                    title: "لا تغيير في المزايا",
                    description:
                      "الموظف (الموظفون) لا يزالوا تابعين للمزايا الحالية",
                    current: ({ employeesCount, benefitsCount }) =>
                      `${employeesCount.toLocaleString(L, {})} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `موظف` })[P.select(employeesCount)] ?? `موظفين`} لا يزال في ${benefitsCount.toLocaleString(L, {})} نظم مزايا`,
                  },
                },
                tour: {
                  manageEmployees: {
                    title: "إدارة موظفيك",
                    description:
                      "تحتاج إلى تحديث بيانات الموظفين؟ قم بتصدير قائمة الموظفين كملف CSV، وأجر التغييرات، ثم أعد استيرادها لمزامنة جميع التحديثات دفعة واحدة.",
                  },
                },
              },
              export: {
                headers: {
                  id: "المعرف",
                  nationalId: "رقم الهوية الإماراتية",
                  firstName: "الاسم الأول",
                  lastName: "اسم العائلة",
                  gender: "الجنس",
                  dateOfBirth: "تاريخ الميلاد",
                  phoneNumber: "رقم الهاتف",
                  address: "العنوان",
                  nationality: "الجنسية",
                  employmentStatus: "حالة التوظيف",
                  department: "القسم",
                  level: "المستوى",
                  branch: "الفرع",
                  jobTitle: "المسمى الوظيفي",
                  passportNumber: "رقم جواز السفر",
                  iban: "رقم الحساب البنكي الدولي",
                  workEmail: "البريد الإلكتروني للعمل",
                  startDate: "تاريخ البدء",
                  endDate: "تاريخ الانتهاء",
                  contribution: "المساهمة",
                  baseSalary: "الراتب الأساسي",
                  fullSalary: "الراتب الكامل",
                },
              },
            },
            activity: {
              header: "سجل النشاط",
              columns: { date: "التاريخ", type: "النوع", description: "الوصف" },
              types: {
                company: "الشركة",
                employees: "الموظفون",
                verifications: "التحققات",
              },
              actions: {
                viewEmployee: "عرض الموظف",
                viewEmployees: "عرض الموظفين",
                viewVerificationDocuments: "عرض وثائق التحقق",
                viewCompanyInformation: "عرض معلومات الشركة",
                viewCompanyAdmins: "عرض مشرفين الشركة",
                viewUsers: "عرض المستخدمين",
              },
              emptyState: {
                title: "لا توجد سجلات نشاط",
                text: "ستظهر سجلات النشاط هنا عند اتخاذ الإجراءات.",
              },
            },
            payments: {
              page: {
                companyPayments: {
                  list: { heading: "المدفوعات" },
                  noRecords: {
                    noRecordsTitle: "لا توجد دفعات للعرض حالياً.",
                    noRecordsContent: "ستظهر دفعاتك المستقبلية هنا.",
                  },
                },
                grid: {
                  id: "البطاقة التعريفية ",
                  type: "النوع",
                  benefitName: "اسم المزايا",
                  amount: "المبلغ",
                  issueDate: "تاريخ الإصدار",
                  dueDate: "تاريخ الاستحقاق",
                  status: "الحالة",
                  report: "تقرير المدفوعات",
                  downloadReport: "تحميل التقرير",
                  inProgress: "قيد التقدم",
                  pastActivity: "النشاط السابق",
                  referenceNumber: "مرجع الدفع",
                  sender: "المرسل",
                  recipient: "المستلم",
                },
                status: {
                  overdue: "متأخر",
                  paid: "تم الاستثمار",
                  paymentMade: "تم معالجة الدفع",
                  rejected: "مرفوض",
                  pending: "قيد الانتظار",
                  approved: "معتمد",
                },
                zipExport: {
                  downloadZip: "تحميل كملف مضغوط",
                  invoices: "الفواتير",
                  receipts: "الإيصالات",
                  invoicesAsZip: "الفواتير كملف .zip",
                  receiptsAsZip: "الإيصالات كملف .zip",
                  selectedCount: (count) => `${count} محدد`,
                  started: "جارٍ تحضير الملف المضغوط...",
                  complete: "الملف المضغوط جاهز",
                  failed: "فشل في إنشاء الملف المضغوط",
                },
              },
            },
            requests: {
              page: {
                companyEmployeeSubscriptionRequests: {
                  list: {
                    approveSubscriptions: "الموافقة على الاشتراكات",
                    approveOnlySelectedDescription:
                      "هل أنت متأكد من أنك تريد الموافقة على جميع الاشتراكات المحددة؟ لا يمكنك التراجع عن هذا الإجراء بعد ذلك.",
                    approveAllDescription:
                      "هل أنت متأكد من أنك تريد الموافقة على جميع الاشتراكات؟ لا يمكنك التراجع عن هذا الإجراء بعد ذلك.",
                    approvedSingle: "تمت الموافقة على الطلب",
                    approvedMultiple: "تمت الموافقة على الطلبات",
                    status: { pending: "قيد الانتظار", approved: "موافق عليه" },
                    type: {
                      voluntary: "الاشتراك الطوعي",
                      oneTimePayment: "دفعة لمرة واحدة",
                    },
                    heading: "الطلبات",
                    grid: {
                      id: "المعرف",
                      employee: "الموظف",
                      company: "الشركة",
                      amount: "المبلغ",
                      dateAdded: "تاريخ الإضافة",
                      status: "الحالة",
                      report: "تقرير طلبات الشركة",
                      pending: "قيد التنفيذ",
                      completed: "مكتمل",
                      type: "النوع",
                    },
                    generate: "تصدير CSV",
                    approveSelected: "الموافقة على المحدد",
                  },
                },
                list: {
                  grid: {
                    noRecords: {
                      noRecordsTitle: "لا يوجد شيء للمراجعة حالياً.",
                      noRecordsContent:
                        "ستظهر هنا مستندات التحقق التي تم تقديمها أو إعادة تقديمها.",
                    },
                  },
                },
              },
            },
            products: {
              page: {
                title: "المنتجات",
                noResults: {
                  title: "لم يتم العثور على نتائج",
                  description: "لا توجد منتجات تطابق بحثك عن ",
                  noProducts: "لا توجد أي منتجات تم إعدادها ضمن هذه الفئة بعد.",
                },
                netContributions: "المساهمات الصافية",
                activeParticipants: "المشاركون النشطون",
                employees: "الموظفون",
                emptyTitle: "لم يتم إنشاء أي منتجات بعد.",
                emptySubtitle: "إنشاء وتكوين منتج جديد وتعيينه للموظفين.",
                createProduct: "إنشاء منتج جديد",
              },
              create: {
                page: {
                  title: "منتج جديد",
                  existingSchemes: "النظم الموجودة",
                  netContributions: "المساهمات الصافية",
                },
              },
              productInstanceId: {
                page: {
                  title: "إعداد المنتج",
                  backToProducts: "العودة إلى المنتجات",
                  errors: {
                    productInstanceNotFound: "لم يتم العثور على مثيل المنتج",
                  },
                  sidebar: { title: "إعداد المنتج" },
                  steps: {
                    details: {
                      title: "تفاصيل المنتج",
                      editProductDetails: "تعديل تفاصيل المنتج",
                      productNameDescription:
                        "فقط أنت وفريقك سيتمكنون من رؤية اسم هذا المنتج.",
                      productNameTitle: "اسم المنتج",
                      productNamePlaceholder: "أدخل اسم المنتج",
                      productNameRequired:
                        "يجب أن يكون لديك اسم للمنتج ويجب أن يحتوي على على الأقل 1 حرف",
                      productType: "نوع المنتج",
                      activateProduct: "تفعيل المنتج",
                      activateProductDescription:
                        "بمجرد التفعيل، يمكنك تعيين الموظفين لهذا المنتج فوراً.",
                      nextStep: "الخطوة التالية",
                      productStatus: "حالة المنتج",
                    },
                    configurations: {
                      title: "الإعدادات والتفاصيل",
                      noAttributes:
                        "لم يتم تكوين خصائص مخصصة لهذا النوع من المنتجات.",
                      validation: {
                        scheduleRequired: "إعداد الجدول الزمني مطلوب",
                        fundRequired: "اختيار الصندوق مطلوب",
                        invalidEmail: "صيغة البريد الإلكتروني غير صالحة",
                        fieldRequired: (field) => `${field} مطلوب`,
                        mustBePositive: (field) =>
                          `${field} يجب أن يكون موجباً`,
                        minValue: ({ field, min }) =>
                          `${field} يجب أن يكون على الأقل ${min}`,
                        maxValue: ({ field, max }) =>
                          `${field} يجب ألا يتجاوز ${max}`,
                      },
                    },
                    employees: {
                      title: "الموظفون المعينون",
                      description: "أضف الموظفين إلى هذا النظام",
                      doItLater: "سأفعل ذلك لاحقاً",
                      uaePensionInformation: {
                        title: "معلومات مهمة",
                        message:
                          "تُعد المساهمة الأساسية لمكافأة نهاية الخدمة منفصلة عن نظام المعاشات التقاعدية الإلزامي في دولة الإمارات العربية المتحدة. إن تعيين مواطن إماراتي في ميزة مكافأة نهاية الخدمة لا يحل محل التزامات صاحب العمل بموجب نظام المعاشات التقاعدية الإماراتي ولا يؤثر فيها.",
                        acknowledge: "حسناً",
                      },
                      grid: {
                        firstName: "الاسم الأول",
                        lastName: "اسم العائلة",
                        name: "الاسم",
                        email: "البريد الإلكتروني",
                        title: "المسمى الوظيفي",
                        department: "القسم",
                        level: "المستوى",
                        pending: "قيد الانتظار",
                        passportNumber: "رقم جواز السفر",
                        dateOfBirth: "تاريخ الميلاد",
                        gender: "الجنس",
                        nationality: "الجنسية",
                        arabicName: "الاسم بالعربية",
                        unifiedNumber: "الرقم الموحد",
                        basicSalary: "الراتب الأساسي",
                        fullSalary: "الراتب الكامل",
                        dateJoined: "تاريخ الانضمام",
                        tenure: "مدة الخدمة",
                        tenureMonthsOnly: (months) =>
                          `${months} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `شهر` })[P.select(months)] ?? `أشهر`}`,
                        tenureYearsOnly: (years) =>
                          `${years} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `سنة` })[P.select(years)] ?? `سنوات`}`,
                        tenureYearsAndMonths: ({ years, months }) =>
                          `${years} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `سنة` })[P.select(years)] ?? `سنوات`} و${months} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `شهر` })[P.select(months)] ?? `أشهر`}`,
                        missing: "مفقود",
                        tabUnassigned: "غير معين",
                        tabErrors: "أخطاء",
                        tabAssigned: "معين",
                        actionAssign: "تعيين",
                        actionUnassign: "إلغاء التعيين",
                        actionBulkAssign: "تعيين",
                        emptyUnassigned:
                          "لم يتم العثور على موظفين نشطين يمكن تعيينهم لهذا المنتج. إذا كنت ترغب في تعيين موظفين لهذا المنتج، يرجى التأكد من تحميلهم أولاً.",
                        emptyAssigned:
                          "لا يوجد موظفون معينون حالياً لهذا المنتج.",
                        emptyError: "لا يوجد موظفون بمعلومات ناقصة.",
                        missingDetailsWarning:
                          "بعض الموظفين لديهم تفاصيل مفقودة. تأكد من ملء جميع التفاصيل للمتابعة في تعيينهم لهذا المنتج.",
                        toastAssignmentInProgress:
                          "جاري التعيين. تحقق مرة أخرى خلال بضع دقائق.",
                        toastCannotAssign: (count) =>
                          `لا يمكن تعيين ${count} موظف(ين) - حقول مطلوبة مفقودة`,
                        toastMovedToErrors: (count) =>
                          `تم نقل ${count} موظف(ين) إلى علامة التبويب الأخطاء - حقول مطلوبة مفقودة`,
                        toastErrorAssigning: "خطأ في تعيين الموظفين",
                        toastErrorUnassigning: "خطأ في إلغاء تعيين الموظفين",
                        toastNoProductInstance: "خطأ: لا يوجد مثيل منتج",
                        filterNoBenefits: "لا توجد مزايا متاحة للتصفية",
                        filterButton: "تصفية",
                      },
                    },
                    confirm: { title: "تأكيد جميع التفاصيل" },
                  },
                },
              },
            },
            verification: {
              page: {
                verification: {
                  processing: {
                    heading: "معالجة عملية التحقق",
                    description:
                      "شكراً لتقديمك المعلومات المطلوبة حول شركتك للتحقق. نعمل حالياً على مراجعة التفاصيل، وسنقوم بإخطارك بمجرد اكتمال عملية التسجيل.",
                  },
                  description:
                    "ملاحظة: قد يتم طلب مستندات إضافية للتحقق من شركتك.",
                  form: {
                    industry: {
                      label: "القطاع",
                      placeholder: "اختر القطاع",
                      industries: {
                        accounting: "المحاسبة",
                        airlinesAviation: "الخطوط الجوية/الطيران",
                        alternativeDisputeResolution: "حل النزاعات البديل",
                        alternativeMedicine: "الطب البديل",
                        animation: "الرسوم المتحركة",
                        apparelAndFashion: "الملابس والأزياء",
                        architectureAndPlanning: "الهندسة المعمارية والتخطيط",
                        artsAndCrafts: "الفنون والحرف اليدوية",
                        automotive: "السيارات",
                        aviationAndAerospace: "الطيران والفضاء",
                        banking: "الخدمات المصرفية",
                        biotechnology: "التكنولوجيا الحيوية",
                        broadcastMedia: "وسائل البث",
                        buildingMaterials: "مواد البناء",
                        businessSuppliesAndEquipment: "مستلزمات ومعدات الأعمال",
                        capitalMarkets: "أسواق المال",
                        chemicals: "الكيماويات",
                        civicAndSocialOrganization:
                          "المنظمة المدنية والاجتماعية",
                        civilEngineering: "الهندسة المدنية",
                        commercialRealEstate: "العقارات التجارية",
                        computerAndNetworkSecurity: "أمن الكمبيوتر والشبكات",
                        computerGames: "ألعاب الكمبيوتر",
                        computerHardware: "أجهزة الكمبيوتر",
                        computerNetworking: "الشبكات الحاسوبية",
                        computerSoftware: "برمجيات الكمبيوتر",
                        construction: "البناء",
                        consulting: "الاستشارات",
                        consumerElectronics: "الإلكترونيات الاستهلاكية",
                        consumerGoods: "السلع الاستهلاكية",
                        consumerServices: "خدمات المستهلك",
                        cosmetics: "مستحضرات التجميل",
                        dairy: "منتجات الألبان",
                        defenseAndSpace: "الدفاع والفضاء",
                        design: "تصميم",
                        educationManagement: "إدارة التعليم",
                        eLearning: "التعلم الإلكتروني",
                        electricalAndElectronicManufacturing:
                          "التصنيع الكهربائي والإلكتروني",
                        entertainment: "الترفيه",
                        environmentalServices: "الخدمات البيئية",
                        eventsServices: "خدمات الأحداث",
                        executiveOffice: "المكتب التنفيذي",
                        facilitiesServices: "خدمات المرافق",
                        farming: "الزراعة",
                        financialServices: "الخدمات المالية",
                        fineArt: "الفن الجميل",
                        fishery: "صيد الأسماك",
                        foodAndBeverages: "الطعام والمشروبات",
                        foodProduction: "إنتاج الطعام",
                        fundraising: "جمع التبرعات",
                        furniture: "الأثاث",
                        gamblingAndCasinos: "القمار والكازينوهات",
                        glassCeramicsAndConcrete: "الزجاج والسيراميك والخرسانة",
                        governmentAdministration: "إدارة الحكومة",
                        governmentRelations: "العلاقات الحكومية",
                        graphicDesign: "التصميم الجرافيكي",
                        healthWellnessAndFitness:
                          "الصحة والعافية واللياقة البدنية",
                        higherEducation: "التعليم العالي",
                        hospitalAndHealthCare: "المستشفى والرعاية اصحية",
                        hospitality: "لضيفة",
                        humanResources: "الموارد البشرية",
                        importAndExport: "استيراد وتصدير",
                        individualAndFamilyServices: "الخدمات الفردية والأسرية",
                        industrialAutomation: "الأتمتة الصناعية",
                        informationServices: "خدمات المعلومات",
                        informationTechnologyAndServices:
                          "تكنولوجيا المعلومات والخدمات",
                        insurance: "التأمين",
                        internationalAffairs: "الشؤون الدولية",
                        internationalTradeAndDevelopment:
                          "التجارة الدولية والتنمية",
                        internet: "الإنترنت",
                        investmentBankingVenture:
                          "الاستثمار المصرفي / المغامرة",
                        investmentManagement: "إدارة الاستثمار",
                        judiciary: "القضاء",
                        lawEnforcement: "إنفاذ القانون",
                        lawPractice: "ممارسة القانون",
                        legalServices: "الخدمات القانونية",
                        legislativeOffice: "مكتب التشريع",
                        leisureAndTravel: "الترفيه والسفر",
                        libraries: "المكتبات",
                        logisticsAndSupplyChain:
                          "الخدمات اللوجستية وسلسلة التوريد",
                        luxuryGoodsAndJewelry: "السلع الفاخرة والمجوهرات",
                        machinery: "الآلات",
                        managementConsulting: "الاستشارات الإدارية",
                        maritime: "بحري",
                        marketingAndAdvertising: "التسويق والإعلان",
                        marketResearch: "البحث السوقي",
                        mechanicalOrIndustrialEngineering:
                          "الهندسة الميكانيكية أو الصناعية",
                        mediaProduction: "إنتاج الوسائط",
                        medicalDevice: "جهاز طبي",
                        medicalPractice: "ممارسة طبية",
                        mentalHealthCare: "رعاية الصحة العقلية",
                        military: "العسكرية",
                        miningAndMetals: "التعدين والمعادن",
                        motionPicturesAndFilm: "الأفلام والسينما",
                        museumsAndInstitutions: "المتاحف والمؤسسات",
                        music: "موسيقى",
                        nanotechnology: "النانوتكنولوجيا",
                        newspapers: "صحف",
                        nonprofitOrganizationManagement:
                          "إدارة المنظمات غير الربحية",
                        oilAndEnergy: "النفط والطاقة",
                        onlinePublishing: "النشر عبر الإنترنت",
                        outsourcingOffshoring: "التعهيد / التصدير",
                        packageFreightDelivery: "توصيل الطرود / الشحنات",
                        packagingAndContainers: "التغليف والحاويات",
                        paperAndForestProducts: "الورق ومنتجات الغابات",
                        performingArts: "الفنون الأدائية",
                        pharmaceuticals: "الأدوية",
                        philanthropy: "العمل الخيري",
                        photography: "تصوير",
                        plastics: "البلاستيك",
                        politicalOrganization: "المنظمة السياية",
                        primarySecondary: "ابتدائي/ثانوي",
                        printing: "طباعة",
                        professionalTraining: "التدريب المهني",
                        programDevelopment: "تطوير البرامج",
                        publicPolicy: "السياسة العامة",
                        publicRelations: "العلاقات العامة",
                        publicSafety: "السلامة العامة",
                        publishing: "النشر",
                        railroadManufacture: "صناعة السكك الحديدية",
                        ranching: "تربية الماشية",
                        realEstate: "العقارات",
                        recreational: "ترفيهي",
                        facilitiesAndServices: "المرافق والخدمات",
                        religiousInstitutions: "المؤسسات الدينية",
                        renewablesAndEnvironment: "الطاقة المتجددة والبيئة",
                        research: "بحث",
                        restaurants: "مطاعم",
                        retail: "التجزئة",
                        securityAndInvestigations: "الأمن والتحقيقات",
                        semiconductors: "الشبه موصلات",
                        shipbuilding: "بناء السفن",
                        sportingGoods: "معدات رياضية",
                        sports: "رياضة",
                        staffingAndRecruiting: "التوظيف والتجنيد",
                        supermarkets: "السوبرماركت",
                        telecommunications: "الاتصالات",
                        textiles: "المنسوجات",
                        thinkTanks: "مراكز الأبحاث",
                        tobacco: "التبغ",
                        translationAndLocalization: "الترجمة والتوطين",
                        transportationTruckingRailroad:
                          "النقل / الشاحنات / السكك الحديدية",
                        utilities: "الخدمات",
                        ventureCapital: "رأس المال الاستثماري",
                        veterinary: "بيطري",
                        warehousing: "التخزين",
                        wholesale: "البيع بالجملة",
                        wineAndSpirits: "النبيذ والمشروبات الروحية",
                        wireless: "لاسلكي",
                        writingAndEditing: "الكتابة والتحرير",
                      },
                      required: "الرجاء اختيار القطاع",
                    },
                    articlesOfAssociation: {
                      label: "عقد التأسيس",
                      hint: "يجب أن يتضمن العقد  توقيعات المالكين المستفيدين النهائيين (UBOs) وتفاصيلهم.",
                    },
                  },
                  requiresResubmission: "يتطلب إعادة التقديم",
                  fileType: " JPG ،PDF أو DOCS (بحد أقصى 5 ميغابايت)",
                  formHeading: {
                    documentsRequired: "تحميل المستندات",
                    documentsInReview: "المستندات المرفوعة",
                    documentsRetry: "مستندات إضافية مطلوبة",
                  },
                },
                detailsApprovalModal: {
                  companyAndOwnership: {
                    defaultOptions: [
                      "الرخصة التجارية سارية المفعول",
                      "النظام الأساسي",
                      "عقد التأسيس",
                      "الهيكل التنظيمي (التوقيع و التاريخ)",
                      "سجل المديرين",
                      "سجل الأعضاء",
                      "آخر تدقيق مالي",
                      "تسجيل الأعمال",
                      "إثبات عنوان التشغيل في الإمارات العربية المتحدة",
                    ],
                  },
                },
                documentsUpload: {
                  upload: {
                    successMessage: "تم تحميل الوثيقة",
                    removeMessage: "تمت إزالة المستند",
                  },
                },
                verificationStatusCard: { heading: "حالة التحقق" },
              },
            },
            benefitPayments: {
              benefitPaymentId: {
                page: {
                  companyPayments: {
                    id: {
                      grid: {
                        name: "اسم الموظف",
                        benefit: "المزايا",
                        fromCompany: "من الشركة",
                        fromEmployee: "من الموظف",
                        finalSalary: "الراتب النهائي",
                        total: "المبلغ المستحق",
                      },
                      receipt: "إيصال",
                      downloadReceipts: "تحميل الإيصالات",
                      title: "تفاصيل الدفع",
                      paymentRejectedOn: "تم رفض الدفع الخاص بك في",
                      manage: "إدارة",
                      adjustment: "التعديل",
                      paymentInvoice: "فاتورة الدفع",
                      paymentReceipt: "إيصال الدفع",
                      addAdjustment: "إضافة التعديل",
                      singleAdjustment: "إضافة التعديل الفردي",
                      bulkAdjustment: "استيراد التعديلات المجمعة",
                      reasonForAdjustment: "سبب التعديل",
                      changedBy: "تم التعديل بواسطة",
                      on: "في",
                      deleteTitle: "حذف هذا التعديل",
                      deleteWarning:
                        "هل أنت متأكد من حذف هذا التعديل؟ لا يمكن التراجع عن هذا الإجراء.",
                      deleteSuccess: "تم حذف التعديل بنجاح",
                      adjustmentsModal: {
                        title: "تعديل المبلغ",
                        currentAmount: "المبلغ الحالي",
                        employee: "الموظف",
                        employeePlaceholder: "ابحث عن موظف",
                        paymentCategory: "الفئة المالية",
                        paymentCategoryPlaceholder: "اختر الفئة المالية",
                        adjustmentType: "نوع التعديل",
                        positive: "موجب",
                        negative: "سالب",
                        newAmount: "أدخل المبلغ الجديد",
                        newAmountDescription:
                          "المبلغ لا يمكن أن يكون أقل من 0.",
                        reason: "أضف سبب التعديل",
                        reasonPlaceholder: "اختر سبب التعديل",
                        otherReason: "يرجى ذكر السبب",
                        addAdjustment: "إضافة التعديل",
                        editAdjustment: "تعديل المبلغ",
                        cancel: "إلغاء",
                        success: "تم إضافة التعديل بنجاح",
                        error: "فشل إضافة التعديل",
                        requiredFields: {
                          employee: "الموظف مطلوب",
                          paymentCategory: "الفئة المالية مطلوبة",
                          adjustmentType: "نوع التعديل مطلوب",
                          newAmount: "المبلغ الجديد مطلوب",
                          reason: "سبب التعديل مطلوب",
                          otherReason: "سبب آخر مطلوب",
                          negativeAmountBelowZero:
                            "سيؤدي التعديل إلى تخفيض المبلغ إلى ما دون الصفر",
                        },
                        adjustmentReasons: {
                          overpayment: "تجاوز المبلغ",
                          underpayment: "تحت المبلغ",
                          creditFee: "رسوم الائتمان",
                          debitFee: "رسوم الديون",
                          otherReason: "سبب آخر",
                        },
                      },
                    },
                  },
                  grid: {
                    rejectPayment: "رفض الدفع",
                    confirmPayment: "تأكيد الدفع",
                    approver: "المراجع",
                    amount: "المبلغ",
                    companyName: "اسم الشركة",
                    benefitName: "اسم المزايا",
                    referenceNumbers: "أرقام مرجعية",
                    createdOn: "تم الإنشاء في",
                    rejectPaymentModal: {
                      paymentNotFound: "لم يتم العثور على الدفعة",
                      paymentNotFullAmount: "كانت الدفعة أقل من المبلغ المطلوب",
                    },
                  },
                  status: { overdue: "متأخر" },
                },
              },
            },
          },
          page: {
            list: {
              addCompany: "تسجيل شركة جديدة",
              companies: "الشركات",
              grid: {
                createdOn: "تم الإنشاء في",
                noRecords: {
                  noRecordsContent:
                    "هذا هو المكان الذي ستتمكن فيه من تتبع وإدارة وإضافة شركات جديدة.",
                  noRecordsTitle: "لا توجد شركات هنا بعد",
                },
                name: "اسم الشركة",
              },
              dataEditor: {
                title: "الشركات",
                openButton: "محرر البيانات",
                updateSuccess: "تم تحديث بيانات الشركة بنجاح",
                updatePartialFailure: ({ failed, total }) =>
                  `فشل تحديث ${failed} من أصل ${total} شركة`,
                mohreLocked:
                  "هذه الشركة خاضعة لتنظيم وزارة الموارد البشرية والتوطين ولا يمكن تعديل بياناتها هنا.",
                columns: {
                  name: "اسم الشركة",
                  registeredNumber: "رقم رخصة التجارة",
                  registeredAddress: "العنوان المسجل",
                  registeredUnder: "مسجلة تحت",
                  verificationStatus: "حالة التحقق",
                  employeesCount: "عدد الموظفين",
                  createdAt: "تم الإنشاء في",
                  updatedAt: "تم التحديث في",
                },
                updateInProgress:
                  "نقوم بتحديث الشركات التي قمت بتعديلها. قد يستغرق ذلك بعض الوقت.",
                updateResult: ({ updated, total }) =>
                  `تم تحديث ${updated} من ${total} شركة بنجاح`,
              },
            },
            skipStep: "سأفعل هذا لاحقا",
          },
          new: {
            page: {
              company: {
                syncWithMohre: "المزامنة مع وزارة الموارد البشرية",
                fillDetailsManually: "إدخال التفاصيل يدويًا",
                registerCompany: "تسجيل شركة",
                registerACompany: "تسجيل شركة",
                howIsCompanyRegistered: "كيف تم تسجيل الشركة؟",
                pickATypeToContinue: "اختر نوعًا للمتابعة.",
                mohreCompany: "شركة وزارة الموارد البشرية والتوطين",
                mohreCompanyDescription:
                  "مسجلة تحت وزارة الموارد البشرية والتوطين في الإمارات.",
                syncAvailable: "المزامنة متاحة",
                nonMohreCompany: "شركة المنطقة الحرة والخارجية",
                nonMohreCompanyDescription:
                  "منطقة حرة أو شركة خارجية أو أي كيان خارج نطاق الوزارة.",
                whatsTheDifference: "ما الفرق؟",
                form: {
                  info: {
                    name: {
                      label: "اسم الشركة",
                      required: "يرجى إدخال اسم الشركة",
                    },
                    website: {
                      label: "موقع الشركة",
                      required: "يرجى إدخال موقع الشركة",
                    },
                    address: {
                      label: "العنوان",
                      required: "يرجى إدخال عنوان الشركة",
                    },
                    registeredNumber: {
                      label: "رقم رخصة التجارة",
                      required: "يرجى تقديم رقم رخصة التجارة للشركة",
                    },
                    industry: {
                      label: "القطاع",
                      required: "يرجى تحديد قطاع الشركة",
                      placeholder: "اختر القطاع",
                      list: {
                        technology: "التكنولوجيا",
                        healthcare: "الرعاية الصحية",
                        finance: "المالية",
                        education: "التعليم",
                      },
                    },
                    onShore: {
                      companyNotFound:
                        "يبدو أننا لا نستطيع العثور على تفاصيلك. تحقق مما إذا كنت قد أدخلت رقم الهوية الخاص بك بشكل صحيح وتأكد من أنك مسجل في برنامج التوفير مع وزارة الموارد البشرية والتوطين.",
                    },
                  },
                  acknowledgment: {
                    label: (citizenships) =>
                      `يُدرك ويُقر ويوافق صاحب العمل على أن (i) الصندوق غير مؤهل للموظفين ذوي جنسيات معينة (${citizenships})، (ii) ولا يجوز له تسجيل أي من موظفيه من ذوي الجنسيات المحظورة، و(iii) يجب عليه أن يُخطر فورًا مدير الصندوق ومسؤول الصندوق إذا تبيّن له أن أحد الموظفين يحمل أو قد اكتسب جنسية محظورة.`,
                    required: "يجب عليك الموافقة على الشروط للمتابعة",
                  },
                },
                mohreOtpDescription:
                  "إذا كنت مخولاً لتسجيل الشركات عبر وزارة الموارد البشرية والتوطين، فسيتم إرسال رمز مكون من خمسة أرقام عبر الرسائل النصية القصيرة.",
                mohreOtpDuration: "سيكون هذا الرمز صالحًا لمدة 5 دقائق.",
                mohreRetrievingCompanies: "نقوم الآن بجلب الشركات المخصصة لك.",
                mohreWillRedirect: "سنقوم بتحويلك إلى الخطوة التالية قريبًا.",
                searchForCompanies: "ابحث عن الشركات",
                empty: { title: "لا توجد شركات تطابق بحثك" },
                updateCompany: "تحديث الشركة",
                companyUpdated: "تم تحديث الشركة بنجاح",
                mohreCodeResentSuccessfully: "تم إعادة إرسال الرمز بنجاح",
                mohreVerifying: "نحن نتحقق من تفاصيلك.",
                mohreWillSendOtp: "سنرسل لك رمز التحقق خلال لحظات.",
                mohreRetrievingCompany: "نحن نسترجع تفاصيل شركتك.",
                mohreForm: {
                  info: {
                    eidaOrUid: {
                      required:
                        "يرجى تقديم الرقم الموحد (UID) أو رقم بطاقة الهوية الإماراتية (EIDA) لشركتك",
                    },
                    eida: {
                      label: "هيئة الإمارات للهوية (EIDA)",
                      description:
                        "رقم الهوية الإماراتية يتكون من 15 رقمًا (مثال: ⁦784-1997-1234567-1⁩).",
                      required:
                        "يجب أن يتكون رقم الهوية الإماراتية من 15 رقمًا",
                    },
                    uid: {
                      label: "الرقم الموحد (UID)",
                      description:
                        "الرقم الموحد يتكون من ⁦6-15⁩ رقمًا (مثال: ⁦123456879265⁩).",
                      required: "يجب أن يتكون الرقم الموحد من ⁦6-15⁩ رقمًا",
                    },
                    warning: {
                      title: "مهم: التحقق من رمز OTP مطلوب",
                      text: "سنرسل رمزًا لمرة واحدة إلى جهة الاتصال المسجلة لمالك الشركة. تأكد من أنهم متاحون لاستلامه وإدخاله قبل المتابعة.",
                    },
                  },
                },
                differenceModal: {
                  title:
                    "وزارة الموارد البشرية والتوطين مقابل المنطقة الحرة والخارجية",
                  mohreTitle: "شركة وزارة الموارد البشرية والتوطين",
                  nonMohreTitle: "شركة المنطقة الحرة والخارجية",
                  mohreDescription:
                    "أصحاب عمل في البر الرئيسي الإماراتي مع ملف تأسيس في وزارة الموارد البشرية. يتم التعرف عليهم عبر الهوية الإماراتية أو الرقم التعريفي الموحد.",
                  nonMohreDescription:
                    "مناطق حرة أو شركات خارجية أو فروع. يتم التعرف عليهم عبر الرخصة التجارية وبطاقة تأسيس الإقامة الصادرة عن الهيئة الاتحادية للهوية والجنسية.",
                  gotIt: "فهمت",
                },
              },
              new: { companyAdded: "تمت إضافة الشركة" },
            },
          },
        },
        controls: {
          page: {
            context: "السياق",
            emailControls: "أدوات التحكم في البريد الإلكتروني",
            engineControls: "أدوات التحكم في المحرك",
            logoEmail: "الشعار - البريد الإلكتروني",
            logoInverse: "الشعار - المعكوس",
            logoRegular: "الشعار - العادي",
            logoSymbol: "Logo - Symbol",
            sendEmail: "إرسال البريد الإلكتروني",
            template: "القالب",
            logo: { fileRequirements: "PNG، JPG أو GIF (الحد الأقصى. 2MB)" },
            emails: {
              edit: {
                success: "لقد تم حفظ التغييرات الخاصة بك.",
                revertSuccess: "لقد تم التراجع عن كافة التغييرات.",
                revertTemplate: "التراجع عن القالب",
                revertTemplateDescription:
                  "هل أنت متأكد من رغبتك في التراجع إلى النسخة المختارة؟ سيتم فقدان جميع التخصيصات الحالية الخاصة بك.",
                testEmailSuccess: "تم إرسال البريد الإلكتروني الاختباري بنجاح",
                error: "تعذّر حفظ التغييرات الخاصة بك.",
                revertError: "تعذّر التراجع عن القالب.",
                testEmailError: "تعذّر إرسال البريد الإلكتروني الاختباري.",
              },
            },
          },
          automations: {
            page: {
              heading: "الأتمتة",
              employeeInvitations: {
                automated: "تلقائي",
                automatedDescription:
                  "دعوة الموظفين تلقائيًا عند إعداد ميزة أو منتج.",
                description:
                  "اختر كيف سيتم دعوة الموظفين الذين تقوم بتوظيفهم إلى المزايا المخصصة لهم.",
                heading: "دعوات الموظفين",
                manual: "يدوي",
                manualDescription: "دعوة الموظفين يدويًا.",
              },
              kycProvider: {
                heading: "الإعدادات الخاصة بـ KYC (Know Your Customer)",
                description:
                  "اختر كيف سيقوم الموظفون الذين تقوم بتوظيفهم بتقديم مستنداتهم بعد التسجيل.",
                manual: "يدوي",
                manualDescription:
                  "يمكن للموظفين إرفاق المستندات مباشرةً إلى فريقك للمراجعة.",
                automated: "تلقائي",
                automatedDescription:
                  "يمكن للموظفين إكمال التحقق من طريقة آمنة من خلال خدمة ثالثة طرفية.",
                externalProvider: {
                  heading: "أي تكامل تريد تمكينه؟",
                  options: {
                    Sumsub: "Sumsub",
                    Onfido: "Onfido",
                    BostonDynamics: "Boston Dynamics",
                  },
                },
              },
            },
          },
          fees: {
            heading: "الرسوم",
            page: {
              cta: "إنشاء رسوم",
              status: {
                live: "مباشر",
                inactive: "غير نشط",
                draft: "غير منشور",
              },
              lastUpdated: "آخر تحديث",
              menu: {
                edit: "تعديل",
                viewWorkflows: "عرض سير العمل",
                duplicate: "تكرار",
                settings: "الإعدادات",
                delete: "حذف",
              },
              empty: {
                createWorkflow: "إنشاء رسوم",
                title: "لم يتم إنشاء أنواع رسوم بعد.",
                description: "قم بإنشاء أول نوع رسوم للبدء",
              },
              noRecords: {
                title: "لم يتم العثور على أنواع رسوم",
                description: "لا يوجد أنواع رسوم تطابق بحثك عن",
              },
              duplicateSuccess: "تم تكرار نوع الرسوم",
              duplicateWorkflowSuccess: "تم تكرار سير عمل الرسوم",
              deleteSuccess: "تم حذف نوع الرسوم",
              activeWorkflows: (count) =>
                `${count} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `سير عمل نشط` })[P.select(count)] ?? `سير عمل نشطة`}`,
              appliedToCompanies: (count) =>
                `مطبق على ${count} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `شركة` })[P.select(count)] ?? `شركات`}`,
              appliedToAllCompanies: "مطبق على جميع الشركات",
              appliedToProducts: (count) =>
                `مطبق على ${count} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `منتج` })[P.select(count)] ?? `منتجات`}`,
              appliedToAllProducts: "مطبق على جميع المنتجات",
              deleteDialog: {
                title: "حذف نوع الرسوم",
                description: (name) =>
                  `هل أنت متأكد من حذف \"${name}\"؟ لا يمكن التراجع عن هذا الإجراء.`,
                success: "تم حذف نوع الرسوم",
              },
            },
            feeId: {
              settings: {
                title: "إعدادات نوع الرسوم",
                details: "التفاصيل",
                nameIsRequired: "اسم سير العمل مطلوب",
                name: "اسم نوع الرسوم",
                description: "الوصف",
                isActive: "تفعيل سير العمل",
                isActiveDescription:
                  "بمجرد التفعيل، يمكنك تطبيق هذه الرسوم على الشركات والمنتجات فوراً.",
                applyFees: "تطبيق الرسوم",
                applyFeesSubtitle:
                  "تطبيق الرسوم إما حسب الشركة أو حسب نوع المنتج",
                companies: "الشركات",
                products: "المنتجات",
                applyToAll: "تطبيق على جميع الشركات",
                applyToAllDescription:
                  "سيؤدي تحديد هذا إلى تطبيق هذه الرسوم تلقائياً على جميع الشركات الحالية والجديدة.",
                chooseCompanies: "اختر الشركات لتطبيق هذه الرسوم عليها",
                companiesSelected: ({ selected, total }) =>
                  `${selected} من أصل ${total} شركة محددة`,
                search: "بحث",
                edit: "تعديل",
                chooseCompaniesTitle: "اختر الشركات لتطبيق هذه الرسوم عليها",
                chooseCompaniesSource: "اختيار الشركات",
                selectedCompaniesTarget: "الشركات المحددة",
                applyFeeToCompanies: (count) =>
                  `تطبيق الرسوم على (${count}) شركة`,
                cancel: "إلغاء",
                xCompanies: (count) => `${count} شركة`,
                noCompaniesSelected: "لم يتم اختيار أي شركة بعد",
                productsLabel: "المنتجات",
                applyToAllCategory: "تطبيق على جميع المنتجات في هذه الفئة",
                applyToAllCategoryDescription:
                  "سيؤدي تحديد هذا إلى تطبيق هذه الرسوم تلقائياً على جميع المنتجات الحالية والجديدة.",
                chooseProducts: "اختر نسخ المنتج لتطبيق هذه الرسوم عليها",
                noProductsSelected: "لم يتم اختيار أي منتج بعد",
                chooseProductsTitle: "اختر نسخ المنتج لتطبيق هذه الرسوم عليها",
                chooseProductsSource: "اختيار المنتجات",
                selectedProductsTarget: "المنتجات المحددة",
                applyFeeToProducts: (count) =>
                  `تطبيق الرسوم على (${count}) منتج`,
                companiesCountLabel: "شركات",
                productsCountLabel: "منتجات",
                editWorkflow: "تعديل سير العمل",
                dangerZone: "منطقة الخطر",
                unpublishTitle: "إلغاء نشر سير العمل",
                unpublishDescription:
                  "سيؤدي إلغاء النشر إلى إخفاء سير العمل هذا عن جميع المستخدمين. يمكنك إعادة نشره لاحقاً دون فقدان أي بيانات.",
                unpublishButton: "إلغاء النشر",
                publishTitle: "نشر سير العمل",
                publishDescription:
                  "نشر سير العمل سيجعله نشطاً ومتاحاً للتنفيذ.",
                publishButton: "نشر",
                deleteTitle: "حذف سير العمل",
                deleteDescription:
                  "سيؤدي حذف سير العمل هذا إلى إزالة جميع البيانات المرتبطة نهائياً. ستتأثر الشركات أو المنتجات التي تستخدم سير العمل هذا.",
                deleteButton: "حذف نهائي",
                confirmUnpublish: (name) =>
                  `هل أنت متأكد من إلغاء نشر \"${name}\"؟`,
                confirmPublish: (name) => `هل أنت متأكد من نشر \"${name}\"؟`,
                confirmDelete: (name) =>
                  `هل أنت متأكد من حذف \"${name}\"؟ لا يمكن التراجع عن هذا الإجراء.`,
              },
              workflowSettings: {
                title: "إعدادات سير العمل",
                nameIsRequired: "اسم سير العمل مطلوب",
                details: "التفاصيل",
                isActive: "تفعيل سير العمل",
                isActiveDescription: "قم بتمكين سير العمل هذا لجعله نشطاً",
                name: "اسم سير العمل",
                description: "الوصف",
                dangerZone: "منطقة الخطر",
                deleteTitle: "حذف سير العمل",
                deleteDescription:
                  "سيؤدي حذف سير العمل هذا إلى إزالة جميع البيانات المرتبطة نهائياً.",
                deleteButton: "حذف نهائي",
                confirmDelete: (name) =>
                  `هل أنت متأكد من حذف \"${name}\"؟ لا يمكن التراجع عن هذا الإجراء.`,
                deleteSuccess: "تم حذف سير العمل",
              },
              workflows: {
                heading: "سير العمل",
                cta: "إنشاء سير عمل",
                empty: {
                  title: "لا توجد سير عمل بعد.",
                  description: "أنشئ أول سير عمل لهذه الرسوم للبدء",
                  createWorkflow: "إنشاء سير عمل",
                },
                noRecords: {
                  title: "لم يتم العثور على سير عمل",
                  description: "لا يوجد سير عمل يطابق بحثك عن",
                },
              },
            },
          },
          translations: {
            heading: "الترجمات",
            identifier: "المعرّف",
            identifierDescription:
              "مفاتيح فريدة تُستخدم في الشيفرة للإشارة إلى نصوص الترجمة",
            string: "النص",
            employerPortal: "بوابة صاحب العمل",
            employeeApp: "تطبيق الموظف",
            versionHistory: "سجل الإصدارات",
            emptyState: {
              title: "لم يتم العثور على نتائج",
              text: "عدّل البحث للعثور على الترجمة",
            },
          },
          branding: {
            platform: { name: "", signInName: "", signUpName: "" },
            page: {
              heading: "تهيئة علامتك التجارية",
              yourDetails: "تفاصيلك",
              platformName: "اسم المنصة",
              privacyNotice: "إشعار الخصوصية",
              privacyNoticeUrl: "رابط إشعار الخصوصية",
              feelingLost: "هل أنت في حيرة؟",
              feelingLostUrl: "رابط هل أنت في حيرة؟",
              domain: {
                label: "حدد نطاقك",
                hint: "هكذا سيتم عرض عنوان URL للمنصة. مثل: acmecorp.com",
                optional: "اختياري",
              },
              signIn: {
                title: (name) => `تسجيل الدخول إلى ${name}`,
                email: { label: "البريد الإلكتروني" },
                password: { label: "كلمة المرور" },
                signIn: "تسجيل الدخول",
                donthaveAccount: "ليس لديك حساب بعد؟",
                signUpLink: "إنشاء حساب",
              },
              uploadLogo: "حمِّل شعارك",
              logoInverse: "الشعار - المعكوس",
              logoRegular: "الشعار - العادي",
              logoEmail: "البريد الإلكتروني",
              logoSymbol: "الشعار - رموز",
              chooseTheme: "اختر المظهر",
              liveChat: "الدردشة المباشرة",
              liveChatWidgetToken: "رمز أداة الدردشة المباشرة",
              liveChatSecretKey: "المفتاح السري للدردشة المباشرة",
              liveChatSecretKeyHint:
                "يُستخدم للتحقق من هوية المستخدم في أداة الدردشة المباشرة",
              applyChanges: "احفظ كل التغييرات",
            },
          },
          mohreSupport: {
            page: {
              heading: "أدوات دعم وزارة الموارد البشرية",
              description:
                "إدارة ودفع البيانات إلى وزارة الموارد البشرية والتوطين",
              pushing: "جارٍ الإرسال...",
              companyOperations: {
                heading: "عمليات الشركة",
                companyId: "معرف الشركة",
                companyIdPlaceholder: "أدخل معرف الشركة",
                pushEmployer: "إرسال صاحب العمل إلى الوزارة",
                pushOwner: "إرسال المالك إلى الوزارة",
                pushAllEmployees: "إرسال جميع الموظفين إلى الوزارة",
                pushSubscriptions: "إرسال اشتراكات الشركة إلى الوزارة",
              },
              employeeOperations: {
                heading: "عمليات الموظف الفردي",
                employeeId: "معرف الموظف",
                employeeIdPlaceholder: "أدخل معرف الموظف",
                pushEmployee: "إرسال الموظف الفردي إلى الوزارة",
                pushSubscription: "إرسال الاشتراك الفردي إلى الوزارة",
              },
              paymentOperations: {
                heading: "عمليات الدفع الفردي",
                paymentId: "معرف الدفع",
                paymentIdPlaceholder: "أدخل معرف الدفع",
                pushPayment: "إرسال الدفع الفردي إلى الوزارة",
              },
              withdrawalOperations: {
                heading: "عمليات السحب",
                paymentId: "معرف الدفعة",
                paymentIdPlaceholder: "أدخل معرف دفعة السحب",
                pushWithdrawal: "إرسال السحب إلى وزارة الموارد البشرية",
              },
            },
          },
          paymentSupport: {
            page: {
              heading: "أدوات دعم المدفوعات",
              description: "أدوات الدعم لإدارة عمليات الدفع",
              removePaymentLines: {
                heading: "إزالة بنود الدفع",
                paymentId: "معرف الدفع",
                paymentIdPlaceholder: "أدخل معرف الدفع",
                paymentLineIds: "معرفات بنود الدفع",
                paymentLineIdsPlaceholder: "اختر بنود الدفع للإزالة",
                keepOnlySelected:
                  "احتفظ فقط بالبنود المحددة وأزل جميع البنود الأخرى",
                submit: "إزالة البنود",
                confirmTitle: "تأكيد إزالة بنود الدفع",
                confirmSubmit: "إزالة البنود",
              },
              regeneratePaymentInvoice: {
                heading: "إعادة إنشاء فاتورة الدفعة",
                paymentId: "معرّف الدفعة",
                paymentIdPlaceholder: "أدخل معرّف الدفعة",
                description:
                  "يعيد إنشاء مستند الفاتورة من بنود الدفعة الحالية ويستبدل الملف المحفوظ.",
                submit: "إعادة إنشاء الفاتورة",
                confirmTitle: "تأكيد إعادة إنشاء الفاتورة",
                confirmSubmit: "إعادة الإنشاء",
              },
            },
          },
          supportTools: {
            tabs: {
              mohre: "MOHRE",
              payment: "الدفع",
              workflow: "سير العمل",
              marketOrder: "أمر السوق",
              employeeStatement: "كشف حساب الموظف",
            },
          },
          employeeStatementSupport: {
            page: {
              success: "تم إصلاح الكشوف — لم يتم إشعار أحد",
              successNotified: "تم إصلاح الكشوف وإشعار الموظفين",
              successNewRunId: (runId) => `التشغيل الجديد: ${runId}`,
              error: "فشل بدء التشغيل الجديد",
              errorMissingProductInstanceId:
                "لا يحتوي هذا التشغيل على productInstanceId — أعد تحميل التشغيل وحاول مرة أخرى.",
              confirmTitle: "تأكيد إصلاح الكشف",
              confirmSubmit: "إصلاح الكشوف",
              confirmFixAllSilent: (count) =>
                `سيؤدي هذا إلى إعادة إنشاء الكشف لجميع الموظفين البالغ عددهم ${count} في هذا التشغيل، بما في ذلك من نجحت عمليتهم بالفعل — استخدم هذا عندما يؤثر خطأ ما على الجميع، وليس فقط من فشلت عمليتهم. لن يتم إرسال أي بريد إلكتروني. يتم الاحتفاظ بالكشوف الأصلية للسجل لكن سيرى الموظفون الكشف المصحح فقط.`,
              confirmFixSilent: (count) =>
                `سيؤدي هذا إلى إعادة إنشاء الكشف لـ ${count} موظف (موظفين) المدرجين أدناه. لن يتم إرسال أي بريد إلكتروني.`,
              confirmFixNotify: (count) =>
                `سيؤدي هذا إلى إعادة إنشاء الكشف لـ ${count} موظف (موظفين) المدرجين أدناه وإرسال بريد إشعار لهم. افعل هذا فقط للموظفين الذين لم يتم إشعارهم بنجاح من قبل — من تم إشعارهم بالفعل سيتم إشعارهم مرة أخرى.`,
              newerRunWarning:
                "قد يكون هذا التشغيل قديمًا — هناك تشغيل أحدث يغطي بعض هؤلاء الموظفين بالفعل.",
              newerRunSingle: (date) => `عرض التشغيل من ${date}`,
              loadRun: {
                heading: "تحميل تشغيل الكشف",
                description:
                  "أدخل معرف تشغيل سير العمل لدفعة كشوف حساب الموظفين لمعرفة حالة إنشاء الكشوف.",
                runId: "معرف تشغيل سير العمل",
                runIdPlaceholder: "أدخل معرف UUID للتشغيل",
                submit: "تحميل",
              },
              statement: {
                heading: "إنشاء الكشوف",
                statusAllGenerated: (count) =>
                  `تم إنشاء جميع الكشوف البالغ عددها ${count} بنجاح`,
                statusSomeMissing: (count) =>
                  `${count} موظف (موظفين) ما زال بدون كشف`,
                succeededCount: (count) => `${count} تم إنشاؤها`,
                failedCount: (count) => `${count} فشل`,
                fixStatements: (count) =>
                  `إصلاح الكشف لـ ${count} موظف (موظفين)`,
                editHint:
                  "معرفات الموظفين، واحد لكل سطر أو مفصولة بفواصل — يبدأ معبأً مسبقًا بمن ينقصهم كشف؛ عدّل القائمة لاستهداف مجموعة مختلفة",
                selectAll: (count) =>
                  `تحديد جميع الموظفين البالغ عددهم ${count}`,
                resetToFailed: "إعادة التعيين إلى الفاشلين فقط",
                idsPlaceholder: "معرفات الموظفين، مفصولة بفواصل أو أسطر جديدة",
                notifyEmployees: "إشعار هؤلاء الموظفين أيضًا",
                notifyEmployeesHint:
                  "معطّل افتراضيًا. فعّل هذا فقط للموظفين الذين لم يتم إشعارهم بنجاح من قبل — من تم إشعارهم بالفعل سيتلقى بريدًا آخر.",
                copied: "تم النسخ إلى الحافظة",
              },
            },
          },
          workflowSupport: {
            page: {
              heading: "أدوات دعم سير العمل",
              description: "أدوات الدعم لإدارة عمليات سير العمل",
              triggerPayrollDeduction: {
                heading: "تشغيل سير عمل خصم الراتب",
                productId: "معرف المنتج",
                productIdPlaceholder: "أدخل معرف المنتج",
                month: "اختر الشهر",
                monthPlaceholder: "اختر شهرًا",
                fund: "الصندوق",
                fundBoth: "كلا الصندوقين",
                fundConventional: "التقليدي فقط",
                fundIslamic: "الإسلامي فقط",
                includeLeavers:
                  "تضمين من انتهت خدمتهم أو انتهى اشتراكهم في الخطة بعد الشهر المحدد",
                submit: "تشغيل سير العمل",
              },
              runWorkflow: {
                heading: "تشغيل سير العمل",
                productInstanceId: "معرف نموذج المنتج",
                productInstanceIdPlaceholder: "أدخل معرف نموذج المنتج",
                employee: "الموظف",
                employeePlaceholder: "اختر الموظف",
                employeeRequired: "يرجى اختيار موظف",
                cashAmount: "مبلغ السحب النقدي",
                cashAmountPlaceholder: "أدخل مبلغ السحب",
                cashAmountRequired: "مبلغ السحب مطلوب",
                customAttributeName: "اسم السمة المخصصة",
                customAttributeNamePlaceholder: "أدخل اسم السمة المخصصة",
                customAttributeNameRequired: "اسم السمة المخصصة مطلوب",
                targetFundName: "اسم الصندوق المستهدف",
                targetFundNamePlaceholder: "أدخل اسم الصندوق المستهدف",
                targetFundNameRequired: "اسم الصندوق المستهدف مطلوب",
                sourceFundName: "اسم الصندوق المصدر",
                sourceFundNamePlaceholder: "أدخل اسم الصندوق المصدر (اختياري)",
                noAdditionalFields: "لا توجد حقول إضافية مطلوبة لهذا الحدث",
                runFeeWorkflowDescription:
                  "هل أنت متأكد أنك تريد تشغيل سير العمل هذا؟ سيؤدي ذلك إلى تشغيل سير العمل لجميع الرسوم المنطبقة.",
                data: "البيانات (JSON)",
                dataPlaceholder: "أدخل كائن JSON",
                dataInvalid: "يرجى إدخال كائن JSON صالح",
                workflowId: "معرف سير العمل",
                workflowIdPlaceholder: "أدخل معرف سير العمل",
                workflowKey: "سير العمل",
                workflowKeyPlaceholder: "اختر سير عمل",
                run: "تشغيل",
                running: "جارٍ التشغيل...",
              },
              rerunTerminations: {
                heading: "إعادة تشغيل إنهاء الخدمة",
                description:
                  "تشغيل مهمة إنهاء الخدمة اليومية لجميع الموظفين الذين ينتهي تاريخ خدمتهم اليوم أو قبله.",
                submit: "إعادة التشغيل",
                confirmTitle: "إعادة تشغيل إنهاء الخدمة",
                confirmDescription:
                  "سيؤدي هذا إلى إعادة معالجة كل موظف ينتهي تاريخ خدمته اليوم أو قبله، على مستوى المستأجر بالكامل. تعمل العملية في الخلفية وقد تستغرق بعض الوقت.",
                confirmSubmit: "إعادة التشغيل",
              },
              rerunTermination: {
                heading: "إعادة تشغيل إنهاء الخدمة لموظف واحد",
                description:
                  "يعيد تشغيل مسار إنهاء الخدمة لموظف واحد، متجاوزاً العلامة التي تمنع تكرار المهمة اليومية. يؤثر فقط على الأرصدة غير المستحقة، أما الأرصدة المستحقة فتحتفظ بتاريخ استحقاقها. استخدمه عندما تُضاف اشتراكات بعد تشغيل إنهاء الخدمة.",
                id: "معرّف الموظف أو معرّف اشتراك المنتج",
                idPlaceholder: "الصق معرّف الموظف أو معرّف اشتراك المنتج",
                submit: "إعادة التشغيل للموظف",
                confirmTitle: "إعادة تشغيل إنهاء الخدمة لموظف واحد",
                confirmDescription:
                  "سيبدأ هذا مسار إنهاء الخدمة من جديد لهذا الموظف. سيتم استحقاق الأرصدة غير المستحقة وقد يُنشأ أمر سوق. لن تُمس الأرصدة المستحقة.",
                confirmSubmit: "إعادة التشغيل",
                success: "تم بدء مسار إنهاء الخدمة",
                error: "تعذّر إعادة تشغيل إنهاء الخدمة",
              },
              rerunFundSwitch: {
                heading: "إعادة تشغيل تبديل الصندوق",
                description:
                  "إعادة إطلاق تبديل الصندوق لموظف واحد. استخدمه عندما لا ينتج عن التبديل الأصلي أمر سوق. لا يتم تغيير الصندوق المختار للموظف.",
                productAssignmentId: "معرف تخصيص المنتج",
                productAssignmentIdPlaceholder: "أدخل معرف تخصيص المنتج",
                customAttributeName: "خاصية الصندوق",
                customAttributeNamePlaceholder:
                  "أدخل اسم خاصية الصندوق، مثل employeeBasicFund",
                sourceFundName: "الصندوق المصدر",
                sourceFundNamePlaceholder:
                  "الصندوق الذي توجد به الحيازات حاليًا",
                targetFundName: "الصندوق الهدف",
                targetFundNamePlaceholder: "الصندوق المراد التبديل إليه",
                submit: "إعادة التشغيل",
                confirmTitle: "إعادة تشغيل تبديل الصندوق",
                confirmDescription:
                  "سيؤدي هذا إلى بدء سير عمل تبديل الصندوق لهذا الموظف وقد ينشئ أمر سوق تبديل جديدًا. تحقق أولًا من وجود أمر تبديل معلق لتفادي تبديل الوحدات مرتين.",
                confirmSubmit: "إعادة التشغيل",
                success: "تم بدء إعادة تشغيل تبديل الصندوق",
                error: "فشل إعادة تشغيل تبديل الصندوق",
              },
              rerunStatement: {
                heading: "إعادة تشغيل كشف حساب الموظف",
                description:
                  "إعادة إنشاء كشف الحساب والإشعار لموظفين محددين. تحقق من تشغيلات المرفقات وسجل البريد الإلكتروني أولًا لتفادي التكرار.",
                productInstanceId: "معرف مثيل المنتج",
                productInstanceIdPlaceholder: "أدخل معرف مثيل المنتج",
                employeeIds: "معرفات الموظفين",
                employeeIdsPlaceholder:
                  "معرف موظف واحد في كل سطر، أو مفصولة بفواصل",
                submit: "إعادة التشغيل",
                confirmTitle: "إعادة تشغيل كشف حساب الموظف",
                confirmDescription:
                  "سيتم إرسال كشف حساب جديد لكل موظف في القائمة. متابعة؟",
                confirmSubmit: "إعادة التشغيل",
                success: "تم بدء إعادة تشغيل كشف حساب الموظف",
                error: "فشل إعادة تشغيل كشف حساب الموظف",
              },
              success: { workflowRan: "تم تشغيل سير العمل بنجاح" },
              errors: {
                workflowNotFound: "لم يتم العثور على إصدار سير العمل",
                noVersionFound: (workflowId) =>
                  `لم يتم العثور على إصدار حالي لتعريف سير العمل \"${workflowId}\"`,
                failedToRun: "فشل تشغيل سير العمل",
              },
            },
          },
          customAttributes: {
            categoryId: {
              page: {
                title: "تهيئة حقول النموذج",
                types: { default: "افتراضي", additional: "إضافي" },
                saveFieldsError: "فشل حفظ الحقول",
                saveFieldsSuccess: "تم حفظ الحقول بنجاح",
              },
            },
            page: {
              group: {
                employer: { title: "توجيهات صاحب العمل" },
                employee: { title: "توجيهات الموظف" },
                nominee: { title: "معلومات المستفيد" },
              },
              category: {
                companyInformation: { name: "معلومات الشركة" },
                companyCreate: { name: "تسجيل الشركة" },
                companyProduct: { name: "منتج الشركة" },
                companyTax: { name: "معلومات ضريبة الشركة" },
                employeePersonalInfo: { name: "معلومات الموظف الشخصية" },
                employeeProduct: { name: "منتج الموظف" },
                employeeContact: { name: "معلومات الاتصال بالموظف" },
                employeeEmploymentDetails: { name: "تفاصيل توظيف الموظف" },
                employeeBankDetails: { name: "التفاصيل البنكية للموظف" },
                nomineeDetails: { name: "معلومات المستفيد الشخصية" },
                employeeAdditionalDetails: { name: "تفاصيل إضافية للموظف" },
                other: { name: "أخرى" },
                taxInformation: { name: "معلومات ضريبية" },
              },
              title: "تهيئة حقول النموذج",
            },
          },
          forms: {
            page: {
              list: {
                title: "النماذج",
                addForm: "إضافة نموذج",
                taxInformation: "معلومات ضريبية",
                emptyFormsTitle: "لم يتم إنشاء أي نماذج بعد.",
                emptyFormsText: "أنشئ نموذجك الأول للبدء.",
                createForm: "إنشاء نموذج",
                category: {
                  taxInformation: {
                    name: "معلومات ضريبية",
                    description: "نماذج متعلقة بالمعلومات الضريبية",
                  },
                  companyInformation: {
                    name: "معلومات الشركة",
                    description: "نماذج متعلقة بمعلومات الشركة",
                  },
                  companyCreate: {
                    name: "تسجيل الشركة",
                    description: "نماذج متعلقة بتسجيل شركة",
                  },
                  companyTax: {
                    name: "معلومات ضريبة الشركة",
                    description: "نماذج متعلقة بمعلومات ضريبة الشركة",
                  },
                  employeePersonalInfo: {
                    name: "معلومات الموظف الشخصية",
                    description: "نماذج متعلقة بمعلومات الموظف الشخصية",
                  },
                  employeeContact: {
                    name: "معلومات الاتصال بالموظف",
                    description: "نماذج متعلقة بمعلومات الاتصال بالموظف",
                  },
                  employeeEmploymentDetails: {
                    name: "تفاصيل توظيف الموظف",
                    description: "نماذج متعلقة بتفاصيل توظيف الموظف",
                  },
                  employeeBankDetails: {
                    name: "التفاصيل البنكية للموظف",
                    description: "نماذج متعلقة بالتفاصيل البنكية للموظف",
                  },
                  employeeAdditionalDetails: {
                    name: "تفاصيل إضافية للموظف",
                    description: "نماذج متعلقة بتفاصيل إضافية للموظف",
                  },
                  nomineeDetails: {
                    name: "معلومات المستفيد",
                    description: "نماذج متعلقة بمعلومات المستفيد",
                  },
                  companyProduct: {
                    name: "منتج الشركة",
                    description: "نماذج متعلقة بمنتج الشركة",
                  },
                  employeeProduct: {
                    name: "منتج الموظف",
                    description: "نماذج متعلقة بمنتج الموظف",
                  },
                  other: {
                    name: "أخرى",
                    description: "نماذج متعلقة بمعلومات أخرى",
                  },
                },
              },
              editor: {
                addField: "أضف حقلًا",
                backToEditing: "العودة إلى التحرير",
                category: "الفئة",
                defaultLabel: "تسمية افتراضية",
                defaultPlaceholder: "نص افتراضي",
                formDescription: "وصف النموذج",
                formName: "اسم النموذج",
                formSettings: "إعدادات النموذج",
                newForm: "نموذج جديد",
                publish: "نشر",
                unpublish: "إلغاء النشر",
                unpublishDialog: {
                  title: "هل أنت متأكد من إلغاء نشر هذا النموذج؟",
                  description:
                    "لن يكون هذا النموذج مرئيًا أو متاحًا للمستخدمين. يمكنك إعادة نشره في أي وقت.",
                  submit: "إلغاء نشر النموذج",
                },
                formStatusUpdatedToast: "تم تحديث حالة النموذج.",
                saveDraft: "حفظ المسودة",
                savedToast: "تم حفظ النموذج. انشره الآن لجعل التغييرات متاحة.",
                actions: {
                  add: "إضافة",
                  edit: "تعديل",
                  duplicate: "تكرار",
                  delete: "حذف",
                  moveUp: "تحريك لأعلى",
                  moveDown: "تحريك لأسفل",
                  toggleVisibility: "تبديل الرؤية",
                  goBack: "العودة",
                  preview: "معاينة",
                  settings: "إعدادات",
                  menu: "قائمة",
                },
              },
            },
          },
          products: {
            page: {
              heading: "اختر منتجاتك",
              category: {
                retirement: "التقاعد",
                benefit: "المزايا",
                wealth: "الثروة",
                advice: "النصيحة",
                insurance: "التأمين",
              },
              product: {
                avs: {
                  name: "مكافأة نهاية الخدمة",
                  description: "خطة ادخار بمزايا محددة",
                },
                ipp: {
                  name: "خطة المعاشات الدولية",
                  description: "ادخار في مكان العمل عبر عدة ولايات قضائية",
                },
                workingSaving: {
                  name: "الادخار في مكان العمل",
                  description: "خطة ادخار بمساهمات محددة",
                },
                sipps: {
                  name: "خطط التقاعد الذاتية",
                  description: "خطة تقاعد شخصية مستثمرة ذاتيًا",
                },
                iras: {
                  name: "حسابات التقاعد الفردية",
                  description: "حساب تقاعد فردي",
                },
                selfDirectedInvestment: {
                  name: "حساب استثمار فردي",
                  description: "استثمار موجه ذاتيًا",
                },
                discretionaryPortfolio: {
                  name: "إدارة المحافظ الاستثمارية التقديرية",
                  description: "إدارة احترافية للمحافظ الاستثمارية",
                },
                execution: {
                  name: "تنفيذ فقط",
                  description: "إدارة المحافظ بشكل ذاتي",
                },
                advisorPlatform: {
                  name: "منصة المستشار",
                  description: "حساب مدار بواسطة مستشار",
                },
                roboAdvisory: {
                  name: "المستشار الآلي",
                  description: "التخطيط المالي الآلي",
                },
                managedAccounts: {
                  name: "الحسابات المدارة",
                  description: "إدارة استثمارية تقديرية",
                },
                groupLife: {
                  name: "تأمين الحياة الجماعي",
                  description: "تأمين حياة للموظفين",
                },
                criticalIllness: {
                  name: "الأمراض الحرجة",
                  description: "تأمين ضد الأمراض الخطيرة",
                },
                incomeProtection: {
                  name: "حماية الدخل",
                  description: "تأمين دخل في حال المرض أو الإصابة",
                },
              },
              comingSoon: "قريبًا",
              productInDevelopment: "هذه المنتجات قيد التطوير حاليًا.",
              noProductEnabled: "لم يتم تفعيل أي منتجات بعد.",
              updateProducts: "تحديث المنتجات",
              XProduct: (count) =>
                `${{ [1]: `تحديث منتج واحد` }[count] ?? `تحديث ${count} منتج`}`,
              addProducts: "إضافة منتجات",
              search: "ابحث عن المنتجات المتاحة",
              title: "المنتجات",
              cta: "إنشاء منتج جديد",
              status: { live: "حي", inactive: "غير مفعل" },
              workflows: "العمليات",
              attributes: "السمات",
              settings: "الإعدادات",
              lastUpdated: "آخر تحديث",
              empty: {
                createProduct: "إنشاء منتج جديد",
                title: "لم يتم إنشاء أي منتجات بعد.",
                description: "إنشاء منتج جديد وتعيينه للموظفين.",
              },
              noRecords: {
                title: "لم يتم العثور على منتجات",
                description: "لا توجد منتجات تطابق بحثك عن ",
              },
            },
            productId: {
              details: {
                page: {
                  createTitle: "إنشاء منتج جديد",
                  editTitle: "تعديل المنتج",
                  settings: "الإعدادات والتفاصيل",
                  name: "اسم المنتج",
                  description: "وصف المنتج",
                  isActive: "جعل المنتج متاحًا على المنصة",
                  isActiveDescription:
                    "عند التمكين، يصبح هذا المنتج متاحًا على المنصة. ستتمكن من إضافة موظفين، ومعالجة المساهمات، وإدارة الفوائد.",
                  saveError: "فشل في حفظ المنتج",
                },
              },
              productCustomAttributes: {
                page: {
                  name: "السمات المنتجة",
                  category: {
                    employer: { title: "المنتج الشركة" },
                    employee: { title: "المنتج الموظف" },
                  },
                  group: {
                    productAttributes: { name: "السمات المنتجة" },
                    productAssignmentAttributes: { name: "السمات المنتجة" },
                  },
                },
              },
              workflows: {
                page: {
                  title: "العمليات",
                  addWorkflow: "إضافة عملية",
                  edited: "تم التعديل",
                  versions: "الإصدارات",
                  status: {
                    Active: "مباشر",
                    Draft: "غير منشور",
                    Inactive: "غير مفعل",
                  },
                  empty: {
                    createProduct: "إنشاء عملية جديدة",
                    title: "لم يتم إنشاء أي عمليات بعد.",
                    description: "إنشاء عملية جديدة للبدء",
                  },
                  noRecords: {
                    title: "لم يتم العثور على عمليات",
                    description: "لا توجد عمليات تطابق بحثك عن ",
                  },
                },
              },
            },
          },
          payments: {
            page: {
              title: "المدفوعات",
              saveError: "فشل في حفظ فئات الدفع",
              tabs: {
                paymentCategories: "فئات الدفع",
                invoiceParties: "أطراف الفاتورة",
              },
              paymentCategory: {
                cta: "إضافة فئة دفع",
                modal: {
                  title: {
                    add: "إضافة فئة دفع جديدة",
                    edit: "تعديل فئة الدفع",
                  },
                  titleEn: {
                    label: "الإنجليزية",
                    placeholder: "مثال: اشتراكات أساسية",
                  },
                  titleAr: {
                    label: "العربية",
                    placeholder: "مثال: اشتراكات أساسية",
                  },
                  adjustable: {
                    label: "إظهار كخيار تعديل",
                    description:
                      "تفعيل هذا لجعل الفئة متاحة عند تعديل سجلات حيازة الدفع.",
                  },
                  delete: {
                    title: "حذف فئة الدفع",
                    description: "هل أنت متأكد أنك تريد حذف الفئة؟",
                    cta: "حذف الفئة",
                  },
                },
              },
              invoiceParty: {
                cta: "إضافة طرف فاتورة",
                errors: {
                  saveFailed: "فشل في حفظ طرف الفاتورة",
                  deleteFailed: "فشل في حذف طرف الفاتورة",
                },
                modal: {
                  title: {
                    add: "إضافة طرف فاتورة",
                    edit: "تعديل طرف الفاتورة",
                  },
                  type: {
                    label: "نوع المستلم",
                    individual: "فرد",
                    company: "شركة",
                  },
                  name: { label: "الاسم الكامل" },
                  invoiceTitle: { label: "عنوان الفاتورة" },
                  address: { label: "العنوان" },
                  trn: { label: "رقم التسجيل الضريبي" },
                  disclaimerEn: {
                    label: "إخلاء المسؤولية (بالإنجليزية)",
                    description: "يُعرض للمستلمين باللغة الإنجليزية.",
                  },
                  disclaimerAr: {
                    label: "إخلاء المسؤولية (بالعربية)",
                    description: "يُعرض للمستلمين باللغة العربية.",
                  },
                  delete: {
                    title: "حذف طرف الفاتورة",
                    description:
                      "هل أنت متأكد أنك تريد حذف طرف الفاتورة؟ لا يمكن التراجع عن هذا الإجراء.",
                    cta: "حذف",
                  },
                },
              },
            },
          },
          emails: {
            page: {
              emails: {
                edit: { subject: "موضوع", from: "من", to: "ل" },
                list: {
                  sidebar: {
                    categories: { employees: "الموظفين", business: "الأعمال" },
                    subCategories: {
                      actionRequired: "الإجراء المطلوب",
                      onboarding: "التوجيه",
                      verification: "تَحَقّق",
                      reports: "التقارير",
                      security: "حماية",
                    },
                    searchPlaceholder: "البحث عن القوالب",
                    noResults: "لم يتم العثور على نتائج",
                    tabs: {
                      chooseTemplate: "اختر القالب",
                      configure: "تكوين",
                      sendTest: "إرسال الاختبار",
                    },
                  },
                  heading: "رسائل البريد الإلكتروني",
                },
              },
            },
            emailType: {
              page: {
                details: "تفاصيل",
                emails: {
                  edit: {
                    recipientAndSenderDetails: "تفاصيل المستلم والمرسل",
                    sender: "مرسل",
                    recipients: "المستلمون",
                    recipientsTooltip:
                      "لتغيير المستلمين، يمكنك تعديل أذونات الدور أو تعيين مستخدمين لدور مختلف. يعتمد مستلمو هذا البريد الإلكتروني على أدوار المستخدمين. لتغيير المستلمين، يمكنك تعديل أذونات الدور أو تعيين مستخدمين لدور مختلف.",
                    recipientsTooltipEditRoles: "تعديل الأدوار",
                    uploadOrChangeYourLogo: "قم بتحميل أو تغيير شعارك",
                    testRecipientDetails: "تفاصيل المتلقي للاختبار",
                    testRecipientDetailsDescription:
                      "افصل بين عناوين البريد الإلكتروني باستخدام فاصلة أو مسافة أو بالضغط على Enter.",
                    testRecipientsAdded: (count) =>
                      `تمت إضافة ${count} مستلمين`,
                    trigger: "مشغل",
                    showVersionHistory: "إظهار تاريخ الإصدار",
                    sendTestEmail: "إرسال بريد إلكتروني اختباري",
                    resetToDefault: "التراجع عن جميع التغييرات",
                  },
                  list: { heading: "رسائل البريد الإلكتروني" },
                },
                invite: {
                  errors: {
                    invalidEmail: "أحد عناوين البريد الإلكتروني غير صالح",
                    atLeastOneEmail: "يرجى إضافة بريد إلكتروني واحد على الأقل",
                  },
                },
              },
            },
          },
          documents: {
            page: {
              title: "المستندات",
              generalDocument: "مستند عام",
              addDocument: "إضافة مستند",
              noDocuments: "لا توجد مستندات بعد",
              fileType: "ملف PDF فقط، الحد الأقصى 10 ميغابايت",
              choose: "اختر",
              configure: "تهيئة",
              dialog: {
                delete: "حذف المستند",
                warning:
                  "هل أنت متأكد أنك تريد حذف هذا المستند؟ سيؤدي ذلك إلى حذف المستندات المحملة بجميع اللغات. لا يمكنك التراجع عن هذا الإجراء لاحقًا.",
              },
              disclaimerNotice: "إشعار إخلاء المسؤولية",
              documentType: "ما نوع المستند الذي تقوم بتحميله؟",
              documentUsage: "كيف يجب استخدام هذا المستند؟",
              addLanguage: "إضافة لغات",
              search: "ابحث عن مستندات أو فئات",
              toast: {
                upload: "تم تحميل المستندات بنجاح",
                update: "تم تحديث المستندات بنجاح",
                delete: "تم حذف المستندات بنجاح",
              },
              fund: "صندوق",
              cta: "حفظ جميع التغييرات",
              failedToFetch:
                "فشل في جلب الملف الأصلي. الرجاء إعادة التحديد يدويًا.",
              missingFile: "الملف مفقود",
              titleRequired: "عنوان المستند مطلوب",
              untitled: "بدون عنوان",
            },
          },
          passwordPolicy: {
            page: {
              heading: "سياسة كلمة المرور",
              description: "حدد قواعد كلمة المرور لجميع المستخدمين",
              policy: {
                capitalLetter: {
                  title: "حرف كبير",
                  description: "يتطلب حرفًا كبيرًا واحدًا على الأقل (A-Z)",
                },
                lowercaseLetter: {
                  title: "حرف صغير",
                  description: "يتطلب حرفًا صغيرًا واحدًا على الأقل (a-z)",
                },
                number: {
                  title: "رقم",
                  description:
                    "يتطلب رقمًا واحدًا على الأقل في كلمة المرور (0-9)",
                },
                specialCharacter: {
                  title: "رمز خاص",
                  description: "يتطلب رمزًا واحدًا على الأقل (!@#$%^&* وغيرها)",
                },
                minimumLength: {
                  title: "الحد الأدنى للطول",
                  description: "حدد الحد الأدنى لعدد الأحرف المطلوبة",
                  label: "تحديد الطول",
                },
                forcePasswordChange: {
                  title: "فرض تغيير كلمة المرور",
                  description:
                    "يتطلب من المستخدمين تحديث كلمة المرور كل [X] يومًا",
                  label: "تحديد عدد الأيام",
                },
                avoidCommonPasswords: {
                  title: "تجنب كلمات المرور الشائعة",
                  description: "حظر كلمات المرور الشائعة أو سهلة التخمين",
                },
                disallowPreviousPasswords: {
                  title: "منع إعادة استخدام كلمات المرور",
                  description: "منع المستخدمين من التبديل بين نفس كلمات المرور",
                },
              },
              toast: {
                success: "تم تحديث سياسة كلمة المرور بنجاح",
                enterValidNumericValue: "يرجى إدخال قيمة رقمية صحيحة",
              },
              tab: {
                passwords: "كلمات المرور",
                nationalities: "الجنسيات",
                passwordRequirements: "متطلبات كلمة المرور",
                securityPolicies: "سياسات الأمان",
                citizenships: "الجنسيات",
                passwordRequirementsTab: {
                  heading: "متطلبات كلمة المرور",
                  description: "حدد القواعد لإنشاء كلمات مرور قوية",
                },
                securityPoliciesTab: {
                  heading: "سياسات الأمان",
                  description: "حدد سياسات الأمان",
                },
              },
              securityPoliciesCard: {
                heading: "تحديد سياسات الأمان",
                description:
                  "تكوين متطلبات كلمة المرور وسياسات الأمان للمنصة الخاصة بك.",
              },
              nationalitiesCard: {
                heading: "حظر الجنسيات",
                description:
                  "اختر الجنسيات التي تريد تقييدها من الوصول إلى المنصة.",
                placeholder: "البحث عن الجنسيات",
              },
            },
          },
          accessAndRestrictions: {
            page: {
              nationalitiesCard: {
                heading: "حظر الجنسيات",
                description:
                  "اختر الجنسيات التي تريد تقييدها من الوصول إلى المنصة.",
                placeholder: "البحث عن الجنسيات",
              },
              toast: {
                success: "تم تحديث سياسة كلمة المرور بنجاح",
                authenticationAndSecurityUpdated:
                  "تم تحديث التسجيل والأمان بنجاح",
                enterValidNumericValue: "يرجى إدخال قيمة رقمية صحيحة",
              },
              policy: {
                capitalLetter: {
                  title: "حرف كبير",
                  description: "يتطلب حرفًا كبيرًا واحدًا على الأقل (A-Z)",
                },
                lowercaseLetter: {
                  title: "حرف صغير",
                  description: "يتطلب حرفًا صغيرًا واحدًا على الأقل (a-z)",
                },
                number: {
                  title: "رقم",
                  description:
                    "يتطلب رقمًا واحدًا على الأقل في كلمة المرور (0-9)",
                },
                specialCharacter: {
                  title: "رمز خاص",
                  description: "يتطلب رمزًا واحدًا على الأقل (!@#$%^&* وغيرها)",
                },
                minimumLength: {
                  title: "الحد الأدنى للطول",
                  description: "حدد الحد الأدنى لعدد الأحرف المطلوبة",
                  label: "تحديد الطول",
                },
                forcePasswordChange: {
                  title: "فرض تغيير كلمة المرور",
                  description:
                    "يتطلب من المستخدمين تحديث كلمة المرور كل [X] يومًا",
                  label: "تحديد عدد الأيام",
                },
                avoidCommonPasswords: {
                  title: "تجنب كلمات المرور الشائعة",
                  description: "حظر كلمات المرور الشائعة أو سهلة التخمين",
                },
                disallowPreviousPasswords: {
                  title: "منع إعادة استخدام كلمات المرور",
                  description: "منع المستخدمين من التبديل بين نفس كلمات المرور",
                },
              },
              tab: {
                authentication: "التسجيل والأمان",
                passwordRequirements: "متطلبات كلمة المرور",
                securityPolicies: "سياسات الأمان",
                passwords: "كلمات المرور",
                nationalities: "الجنسيات",
                features: "الميزات",
                content: "المحتوى",
                citizenships: "الجنسيات",
              },
              contentCard: {
                heading: "معاملات الموظف",
                description:
                  "التحكم في المعلومات المعروضة في سجل معاملات الموظف.",
                feeBalance: {
                  title: "رصيد الرسوم",
                  description: "إظهار رصيد الرسوم في معاملات الموظف",
                },
                toast: { success: "تم تحديث إعدادات المحتوى" },
              },
              featuresCard: {
                heading: "إخفاء أو تمكين ميزات معينة للمنصة",
                description: "اختر الميزات التي تريد تمكينها أو إخفائها.",
                segmentEmployers: "لأصحاب العمل",
                segmentEmployees: "للموظفين",
                employeeAutoInvite: {
                  title: "دعوات الموظفين التلقائية",
                  description: "دعوة الموظفين تلقائيًا عند إضافتهم إلى المنصة.",
                },
                beneficiaries: {
                  title: "المستفيدون",
                  description:
                    "السماح للموظفين بإضافة أو تعديل تفاصيل المستفيدين.",
                },
                saml: {
                  title: "تسجيل الدخول الموحد (SSO)",
                  description:
                    "السماح للمسؤولين بإعداد تسجيل الدخول الموحد باستخدام SAML.",
                },
                googleSignIn: {
                  title: "تسجيل الدخول عبر Google",
                  description:
                    "السماح للمستخدمين بتسجيل الدخول باستخدام حساب Google.",
                },
                marketOrderConfirmation: {
                  title: "تأكيد أوامر السوق",
                  description:
                    "مطالبة المسؤولين بتأكيد أوامر السوق قبل إرسالها.",
                },
                workflowConfiguration: {
                  title: "إعداد سير العمل",
                  description:
                    "تمكين مسارات العمل المُدارة من خلال إعدادات المنصة.",
                },
                dataEditor: {
                  title: "محرر البيانات",
                  description:
                    "السماح للمسؤولين بتعديل بيانات المنصة المدعومة بشكل جماعي.",
                },
                tasks: {
                  title: "المهام",
                  description:
                    "تمكين إدارة المهام ومسارات التشغيل القائمة على المهام.",
                },
                adminDashboard: {
                  title: "لوحة تحكم المسؤول",
                  description: "عرض تجربة لوحة التحكم لمسؤولي المنصة.",
                },
                transactionFees: {
                  title: "رسوم المعاملات",
                  description: "إظهار مبالغ الرسوم في سجل معاملات الموظف.",
                },
                statements: {
                  title: "الكشوفات",
                  description: "السماح للموظفين بعرض كشوفاتهم وتنزيلها.",
                },
                toast: { success: "تم تحديث ميزات المنصة." },
                activity: {
                  title: "النشاط",
                  description:
                    "إظهار صفحات النشاط، حيث يتم تتبع كل مرحلة من مراحل نشاط الشركة.",
                },
              },
              securityPoliciesCard: {
                heading: "تحديد سياسات الأمان",
                description:
                  "تكوين متطلبات كلمة المرور وسياسات الأمان للمنصة الخاصة بك.",
              },
              signInCard: {
                heading: "التحكم في التسجيل والأمان",
                description: "تحكم في كيفية الوصول إلى المنصة والبقاء آمنًا.",
                button: "حفظ",
                singleSignOn: "تسجيل الدخول الموحد (SSO)",
                singleSignOnDescription:
                  "السماح للمستخدمين بتسجيل الدخول باستخدام نظام تسجيل الدخول الخاص بشركتك",
                googleSignIn: "تسجيل الدخول باستخدام Google",
                googleSignInDescription:
                  "السماح للمستخدمين بتسجيل الدخول باستخدام حسابات Google.",
                inactivityTimeout: "مهلة انتهاء الجلسة بسبب عدم النشاط",
                inactivityTimeoutDescription:
                  "عدد الدقائق قبل تسجيل خروج المستخدم بسبب عدم النشاط. اتركه كما هو للإبقاء على الإعداد الافتراضي للبيئة.",
              },
            },
          },
          workflow: {
            new: {
              page: {
                title: "سير عمل غير مسمى",
                toast: {
                  productIdRequired: "يجب أن يكون لديك معرف المنتج",
                  workflowIdRequired: "معرف سير العمل مطلوب",
                  cannotCreateWorkflowWithoutProductId:
                    "لا يمكن إنشاء سير عمل بدون معرف المنتج",
                  workflowSaved: "تم حفظ السير العملي",
                  workflowUpdated: "تم تحديث السير العملي",
                  workflowPublished: "تم نشر السير العملي",
                  workflowDeactivated: "تم تعطيل السير العملي",
                  workflowStatusUpdated: "تم تحديث حالة سير العمل",
                  workflowVersionUpdated: "تم تحديث إصدار سير العمل",
                },
                badgeLabel: {
                  draft: "غير منشور",
                  active: "مباشر",
                  inactive: "معطل",
                },
                nodeTemplates: { trigger: "مشغل" },
              },
            },
            page: {
              badgeLabel: { draft: "غير منشور" },
              topNavigation: {
                exitBuilder: "الخروج من المنشئ",
                publishWorkflow: "نشر السير العملي",
                unpublishWorkflow: "إلغاء نشر سير العمل",
                publishFeeModal: {
                  title: "نشر سير العمل هذا",
                  description:
                    "لم تقم بتعيين سير العمل هذا لأي شركات أو منتجات بعد. يمكنك القيام بذلك من إعدادات سير العمل.",
                  skipAndSaveAsDraft: "تخطي وحفظ كمسودة",
                  goToWorkflowSettings: "الذهاب إلى إعدادات سير العمل",
                },
              },
              versionHistory: {
                title: "سجل الإصدارات",
                current: "الحالي",
                pendingSummary: "جارٍ إنشاء الملخص...",
                useThisVersion: "استخدام هذا الإصدار",
                renameTitle: "إعادة تسمية الإصدار",
                renamePlaceholder: "أدخل اسم الإصدار",
                deleteTitle: "حذف الإصدار",
                deleteDescription: "هل أنت متأكد أنك تريد حذف هذا الإصدار؟",
                deleteConfirm: "حذف الإصدار",
              },
              versionBanners: {
                latest: {
                  text: "هذا ليس أحدث إصدار من هذا السير العملي.",
                  action: "الانتقال إلى أحدث إصدار",
                },
                live: {
                  text: "هذا ليس الإصدار الحي حاليًا من هذا السير العملي.",
                  action: "الانتقال إلى الإصدار الحي",
                  cta: "اجعل هذا الإصدار حيًا",
                },
              },
              readOnlyBanner: {
                text: "تتم إدارة هذا السير العملي في الشيفرة البرمجية ولا يمكن تعديله هنا.",
              },
              shared: {
                dataSourceBadges: {
                  retrievingDataFrom: "استرداد البيانات من:",
                },
              },
              nameModal: {
                title: "اسم السير العملي",
                nameLabel: "اسم القالب",
                descriptionLabel: "وصف القالب",
                save: "حفظ القالب",
              },
              leftSidebar: {
                vestHoldings: "الحيازات المؤقتة",
                upcomingPaymentNotice: "إشعار الدفعة القادمة",
                notification: "إشعار",
                attachment: "مرفق",
                triggers: "التسللات",
                hooks: "الخطافات",
                query: {
                  title: "البيانات المطلوبة",
                  displayName: "البيانات",
                  defaultRules: {
                    queryType: {
                      name: "نوع البيانات",
                      options: [
                        "بيانات الموظف",
                        "بيانات الشركة",
                        "بيانات المنتج",
                        "بيانات مخصصة",
                      ],
                    },
                    cacheResults: { name: "تخزين النتائج" },
                  },
                },
                transform: "التحويل",
                timer: "المؤقت",
                gate: "البوابة",
                condition: "شرط",
                payment: "الدفع",
                marketOrder: "طلب السوق",
                barrier: "حاجز",
                workflow: "سير العمل",
                aumFee: "رسوم إدارة الأصول",
              },
              pwbsidebar: {
                search: "بحث",
                noResultFound: "لم يتم العثور على نتائج",
                categories: {
                  initiations: "البدء",
                  dataAndLogic: "البيانات والمنطق",
                  actions: "الإجراءات",
                  communications: "الاتصالات",
                  conditions: "الشروط",
                },
              },
              entities: {
                employee: {
                  title: "الموظف",
                  description: "سجلات ومعلومات الموظفين",
                },
                productAssignment: {
                  title: "الموظف-المنتج",
                  description: "خصائص الموظف لمنتجات محددة",
                },
                company: {
                  title: "الشركة",
                  description: "معلومات الشركة والمؤسسة",
                },
                product: {
                  title: "المنتج",
                  description: "كتالوج ومعلومات المنتجات",
                },
                holding: {
                  title: "الحيازة",
                  description: "معلومات وخصائص الحيازة",
                },
                fundPrice: {
                  title: "أحدث أسعار الصندوق",
                  description: "أحدث سعر للصندوق لكل رمز ISIN",
                },
                fundPriceHistory: {
                  title: "السعر التاريخي للصندوق",
                  description:
                    "سجل كامل لأسعار الصندوق لكل رمز ISIN، لتحديد السعر في تاريخ سابق",
                },
                aumFee: {
                  title: "رسوم إدارة الأصول",
                  description: "رسوم إدارة الأصول المستحقة لكل حيازة موظف",
                },
                paymentLineItem: {
                  title: "الدفع",
                  description: "بنود الدفع المرتبطة بتخصيصات منتجات الموظفين",
                },
                marketOrderTransaction: {
                  title: "معاملة أمر السوق",
                  description:
                    "معاملات أوامر السوق المرتبطة بتخصيصات منتجات الموظفين",
                },
                user: {
                  title: "المستخدم",
                  description: "مستخدمو المنصة وأدوارهم",
                },
                investmentTransaction: {
                  title: "معاملة استثمارية",
                  description:
                    "المساهمات والسحوبات لكل موظف، مطابقة مسبقًا للصندوق والمبلغ",
                },
                portfolio: {
                  title: "المحفظة",
                  description:
                    "القيمة الافتتاحية والختامية والوحدات والتدفق النقدي لكل صندوق خلال فترة التقرير",
                },
              },
              rulesSidebarDrawer: {
                title: (category) => `تكوين العقدة ${category}`,
                backToTriggerRules: "العودة إلى قواعد التسلل",
                triggers: {
                  title: "كيف تعمل العقد التسللية",
                  description:
                    "تعرف العقد التسللية على أنها العقد التي تحدد متى يبدأ السير العملي. استخدم الجدول لبدء السير العملي بناءً على الوقت (على سبيل المثال، 'كل 1st في 09:00') والحدث لبدء السير العملي بناءً على الحدث. النطاق يحدد مكان تنفيذه (المنصة).",
                },
              },
              nodeTemplates: {
                trigger: "مشغل",
                eventHookTrigger: "مشغل خطاف الحدث",
                endOfEmployment: "نهاية التوظيف",
                formSubmission: "إرسال النموذج",
                dateReached: "تم الوصول للتاريخ",
                sendEmail: "إرسال بريد إلكتروني",
                createTask: "إنشاء مهمة",
                updateRecord: "تحديث السجل",
                setWaitPeriod: "تحديد فترة الانتظار",
                timer: "المؤقت",
                changeSubscription: "تغيير الاشتراك",
                convertDataFormat: "تحويل تنسيق البيانات",
                mapFields: "ربط الحقول",
                filterData: "تصفية البيانات",
                processPayment: "معالجة الدفع",
                refundPayment: "استرداد الدفع",
                verifyPayment: "التحقق من الدفع",
                validateEmail: "التحقق من البريد الإلكتروني",
                validatePhoneNumber: "التحقق من رقم الهاتف",
                checkRequiredFields: "التحقق من الحقول المطلوبة",
                query: "استعلام",
                companyDataQuery: "استعلام بيانات الشركة",
                productDataQuery: "استعلام بيانات المنتج",
                marketOrder: "أمر السوق",
                barrier: "حاجز",
                aumFee: "رسوم إدارة الأصول",
                vestHoldings: "الحيازات المؤقتة",
                upcomingPaymentNotice: "إشعار الدفعة القادمة",
                notification: "إشعار",
                attachment: "مرفق",
                gate: "البوابة",
                condition: "شرط",
                rules: {
                  triggerType: "نوع المشغل",
                  scheduleScope: "نطاق الجدولة",
                  frequency: "التكرار",
                  runOn: "تشغيل في",
                  eventType: "نوع الحدث",
                  employeeStatus: "حالة الموظف",
                  noticePeriod: "فترة الإشعار",
                  formType: "نوع النموذج",
                  dateCondition: "شرط التاريخ",
                  emailTemplate: "قالب البريد الإلكتروني",
                  sendImmediately: "إرسال فوري",
                  taskPriority: "أولوية المهمة",
                  assignTo: "تعيين إلى",
                  recordType: "نوع السجل",
                  updateFields: "تحديث الحقول",
                  waitingTime: "وقت الانتظار",
                  businessDaysOnly: "أيام العمل فقط",
                  subscriptionType: "نوع الاشتراك",
                  autoRenewal: "التجديد التلقائي",
                  sourceFormat: "تنسيق المصدر",
                  targetFormat: "التنسيق المستهدف",
                  preserveFormatting: "الحفاظ على التنسيق",
                  sourceField: "حقل المصدر",
                  targetField: "الحقل المستهدف",
                  applyTransformation: "تطبيق التحويل",
                  filterCondition: "شرط التصفية",
                  includeEmptyValues: "تضمين القيم الفارغة",
                  paymentMethod: "طريقة الدفع",
                  currency: "العملة",
                  sendReceipt: "إرسال إيصال",
                  refundType: "نوع الاسترداد",
                  reasonRequired: "السبب مطلوب",
                  verificationMethod: "طريقة التحقق",
                  fraudDetection: "كشف الاحتيال",
                  checkFormat: "التحقق من التنسيق",
                  verifyDomain: "التحقق من النطاق",
                  checkDisposable: "التحقق من المؤقت",
                  countryCode: "رمز البلد",
                  formatValidation: "التحقق من التنسيق",
                  requiredFields: "الحقول المطلوبة",
                  allowPartialValidation: "السماح بالتحقق الجزئي",
                  queryType: "نوع الاستعلام",
                  cacheResults: "تخزين النتائج",
                  orderType: "نوع الأمر",
                  customRecurringDate: "تاريخ التكرار المخصص",
                  timeZone: "المنطقة الزمنية",
                },
                values: {
                  schedule: "جدولة",
                  hook: "خطاف",
                  then: "عند تحقق الشرط",
                  else: "عند عدم تحقق الشرط",
                  platform: "المنصة",
                  product: "المنتج",
                  daily: "يومي",
                  weekly: "أسبوعي",
                  monthly: "شهري",
                  quarterly: "ربع سنوي",
                  yearly: "سنوي",
                  custom: "مخصص",
                  payrollDay: "يوم الراتب",
                  monthEnd: "نهاية الشهر",
                  quarterEnd: "نهاية الربع",
                  anniversaryDate: "تاريخ الذكرى",
                  customDate: "تاريخ مخصص",
                  withdrawalRequested: "طلب_سحب",
                  employeeTerminated: "إنهاء_موظف",
                  employeeFundSwitched: "تبديل_صندوق_الموظف",
                  citizenshipBlocked: "حظر_الجنسية",
                  active: "نشط",
                  terminated: "منهي",
                  onLeave: "في إجازة",
                  thirtyDays: "30 يوم",
                  contactForm: "نموذج التواصل",
                  registrationForm: "نموذج التسجيل",
                  feedbackForm: "نموذج التغذية الراجعة",
                  specificDate: "تاريخ محدد",
                  defaultTemplate: "القالب الافتراضي",
                  welcomeTemplate: "قالب الترحيب",
                  reminderTemplate: "قالب التذكير",
                  low: "منخفض",
                  medium: "متوسط",
                  high: "عالي",
                  critical: "حرج",
                  defaultAssignee: "المعين الافتراضي",
                  userRecord: "سجل المستخدم",
                  status: "الحالة",
                  sevenDays: "7 أيام",
                  basicSubscription: "اشتراك أساسي",
                  premiumSubscription: "اشتراك مميز",
                  enterpriseSubscription: "اشتراك مؤسسي",
                  json: "JSON",
                  xml: "XML",
                  csv: "CSV",
                  yaml: "YAML",
                  firstName: "firstName",
                  firstNameUnderscore: "first_name",
                  statusActive: "status = active",
                  ageGreaterThan18: "age > 18",
                  verifiedTrue: "verified = true",
                  creditCard: "بطاقة ائتمان",
                  bankTransfer: "حوالة مصرفية",
                  paypal: "PayPal",
                  stripe: "Stripe",
                  usd: "USD",
                  eur: "EUR",
                  gbp: "GBP",
                  cad: "CAD",
                  fullRefund: "استرداد كامل",
                  partialRefund: "استرداد جزئي",
                  manualReview: "مراجعة يدوية",
                  automatedCheck: "فحص آلي",
                  thirdPartyService: "خدمة طرف ثالث",
                  us: "الولايات المتحدة",
                  ca: "كندا",
                  uk: "المملكة المتحدة",
                  au: "أستراليا",
                  international: "دولي",
                  nameEmailPhone: "الاسم، البريد الإلكتروني، الهاتف",
                  employeeData: "بيانات الموظف",
                  companyData: "بيانات الشركة",
                  productData: "بيانات المنتج",
                  customQuery: "استعلام مخصص",
                  buy: "شراء",
                  sell: "بيع",
                  switch: "تبديل",
                },
              },
              nodeConfig: {
                shared: {
                  dataSourceSelector: {
                    label: "مصدر البيانات",
                    description:
                      "اختر العقدة المرتبطة بالمتدفق والتي ستوفر البيانات لهذه العملية.",
                    placeholder: "اختر العقد",
                  },
                  ruleAccordion: {
                    customScheduleInfo:
                      'تكوين الجدولة المخصصة متاح في العرض المتقدم. ستظهر إعدادات الجدولة التفصيلية أعلاه عند اختيار تكرار "مخصص".',
                    noRulesConfigured: "لا توجد قواعد مكونة لهذه العقدة.",
                  },
                  validation: {
                    dataSourceRequired: "يجب تحديد مصدر بيانات واحد على الأقل",
                  },
                  code: {
                    stale:
                      "تغيّرت المدخلات — ستتم إعادة توليد الشيفرة في التشغيل التالي",
                  },
                },
                gate: {
                  title: "كيف تعمل عقد البوابة",
                  description:
                    "تقوم عقد البوابة بتقييم تعبير من سياق سير العمل الخاص بك مقابل قيمة متوقعة باستخدام مشغل مقارنة. يسمح لك ذلك بتنفيذ المنطق الشرطي ومنع البيانات غير الصالحة من التقدم في سير العمل.",
                  backToGateRules: "العودة إلى قواعد البوابة",
                  noValue: "لا توجد قيمة",
                  inputExpression: {
                    label: "تعبير الإدخال",
                    description:
                      "المعلومات التي يجب فحصها من سير العمل الخاص بك. يجب أن تكون محاطة بأقواس مجعدة، مثل {'query:1.result.0.kycVerified'}'",
                  },
                  operator: {
                    label: "المشغل",
                    description:
                      "كيفية مقارنة المعلومات بالقيمة (يساوي، أكبر من، موجود، إلخ)",
                    placeholder: "البحث",
                  },
                  value: {
                    label: "القيمة",
                    description:
                      "ما يجب أن تكون عليه القيمة لكي يستمر سير العمل. مثل صواب أو خطأ",
                    configure: "تكوين",
                  },
                  operators: {
                    equals: "يساوي",
                    notEquals: "لا يساوي",
                    greaterThan: "أكبر من",
                    lessThan: "أقل من",
                    greaterThanOrEqual: "أكبر من أو يساوي",
                    lessThanOrEqual: "أقل من أو يساوي",
                    exists: "موجود",
                    includedInArray: "مدرج في المصفوفة",
                  },
                  valueConfig: {
                    setValueType: "تحديد نوع القيمة",
                    description:
                      "اختر نوع القيمة للمقارنة مع التعبير الخاص بك.",
                    types: {
                      boolean: "صواب/خطأ",
                      number: "رقم",
                      string: "نص",
                      array: "مصفوفة نصوص",
                    },
                    booleanValues: { true: "صواب", false: "خطأ" },
                    inputs: { number: "رقم", string: "نص" },
                    array: { title: "مصفوفة نصوص", addItem: "إضافة عنصر" },
                  },
                  validation: {
                    expressionFormat:
                      "يجب أن يكون التعبير محاطًا بأقواس معقوفة، مثل {query:1.result}'",
                    valueRequired: "القيمة مطلوبة",
                  },
                },
                condition: {
                  title: "كيف تعمل عقد الشرط",
                  description:
                    "تقوم عقد الشرط بتقييم تعبير من سياق سير العمل الخاص بك مقابل قيمة متوقعة باستخدام مشغل مقارنة. يسمح لك ذلك بتفرّع سير العمل بناءً على ما إذا كان الشرط صحيحاً أم لا.",
                  backToGateRules: "العودة إلى قواعد الشرط",
                  noValue: "لا توجد قيمة",
                  inputExpression: {
                    label: "تعبير الإدخال",
                    description:
                      "المعلومات التي يجب فحصها من سير العمل الخاص بك. يجب أن تكون محاطة بأقواس مجعدة، مثل {'query:1.result.0.kycVerified'}'",
                  },
                  operator: {
                    label: "المشغل",
                    description:
                      "كيفية مقارنة المعلومات بالقيمة (يساوي، أكبر من، موجود، إلخ)",
                    placeholder: "البحث",
                  },
                  value: {
                    label: "القيمة",
                    description:
                      "ما يجب أن تكون عليه القيمة لكي يتفرع سير العمل. مثل صواب أو خطأ",
                    configure: "تكوين",
                  },
                  operators: {
                    equals: "يساوي",
                    notEquals: "لا يساوي",
                    greaterThan: "أكبر من",
                    lessThan: "أقل من",
                    greaterThanOrEqual: "أكبر من أو يساوي",
                    lessThanOrEqual: "أقل من أو يساوي",
                    exists: "موجود",
                    includedInArray: "مدرج في المصفوفة",
                  },
                  valueConfig: {
                    setValueType: "تحديد نوع القيمة",
                    description:
                      "اختر نوع القيمة للمقارنة مع التعبير الخاص بك.",
                    types: {
                      boolean: "صواب/خطأ",
                      number: "رقم",
                      string: "نص",
                      array: "مصفوفة نصوص",
                    },
                    booleanValues: { true: "صواب", false: "خطأ" },
                    inputs: { number: "رقم", string: "نص" },
                    array: { title: "مصفوفة نصوص", addItem: "إضافة عنصر" },
                  },
                },
                barrier: {
                  title: "كيف تعمل عقد الحاجز",
                  description:
                    "تقوم عقد الحاجز بإيقاف سير العمل حتى تنتهي جميع تشغيلات تعريفات سير العمل المحددة لنفس النطاق.",
                  workflowDefinitionIds: {
                    label: "تعريفات سير العمل المطلوب انتظارها",
                    description:
                      "اختر تعريفات سير العمل. ينتظر سير العمل حتى تكتمل جميع التشغيلات الجارية لهذه التعريفات ضمن نفس النطاق.",
                    placeholder: "اختر تعريفات سير العمل...",
                  },
                  workflowKeys: {
                    label: "مفاتيح سير العمل التي ينتظرها هذا الحاجز",
                    description:
                      "تُضبط في إعدادات سير العمل. ينتظر سير العمل حتى تكتمل جميع التشغيلات الجارية لهذه الأنواع ضمن نفس النطاق.",
                    empty: "هذا الحاجز لا ينتظر أي سير عمل.",
                  },
                  validation: {
                    workflowDefinitionsRequired: "تعريفات سير العمل مطلوبة",
                  },
                },
                marketOrder: {
                  title: "كيف تعمل عقد أوامر السوق",
                  description:
                    "تنفذ عقد الاستثمار أوامر السوق باستخدام التحليل المدعوم بالذكاء الاصطناعي. يمكنها استقبال البيانات من عقد التحويل/الاستعلام للتحليل أثناء انتظار اكتمال تبعيات الدفع/التنفيذ أولاً.",
                  instructions: {
                    label: "تعليمات أوامر السوق",
                    description:
                      "اشرح بوضوح كيف يجب تحويل البيانات إلى أوامر سوق. لكل أمر، حدّد نوع الأمر (شراء/بيع/تحويل) ومعرّف الشركة. قدّم قائمة بالمعاملات، ويجب أن تتضمن كل معاملة معرّف تعيين المنتج للموظف، ومبلغ التداول نقداً أو بوحدات، وأرقام ISIN. لطلبات الشراء، حدّد أيضاً قواعد الاستحقاق. ويمكنك إضافة تفاصيل إضافية مثل معلومات الصندوق وفئة الحصة.",
                    placeholder:
                      "مثال: احسب إجمالي التعويض بإضافة الراتب_الأساسي + المكافأة + قيمة_الأسهم. صفي الموظفين بحالة 'نشط' وتاريخ_التوظيف > 2020. طبق تحويل العملة حسب الحاجة.",
                  },
                  validation: { instructionsRequired: "التعليمات مطلوبة" },
                },
                aumFee: {
                  title: "كيف تعمل عقد رسوم إدارة الأصول",
                  description:
                    "تحسب عقد الرسوم رسوم إدارة الأصول اليومية لكل حيازة موظف باستخدام التحليل المدعوم بالذكاء الاصطناعي. تحسب الرسوم بناءً على المعدل السنوي ومراكز الصناديق الحالية، وتخزن النتائج كرسوم معلقة للتحصيل لاحقاً.",
                  computation: {
                    label: "حساب الرسوم",
                    percentage: "نسبة مئوية",
                    customLogic: "منطق مخصص",
                    percentageHint: "اختر معدل الرسوم السنوي بين 0–1%",
                    customHint:
                      "صف كيف يجب حساب الرسوم بلغة بسيطة. سيقوم الذكاء الاصطناعي بتفسير وتطبيق منطقك.",
                  },
                  instructions: {
                    label: "تعليمات حساب الرسوم",
                    description:
                      "حدد كيفية حساب الرسوم باستخدام بيانات الحيازات وأسعار الصناديق.",
                    placeholder:
                      "مثال: لكل حيازة موظف، احسب الرسوم اليومية بتطبيق المعدل السنوي على إجمالي قيمة المركز. استخدم آخر سعر للصندوق لتحويل الوحدات إلى قيمة نقدية.",
                  },
                  validation: {
                    percentageRequired: "النسبة المئوية مطلوبة",
                    percentageExceedsMax: "لا يمكن أن تتجاوز النسبة المئوية 1%",
                    instructionsRequired: "التعليمات مطلوبة",
                  },
                },
                payment: {
                  title: "كيف تعمل عقد الدفع",
                  description:
                    "كوّن حسابات المرسل/المستقبل، العملة، مسارات بيانات الإدخال، وتعليمات معالجة الدفع.",
                  currency: { label: "العملة", placeholder: "اختر العملة" },
                  instructions: {
                    label: "تعليمات الدفع",
                    description:
                      "اشرح بوضوح كيف يجب تحويل البيانات إلى دفعات. لكل دفعة، حدّد المرسل والمستلم ورقم الآيبان للتحويل البنكي. ثم قسّم كل دفعة إلى بند واحد أو أكثر. يجب أن يتضمن كل بند المصدر وفئة الدفع والمبلغ المقابل. يمكنك أيضاً إضافة تفاصيل إضافية مثل معلومات الراتب.",
                    placeholder:
                      "مثال: احسب إجمالي التعويض بإضافة الراتب_الأساسي + المكافأة + قيمة_الأسهم. صفي الموظفين بحالة 'نشط' وتاريخ_التوظيف > 2020. طبق تحويل العملة حسب الحاجة.",
                  },
                  tabs: { payment: "الدفع", invoice: "الفاتورة" },
                  yourPayments: "دفعاتك",
                  configurePayment: "ضبط الدفعة",
                  addPayment: "إضافة دفعة",
                  backToPayments: "العودة إلى الدفعات",
                  defaultPaymentTitle: "دفعة",
                  deleteConfirm: {
                    title: "إزالة الدفعة؟",
                    description:
                      "سيتم إزالة هذه الدفعة وجميع إعداداتها نهائيًا.",
                  },
                  invoice: {
                    billedBy: "صادر من",
                    billedTo: "صادر إلى",
                    paymentName: "اسم الدفعة",
                    paymentNameDescription:
                      "سيظهر هذا الاسم على الفاتورة ويُعرِّف هذه الدفعة في إعدادات الدفع.",
                    paymentNamePlaceholder: "مثال: رسوم المشاركة",
                    description: "الوصف",
                    descriptionDescription:
                      "سيظهر هذا على الفاتورة لوصف الدفعة بمزيد من التفاصيل.",
                    descriptionPlaceholder: "مثال: الفوترة الشهرية",
                    taxRate: "معدل الضريبة",
                    taxRateDescription:
                      "نسبة مبلغ الدفعة التي تُطبَّق كضريبة. أدخل قيمة بين 0 و100.",
                    taxRatePlaceholder: "مثال: 5",
                  },
                  validation: {
                    currencyRequired: "العملة مطلوبة",
                    instructionsRequired: "التعليمات مطلوبة",
                    paymentsRequired: "يجب إضافة دفعة واحدة على الأقل",
                    taxRateInvalid: "يجب أن يكون معدل الضريبة بين 0% و100%",
                  },
                  routing: {
                    modeLabel: "وضع الدفع",
                    modeGuided: "موجّه",
                    modeCustom: "مخصص",
                    senderType: "نوع المرسل",
                    recipientType: "نوع المستلم",
                    iban: "رقم الآيبان",
                    swiftCode: "رمز السويفت (اختياري)",
                    bankName: "اسم البنك (اختياري)",
                    category: "فئة الدفع",
                    lineItemLogic: "منطق بنود الدفع",
                    lineItemLogicDescription:
                      "اشرح كيفية تجميع المبالغ وحسابها لهذه الدفعة. لا تُدرج تفاصيل التوجيه — فهي محددة في الحقول البنيوية أعلاه.",
                    lineItemLogicPlaceholder:
                      "مثال: قسّم حسب الشركة واجمع رسوم كل عضو بالنسبة لحصته كبند.",
                    customPlaceholder:
                      "اشرح كيفية توجيه هذه الدفعة: المرسل، المستلم، الآيبان، وبنود الدفع.",
                  },
                },
                query: {
                  title: "كيف تعمل عقد الاستعلام",
                  description:
                    "تستخرج عقد الاستعلام أعمدة مختارة من كيان محدد وتصدر مجموعة بيانات نظيفة للخطوات اللاحقة. استخدم المرشحات والتخطيط للاحتفاظ بما هو مطلوب فقط وتوحيد أسماء الحقول.",
                  dataSource: {
                    label: "مصدر البيانات",
                    description:
                      "اختر أي عقدة سابقة ستوفر البيانات لهذه العملية.",
                    placeholder: "اختر كياناً...",
                  },
                  columns: {
                    selectedCount: ({ selected, total }) =>
                      `${selected} من ${total} أعمدة محددة`,
                  },
                  noEntity: {
                    title: "لم يتم اختيار كيان",
                    description: "اختر كياناً أعلاه لتكوين استعلامك",
                  },
                  window: {
                    label: "نطاق اللقطة",
                    description: "اختر بداية ونهاية لقطة المحفظة هذه.",
                    mode: {
                      label: "بداية الفترة",
                      placeholder: "اختر بداية...",
                      sinceInception: "منذ البداية",
                      relative: "نسبةً إلى نهاية الفترة",
                    },
                    value: { label: "القيمة", placeholder: "مثال: 6" },
                    unit: {
                      label: "الوحدة",
                      placeholder: "اختر وحدة...",
                      days: "أيام",
                      months: "أشهر",
                      years: "سنوات",
                    },
                    periodEnd: {
                      label: "نهاية الفترة",
                      description:
                        "عدد الأشهر المكتملة للرجوع إليها من اليوم. الافتراضي 0 لأحدث البيانات.",
                      placeholder: "مثال: 0",
                    },
                  },
                },
                transform: {
                  title: "كيف تعمل عقد التحويل",
                  description:
                    "تستقبل عقد التحويل البيانات من العقد المتصلة وتطبق قواعد التحويل الخاصة بك لإنتاج تنسيق الإخراج المحدد. بيانات الإدخال متاحة تلقائياً من الاتصالات السابقة.",
                  rules: {
                    label: "قواعد التحويل",
                    description:
                      "حدد كيفية تحويل بيانات الإدخال. صف المنطق، الحسابات، أو معالجة البيانات المطلوبة.",
                    placeholder:
                      "مثال: احسب إجمالي التعويض بإضافة الراتب_الأساسي + المكافأة + قيمة_الأسهم. صفي الموظفين بحالة 'نشط' وتاريخ_التوظيف > 2020. طبق تحويل العملة حسب الحاجة.",
                  },
                  outputFormat: {
                    label: "تنسيق الإخراج",
                    description:
                      "صف هيكل وحقول JSON الإخراج. حدد كل حقل ونوع بياناته.",
                    placeholder:
                      "مثال: حدد هيكل الإخراج مع أسماء الحقول وأنواع البيانات، مثل معلومات الموظف مع تفاصيل التعويض والتواريخ الفعلية.",
                  },
                  code: {
                    label: "الكود المُنشأ",
                    description:
                      "كود JavaScript يُنفَّذ عند تشغيل سير العمل. يُنشأ تلقائياً من القواعد وتنسيق الإخراج عند أول تشغيل لسير العمل ويُخزَّن هنا، ثم عدّله عند الحاجة.",
                    placeholder:
                      "// يتم إنشاء الكود تلقائياً وتخزينه هنا بعد أول تشغيل لسير العمل، أو الصق الكود هنا.",
                    generate: "إنشاء الكود",
                  },
                  validation: {
                    rulesRequired: "قواعد التحويل مطلوبة",
                    outputFormatRequired: "تنسيق الإخراج مطلوب",
                  },
                },
                timer: {
                  title: "كيف تعمل عقد المؤقت",
                  description:
                    "تقوم عقد المؤقت بإيقاف سير العمل لمدة زمنية محددة قبل المتابعة.",
                  duration: {
                    label: "المدة",
                    description:
                      'استخدم مدة مفهومة مثل "2 days" أو "15 minutes" أو "500ms".',
                    placeholder: "2 days",
                  },
                  validation: {
                    durationRequired: "المدة مطلوبة",
                    durationInvalid: "يجب أن تكون المدة بتنسيق صالح",
                  },
                },
                vestHoldings: {
                  title: "كيف تعمل عقد الاستحقاق",
                  description:
                    "تأخذ عقد الاستحقاق الحيازات الحالية كمدخلات وتقوم فوراً باستحقاق جميع الحيازات غير المستحقة. يتيح لك ذلك تحديث حالة استحقاق الحيازة تلقائياً في نقاط محددة في سير العمل بناءً على منطق الاستحقاق والشروط الخاصة بك.",
                },
                upcomingPaymentNotice: {
                  title: "كيف تعمل عقد إشعار الدفعات القادمة",
                  description:
                    "تستخدم عقد إشعار الدفعات القادمة بيانات الدفع من المصدر المحدد لإرسال تنبيهات قبل مواعيد الاستحقاق. استخدمها لإخطار أصحاب المصلحة قبل معالجة الدفعات وفقاً لمنطق الجدولة الذي تصممه في سير العمل.",
                },
                notification: {
                  title: "كيف تعمل عقد الإشعارات",
                  description:
                    "ترسل عقد الإشعارات إشعارات بريد إلكتروني عند وصول سير العمل إلى هذه الخطوة.",
                  to: {
                    label: "إلى",
                    description: "عنوان البريد الإلكتروني للمستلم.",
                    placeholder: "recipient@example.com",
                  },
                  bcc: {
                    label: "نسخة مخفية",
                    description:
                      "عنوان البريد الإلكتروني للنسخة المخفية (اختياري).",
                    placeholder: "bcc@example.com",
                  },
                  subject: {
                    label: "الموضوع",
                    description: "سطر موضوع البريد الإلكتروني.",
                    placeholder: "تم تجهيز كشوف الرواتب",
                  },
                  message: {
                    label: "الرسالة",
                    description: "نص رسالة البريد الإلكتروني.",
                    placeholder:
                      "كتابة رسالة بريد إلكتروني لإرسالها عند تنفيذ هذه الخطوة.",
                  },
                  attachment: {
                    content: {
                      label: "محتوى المرفق",
                      description: "تعبير يُحلّ إلى مخزن الملف من عقدة سابقة.",
                      placeholder: "e.g. attachment:1.result.content",
                    },
                    filename: {
                      label: "اسم ملف المرفق",
                      description: "اسم الملف أو تعبير يُحلّ إلى اسم الملف.",
                      placeholder: "report.xlsx",
                    },
                  },
                },
                attachment: {
                  title: "كيف تعمل عقد المرفقات",
                  description:
                    "تحدد عقد المرفقات مخرجات المرفقات بناءً على القواعد المهيأة والبيانات من عقد الإدخال المتصلة.",
                  instructions: {
                    label: "التعليمات",
                    description: "حدد كيفية حفظ هذا المرفق في قاعدة البيانات.",
                    placeholder: "تعليمات حفظ المرفق هنا",
                  },
                  documentType: {
                    label: "نوع المستند",
                    description: "اختر نوع المستند الذي تريد تهيئته.",
                    options: { pdf: "PDF", excel: "Excel" },
                  },
                  template: {
                    label: "اختر القالب",
                    placeholder: "اختر القالب",
                  },
                  templates: { employeeStatement: "كشف حساب الموظف" },
                },
              },
              toast: {
                workflowSaved: "تم حفظ السير العملي",
                workflowUpdated: "تم تحديث السير العملي",
                versionRenamed: "تمت إعادة تسمية الإصدار",
                versionDeleted: "تم حذف الإصدار",
                nodeDeleted: "تم حذف العقدة",
                cannotDeleteTrigger: "لا يمكن حذف عقدة المشغل",
              },
            },
          },
          compliance: {
            page: {
              controls: {
                compliance: {
                  companyStatus: {
                    companyInReviewTitle: "هذا كل ما نحتاجه للآن.",
                    companyInReviewDescription:
                      "سنقوم بالتوصل بك عندما نتحقق من المستندات. بما أن الشركة قد تم التحقق منها، ستتمكن من الوصول إلى كل ما تحتاجه لبدء إضافة الموظفين، الفوائد، ومعالجة الدفع.",
                    companyRejectedTitle: "لم تتم الموافقة على التحقق من شركتك",
                    companyRejectedDescription:
                      "لقد قمنا بمراجعة مستندات شركتك والتحقق منها، إلا أن المسؤول لم يتمكن من الموافقة على طلبك. لن تتمكن من متابعة إعداد شركتك. لمزيد من المعلومات حول سبب هذا القرار والخطوات التالية، يُرجى التواصل مع المسؤول الخاص بك. ",
                  },
                  home: {
                    cards: {
                      companyDocuments: {
                        title: "إدارة مستندات الشركة",
                        description: "حدد المستندات المطلوبة على مستوى الشركة",
                      },
                      signatoryDocuments: {
                        title: "إدارة مستندات المفوضين بالتوقيع",
                        description:
                          "إدارة المستندات التي سيتم طلبها من كل مفوض بالتوقيع",
                      },
                      kycDocuments: {
                        title: "إدارة مستندات الموظفين",
                        description:
                          "حدد المستندات المطلوبة للتحقق من هوية الموظفين",
                      },
                    },
                    kybHeading: "اعرف عملك (KYB)",
                    kycHeading: "اعرف عملك (KYC)",
                  },
                  kybDocuments: {
                    companyDocuments: "مستندات الشركة",
                    signatoryDocuments: "مستندات المفوضين بالتوقيع",
                    messages: {
                      unsavedChanges:
                        "لديك تغييرات غير محفوظة. هل أنت متأكد من رغبتك في الخروج من هذه الصفحة؟",
                      saveSuccess: "تم حفظ المستندات بنجاح",
                      editSuccess: "تم تحديث المستند بنجاح",
                    },
                    errors: {
                      saveFailed: "فشل حفظ المستندات، يرجى المحاولة مرة أخرى",
                    },
                    header: {
                      companyTitle: "إدارة مستندات الشركة",
                      companyDescription:
                        "حدد المستندات المطلوبة على مستوى الشركة",
                      signatoryTitle: "إدارة مستندات المفوضين بالتوقيع",
                      signatoryDescription:
                        "إدارة المستندات التي سيتم طلبها من كل مفوض بالتوقيع.",
                      title: "أنواع مستندات KYC",
                      description:
                        "حدد المستندات المطلوبة للتحقق من هوية الموظفين.",
                    },
                    actions: {
                      optional: "اختياري",
                      add: "إضافة مستند",
                      edit: "تحرير المستند",
                      remove: "حذف المستند",
                      save: "حفظ التغييرات",
                      deleteDocument: "حذف المستند",
                      deleteDocumentWarning:
                        "هل أنت متأكد من رغبتك في حذف هذا المستند؟ سيؤدي هذا إلى حذف المستندات المرفوعة بجميع اللغات. لا يمكنك التراجع عن هذا الإجراء بعد ذلك.",
                      cancel: "إلغاء",
                      documentName: "اسم المستند",
                      documentDescription: "الوصف",
                      makeDocumentMandatory: "جعل المستند إلزامياً",
                      makeDocumentMandatoryDescription:
                        "سيحتاج المستخدمون إلى تقديم هذا المستند من أجل اجتياز التحقق.",
                    },
                    required: "إلزامي",
                    optional: "اختياري",
                  },
                  kycDocuments: {
                    title: "مستندات الموظف",
                    messages: { saveSuccess: "تم حفظ المستندات بنجاح" },
                    errors: {
                      saveFailed: "فشل حفظ المستندات، يرجى المحاولة مرة أخرى",
                    },
                    header: {
                      title: "أنواع مستندات KYC",
                      description:
                        "حدد المستندات المطلوبة للتحقق من هوية الموظفين.",
                    },
                    actions: {
                      add: "إضافة مستند",
                      edit: "تحرير المستند",
                      remove: "حذف المستند",
                      save: "حفظ التغييرات",
                      cancel: "إلغاء",
                      optional: "اختياري",
                      documentName: "اسم المستند",
                      documentDescription: "الوصف",
                    },
                    required: "إلزامي",
                    optional: "اختياري",
                  },
                },
              },
            },
          },
          marketOrderSupport: {
            page: {
              updateReceipt: {
                heading: "تحديث إيصال أمر السوق",
                description:
                  "يستبدل مستند الإيصال المخزَّن على أمر السوق دون إعادة تنفيذه. تحتوي أوامر التحويل على إيصال شراء وإيصال بيع منفصلين.",
                marketOrderId: "معرّف أمر السوق",
                marketOrderIdPlaceholder: "أدخل معرّف أمر السوق",
                loading: "جارٍ تحميل أمر السوق…",
                notFound: "لا يوجد أمر سوق بهذا المعرّف.",
                reference: "المرجع",
                type: "النوع",
                state: "الحالة",
                units: "الوحدات / المبلغ",
                buyUnits: "المشترى (وحدات / مبلغ)",
                sellUnits: "المُباع (وحدات / مبلغ)",
                currentReceipt: "إيصال الشراء الحالي",
                currentReceiptFrom: "إيصال البيع الحالي",
                noDocument: "لا يوجد",
                selectDocument: "المستند المراد تحديثه",
                targetBuy: "إيصال الشراء",
                targetSell: "إيصال البيع",
                targetBoth: "كلاهما",
                uploadReceipt: "الإيصال",
                uploadBuy: "إيصال الشراء",
                uploadSell: "إيصال البيع",
                submit: "تحديث الإيصال",
                confirmTitle: "تأكيد تحديث الإيصال",
                confirmDescription: ({ documents, reference }) =>
                  `هل تريد استبدال ${documents} في أمر السوق ${reference}؟ سيتم استبدال المستند الحالي.`,
                confirmSubmit: "تحديث",
                toastSuccess: "تم تحديث إيصال أمر السوق",
              },
            },
          },
          activity: {
            page: {
              color: "اللون",
              colors: {
                info: "أزرق",
                neutral: "رمادي",
                primary: "لون العلامة",
                success: "أخضر",
                warning: "كهرماني",
              },
              completedDescriptionHint:
                "كيف تظهر المرحلة الأخيرة بعد اكتمالها، مثلاً «تم الاستثمار» بدلاً من «قيد الاستثمار». إذا تُرك فارغاً يبقى اسمها كما هو.",
              completedTitle: "بعد اكتمال المرحلة الأخيرة",
              currentVersion: (version) => `الإصدار ${version} (الحالي)`,
              description:
                "اختر الأنشطة التي تظهر في صفحات النشاط، وأسماءها، ومن يمكنه رؤيتها.",
              inheritedNaming: (version) =>
                `لم يتم تسمية هذا الإصدار بعد، لذلك يعرض أسماء الإصدار ${version}. احفظ لإعطائه أسماءه الخاصة.`,
              noStages: "لا توجد مراحل لتسميتها في هذا النشاط.",
              onCompanyPage: "صفحة الشركة",
              onCompanyPageDescription: "إظهار هذا النشاط في صفحة نشاط الشركة.",
              onPlatformPage: "صفحة المنصة",
              onPlatformPageDescription:
                "إظهار هذا النشاط في صفحة نشاط المنصة.",
              permission: "الصلاحية المطلوبة لعرضه",
              saved: "تم حفظ إعدادات النشاط",
              stageDescriptionAr: "الوصف (بالعربية)",
              stageDescriptionEn: "الوصف (بالإنجليزية)",
              stageNameAr: "الاسم (بالعربية)",
              stageNameEn: "الاسم (بالإنجليزية)",
              stages: "المراحل",
              stagesHint:
                "أسماء المراحل تخص إصدارًا واحدًا من النشاط. الإصدار الذي لم تسمّه بعد يأخذ أسماء الإصدار الذي قبله.",
              title: "النشاط",
              typeLabelAr: "تسمية النوع (بالعربية)",
              typeLabelEn: "تسمية النوع (بالإنجليزية)",
              version: (version) => `الإصدار ${version}`,
              versionLabel: "الإصدار",
            },
          },
        },
        disclaimers: {
          page: {
            consent: "الموافقة والمتابعة",
            description: {
              contact:
                "المكتب 402، الطابق الرابع عشر، برج السراب، مربعة سوق أبوظبي العالمي، جزيرة المارية، أبوظبي، دولة الإمارات العربية المتحدة",
              email: "البريد الإلكتروني: support@aurem.ae",
              phone: "،+971 2 499 6333",
              question: "إذا كانت لديك أي أسئلة، يرجى الاتصال بنا على:",
              text: "تتعلق هذه الوثائق ببعض منتجاتنا مثل الاستثمار والادخار والمزيد. للحصول على فهم كامل، يرجى قراءة الاتفاقيات المرفقة. يرجى قراءة جميع الوثائق بعناية.",
            },
            disclaimers: {
              heading: "إخلاء المسؤولية",
              noticePrivacy: "إشعار الخصوصية",
            },
            heading: "وثائقك",
          },
        },
        errorBoundary: {
          reload: "حاول مرة أخرى",
          subtext:
            "حدث خطأ غير متوقع. يرجى محاولة مسح ذاكرة التخزين المؤقت للمتصفح وإعادة تحميل الصفحة",
          title: "الرجاء المحاولة مجددا",
        },
        forgotPassword: {
          page: {
            title: "هل نسيت كلمة المرور؟",
            success: {
              title: "تحقق من بريدك الإلكتروني",
              description:
                "إذا كان هناك حساب مرتبط بعنوان البريد الإلكتروني هذا، ستتلقى رسالة بريد إلكتروني منا قريبًا. بعد استلامها، اضغط على الرابط الموجود في الرسالة واضبط كلمة مرور جديدة. الرابط صالح لمدة 24 ساعة.",
            },
            description:
              "أدخل بريدك الإلكتروني لاستلام رابط إعادة تعيين كلمة المرور.",
            email: { label: "أدخل بريدك الإلكتروني" },
            error: "تعذر إرسال الرابط. تحقق من اتصال الإنترنت وحاول مرة أخرى.",
            submit: "أرسل الرابط إلى البريد الإلكتروني",
            cancel: "إلغاء",
          },
        },
        funds: {
          page: {
            list: {
              grid: {
                amount: "المبلغ",
                companies: "الشركات",
                companiesInFund: "الشركات في الصندوق",
                companyName: "اسم الشركة",
                employeesInCompany: "الموظفون في الشركة",
                noRecords: {
                  noRecordsContent:
                    "ستظهر رؤى الصندوق الخاصة بك هنا مع تفاصيلها.",
                  noRecordsTitle: "لا توجد رؤى صندوق متاحة بعد",
                },
                fundClass: "فئة الصندوق",
                fundName: "اسم الصندوق",
                report: "تقرير رؤى الصندوق",
                title: "رؤى الصندوق",
                totalAmount: "إجمالي المبلغ",
                totalUnits: "إجمالي الوحدات",
                units: "الوحدات",
                viewByCompany: "عرض حسب الشركة",
                viewByFundClass: "عرض حسب فئة الصندوق",
              },
            },
          },
          isin: {
            page: {
              list: {
                grid: {
                  companyName: "اسم الشركة",
                  employeesInCompany: "الموظفون في الشركة",
                  units: "الوحدات",
                  amount: "المبلغ",
                  report: "تقرير رؤى الصندوق",
                  viewByFundClass: "عرض حسب فئة الصندوق",
                  companiesClass: (className) =>
                    `الشركات من الفئة ${className}`,
                  fundName: "اسم الصندوق",
                  companies: "الشركات",
                  totalUnits: "إجمالي الوحدات",
                  totalAmount: "إجمالي المبلغ",
                },
              },
            },
            fundCompanyId: {
              page: {
                list: {
                  grid: {
                    companyEmployees: (company) => `موظفين من  ${company}`,
                    amount: "المبلغ",
                    report: "تقرير رؤى الصندوق",
                    viewByFundClass: "عرض حسب فئة الصندوق",
                    totalUnits: "إجمالي الوحدات",
                    employeesInFund: "موظفون مستثمرون في الصندوق",
                  },
                },
              },
            },
          },
          company: {
            fundCompanyId: {
              page: {
                list: {
                  grid: {
                    fundName: "اسم الصندوق",
                    fundClass: "فئة الصندوق",
                    employeesInFund: "موظفون مستثمرون في الصندوق",
                    units: "الوحدات",
                    amount: "المبلغ",
                    report: "تقرير رؤى الصندوق",
                    viewByFundClass: "عرض حسب فئة الصندوق",
                    companyFundDetails: (company) => `تفاصيل صندوق ${company}`,
                    fundClasses: "فئات الصندوق",
                    totalUnits: "إجمالي الوحدات",
                    totalAmount: "إجمالي المبلغ",
                  },
                },
              },
            },
          },
        },
        holdings: {
          page: {
            title: "المخزونات",
            views: { employee: "عرض الموظف", employer: "عرض صاحب العمل" },
            totalHoldings: "إجمالي المقتنيات",
            tableColumns: {
              employee: "الموظف",
              company: "الشركة",
              benefit: "الفائدة",
              isin: "ISIN",
              totalUnits: "إجمالي الوحدات",
              marketValue: "القيمة السوقية",
              lastUpdated: "آخر تحديث",
              companyName: "اسم الشركة",
              fundName: "اسم الصندوق",
              shareClass: "فئة الحصة",
              navPrice: "سعر صافي قيمة الأصول",
            },
            empty: {
              filtersEmpty: {
                title: "لا توجد مخزونات متاحة",
                description: "لا توجد مخزونات متاحة للفلترات المحددة.",
              },
              generalEmpty: {
                title: "لا توجد مخزونات متاحة",
                description: "سيتم عرض بيانات المخزونات هنا مع تفاصيلها.",
              },
            },
            filters: {
              company: "الشركة",
              benefit: "الفائدة",
              marketValue: "القيمة السوقية",
              allValues: "جميع القيم",
            },
            dataEditor: {
              title: "المخزونات (للعرض فقط)",
              unitPrice: "سعر الوحدة",
              manage: "إدارة",
              viewInDataEditor: "عارض البيانات",
            },
            adjustment: {
              adjustmentCta: "إضافة معدل",
              adjustmentModal: {
                title: "تعديل المخزون",
                vestedAt: {
                  label: "تمليك في",
                  error: "تمليك في إلزامي",
                  validationError: "تمليك في يجب أن يكون تاريخا صالحا",
                },
                adjustmentType: {
                  title: "نوع التعديل",
                  positive: "موجب",
                  negative: "سالب",
                },
                newAmount: {
                  label: "أدخل الوحدات الجديدة",
                  description: "الوحدات لا يمكن أن يكون أقل من 0",
                },
                reason: {
                  label: "السبب",
                  placeholder: "اختر السبب",
                  overpayment: "تسديد مبلغ زائد",
                  underpayment: "تسديد مبلغ أقل",
                  creditFee: "رسوم اعتمادية",
                  debitFee: "رسوم دفعية",
                  other: "آخر",
                },
                otherReason: {
                  label: "السبب الآخر",
                  placeholder: "أدخل السبب الآخر",
                },
                submitButton: "إضافة التعديل",
                cancelButton: "إلغاء",
                requiredFields: {
                  adjustmentType: "نوع التعديل إلزامي",
                  newAmount: "الوحدات الجديدة إلزامية",
                  reason: "السبب إلزامي",
                  otherReason: "السبب الآخر إلزامي",
                  negativeAmountBelowZero:
                    "سيؤدي التعديل إلى تخفيض الوحدات إلى ما دون الصفر",
                },
                successMessage: "تم إرسال التعديل بنجاح",
              },
            },
          },
        },
        holdingsDetails: {
          page: {
            title: "تفاصيل المخزونات",
            backToHoldings: "العودة إلى المخزونات",
            header: {
              employeeName: "اسم الموظف",
              companyName: "اسم الشركة",
              amount: "القيمة السوقية",
              productName: "اسم الفائدة",
              isin: "ISIN",
              fundName: "اسم الصندوق",
              shareClass: "فئة الأسهم",
            },
            tableColumns: {
              units: "الوحدات",
              amount: "القيمة السوقية",
              vesting: "التمليك",
              executedAt: "تاريخ التنفيذ",
              shareClass: "فئة الأسهم",
              reason: "السبب",
              changedBy: "تم التغيير بواسطة",
              changedAt: "تاريخ التغيير",
            },
            aumFeeTooltip: "رسوم في انتظار التحصيل",
            tableEmptyState: {
              title: "لا توجد مخزونات متاحة",
              description: "سيتم عرض بيانات المخزونات هنا مع تفاصيلها.",
            },
            dataEditor: {
              title: "تفاصيل المخزون (للعرض فقط)",
              viewInDataEditor: "عارض البيانات",
            },
          },
        },
        inactive: {
          back: "إغلاق",
          subtext:
            "لقد انتهت مدة جلستك وتم تسجيل خروجك تلقائيًا بسبب عدم النشاط.",
          title: "تم تسجيل خروجك",
        },
        marketOrders: {
          page: {
            type: {
              buy: "شراء",
              sell: "بيع",
              switch: "تبديل",
              withdraw: "سحب",
            },
            bulkUpdateMarketOrdersModal: {
              title: "تعديل جماعي",
              cta: "تحميل وتحديث",
              fileRequirements: "ملف Excel (الحد الأقصى 2 ميغابايت)",
              clickToUpload: "انقر للتحميل",
              orDragAndDrop: "أو اسحب وأفلت",
              success: "تم بدء تحديث أوامر السوق بنجاح.",
              error:
                "فشل في بدء تحديث أوامر السوق. يرجى التحقق من تنسيق الملف والمحاولة مرة أخرى.",
            },
            grid: {
              status: {
                pending: "قيد الانتظار",
                executed: "تم التنفيذ",
                overdue: "متأخر",
              },
              today: "اليوم",
              difference: (diffrence) =>
                `منذ ${diffrence} ${/**@type{Record<string,unknown>}*/ ({ ["one"]: `يوم` })[P.select(diffrence)] ?? `أيام`}`,
              noRecords: {
                noRecordsContent:
                  "ستظهر طلبات السوق الخاصة بك هنا مع حالتها وتفاصيلها.",
                noRecordsTitle: "للا توجد أوامر سوق جديدة حتى الآن",
              },
              fundName: "اسم الصندوق",
              fundIsin: "رقم التعريف الدولي للأوراق المالية (ISIN) للصندوق",
              fundClass: "فئة الصندوق",
              type: "نوع الطلب",
              aumFee: { label: "رسوم", popover: "الأصول الخاضعة للإدارة" },
              createdAt: "تاريخ الإنشاء",
              amount: "المبلغ",
              executedBy: "نفذ بواسطة",
              executedOn: "تم التنفيذ في",
              units: "وحدات",
              unitPrice: "سعر الوحدة",
              transferBy: "التحويل بواسطة",
              report: "تقرير أوامر السوق",
              movedFrom: (item) => `نقل من ${item}`,
              inProgress: "قيد التقدم",
              pastActivity: "النشاط السابق",
              title: "طلبات السوق",
              marketOrderId: "رقم أمر السوق",
              receiptAlt: "إيصال أمر السوق",
              filters: {
                last3Months: "آخر 3 أشهر",
                last6Months: "آخر 6 أشهر",
                lastMonth: "الشهر الماضي",
                thisYear: "هذا العام",
                fundClass: "فئة الصندوق",
                executionStatus: "حالة التنفيذ",
                employeeTenure: "مدة خدمة الموظف",
                allValues: "جميع القيم",
                placeholders: {
                  type: "جميع القيم",
                  company: "ابحث عن شركة",
                  createdAt: "اختر النطاق الزمني",
                },
              },
              dynamicReports: {
                pending:
                  "تصدير قائمة أوامر السوق المعلقة، تتضمن الحالة، اسم الصندوق، فئة الصندوق، رمز ISIN للصندوق، الشركة، الموظف، النوع، المبلغ، تاريخ الإنشاء، ومنفّذ التحويل",
                executed:
                  "تصدير قائمة بجميع أوامر السوق المنفذة، تتضمن الحالة، اسم الصندوق، فئة الصندوق، رمز ISIN للصندوق، اسم الشركة، اسم الموظف، النوع، الملف، إجمالي المبلغ المستثمر، إجمالي الوحدات المستثمرة، سعر وحدة الصندوق، المنفذ، تاريخ التنفيذ، وتاريخ الإنشاء",
              },
              searchPlaceholder: "البحث حسب اسم الشركة أو الموظف...",
            },
            dataEditor: {
              title: "أوامر السوق (للعرض فقط)",
              manage: "إدارة",
              viewInDataEditor: "عارض البيانات",
            },
          },
          marketOrderId: {
            page: {
              confirm: {
                amount: "المبلغ",
                units: "كمية الوحدات",
                description:
                  "يرجى تأكيد تاريخ متطلبات السوق وسعر الشراء / البيع.",
                executedAt: { label: "تاريخ متطلبات السوق " },
                heading: "تأكيد متطلبات السوق ",
                iban: "رقم الحساب المصرفي الدولي IBAN",
                name: "الاسم",
                receipt: {
                  fileRequirements: "PDF، PNG أو JPG (بحد أقصى 2MB)",
                  heading: "إيصال",
                  headingPurchase: "إيصال الشراء",
                  headingSale: "إيصال البيع",
                },
                reference: "المرجع",
                transferExecutedAt: { label: "تم تنفيذ التحويل في" },
                unitPrice: {
                  labelBuy: "سعر الوحدات التي تم شراؤها ",
                  labelSell: "سعر الوحدة المباعة",
                  required: "سعر الوحدة إلزامي",
                },
                unitsAmount: {
                  labelBuy: "الوحدات المشتراة",
                  labelSell: "الوحدات المباعة",
                  required: "الوحدات إلزامية",
                },
                withdrawalDescription:
                  "يرجى التأكيد على أن التحويل قد تم إلى الحساب البنكي للمستفيد.",
              },
              withdrawalPayment: {
                description:
                  "يرجى معالجة وإكمال الدفع إلى الحساب البنكي للمستفيد.",
                cta: "تأكيد السحب",
              },
              confirmWithdrawal: "تأكيد السحب",
              execute: "تنفيذ",
              success: "تم تنفيذ أمر السوق بنجاح",
              grid: {
                amount: "المبلغ",
                amountRequested: "المبلغ المطلوب",
                createdAt: "تم الإنشاء في",
                currency: "العملة",
                detailsTitle: "تفاصيل أمر السوق",
                executedBy: "نفذ بواسطة",
                executedOn: "تم التنفيذ في",
                fundClass: "فئة الصندوق",
                fundClassSource: "من فئة الصندوق",
                fundClassTarget: "إلى فئة الصندوق",
                fundId: "البطاقة التعريفية للصندوق ",
                fundIsin: "رقم التعريف الدولي للأوراق المالية (ISIN) للصندوق",
                fundIsinSource: "من رقم ISIN",
                fundIsinTarget: "إلى رقم ISIN",
                fundName: "اسم الصندوق",
                fundNameSource: "من الصندوق",
                fundNameTarget: "إلى الصندوق",
                iban: "رقم الحساب المصرفي الدولي IBAN",
                isin: "ISIN",
                report: "تقرير أوامر السوق",
                status: { overdue: "متأخر" },
                transferBy: "التحويل بواسطة",
                type: "النوع",
                units: "وحدات",
                confirmWithdrawalDialog: {
                  uploadReceipt: "تحميل الإيصال",
                  uploadReceiptDescription:
                    "أكد أنك قمت بهذا الدفع من خلال رفع إيصال.",
                },
                noRecords: {
                  noRecordsTitle: "لا توجد معاملات شراء أو بيع بعد",
                  noRecordsContent:
                    "ستظهر هنا معاملات الشراء والبيع الخاصة بهذا الطلب.",
                },
              },
              list: {
                grid: {
                  unitsSold: "وحدات بيعت",
                  amountSold: "تم بيع المبلغ",
                  unitsBought: "وحدات تم شراؤها",
                  amountBought: "المبلغ تم شراؤها",
                  unitsToSell: "وحدات للبيع",
                  createdOn: "تم الإنشاء في",
                  totalUnitsToSell: "إجمالي وحدات للبيع",
                  totalUnitsSold: "إجمالي وحدات بيعت",
                  totalAmountSold: "إجمالي المبلغ بيعت",
                  totalUnitsBought: "إجمالي وحدات تم شراؤها",
                  totalAmountBought: "إجمالي المبلغ تم شراؤها",
                  units: "الوحدات",
                  amount: "المبلغ",
                  noRecords: {
                    noRecordsTitle: "لا توجد معاملات تبديل بعد",
                    noRecordsContent:
                      "ستظهر هنا معاملات التبديل الخاصة بهذا الطلب.",
                  },
                },
              },
              marketOrders: {
                marketOrderId: {
                  executeSheet: {
                    title: "تأكيد أمر السوق",
                    subtitle: "تأكيد تاريخ أمر السوق وسعر الشراء / البيع.",
                    executedAt: "تاريخ أمر السوق",
                    totalAmount: "إجمالي المبلغ",
                    unitsBought: "وحدات تم شراؤها",
                    totalUnits: "إجمالي الوحدات",
                    unitPriceSold: "سعر الوحدة المباعة",
                    receiptSale: "إيصال البيع",
                    unitPriceBought: "سعر الوحدة المشتراة",
                    receiptPurchase: "إيصال الشراء",
                    toastSuccess: "تم تنفيذ أمر السوق بنجاح.",
                    unitsBoughtRequired: "وحدات تم شراؤها إلزامي",
                    receiptRequired: "الإيصال إلزامي",
                    unitPriceSoldRequired: "سعر الوحدة المباعة إلزامي",
                    unitPriceBoughtRequired: "سعر الوحدة المشتراة إلزامي",
                    unitsPrice: "سعر الوحدات",
                    assetQuantity: "كمية الأصل",
                  },
                },
              },
              adjustments: {
                addAdjustment: "إضافة التعديل",
                adjustmentModal: {
                  editAmount: "تعديل المبلغ",
                  editUnits: "تعديل الوحدات",
                  currentAmount: "المبلغ الحالي",
                  currentUnits: "الوحدات الحالية",
                  employeeFieldLabel: "الموظف",
                  employeeFieldPlaceholder: "بحث عن موظف",
                  reasonFieldLabel: "أضف سبب هذا التعديل",
                  reasonFieldPlaceholder: "اختر سبب",
                  newAmountFieldLabel: "المبلغ الجديد",
                  newAmountFieldDescription: "المبلغ لا يمكن أن يكون أقل من 0",
                  newUnitsFieldLabel: "الوحدات الجديدة",
                  newUnitsFieldDescription: "الوحدات لا يمكن أن يكون أقل من 0",
                  submitButton: "إضافة التعديل",
                  editAdjustmentButton: "تعديل التعديل",
                  cancelButton: "إلغاء",
                  otherReasonFieldLabel: "سبب آخر",
                  otherReasonFieldPlaceholder: "أدخل سبب آخر",
                  adjustmentType: {
                    title: "نوع التعديل",
                    positive: "موجب",
                    negative: "سالب",
                  },
                  requiredFields: {
                    employee: "الموظف إلزامي",
                    adjustmentType: "نوع التعديل إلزامي",
                    newAmount: "المبلغ الجديد إلزامي",
                    newUnits: "الوحدات الجديدة إلزامية",
                    reason: "سبب التعديل إلزامي",
                    otherReason: "سبب آخر إلزامي",
                    exactlyOneRequired: "المبلغ المطلوب",
                    negativeAmountBelowZero:
                      "سيؤدي التعديل إلى تخفيض المبلغ إلى ما دون الصفر",
                  },
                  adjustmentReasons: {
                    overpayment: "إضافة إلى المبلغ",
                    underpayment: "طرح من المبلغ",
                    creditFee: "رسوم ائتمانية",
                    debitFee: "رسوم ديونية",
                    otherReason: "سبب آخر",
                  },
                  successMessage: "تم إضافة التعديل على أمر السوق بنجاح",
                },
              },
            },
            executeSheet: {
              title: "تأكيد أمر السوق",
              subtitle: "تأكيد تاريخ أمر السوق وسعر الشراء / البيع.",
              toastSuccess: "تم تنفيذ أمر السوق بنجاح.",
              executedAt: "تاريخ أمر السوق",
              totalUnits: "إجمالي الوحدات",
              unitPriceSold: "سعر الوحدة المباعة",
              unitPriceSoldRequired: "سعر الوحدة المباعة إلزامي",
              receipt: "رفع الإيصال",
              receiptRequired: "الإيصال إلزامي",
              receiptDescription: "تأكيد أنك قمت بتنفيذ أمر السوق برفع إيصال.",
              totalAmount: "إجمالي المبلغ",
              unitsBought: "وحدات تم شراؤها",
              unitsBoughtRequired: "وحدات تم شراؤها إلزامي",
              unitPriceBought: "سعر الوحدة المشتراة",
              unitPriceBoughtRequired: "سعر الوحدة المشتراة إلزامي",
              receiptSale: "إيصال البيع",
              receiptPurchase: "إيصال الشراء",
            },
          },
        },
        notFound: {
          page: {
            back: "رجوع",
            companies: "اذهب إلى عرض الشركات",
            description: "عذرًا، الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
            error: "خطأ 404",
            heading: "الصفحة غير موجودة...",
          },
        },
        payments: {
          page: {
            totalPayments: "إجمالي المدفوعات",
            list: { heading: "المدفوعات" },
            grid: {
              amount: "المبلغ",
              taxAmount: "مبلغ الضريبة",
              bucket: "فئة الدفع",
              approver: "المراجع",
              product: "المنتج",
              benefitName: "اسم المزايا",
              companyName: "اسم الشركة",
              dueBy: "مستحق بحلول",
              inProgress: "قيد التقدم",
              pastActivity: "النشاط السابق",
              status: "الحالة",
              confirmPayment: "تأكيد الدفع",
              rejectPayment: "رفض الدفع",
              tabs: { payments: "المدفوعات", withdrawals: "عمليات السحب" },
              statuses: { pending: "قيد الانتظار", completed: "تم الدفع" },
              noWithdrawalRecords: {
                noRecordsTitle: "لا توجد عمليات سحب للعرض حالياً.",
                noRecordsContent:
                  "ستُعرض عمليات السحب المستقبلية التي يجب تنفيذها هنا.",
              },
              referenceNumber: "مرجع الدفع",
              employeeName: "اسم الموظف",
              requestedAt: "تاريخ الطلب",
              type: "النوع",
              basicSalary: "الراتب الأساسي",
              fullSalary: "الراتب الكامل",
              confirmWithdrawalDialog: {
                title: "تأكيد تحويل السحب",
                subtitle: "تأكيد إجراء التحويل إلى الحساب المصرفي للمستفيد",
                totalAmount: "المبلغ الإجمالي",
                beneficiary: "المستفيد",
                iban: "رقم الآيبان",
                paymentReference: "رقم مرجع الدفع",
                paymentReferenceWarning:
                  "يجب عليك تضمين رقم المرجع هذا كجزء من التحويل لتجنب رفض الدفع و/أو التأخير.",
                executedAt: "تاريخ تنفيذ التحويل",
                uploadReceipt: "تحميل الإيصال",
                uploadReceiptDescription:
                  "أكد أنك قمت بهذا الدفع من خلال رفع إيصال.",
                confirm: "تأكيد التحويل",
                cancel: "إلغاء",
                receiptRequired: "إثبات الدفع مطلوب",
                toastSuccess: "تم تأكيد تحويل السحب بنجاح.",
              },
              confirmPaymentModal: {
                downloadReceipt: "تحميل الإيصال",
                note: "أضف ملاحظة",
              },
              rejectPaymentModal: {
                title: "تأكيد الرفض",
                subtitle: "يرجى تقديم سبب لرفض الدفع",
                paymentNotFound: "لم يتم العثور على الدفعة",
                paymentNotFullAmount: "كانت الدفعة أقل من المبلغ المطلوب",
                note: {
                  label: "أضف ملاحظة للعميل لوصف المشكلة",
                  placeholder: "أضف ملاحظة هنا",
                  required: "الملاحظة مطلوبة",
                },
              },
              noRecords: {
                noRecordsTitle: "لا توجد دفعات للعرض حالياً.",
                noRecordsContent: "ستُعرض دفعاتك المستقبلية هنا.",
              },
              sender: "المرسل",
              recipient: "المستلم",
              iban: "الرقم الدولي للحساب المصرفي IBAN",
              accountName: "اسم الحساب",
              swiftCode: "رمز السويفت",
              branchName: "اسم الفرع",
              branchAddress: "عنوان الفرع",
              issueDate: "تاريخ الإصدار",
              dueDate: "تاريخ الاستحقاق",
              paymentForMonth: "دفعة عن شهر",
              pendingNote:
                "يرجى التأكد من إتمام دفعتك الشهرية بحلول اليوم الخامس من الشهر التالي.",
              report: "تقرير المدفوعات",
              dynamicReports: {
                payments: {
                  pending:
                    "تصدير قائمة بصيغة csv لمدفوعات المزايا قيد التنفيذ، المتأخرة أو التي تم دفعها تتضمن الحالة، اسم الشركة، المعرّف، مرجع الدفع، اسم الميزة، المبلغ وتاريخ الاستحقاق",
                  completed:
                    "تصدير قائمة بصيغة csv لمدفوعات المزايا المكتملة أو المرفوضة تتضمن الحالة، اسم الشركة، المعرّف، مرجع الدفع، اسم الميزة، الحالة، اسم الشركة، المعرّف، مرجع الدفع، اسم الميزة، المعتمد والمبلغ",
                },
                withdrawals: {
                  pending:
                    "تصدير قائمة بصيغة csv لمدفوعات سحب الموظفين قيد التنفيذ، تتضمن الحالة، مرجع الدفع، اسم الشركة، اسم الموظف، النوع، تاريخ الطلب والمبلغ",
                  completed:
                    "تصدير قائمة بصيغة csv لمدفوعات سحب الموظفين المكتملة، تتضمن الحالة، مرجع الدفع، اسم الشركة، اسم الموظف، المعتمد، النوع، تاريخ الطلب والمبلغ",
                },
              },
              noResults: {
                title: "لم يتم العثور على بنود",
                description: "لا توجد بنود تطابق بحثك.",
              },
              noLineItems: {
                title: "لا توجد بنود بعد",
                description: "ستظهر هنا بنود هذه الدفعة.",
              },
            },
            filters: {
              issueDate: "تاريخ الإصدار",
              currency: "العملة",
              amount: "المبلغ",
              from: "من",
              to: "إلى",
              min: "الحد الأدنى",
              max: "الحد الأقصى",
              allValues: "جميع القيم",
              product: "المنتج",
              allProducts: "جميع المنتجات",
            },
            reviewPaymentsDrawer: {
              confirmPaymentDetails: "تأكيد تفاصيل الدفع",
              overview: "نظرة عامة",
              totalAmount: "المبلغ الإجمالي",
              payment: "الدفع",
              fund: "الصندوق",
              amount: "المبلغ",
              iban: "الرقم الدولي للحساب المصرفي IBAN",
              referenceNumber: "رقم مرجع الدفع",
              confirmPayments: "تأكيد الدفع",
              failureConfirmation: "لقد تم رفض المعاملة",
              successConfirmation: "تم تأكيد المعاملة",
            },
            status: {
              overdue: "متأخر",
              paid: "تم الاستثمار",
              paymentMade: "تم معالجة الدفع",
              processing: "قيد المعالجة",
              rejected: "مرفوض",
              pending: "قيد الانتظار",
              approved: "تمت الموافقة",
            },
            confirm: {
              receipt: { fileRequirements: "PDF، PNG أو JPG (بحد أقصى 2MB)" },
            },
            companyPayments: {
              noRecords: {
                noRecordsTitle: "لا توجد دفعات للعرض حالياً.",
                noRecordsContent: "ستظهر دفعاتك المستقبلية هنا.",
              },
            },
            dataEditor: {
              title: "المدفوعات (للعرض فقط)",
              manage: "إدارة",
              viewInDataEditor: "عارض البيانات",
            },
          },
          id: {
            page: {
              grid: { dueBy: "مستحق بحلول" },
              reviewPaymentsDrawer: {
                amount: "المبلغ",
                confirmPayments: "تأكيد الدفع",
                fund: "الصندوق",
                iban: "الرقم الدولي للحساب المصرفي IBAN",
                accountName: "اسم الحساب",
                swiftCode: "رمز السويفت",
                branchName: "اسم الفرع",
                branchAddress: "عنوان الفرع",
                overview: "نظرة عامة",
                payment: "الدفع",
                referenceNumber: "رقم مرجع الدفع",
                referenceNumberTooltip:
                  'قد يطلق عليه البنك الخاص بك "وصف التحويل" أو "ملاحظة للمستلم".',
                success: "تم دفع المعاملة بنجاح",
                title: "مراجعة وتأكيد المدفوعات",
                totalAmount: "المبلغ الإجمالي",
                uploadReceipt: "تحميل الإيصال",
                uploadReceiptDescription:
                  "أكد أنك قمت بإجراء هذا الدفع عن طريق تحميل الإيصال.",
                warning:
                  "يجب عليك تضمين رقم المرجع هذا كجزء من التحويل الخاص بك لتجنب خطر رفض الدفع و/أو التأخير.",
              },
            },
          },
        },
        profile: {
          page: {
            contact: {
              email: { label: "البريد الإلكتروني" },
              error: "فشل في تحديث معلومات الاتصال",
              heading: "معلومات الاتصال",
              success: "يرجى التحقق من بريدك الإلكتروني لتعكس التغييرات هنا",
            },
            mfa: {
              codeRequest: {
                description:
                  "امسح رمز QR وادخل الرمز المكوّن من 6 أرقام الظاهر في تطبيق المصادقة.",
                heading: "إعداد التحقق بخطوتين",
                verificationCode: "رمز التحقق",
              },
              codeRequestForDisable: {
                description:
                  "أدخل الرمز من تطبيق المصادقة لتعطيل المصادقة متعددة العوامل.",
                heading: "قم بإيقاف  المصادقة متعددة العوامل",
              },
              heading: "المصادقة متعددة العوامل",
              headingDescription:
                "حافظ على أمان حسابك من خلال استخدام رمز الأمان بالإضافة إلى كلمة المرور الخاصة بك أثناء تسجيل الدخول. ستحتاج إلى إعداد تطبيق المصادقة",
              passwordRequest: {
                description:
                  "أدخل كلمة المرور الخاصة بك لتشغيل  المصادقة متعددة العوامل",
                enterPassword: "أدخل كلمة المرور",
                error: "كلمة المرور غير صحيحة",
                heading: "قم بتشغيل المصادقة متعددة العوامل",
                password: "كلمة السر",
              },
              successDisable: "تم إيقاف المصادقة متعددة العوامل بنجاح",
              successEnable: "تم إعداد المصادقة متعددة العوامل بنجاح",
              invalidCode: "رمز التوثيق غير صحيح. يرجى المحاولة مرة أخرى.",
            },
            personal: {
              error: "فشل في حفظ تغييرات الملف الشخصي",
              heading: "معلومات شخصية",
              name: {
                label: "الاسم كامل",
                placeholder: "أدخل الاسم الكامل",
                required: "الاسم الكامل مطلوب",
              },
              success: "تم حفظ الملف الشخصي بنجاح",
            },
            security: {
              heading: "الأمن",
              password: {
                button: "تغيير كلمة المرور",
                dialog: {
                  description:
                    "أدخل كلمة المرور الحالية الخاصة بك للتحقق من أنه أنت.",
                  title: "تغيير كلمة المرور",
                },
                form: {
                  confirmPassword: { label: "تأكيد كلمة المرور الجديدة" },
                  existingPassword: {
                    label: "كلمة المرور الحالية",
                    placeholder: "أدخل كلمة المرور الحالية",
                  },
                  newPassword: {
                    hint: "يجب أن يكون على الأقل 8 أحرف",
                    label: "كلمة المرور الجديدة",
                    placeholder: "أدخل كلمة المرور الجديدة",
                  },
                  submitButton: "تغيير كلمة المرور",
                },
                label: "كلمة السر",
                lastChanged: "آخر تغيير",
                match: "كلمات المرور غير متطابقة",
                success: "تم تغيير كلمة المرور بنجاح",
              },
            },
            shared: { title: "إعدادات الملف الشخصي" },
            tabs: { accountDetails: "تفاصيل الحساب", security: "الأمان" },
          },
        },
        requests: {
          company: {
            companyId: {
              page: {
                tabTitle: { documents: "الوثائق", company: "الشركة" },
                documentsTab: {
                  approveDialog: {
                    successMessage: "تمت الموافقة على طلب التحقق من الشركة",
                    heading: "الموافقة على طلب التحقق",
                    subHeading:
                      "هل أنت متأكد أنك تريد الموافقة على هذا الطلب؟ لا يمكنك التراجع عن هذا الإجراء لاحقًا.",
                    cancelButton: "إلغاء",
                    confirmButton: "تأكيد الموافقة",
                  },
                  resubmittedDocuments: "إعادة التقديم ",
                  footer: {
                    heading: "هل أنت مستعد للموافقة؟",
                    subHeading:
                      "الآن بعد أن راجعت أنشطة الأعمال، يمكنك طلب المزيد من الوثائق لإكمال عملية التعرف على الأعمال.",
                    rejectButton: "رفض طلب التحقق",
                    requestMoreButton: "طلب المزيد من الوثائق",
                    resubmitButton: "طلب إعادة تقديم الوثائق",
                    approveButton: "الموافقة على التحقق",
                  },
                  companyDocuments: { heading: "الشركة والملكية" },
                  signatoryDocuments: { heading: "وثائق الموقعين" },
                },
                rejectRequestAlertDialog: {
                  alert: { successMessage: "تم الرفض بنجاح" },
                  heading: "رفض طلب التحقق",
                  subHeading:
                    "هل أنت متأكد أنك تريد رفض هذا الطلب؟ لا يمكنك التراجع عن هذا الإجراء لاحقًا.",
                  button: { cancel: "ليس الآن", submit: "تأكيد الرفض" },
                },
                company: { form: { info: { heading: "معلومات الشركة" } } },
                new: {
                  name: { label: "اسم الشركة" },
                  registeredNumber: { label: "رقم الرخصة التجارية" },
                  website: { label: "الموقع الإلكتروني" },
                  fabCif: { label: "رقم CIF" },
                  taxInformation: {
                    label: "المعلومات الضريبية",
                    completed: "اكتمل عبر نموذج فاتكا",
                    pending: "في انتظار إكمال فاتكا",
                  },
                },
                signatureRequest: {
                  heading: "الوثائق الموقعة",
                  companyDocument: "وثيقة الشركة",
                  deedDocument: "وثيقة سند الانضمام",
                  download: "تحميل",
                  waitingForSignature: "في انتظار توقيع المستخدم على الوثيقة",
                },
                detailsApprovalModal: {
                  documentNamePlaceholder: "أدخل اسم المستند",
                  companyAndOwnership: {
                    defaultOptions: [
                      "الرخصة التجارية سارية المفعول",
                      "النظام الأساسي",
                      "عقد التأسيس",
                      "الهيكل التنظيمي (التوقيع و التاريخ)",
                      "سجل المديرين",
                      "سجل الأعضاء",
                      "آخر تدقيق مالي",
                      "تسجيل الأعمال",
                      "إثبات عنوان التشغيل في الإمارات العربية المتحدة",
                    ],
                    title: "الشركة والملكية",
                  },
                  signatoryDocuments: { title: "وثائق الموقعين" },
                  signatory: "الموقع",
                  button: { addOther: "إضافة آخر", submit: "إرسال الطلب" },
                },
                requestMoreDocumentsModal: {
                  alert: { successMessage: "تم إرسال طلب المستندات بنجاح" },
                  heading: "طلب المزيد من الوثائق",
                },
                documentsResubmissionModal: {
                  successMessage: "تم إرسال طلب إعادة تقديم الوثائق",
                  heading: "طلب إعادة تقديم الوثائق",
                  companyDocuments: "وثائق الشركة",
                  signatoryDocuments: "وثائق الموقعين",
                  remarkLabel: "ملاحظات (اختياري)",
                  cancelButton: "إلغاء",
                  submitButton: "إرسال الطلب",
                },
              },
            },
          },
          page: {
            list: {
              grid: {
                columns: {
                  dateReceived: "تاريخ الاستلام",
                  dateReviewed: "تاريخ المراجعة",
                  reviewer: "المراجع",
                },
                noRecords: {
                  noRecordsTitle: "لا يوجد شيء للمراجعة حالياً.",
                  noRecordsContent:
                    "ستظهر هنا مستندات التحقق التي تم تقديمها أو إعادة تقديمها.",
                },
                emptyPrompt: {
                  content:
                    "نظرًا لورود المزيد من الطلبات من شركاتك أو موظفيك، فستراها مدرجة هنا للمراجعة",
                  title: "لا توجد طلبات جديدة بعد",
                },
                report: "تقرير الطلبات",
                status: {
                  approved: "معتمد",
                  documentsInReview: "الوثائق قيد المراجعة",
                  documentsRequired: "في انتظار تقديم الوثائق",
                  documentsRetry: "في انتظار إعادة تقديم الوثائق",
                  rejected: "مرفوض",
                  signatoryRequired:
                    "في انتظار رسائل البريد الإلكتروني للموقعين",
                  waitingForSignature: "في انتظار التوقيعات الرقمية",
                  awaitingSubmission: "في انتظار التقديم",
                  awaitingResubmission: "في انتظار إعادة التقديم",
                  awaitingAdditionalDocuments: "في انتظار وثائق إضافية",
                  pendingReview: "في انتظار المراجعة",
                  reset: "أُعيد التعيين",
                },
                statuses: { completed: "مكتمل", pending: "في تَقَدم" },
                tabs: {
                  companies: "مستندات الشركة",
                  employees: "مستندات الموظفين",
                  subscriptions: "الاشتراكات",
                },
              },
              heading: "الطلبات",
              dynamicReports: {
                pending: {
                  employeeSubscription:
                    "تصدير قائمة بصيغة csv لطلبات اشتراكات الموظفين قيد التنفيذ، تتضمن اسم الموظف، الشركة، النوع، المبلغ وتاريخ الإضافة",
                  companyRequests:
                    "تصدير قائمة بصيغة csv لجميع مستندات الشركات قيد التنفيذ تتضمن حالة التحقق من الشركة، اسم الشركة، اسم المراجع، تاريخ الاستلام وتاريخ المراجعة",
                  employeeRequests:
                    "تصدير قائمة بصيغة csv لمستندات الموظفين قيد التنفيذ تتضمن الحالة، اسم الموظف وتاريخ الاستلام",
                },
                completed: {
                  employeeSubscription:
                    "تصدير قائمة بصيغة csv لطلبات اشتراكات الموظفين المعتمدة، تتضمن اسم الموظف، الشركة، النوع، المبلغ وتاريخ الإضافة",
                  companyRequests:
                    "تصدير قائمة بصيغة csv لمستندات الشركات المكتملة تتضمن حالة التحقق من الشركة، اسم الشركة، اسم المراجع، تاريخ الاستلام وتاريخ المراجعة",
                  employeeRequests:
                    "تصدير قائمة بصيغة csv لمستندات الموظفين المكتملة تتضمن الحالة، اسم الموظف، المعتمد، تاريخ الاستلام وتاريخ المراجعة",
                },
              },
              dataEditor: {
                manage: "إدارة",
                viewInDataEditor: "عارض البيانات",
                subscriptionsTitle: "الاشتراكات (للعرض فقط)",
                companiesTitle: "مستندات الشركة (للعرض فقط)",
                employeesTitle: "مستندات الموظفين (للعرض فقط)",
              },
              bulkReset: {
                button: "إعادة تعيين الطلبات",
                selected: (count) => `${count} محدد`,
                title: "إعادة تعيين الطلبات",
                description: (count) =>
                  `أنت على وشك إعادة تعيين ${count} من الطلبات. سيتم إخطار الموظفين وسيحتاجون إلى تقديم طلباتهم مرة أخرى عندما يكونون مستعدين.`,
                submitButton: "إعادة تعيين الطلبات",
                successMessage: ({ resetCount, skippedCount }) =>
                  `${resetCount} أُعيد تعيينها، ${skippedCount} تم تخطيها`,
                failedMessage: (failedCount) =>
                  `${failedCount} تعذّرت إعادة تعيينها`,
              },
              filters: { status: "الحالة", allStatuses: "جميع الحالات" },
            },
            employeeSubscriptionRequests: {
              grid: {
                amount: "المبلغ",
                dateAdded: "تاريخ الإضافة",
                type: "النوع",
              },
            },
            type: {
              voluntary: "الاشتراك الطوعي",
              oneTimePayment: "دفعة لمرة واحدة",
            },
          },
          employee: {
            requestId: {
              page: {
                tabTitle: {
                  documents: "الوثائق والفحص",
                  employee: "تفاصيل الموظف",
                },
                documentsTab: {
                  approveDialog: {
                    heading: "الموافقة على طلب التحقق",
                    subHeading:
                      "هل أنت متأكد أنك تريد الموافقة على هذا الطلب؟ لا يمكنك التراجع عن هذا الإجراء لاحقًا.",
                    riskRating: {
                      header: "تعيين تقييم المخاطر",
                      high: "مرتفع",
                      description: {
                        high: "يتطلب مراجعة منتظمة",
                        medium: "قد يتطلب مراجعة",
                        low: "لا توجد مخاوف مادية",
                      },
                      medium: "متوسط",
                      low: "منخفض",
                    },
                    confirmButton: "تأكيد الموافقة",
                  },
                  employeeDocuments: {
                    personalId: "مستند الهوية",
                    proofOfAddress: "إثبات العنوان",
                  },
                  documentPreview: {
                    documentTypes: {
                      identityDocument: "مستند الهوية",
                      proofOfAddress: "إثبات العنوان",
                      document: "مستند",
                    },
                    sides: { front: "الأمام", back: "الخلف" },
                    labels: { fileName: "اسم الملف", fileSize: "حجم الملف" },
                    messages: {
                      noPreviewAvailable: "لا يوجد معاينة متاحة",
                      unknownFilename: "اسم ملف غير معروف",
                      previewNotAvailable: "المعاينة غير متاحة",
                    },
                    actions: { downloadDocument: "تحميل المستند" },
                  },
                  footer: {
                    heading: "هل أنت مستعد للموافقة؟",
                    subHeading:
                      "الآن بعد أن قمت بمراجعة تفاصيل الموظف، يمكنك إما رفض عملية تحديد هوية الموظف أو الموافقة عليها.",
                    rejectButton: "رفض طلب التحقق",
                    approveButton: "الموافقة على التحقق",
                  },
                  emptyState: {
                    status: "الحالة",
                    message: (employeeName) =>
                      `${employeeName} لم يقم بتقديم وثائق التحقق من الهوية بعد. ستظهر مشاركتهم هنا بمجرد تحميل الملفات المطلوبة.`,
                  },
                  actionRequired: "مطلوب الإجراء",
                  status: "الحالة",
                  statusBanner: {
                    approved: "تم التحقق بنجاح",
                    rejected: "فشل التحقق",
                    inProgress: "التحقق جارٍ",
                    reset: "تمت إعادة تعيين الطلب",
                    approvedMessage: ({ name, date }) =>
                      `تمت الموافقة على المستندات من قِبل ${name} بتاريخ ${date}.`,
                    rejectedMessage: ({ name, date, note }) =>
                      `تم رفض المستندات من قِبل ${name} بتاريخ ${date} مع ملاحظة الرفض: ${note}`,
                    resetMessage: ({ name, date, note }) =>
                      `تمت إعادة تعيين الطلب من قِبل ${name} بتاريخ ${date} للسبب التالي: ${note}`,
                    verificationSuccessful: "تم التحقق بنجاح.",
                    noMatchesFound:
                      "تم فحص جميع المستندات ولم يتم العثور على أي تطابقات في قوائم العقوبات أو المراقبة.",
                    verificationFailed: "فشل التحقق",
                  },
                  actions: {
                    approve: "الموافقة والإكمال",
                    request: "الرفض - طلب إعادة التقديم",
                    reject: "رفض نهائي - غير مسموح بإعادة المحاولة",
                    reset: "إعادة تعيين الطلب",
                    approveDescription:
                      "تم التحقق من المستندات المقدمة وقبولها.",
                    requestDescription:
                      "المستندات المقدمة غير كافية أو غير صحيحة. سيتم مطالبة الموظف بإعادة تقديم مستندات إضافية أو مصححة.",
                    rejectDescription:
                      "المستندات المقدمة غير صالحة ولا يمكن قبولها. سيتم إخطار الموظف بالرفض النهائي ولن يُسمح له بإعادة التقديم.",
                    resetDescription:
                      "إعادة الطلب إلى الموظف. لا يلزم اتخاذ أي إجراء من جانبه حتى يقرر المتابعة.",
                    requestMoreDocuments: "طلب المزيد من الوثائق",
                    requestMoreDocumentsDescription:
                      "المستندات المقدمة غير كافية. سيُطلب من الموظف تقديم مستندات إضافية.",
                  },
                  confirmButton: "تأكيد",
                },
                rejectRequestAlertDialog: {
                  button: { cancel: "ليس الآن" },
                  heading: "رفض طلب التحقق",
                },
                resubmitKycDocuments: {
                  note: {
                    required: "السبب مطلوب",
                    hint: "رسالتك أدناه ستتم مشاركتها مع الموظف لتوضيح ما هو مطلوب ولماذا.",
                    label: "سبب طلب الوثائق",
                  },
                },
                rejectKycDocuments: {
                  note: {
                    required: "السبب مطلوب",
                    hint: "رسالتك أدناه ستتم مشاركتها مع الموظف لتوضيح ما هو مطلوب ولماذا.",
                    label: "سبب طلب الوثائق",
                  },
                  description:
                    "هل أنت متأكد أنك تريد رفض هذا الطلب؟ لا يمكنك التراجع عن هذا الإجراء بعد ذلك.",
                  notNow: "ليس الآن",
                  confirmRejection: "تأكيد الرفض",
                },
                documentsResubmitDialog: {
                  title: "طلب إعادة تقديم الوثائق",
                  description:
                    "ستتم مشاركة رسالتك أدناه مع الموظف لتوضيح ما هو مطلوب ولماذا.",
                  selectDocuments: "اختر الوثائق التي تتطلب إعادة التقديم",
                  submitButton: "طلب الوثائق",
                  successMessage: "تم طلب إعادة تقديم الوثائق بنجاح",
                },
                documentsRejectDialog: {
                  title: "رفض الوثائق",
                  description:
                    "هل أنت متأكد أنك تريد رفض هذه الوثائق؟ لا يمكنك التراجع عن هذا الإجراء لاحقًا.",
                  submitButton: "رفض الوثائق",
                  successMessage: "تم رفض الوثائق بنجاح",
                },
                documentsResetDialog: {
                  title: "إعادة تعيين الطلب",
                  description:
                    "هل أنت متأكد أنك تريد إعادة تعيين هذا الطلب؟ سيتم إخطار الموظف وسيحتاج إلى تقديم الطلب مرة أخرى عندما يكون مستعدًا.",
                  submitButton: "إعادة تعيين الطلب",
                  successMessage: "تمت إعادة تعيين الطلب بنجاح",
                  note: { required: "السبب مطلوب", label: "سبب إعادة التعيين" },
                },
                documentsApproveDialog: {
                  title: "الموافقة على الوثائق",
                  description:
                    "هل أنت متأكد أنك تريد الموافقة على هذه الوثائق؟ لا يمكنك التراجع عن هذا الإجراء لاحقًا.",
                  overrideMessage:
                    "أنت على وشك الموافقة على موظف يمكن أن يتم رفضه للتحقق من الهوية. سيتم تجاوز التقييم التلقائي وسيتم السماح للموظف بالمتابعة.",
                  extractedDataReview:
                    "مراجعة وتحقق من معلومات المتقدم المستخرجة من نظام التحقق من الهوية. يرجى التأكد من أن جميع البيانات تتوافق بدقة مع الوثائق المقدمة.",
                  assignRiskRating: "تعيين تقييم المخاطر",
                  reasonForRiskRating: "سبب تقييم المخاطر",
                  reasonDescription:
                    "رسالتك أدناه ستكون مرئية لك فقط ولن تتم مشاركتها مع الموظف.",
                  submitButton: "الموافقة على الوثائق",
                  successMessage: "تمت الموافقة على الوثائق بنجاح",
                },
                form: {
                  personal: { heading: "المعلومات الشخصية" },
                  nationalId: { label: "بطاقة الهوية الإماراتية" },
                  labourId: { label: "البطاقة التعريفية لوزارة العمل " },
                  contact: { heading: "الاتصال" },
                  email: { label: "البريد الإلكتروني للعمل" },
                  details: { heading: "تفاصيل العمل" },
                  startDate: { label: "بداية العمل" },
                  endDate: { label: "نهاية العمل (اختياري)" },
                  fullSalary: { label: "الراتب الشهري" },
                  basicSalary: { label: "الراتب الأساسي الشهري" },
                  iban: { label: "رقم الحساب المصرفي الدولي IBAN" },
                  level: { label: "المستوى (اختياري)" },
                  department: { label: "القسم (اختياري)" },
                  jobTitle: { label: "المسمى الوظيفي" },
                },
                verification: {
                  formHeading: { documentsInReview: "المستندات المرفوعة" },
                },
                extractedData: {
                  title: "البيانات المستخرجة",
                  fields: {
                    country: "البلد",
                    firstName: "الاسم الأول",
                    middleName: "الاسم الأوسط",
                    lastName: "اسم العائلة",
                    dob: "تاريخ الميلاد",
                    gender: "الجنس",
                    placeOfBirth: "مكان الميلاد",
                    address: "Address",
                  },
                },
                screeningData: { title: "بيانات الفحص" },
                applicantData: {
                  noData: {
                    title: "لا توجد بيانات للعرض بعد",
                    text: "يتم معالجة هذه البيانات حاليًا",
                  },
                  details: "التفاصيل",
                  id: "المعرف",
                  submitted: "تم الإرسال",
                  screened: "تم الفحص",
                  vendor: "المزود",
                  monitoring: "المراقبة",
                  enabled: "مفعّل",
                  disabled: "معطّل",
                  result: "النتيجة",
                  metadata: "البيانات الوصفية",
                  screeningId: "معرف الفحص",
                  apiTimestamp: "الطابع الزمني للـ API",
                  auremId: "معرف أوريم",
                  potentialMatches: "التطابقات المحتملة",
                  birthYears: "سنة الميلاد",
                  matchStatus: "حالة التطابق",
                  whitelisted: "القائمة البيضاء",
                  categories: "الفئات",
                  sources: "المصادر",
                  since: "منذ",
                },
                list: {
                  grid: { status: { awaitingSubmission: "في انتظار التقديم" } },
                  heading: "الطلبات",
                },
              },
            },
            requestMoreDocumentsModal: {
              heading: "طلب المزيد من الوثائق",
              alert: { successMessage: "تم طلب الوثائق بنجاح" },
            },
          },
        },
        signIn: {
          page: {
            signIn: {
              mfa: {
                heading: "تحقق من هويتك",
                description:
                  "أدخل رمز التحقق المكون من 6 أرقام من تطبيق المصادقة.",
                error: "تعذّر تسجيل الدخول. الرجاء المحاولة مرة أخرى.",
              },
              invalidInvitation:
                "تم استخدام هذه الدعوة بالفعل. حاول تسجيل الدخول بدلاً من ذلك.",
              signIn: "تسجيل الدخول",
              title: "تسجيل الدخول إلى",
              email: {
                label: "البريد الإلكتروني",
                placeholder: "أدخل بريدك الإلكتروني",
              },
              password: {
                label: "كلمة المرور",
                placeholder: "أدخل كلمة المرور الخاصة بك",
              },
              error: "البريد الإلكتروني أو كلمة المرور غير صحيحة",
              signInWithGoogle: "تسجيل الدخول باستخدام  Google",
              youCanAlso: "يمكنك أيضا",
              continueWithSaml: "تابع مع SAML SSO",
              donthaveAccount: "ليس لديك حساب بعد؟",
              signUpLink: "التسجيل",
              forgotPassword: "نسيت كلمة المرور",
            },
          },
        },
        signInWithSaml: {
          page: {
            signIn: {
              title: (name) => `تسجيل الدخول إلى ${name}`,
              email: {
                label: "البريد الإلكتروني",
                placeholder: "أدخل بريدك الإلكتروني",
              },
              youCanAlso: "يمكنك أيضا",
              donthaveAccount: "ليس لديك حساب بعد؟",
              signUpLink: "التسجيل",
              forgotPassword: "نسيت كلمة المرور",
            },
            signInWithSaml: {
              signIn: "تسجيل الدخول باستخدام SAML",
              continueWithEmail: "تابع بالبريد الإلكتروني",
            },
          },
        },
        signUp: {
          page: {
            signUp: {
              title: "سجّل مع",
              alreadyHaveAccount: "هل لديك حساب بالفعل؟",
              signInLink: "تسجيل الدخول",
              email: {
                label: "البريد الإلكتروني",
                placeholder: "أدخل بريدك الإلكتروني",
              },
              password: {
                label: "كلمة المرور",
                placeholder: "أدخل كلمة المرور الخاصة بك",
                hint: "يجب أن تكون 8 أحرف على الأقل.",
              },
              disclaimer: {
                textFirst: "بمواصلتك استخدام هذه المنصة، فإنك توافق على",
                link: "الشروط والأحكام",
                textSecond:
                  " وسياسة الخصوصية، وتوافق على مشاركة معلوماتك لغرض الاستحقاقات الخاصة بنهاية الخدمة.",
              },
              agreeTerms:
                "باستمرارك في استخدام هذه المنصة، فإنك توافق على مشاركة معلوماتك لغرض استحقاقات نهاية الخدمة الخاصة بك.",
              signUp: "إنشاء حساب",
              signUpWithGoogle: "سجل باستخدام Google ",
            },
          },
        },
        signUpNewCompanyAdmin: {
          page: {
            emailVerified: "تم التحقق من البريد الإلكتروني.",
            passwordConfirmation: { label: "تأكيد كلمة المرور" },
            password: {
              label: "كلمة المرور الجديدة الخاصة بك",
              hint: "يجب أن تكون 8 أحرف على الأقل.",
            },
            nextStep: "الخطوة التالية",
            setYourPassword: "قم بتعيين كلمة المرور الخاصة بك.",
            setPassword: "تعيين كلمة المرور",
            welcome:
              "مرحبًا بكم في نظام التشغيل الذكي لمقدمي خدمات التقاعد والثروة. هيا نبدأ.",
            fullName: { label: "اسمك الكامل" },
            preferredName: {
              label: "الاسم المفضل",
              hint: "يمكن أن يكون هذا اسمك الأول أو اسمًا مستعارًا — الاسم الذي تود أن يراه الناس ويستخدموه عند الإشارة إليك على المنصة.",
            },
          },
        },
        usersManagement: {
          users: {
            page: {
              list: {
                emailVerified: "تم التحقق من البريد الإلكتروني",
                grid: {
                  roles: "الأدوار",
                  employeeStatus: { active: "نشط", invited: "مدعو" },
                  blockStatus: "حالة الحظر",
                  blocked: "محظور",
                  block: "حظر",
                  unblock: "إلغاء الحظر",
                  active: "نشط",
                  invited: "مدعو",
                },
              },
              invite: {
                assignUsersToRole: "تعيين المستخدمين إلى دور",
                addUsers: "أضف المستخدمين",
                choosePermissions: "اختر الأذونات وعيّن الأدوار",
                assignAnotherRole: "تعيين دور آخر",
                chooseRole: "اختر دورًا",
                company: { label: "الشركة", placeholder: "اختر شركة" },
                companyPermissions: {
                  hint: "سيكون لدى المستخدمين بصلاحيات الشركة وصول محدود إلى صلاحيات محددة بناءً على إعدادات الشركة.",
                  label: "صلاحيات الشركة",
                },
                description: "أضف المستخدمين الخاصين بك",
                errors: {
                  atLeastOneEmail: "يرجى إضافة بريد إلكتروني واحد على الأقل",
                  selectCompany: "يرجى اختيار شركة",
                  selectRole: "يرجى اختيار دور",
                  invalidEmail: "أحد عناوين البريد الإلكتروني غير صالح",
                  duplicatedRoles: "لا يمكنك اختيار نفس الدور أكثر من مرة.",
                  userAlreadyExists: "هذا المستخدم مسجل بالفعل في النظام.",
                  duplicateEmail:
                    "تمت دعوة هذا البريد الإلكتروني أو إضافته بالفعل.",
                },
                peopleSelected: (count) =>
                  `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `لا يوجد مستخدمين`, ["one"]: `مستخدم واحد تم تحديده`, ["two"]: `مستخدمان تم تحديدهما`, ["few"]: `${count} مستخدمين تم تحديدهم`, ["many"]: `${count} مستخدم تم تحديدهم` })[P.select(count)] ?? `${count} مستخدم تم تحديدهم`}`,
                platformPermissions: {
                  hint: "سيكون لدى المستخدمين صلاحيات الوصول إلى جميع ميزات المنصة. يجب دعوة الأشخاص الذين تثق بهم فقط.",
                  label: "صلاحيات المنصة",
                },
                role: { label: "الدور", placeholder: "اختر دورًا" },
                selectPermissionsGroup: "اختر مجموعة الصلاحيات",
                title: "دعوة المستخدمين",
                useComma:
                  "افصل بين عناوين البريد الإلكتروني باستخدام فاصلة أو مسافة أو بالضغط على Enter.",
              },
              invitationAcceptance: { invited: "تمت دعوة المستخدمين." },
              admins: { invitedBy: "دعوة بواسطة", lastActive: "آخر تفعيل" },
              emptyTitle: "لا يوجد مستخدمون للعرض",
              assignNewRole: "تعيين دور جديد",
              rolesUpdatedSuccessfully: "تم تحديث الأدوار بنجاح",
              blockUser: {
                blockTitle: "حظر المستخدم",
                blockDescription: (email) =>
                  `هل أنت متأكد أنك تريد حظر ${email}؟ لن يتمكن من تسجيل الدخول بعد الآن.`,
                blockConfirm: "حظر",
                unblockTitle: "إلغاء حظر المستخدم",
                unblockDescription: (email) =>
                  `هل أنت متأكد أنك تريد إلغاء حظر ${email}؟ سيتمكن من تسجيل الدخول مرة أخرى.`,
                unblockConfirm: "إلغاء الحظر",
                aggregateTitle: "تأكيد تغييرات حالة الحظر",
                aggregateSubmit: "تأكيد",
                aggregateBlockHeading: (count) =>
                  `${{ [1]: `حظر هذا المستخدم:`, [2]: `حظر هذين المستخدمين:` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `حظر ${count} مستخدمين:`, ["many"]: `حظر ${count} مستخدمًا:` })[P.select(count)] ?? `حظر ${count} مستخدم:`}`,
                aggregateUnblockHeading: (count) =>
                  `${{ [1]: `إلغاء حظر هذا المستخدم:`, [2]: `إلغاء حظر هذين المستخدمين:` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `إلغاء حظر ${count} مستخدمين:`, ["many"]: `إلغاء حظر ${count} مستخدمًا:` })[P.select(count)] ?? `إلغاء حظر ${count} مستخدم:`}`,
                error: {
                  cannotBlockSelf: "لا يمكنك حظر حسابك الخاص",
                  userAlreadyBlocked: "المستخدم محظور بالفعل",
                  userNotBlocked: "المستخدم غير محظور",
                  cannotBlockLastPlatformAdmin:
                    "لا يمكن حظر آخر مسؤول نشط على المنصة",
                },
              },
              blockedFilter: {
                all: "الكل",
                blocked: "محظور",
                nonBlocked: "غير محظور",
              },
              cancelInvite: {
                title: "إلغاء الدعوة",
                description: (email) =>
                  `هل أنت متأكد أنك تريد إلغاء دعوة ${email}؟ لن يتمكن من استخدام هذه الدعوة لتسجيل الدخول بعد الآن.`,
                confirm: "إلغاء الدعوة",
                action: "إلغاء الدعوة",
              },
              resendInvite: {
                title: "إعادة إرسال الدعوة",
                description: (email) =>
                  `هل أنت متأكد أنك تريد إعادة إرسال الدعوة إلى ${email}؟`,
                confirm: "إعادة إرسال الدعوة",
                action: "إعادة إرسال الدعوة",
                success: "تم إعادة إرسال الدعوة",
              },
              dataEditor: {
                action: "محرر البيانات",
                title: "المستخدمون",
                inviteInProgress:
                  "نقوم بإرسال الدعوات التي أضفتها. قد يستغرق ذلك بعض الوقت.",
                inviteResult: ({ invited, total }) =>
                  `تم إرسال ${invited} من ${total} دعوة بنجاح`,
              },
            },
            userId: {
              page: {
                joined: "تاريخ الانضمام",
                chooseRole: "اختر الدور",
                selectRole: "تحديد الدور",
                assignedAt: "تاريخ التعيين",
                assignedBy: "تم التعيين بواسطة",
                otherRole: "إضافة دور آخر",
                duplicatedRoles: "لا يمكنك اختيار نفس الدور أكثر من مرة.",
                uploadFailed: "فشل في تحديث الأدوار",
                loading: "جارٍ تحميل الأدوار...",
                platformRoles: "أدوار المنصة",
                rolesUpdatedSuccessfully: "تم تحديث الأدوار بنجاح",
                noRoles: {
                  title: "هذا المستخدم لا يملك أي أدوار حتى الآن",
                  text: "قم بتعيين الأدوار لتحديد ما يمكن لهذا المستخدم الوصول إليه وإدارته",
                },
                pendingInvitation: {
                  title: "لم يقبل هذا المستخدم الدعوة بعد",
                  text: "ستتوفر الصلاحيات وخصائص الوصول عند انضمام المستخدم إلى المنصة",
                  action: "الرجوع إلى جميع المستخدمين",
                },
                assignNewRole: "تعيين دور جديد",
                updateEmail: {
                  editAriaLabel: "تعديل البريد الإلكتروني",
                  title: "تحديث البريد الإلكتروني",
                  description:
                    "أدخل عنوان البريد الإلكتروني الجديد لهذا المستخدم. سيسري التغيير على الفور.",
                  emailLabel: "البريد الإلكتروني",
                  emailPlaceholder: "name@example.com",
                  successTitle: "تم تحديث البريد الإلكتروني",
                  errors: {
                    required: "البريد الإلكتروني مطلوب",
                    invalid: "أدخل عنوان بريد إلكتروني صالح",
                  },
                },
              },
            },
          },
        },
        passwordReset: {
          requestId: {
            page: {
              resetPassword: {
                title: "تعيين كلمة مرور جديدة",
                password: {
                  label: "كلمة المرور الجديدة",
                  placeholder: "أدخل كلمة مرور جديدة",
                },
                confirmPassword: { label: "أعد إدخال كلمة المرور الجديدة" },
                passwordHint: "يجب أن تتكون من 8 أحرف على الأقل",
                submit: "تغيير كلمة المرور",
                cancel: "العودة إلى تسجيل الدخول",
              },
            },
          },
        },
        invitation: {
          admin: {
            invitationId: {
              page: {
                invitationAcceptance: {
                  success: (roleName) => `أنت الآن ${roleName}!`,
                  failure:
                    "فشل التحقق من دعوة المستخدم، تواصل مع الشخص الذي قام بدعوتك لطلب دعوة جديدة",
                },
              },
            },
          },
        },
        emailVerification: {
          verificationId: {
            page: {
              verification: {
                success: (email) =>
                  `تم التحقق من بريدك الإلكتروني ${email} بنجاح!`,
                failure: "فشل التحقق من البريد الإلكتروني",
              },
            },
          },
        },
        chats: {
          page: {
            title: "المحادثات",
            search: "ابحث في رؤاك...",
            history: "السجل",
            allChats: "جميع المحادثات",
            reports: "التقارير",
            newChat: "محادثة جديدة",
            threads: {
              count: (count) =>
                `لديك ${{ [1]: `محادثة سابقة واحدة.` }[count] ?? `${count} محادثات سابقة.`}`,
              empty: {
                noThreadsSearch: "لم يتم العثور على محادثات.",
                noReportsSearch: "لم يتم العثور على تقارير.",
                starter: {
                  noThreadsMessage:
                    "ابدأ محادثة لاستكشاف الرؤى أو الملخصات أو الإجابات.",
                },
              },
              loading: "تحميل المزيد...",
              menu: {
                documents: "الملفات",
                rename: "إعادة التسمية",
                star: "تمييز",
                unstar: "إلغاء التمييز",
                delete: "حذف",
              },
              modal: {
                rename: {
                  title: "إعادة تسمية المحادثة",
                  placeholder: "أدخل عنوان المحادثة الجديد",
                  emptyError: "لا يمكن أن يكون العنوان فارغًا",
                },
                delete: {
                  title: "حذف المحادثة",
                  description: "هل أنت متأكد أنك تريد حذف هذه المحادثة؟",
                },
              },
              toast: {
                starred: "تم تمييز المحادثة",
                unstarred: "تم إلغاء تمييز المحادثة",
                renamed: "تمت إعادة تسمية المحادثة بنجاح",
                deleted: "تم حذف المحادثة",
                updateFailed: "فشل في تحديث المحادثة",
                deleteFailed: "فشل حذف المحادثة",
              },
              documents: {
                title: "ملفات من الدردشة",
                description: "تنزيل ملفاتك وتقاريرك التي تم تصديرها",
                error: "فشل في تحميل المستندات",
                empty: {
                  title: "لا توجد مستندات بعد",
                  description: "ستظهر المستندات المصدّرة من هذه المحادثة هنا",
                },
              },
            },
          },
        },
        tasks: {
          title: "المهام",
          list: {
            yourTasksLabel: "أنت",
            allTasksLabel: "الكل",
            searchPlaceholder: "ابحث بالكلمة المفتاحية أو الفئة أو المكلَّف...",
            filters: "التصفيات",
          },
          createTask: {
            title: "إنشاء مهمة جديدة",
            submit: "إنشاء مهمة",
            taskTitle: "عنوان المهمة",
            taskTitlePlaceholder: "مثال: تأكيد الدفع لـ ABC",
            taskDescription: "وصف المهمة",
            taskDescriptionPlaceholder:
              "مثال: قم بدفع مبلغ 1,500.00 درهم، ثم قم بتحميل إثبات الدفع.",
            assignee: "المسؤول",
            assigneePlaceholder: "اختر المسؤول",
            successMessage: "تم إنشاء المهمة بنجاح",
            addTask: "إضافة مهمة",
          },
          noItems: { text: "لا توجد مهام" },
          noSelection: {
            title: "لم يتم اختيار مهمة",
            text: "اختر مهمة لعرض تفاصيلها",
          },
          escalated: "تم تصعيدها",
          untitled: "مهمة بدون عنوان",
          types: {
            PaymentEntity: "المدفوعات",
            MarketOrderEntity: "أوامر السوق",
            CompanyVerificationEntity: "طلبات التحقق من الشركة",
            KycRequestEntity: "طلبات اعرف عميلك",
            ManualTaskEntity: "المهام اليدوية",
            ProductAssignmentSubscriptionRequestEntity: "طلبات الاشتراك",
            AttributesCorrectionsRequestEntity: "طلبات التصحيح",
          },
          taskTitle: {
            MarketOrderEntity: ({ type, amount, employeeName, companyName }) =>
              `${type} أمر سوق بقيمة ${amount} لـ ${employeeName} في ${companyName}`,
            MarketOrderEntityUnits: ({
              type,
              amount,
              employeeName,
              companyName,
            }) =>
              `${type} أمر سوق بـ ${amount} وحدة لـ ${employeeName} في ${companyName}`,
            CompanyVerificationEntity: (companyName) =>
              `مستندات KYB من ${companyName}`,
            KycRequestEntity: (employeeName) =>
              `التحقق من هوية KYC لـ ${employeeName}`,
            ManualTaskEntity: "المهام اليدوية",
            ProductAssignmentSubscriptionRequestEntity: (employeeName) =>
              `طلب اشتراك من ${employeeName}`,
            AttributesCorrectionsRequestEntity: (employeeName) =>
              `طلب تحديث بيانات الموظف ${employeeName}`,
            ContributionPaymentEntity: ({ amount, companyName }) =>
              `دفعة مساهمة ${amount} لـ ${companyName}`,
            AdjustmentPaymentEntity: ({ amount, companyName }) =>
              `دفعة تسوية ${amount} لـ ${companyName}`,
            WithdrawalPaymentEntity: ({ amount, employeeName }) =>
              `دفعة سحب ${amount} لـ ${employeeName}`,
            FeeDistributionEntity: (amount) => `دفعة توزيع رسوم ${amount}`,
            FeePayoutEntity: ({ amount, companyName }) =>
              `دفعة صرف رسوم ${amount} لـ ${companyName}`,
            marketOrderType: { buy: "شراء", sell: "بيع", switch: "تبديل" },
          },
          statuses: {
            inReview: "قيد المراجعة",
            inProgress: "قيد التنفيذ",
            completed: "مكتمل",
          },
          urgency: {
            overdue: (count) =>
              `متأخرة ${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `${count} يوم`, ["one"]: `يوم واحد`, ["two"]: `يومان`, ["few"]: `${count} أيام`, ["many"]: `${count} يوماً` })[P.select(count)] ?? `${count} يوم`}`,
            due: (d) => `تستحق في ${d}`,
            noDueDate: "بدون تاريخ استحقاق",
          },
          priorities: { low: "منخفض", medium: "متوسط", high: "مرتفع" },
          filters: {
            filterTasks: "تصفية المهام",
            sortBy: "الترتيب حسب",
            issueDate: "تاريخ الإصدار",
            priority: "الأولوية",
            taskTypes: "أنواع المهام",
            taskStatus: "حالة المهمة",
            assignees: "المكلفون",
            assigneesPlaceholder: "ابحث بالاسم أو الدور",
            assignedBy: "مُعيَّن من قِبَل",
            assignedByPlaceholder: "ابحث بالاسم أو الدور",
            companies: "الشركات",
            companiesPlaceholder: "ابحث بالشركة",
          },
        },
        taskDetails: {
          title: "تفاصيل المهمة",
          escalate: "تصعيد المهمة",
          escalateTitle: "هل أنت متأكد أنك تريد تصعيد هذه المهمة؟",
          escalateDescription:
            "هل أنت متأكد أنك تريد تصعيد هذه المهمة؟ تصعيد هذه المهمة سيؤدي إلى إعلام المكلف وتحديد هذه المهمة بشكل دائم حتى يتم إغلاقها.",
          filesAndLinks: {
            label: "الملفات والروابط",
            files: "الملفات",
            links: "الروابط",
            noFiles: "لا توجد ملفات مرفقة",
            noLinks: "لا توجد روابط مضافة",
          },
          markTaskAsCompleted: "هل تريد وضع علامة اكتمال على هذه المهمة؟",
          submitTaskForReview: "هل تريد إرسال المهمة للمراجعة؟",
          submittedForReview: "تم إرسال المهمة للمراجعة",
          submitTaskForReviewDescription:
            "سيتم إعلام منشئ هذه المهمة ولن تتمكن من إجراء أي تعديلات عليها بعد ذلك.",
          markTaskAsCompletedDescription:
            "سيتم وضع علامة اكتمال على هذه المهمة ولن تتمكن من إجراء أي تعديلات عليها بعد ذلك.",
          backToAllTasks: "العودة إلى جميع المهام",
          assigneeTooltip: "اختر مكلفًا لهذه المهمة",
          priorityTooltip: "اختر أولوية لهذه المهمة",
          tabs: {
            taskDetails: "تفاصيل المهمة",
            paymentDetails: "تفاصيل الدفع",
            confirmPayment: "تأكيد الدفع",
            actionRequired: "إجراء مطلوب",
            marketOrderDetails: "تفاصيل أمر السوق",
            reviewDocuments: "مراجعة المستندات",
            activityAndComments: "النشاط والتعليقات",
            activity: "النشاط",
            uploadDocuments: "رفع المستندات",
            reviewDetails: "تفاصيل الطلب",
            companyDetails: "تفاصيل الشركة",
            employeeDetails: "تفاصيل الموظف",
            reviewChanges: "مراجعة التغييرات",
          },
          subscriptionRequest: {
            title: "تفاصيل الطلب",
            employee: "الموظف",
            companyName: "اسم الشركة",
            type: "النوع",
            amount: "المبلغ",
            dateAdded: "تاريخ الإنشاء",
            typeRecurrent: "الدفع الشهري",
            typeOneTimePayment: "دفعة مقطوعة",
          },
          category: "الفئة",
          taskStatus: "حالة المهمة",
          priority: {
            label: "الأولوية",
            low: "منخفض",
            medium: "متوسط",
            high: "مرتفع",
          },
          activityAndComments: {
            writeAComment: "اكتب تعليقًا...",
            send: "إرسال",
            attachFile: "إرفاق ملف",
            addedAComment: "أضاف تعليقاً",
            you: "أنت",
            user: "المستخدم",
            removeFile: "إزالة الملف",
            downloadFile: "تحميل الملف",
            failedToPreviewFile: "فشل في عرض الملف",
            activity: {
              taskCreated: "تم إنشاء المهمة",
              taskCreatedVia: "عبر",
              requestedVia: {
                requestedVia: "طلب من خلال",
                Contribution: "مساهمة",
                Withdrawal: "سحب",
                FundSwitch: "تحويل صندوق",
              },
              statusChanged: "تم تغيير حالة المهمة إلى ",
              assigneeChanged: "تم تعيين المهمة إلى ",
              submittedForReview: " أرسل مستندات لمراجعة",
              escalated: " صعّد المهمة",
              escalatedAutomatically: "تم تصعيد المهمة تلقائياً",
              markedAsCompleted: " وضع علامة المهمة كمكتملة",
              reviewerChanged: "تم تعيين المراجع للمهمة إلى ",
              taskClosed: "تم إغلاق المهمة",
              documentsUploaded: "تم تقديم مستندات جديدة",
              resubmissionRequested: "طلب إعادة تقديم المستندات ",
              correctionAccepted: "قبل طلب التصحيح",
              correctionRejected: "رفض طلب التصحيح",
              correctionResolved: "حل طلب التصحيح",
            },
          },
          reviewDocuments: {
            reviewDocuments: "مراجعة المستندات",
            reviewCompanyDocuments: "مراجعة المستندات الشركة",
            reviewSignatoryDocuments: "مراجعة المستندات المفوضين",
            downloadAllDocuments: "تحميل الكل ",
            signatory: "المفوضين",
            documents: "المستندات",
            openInNewTab: "فتح في علامة تبويب جديدة",
            downloadDocument: "تحميل الملف",
          },
          assignee: "المكلّف",
          unAssigned: "غير مكلّف",
          reviewer: "المراجع",
          taskStatusUpdated: "تم تحديث حالة المهمة بنجاح",
          kyb: {
            noDocumentsYet: "لا توجد مستندات بعد",
            noDocumentsYetDescription:
              "ستظهر المستندات المصدّرة من هذه المحادثة هنا",
            uploadCompanyDocuments: "تحميل المستندات الشركة",
            uploadSignatoryDocuments: "تحميل المستندات المفوضين",
            submitForReview: "إرسال المستندات للمراجعة",
            submittedForReview: "تم إرسال المستندات للمراجعة",
            documentsInReview: "تم إرسال المستندات للمراجعة ويتم مراجعتها",
            documentsRetry: "تم رفض المستندات ويتم إعادة تقديمها",
            rejected: "لم يتم التحقق من الشركة. تم مراجعة المستندات ورفضها.",
            approved: "تهانينا! تم قبول المستندات وتم التحقق من الشركة.",
            additionalDocumentsRequired: "تم طلب المزيد من المستندات",
            goToDashboard: "العودة إلى لوحة التحكم",
            documentRequiresResubmission: "تحتاج المستندات إلى إعادة التقديم",
            resubmittedForReview: "تم إعادة تقديم المستندات للمراجعة",
            additionalDocumentRequired: "مستند إضافي مطلوب",
            addSignatory: "إضافة مفوض",
            requestMoreDocuments: "طلب المزيد من المستندات",
            requestMoreDocumentsDescription:
              "المستندات المقدمة غير كافية. سيُطلب من مسؤول الشركة تقديم مستندات إضافية.",
            resubmit: "طلب إعادة التقديم",
            resubmitDescription:
              "المستندات المقدمة غير صحيحة. سيُطلب من مسؤول الشركة إعادة تقديم مستندات صحيحة.",
            reject: "رفض طلب التحقق",
            rejectDescription: "المستندات المقدمة غير صالحة ولا يمكن قبولها.",
            approve: "الموافقة والإكمال",
            approveDescription: "المستندات المقدمة صالحة ويمكن قبولها.",
            confirmButton: "تأكيد القرار",
            actionRequired: "يتطلب إجراء",
            requestedResubmission: "لقد طلبت إعادة تقديم المستندات.",
            requestedResubmissionDescription:
              "سيتم إشعارك عندما يقوم المكلف بتقديم المستندات للمراجعة.",
            rejectedCompanyVerification:
              "لقد رفضت طلب التحقق وتم إشعار مسؤول الشركة.",
            requestedMoreDocuments: "لقد طلبت المزيد من المستندات.",
            requestedMoreDocumentsDescription:
              "سيتم إشعارك عندما يقوم المكلف بتقديم المستندات للمراجعة.",
            approvedCompanyVerification:
              "لقد وافقت على طلب التحقق وتم إشعار مسؤول الشركة.",
            updateSignatories: "تحديث المفوضين",
            signatoryDocumentsUpdated: "تم تحديث المستندات المفوضين بنجاح",
            failedToUpdateSignatories: "فشل تحديث المستندات المفوضين",
            companyDocuments: "مستندات الشركة",
            signatoryDocuments: "مستندات المفوضين",
            downloadDocument: "تحميل المستند",
            noDocumentsSubmitted: "لم يتم تقديم مستندات بعد",
            noDocumentsSubmittedDescription:
              "لم يتم تقديم مستندات لهذه المهمة.",
            companyDetails: {
              title: "تفاصيل الشركة",
              name: "اسم الشركة",
              tradeLicenseNumber: "رقم رخصة التجارة",
            },
          },
          marketOrder: {
            title: "تفاصيل أمر السوق",
            fundDetails: "تفاصيل الصندوق",
            orderDetails: "تفاصيل الأمر",
            executionDetails: "تفاصيل التنفيذ",
            fundName: "اسم الصندوق",
            fundClass: "فئة الصندوق",
            amount: "المبلغ",
            fundIsin: "رقم ISIN للصندوق",
            companyName: "اسم الشركة",
            type: "النوع",
            createdOn: "تاريخ الإنشاء",
            dueOn: "تاريخ الاستحقاق",
            transferedBy: "تم التحويل بواسطة",
            status: "حالة أمر السوق",
            confirm: {
              title: "تأكيد أمر السوق",
              description:
                "قم بتنفيذ أمر السوق ورفع الإيصال مع تفاصيل التنفيذ لتأكيد المعاملة.",
              button: "تأكيد أمر السوق",
              success: "تم تأكيد أمر السوق بنجاح",
            },
            receipt: "الإيصال",
            saleReceipt: "إيصال البيع",
            purchaseReceipt: "إيصال الشراء",
            marketOrderDate: "تاريخ أمر السوق",
            unitPrice: "سعر الوحدة",
            assetQuantity: "كمية الأصل",
            unitPricePlaceholder: "أدخل سعر الوحدة",
            uploadReceipt: "تحميل الإيصال",
            uploadReceiptDescription:
              "يجب أن يكون الملف بصيغة PDF أو JPG أو DOCS (بحد أقصى 5 ميجابايت)",
            dateIsRequired: "تاريخ مطلوب",
            invalidNumber: "رقم غير صالح",
            numberIsRequired: "رقم مطلوب",
            fileIsRequired: "ملف مطلوب",
            executedOn: "تاريخ التنفيذ",
            unitsSold: "الوحدات المباعة",
            unitsBought: "الوحدات المشتراة",
            totalUnitsToSell: "الوحدات المباعة الكلية",
            switch: {
              sellMarketOrderDate: "تاريخ أمر بيع السوق",
              buyMarketOrderDate: "تاريخ أمر شراء السوق",
              unitPriceSold: "سعر الوحدة المباعة",
              unitPriceBought: "سعر الوحدة المشتراة",
              totalAmountSold: "إجمالي المبلغ المباع",
              uploadSaleReceipt: "تحميل إيصال البيع",
              uploadPurchaseReceipt: "تحميل إيصال الشراء",
            },
          },
          kyc: {
            uploadDocuments: "تحميل مستندات",
            reviewEmployeeDocuments: "مراجعة مستندات الموظف",
            documentsInReview: "تم إرسال مستنداتك وهي قيد المراجعة",
            submitForReview: "إرسال المستندات للمراجعة",
            rejected: "تمت مراجعة مستنداتك ورفضها.",
            approved: "تمت الموافقة على مستنداتك واكتمال التحقق.",
            goToRequest: "الذهاب إلى الطلب",
            requestedResubmission: "طلب المراجع إعادة تقديم المستندات.",
            rejectedVerification: "لقد رفضت طلب التحقق وتم إخطار الموظف.",
            approvedVerification: "لقد وافقت على طلب التحقق وتم إخطار الموظف.",
            requestedMoreDocuments: "لقد طلبت المزيد من المستندات.",
            requestedMoreDocumentsDescription:
              "سيتم إخطارك عندما يقدم الموظف المستندات للمراجعة.",
            requestedResubmissionTitle: "لقد طلبت إعادة تقديم المستندات.",
            requestedResubmissionDescription:
              "سيتم إخطارك عندما يقدم الموظف المستندات للمراجعة.",
            approve: "الموافقة والإكمال",
            approveDescription: "المستندات المقدمة صالحة ويمكن قبولها.",
            resubmit: "طلب إعادة التقديم",
            resubmitDescription:
              "المستندات المقدمة غير صحيحة. سيُطلب من الموظف إعادة تقديم مستندات مصححة.",
            reject: "رفض نهائي - غير مسموح بإعادة المحاولة",
            rejectDescription:
              "المستندات المقدمة غير صالحة ولا يمكن قبولها. سيتم إخطار الموظف بالرفض النهائي ولن يُسمح له بإعادة التقديم.",
            cancelAndClose: "إلغاء وإغلاق المهمة",
            cancelAndCloseDescription:
              "إغلاق عملية التحقق من المستندات دون إكمالها.",
            confirmButton: "تأكيد القرار",
            actionRequired: "إجراء مطلوب",
            documentRequiresResubmission: "مطلوب إعادة التقديم",
            resubmittedForReview: "أعيد تقديمه للمراجعة",
            documentType: {
              identity: "مستند الهوية",
              proofOfAddress: "إثبات العنوان",
              identityDescription:
                "بطاقة هوية حكومية رسمية (جواز سفر، بطاقة هوية الإمارات، أو رخصة قيادة).",
              proofOfAddressDescription:
                "مستندات حديثة تظهر عنوان السكن المادي للفرد (فاتورة مرافق، فاتورة هاتف سكني، أو كشف حساب بنكي). يجب أن يكون المستند موقعاً خلال الأشهر الثلاثة الأخيرة.",
            },
            requestMoreDocuments: "طلب المزيد من الوثائق",
            requestMoreDocumentsDescription:
              "الوثائق المقدمة غير كافية. سيُطلب من الموظف تقديم وثائق إضافية.",
            reset: "إعادة تعيين الطلب",
            resetDescription: "إعادة الطلب إلى الموظف دون إكمال عملية التحقق.",
          },
          payment: {
            title: "تفاصيل الدفع",
            paymentType: "نوع الدفع",
            paymentTypes: {
              ContributionPaymentEntity: "مساهمات",
              AdjustmentPaymentEntity: "تسويات",
              WithdrawalPaymentEntity: "سحوبات",
              FeeDistributionEntity: "توزيع رسوم",
              FeePayoutEntity: "صرف رسوم",
            },
            sender: "المرسل",
            recipient: "المستلم",
            paymentId: "رقم الدفع",
            taxAmount: "مبلغ الضريبة",
            invoice: "الفاتورة",
            downloadInvoice: "تحميل الفاتورة",
            downloadReceipt: "تحميل الإيصال",
            referenceNumber: "الرقم المرجعي",
            iban: "رقم الآيبان",
            accountName: "اسم الحساب",
            swiftCode: "رمز السويفت",
            branchName: "اسم الفرع",
            branchAddress: "عنوان الفرع",
            amount: "المبلغ",
            createdOn: "تاريخ الإنشاء",
            paymentForMonth: "دفعة عن شهر",
            status: "حالة الدفع",
            confirm: {
              note: "تم التحقق من الإيصال وقبوله.",
              button: "تأكيد الدفع",
              description:
                "قم بمعالجة الدفع ورفع إيصال الدفع. تأكد من تضمين الرقم المرجعي في التحويل لتجنب رفض الدفع أو تأخره.",
              decision: "تأكيد القرار",
              success: "تم تأكيد الدفع بنجاح",
            },
            uploadReceipt: "تحميل الإيصال",
            receipt: "الإيصال",
            uploadReceiptDescription:
              "يجب أن يكون الملف بصيغة PDF أو JPG أو DOCS (بحد أقصى 5 ميجابايت)",
            actionRequired: {
              title: "إجراء مطلوب",
              description: "تحقق من الإيصال المرفوع وقم بتأكيد الدفع أو رفضه.",
            },
            rejectButton: "رفض الدفع",
            rejectSuccess: "تم رفض الدفع بنجاح",
            notePlaceholder: "يرجى إعطاء سبب الرفض...",
            rejectNotePlaceholder: "أضف سبب الرفض...",
            rejectReasonDialogTitle: "لماذا تريد رفض هذا الدفع؟",
            noActionForStatus: "لا يوجد إجراء متاح لحالة الدفع هذه.",
            transactionSection: "المعاملة",
            senderSection: "المرسل",
            recipientSection: "المستلم",
          },
          correction: {
            employeeDetails: {
              title: "تفاصيل الموظف",
              employeeName: "اسم الموظف",
              name: "الاسم الكامل",
              nationalId: "الهوية الوطنية",
              iban: "آيبان",
              firstName: "الاسم الأول",
              lastName: "اسم العائلة",
              gender: "الجنس",
              dateOfBirth: "تاريخ الميلاد",
              nationality: "الجنسية",
              emiratesId: "الهوية الإماراتية",
              passportNumber: "رقم جواز السفر",
              startDate: "تاريخ البدء",
              endDate: "تاريخ الانتهاء",
              employmentStatus: "حالة التوظيف",
              jobTitle: "المسمى الوظيفي",
              department: "القسم",
              branch: "الفرع",
              level: "المستوى",
              workEmail: "البريد الإلكتروني للعمل",
              phoneNumber: "رقم الهاتف",
              address: "العنوان",
              basicSalary: "الراتب الأساسي",
              fullSalary: "الراتب الكامل",
              empty: "فارغ",
              mohreManaged:
                "يرجى التواصل مع وزارة الموارد البشرية والتوطين (موهري) لتحديث هذا الحقل.",
              mohreUpdateRequestPrefix: "طلب الموظف تحديث هذا الحقل إلى",
            },
          },
        },
        roles: {
          administrative: {
            adminsAndUsers: {
              name: "المسؤولون والمستخدمون",
              permissions: {
                update: {
                  description:
                    "السماح للدور بتحديث تفاصيل المسؤولين والمستخدمين.",
                  name: "تحديث المستخدمين",
                },
                updateEmail: {
                  description:
                    "السماح للدور بتحديث عنوان البريد الإلكتروني للمسؤولين والمستخدمين.",
                  name: "تحديث البريد الإلكتروني للمستخدم",
                },
                view: {
                  description: "السماح للدور بمشاهدة المسؤولين والمستخدمين.",
                  name: "عرض المستخدمين",
                },
              },
            },
            companies: {
              name: "الشركات",
              permissions: {
                create: {
                  description: "السماح للدور بإضافة وإنشاء شركات جديدة.",
                  name: "إنشاء شركات",
                },
                dashboard: {
                  description: "السماح للدور بعرض لوحة التحكم الخاصة بالشركة.",
                  name: "عرض لوحة التحكم",
                },
                viewActivityLog: {
                  description: "السماح للدور بعرض سجل النشاط.",
                  name: "عرض سجل النشاط",
                },
                list: {
                  description: "السماح للدور بعرض الشركات.",
                  name: "عرض الشركات",
                },
                manageBankingDetails: {
                  description: "السماح للدور بإدارة التفاصيل المصرفية للشركات.",
                  name: "إدارة التفاصيل المصرفية",
                },
                update: {
                  description: "السماح للدور بتحديث تفاصيل الشركات الموجودة.",
                  name: "تحديث الشركات",
                },
                view: {
                  description: "السماح للدور بمشاهدة الشركات التي تم إنشاؤها.",
                  name: "عرض تفاصيل الشركات",
                },
              },
            },
            internalData: {
              name: "البيانات الداخلية",
              permissions: {
                manage: {
                  description:
                    "السماح للدور بالوصول إلى بيانات المنصة الداخلية وإدارتها.",
                  name: "إدارة البيانات الداخلية",
                },
                manageSupportTools: {
                  description:
                    "السماح للدور بالوصول إلى أدوات الدعم الداخلية واستخدامها.",
                  name: "إدارة أدوات الدعم",
                },
              },
            },
            name: "الإدارية",
            rolesAndPermissions: {
              name: "الأدوار والصلاحيات",
              permissions: {
                create: {
                  description: "السماح للدور بإنشاء أدوار وصلاحيات جديدة.",
                  name: "إنشاء أدوار",
                },
                delete: {
                  description: "السماح للدور بحذف الأدوار والصلاحيات.",
                  name: "حذف الأدوار",
                },
                list: {
                  description: "السماح للدور بعرض جميع الأدوار والصلاحيات.",
                  name: "عرض الأدوار",
                },
                update: {
                  description: "السماح للدور بتحديث تفاصيل الأدوار والصلاحيات.",
                  name: "تحديث الأدوار",
                },
                view: {
                  description: "السماح للدور بمشاهدة جميع الأدوار والصلاحيات.",
                  name: "عرض التفاصيل",
                },
              },
            },
          },
          features: {
            benefits: {
              name: "الفوائد",
              permissions: {
                approveAndDeposit: {
                  description:
                    "السماح للدور بالموافقة على الطلبات وإدارة المدفوعات.",
                  name: "الموافقة على الفوائد وإيداعها",
                },
                create: {
                  description: "السماح للدور بإنشاء وإعداد فوائد جديدة.",
                  name: "إنشاء فوائد",
                },
                delete: {
                  description: "السماح للدور بحذف الفوائد بشكل دائم.",
                  name: "حذف الفوائد",
                },
                update: {
                  description:
                    "السماح للدور بتحديث تفاصيل الفوائد بما في ذلك المعايير والموظفين المخصصين.",
                  name: "تحديث الفوائد",
                },
                view: {
                  description: "السماح للدور بعرض جميع الفوائد.",
                  name: "عرض الفوائد",
                },
              },
            },
            controlsAndCustomization: {
              name: "التحكم والتخصيص",
              permissions: {
                updateBranding: {
                  description:
                    "السماح للدور بتخصيص الألوان وثيم النظام الأساسي.",
                  name: "تحديث العلامة التجارية",
                },
                updateContent: {
                  description:
                    "السماح للدور بتخصيص كل المحتوى المتاح في المنصة، المحتوى البريدي، والترجمات.",
                  name: "تحديث المحتوى",
                },
                updateDocument: {
                  description:
                    "السماح للدور بإضافة، تحديث، وحذف مستندات المنصة.",
                  name: "تحديث مستندات المنصة",
                },
                updateProduct: {
                  description: "السماح للدور بتمكين وتعطيل جميع منتجات المنصة.",
                  name: "تحديث منتجات المنصة",
                },
                manageForms: {
                  description: "السماح للدور بإضافة وتحديث وحذف النماذج.",
                  name: "تحديث النماذج",
                },
                managePasswordPolicy: {
                  description: "السماح للدور بتحديث سياسة كلمة المرور.",
                  name: "تحديث سياسة كلمة المرور",
                },
                manageProductWorkflow: {
                  description: "السماح للدور بإضافة وتحديث وحذف سير العمل.",
                  name: "تحديث سير عمل المنتج",
                },
                manageAuthenticationPolicy: {
                  description: "السماح للدور بتحديث سياسة التسجيل والأمان.",
                  name: "تحديث سياسة التسجيل والأمان",
                },
                manageTasks: {
                  description:
                    "السماح للدور بعرض وإدارة المهام في عناصر التحكم.",
                  name: "إدارة المهام",
                },
                manageActivityPage: {
                  name: "إدارة صفحة النشاط",
                  description:
                    "تحديد الأنشطة التي تظهر في صفحات النشاط وأسماءها ومن يمكنه رؤيتها.",
                },
                manageFees: {
                  description:
                    "السماح للدور بإنشاء أنواع الرسوم وتحديثها وحذفها وإدارة سير عملها.",
                  name: "إدارة الرسوم",
                },
                managePaymentCategories: {
                  description:
                    "السماح للدور بإنشاء فئات الدفع وتحديثها وحذفها.",
                  name: "إدارة فئات الدفع",
                },
                viewPaymentCategories: {
                  description: "السماح للدور بعرض فئات الدفع.",
                  name: "عرض فئات الدفع",
                },
              },
            },
            complianceAndVerification: {
              name: "الامتثال والتحقق",
              permissions: {
                manageKYB: {
                  description:
                    "السماح للدور بالموافقة على مستندات الشركة أو رفضها وطلب مستندات إضافية.",
                  name: "إدارة مستندات KYB",
                },
                manageCompanyDocumentType: {
                  description: "السماح للدور بإدارة انواع مستندات الشركة.",
                  name: "إدارة انواع مستندات الشركة",
                },
                manageKYC: {
                  description:
                    "السماح للدور بالموافقة على مستندات الموظفين أو رفضها.",
                  name: "إدارة مستندات KYC",
                },
                submitKYB: {
                  description: "السماح للدور بتقديم مستندات الشركة للتحقق.",
                  name: "تقديم مستندات KYB",
                },
                viewKYB: {
                  description:
                    "السماح للدور بعرض مستندات الشركة وطلبات التحقق دون اتخاذ أي إجراء.",
                  name: "عرض مستندات KYB",
                },
                viewKYC: {
                  description:
                    "السماح للدور بعرض مستندات الموظفين وطلبات التحقق دون اتخاذ أي إجراء.",
                  name: "عرض مستندات KYC",
                },
              },
            },
            employees: {
              name: "الموظفون",
              permissions: {
                create: {
                  description: "السماح للدور بإضافة موظفين جدد.",
                  name: "إنشاء موظفين",
                },
                invite: {
                  description: "السماح للدور بدعوة موظفين جدد.",
                  name: "دعوة الموظفين",
                },
                list: {
                  description:
                    "السماح للدور بعرض جميع الموظفين المدعوين والنشطين وغير النشطين.",
                  name: "عرض الموظفين",
                },
                update: {
                  description:
                    "السماح للدور بتحديث تفاصيل الموظفين وتعيين الموظفين للمزايا.",
                  name: "تحديث الموظفين",
                },
                view: {
                  description:
                    "السماح للدور بمشاهدة جميع الموظفين المدعوين والنشطين وغير النشطين.",
                  name: "عرض تفاصيل الموظفين",
                },
                viewNominees: {
                  description: "السماح للدور بعرض المستفيدين المرشحين للموظف.",
                  name: "عرض مستفيدي الموظف",
                },
              },
            },
            holdings: {
              name: "المخزونات",
              permissions: {
                view: {
                  description: "السماح للدور بعرض جميع المخزونات وتفاصيلها.",
                  name: "عرض",
                },
                adjust: {
                  description: "السماح للدور بإضافة إدخالات معدلة إلى الأصول.",
                  name: "تعديل الأصول",
                },
              },
            },
            marketOrders: {
              name: "طلبات السوق",
              permissions: {
                update: {
                  description: "السماح للدور بتحديث تفاصيل طلبات السوق.",
                  name: "تحديث طلبات السوق",
                },
                view: {
                  description: "السماح للدور بعرض جميع طلبات السوق.",
                  name: "عرض طلبات السوق",
                },
                adjust: {
                  description:
                    "السماح للدور بإضافة إدخالات معدلة إلى طلبات السوق.",
                  name: "تعديل طلبات السوق",
                },
              },
            },
            name: "الميزات",
            payments: {
              name: "المدفوعات",
              permissions: {
                approveAndReject: {
                  description:
                    "السماح للدور بالموافقة على المدفوعات التي تقدمها الشركات أو رفضها.",
                  name: "الموافقة على المدفوعات ورفضها",
                },
                create: {
                  description: "السماح للدور بإنشاء مدفوعات جديدة للشركات.",
                  name: "إنشاء مدفوعات",
                },
                makeFundProviderPayment: {
                  description: "السماح للدور بسداد مدفوعات مزود الصندوق.",
                  name: "سداد مدفوعات مزود الصندوق",
                },
                view: {
                  description:
                    "السماح للدور بعرض جميع المدفوعات المستلمة والمدفوعة من الشركات.",
                  name: "عرض المدفوعات",
                },
                viewWithdrawal: {
                  description: "السماح للدور بعرض جميع عمليات السحب.",
                  name: "عرض عمليات السحب",
                },
                manageWithdrawal: {
                  description: "السماح للدور بتنفيذ عمليات السحب.",
                  name: "إدارة عمليات السحب",
                },
                adjust: {
                  description:
                    "السماح للدور بإضافة إدخالات معدلة إلى المدفوعات.",
                  name: "تعديل المدفوعات",
                },
              },
            },
            reports: {
              name: "التقارير",
              permissions: {
                exportAndDownload: {
                  description: "السماح للدور بتصدير وتنزيل جميع التقارير.",
                  name: "تصدير وتنزيل التقارير",
                },
                view: {
                  description: "السماح للدور بعرض جميع التقارير المتاحة.",
                  name: "عرض التقارير",
                },
              },
            },
            aiAssistant: {
              name: "مساعد الذكاء الاصطناعي",
              permissions: {
                manage: {
                  description:
                    "السماح للدور بالتفاعل مع مساعد الذكاء الاصطناعي.",
                  name: "إدارة مساعد الذكاء الاصطناعي",
                },
              },
            },
          },
          platformPermissions: "صلاحيات المنصة",
          companyPermissions: "صلاحيات الشركة",
          defaultRoles: "الصلاحيات الافتراضية",
          customRoles: "الصلاحيات المخصصة",
          createRole: "إنشاء دور",
          empty: { title: "لم يتم العثور على أدوار" },
          manage: {
            toast: (count) => `لقد أخفيت ${count} شركة عن هذا الدور.`,
            hideCompanies: "إخفاء الشركات عن الدور",
            companiesSelected: (count) => `${count} شركة محددة`,
            chooseCompanies:
              "اختر الشركات، إن وجدت، التي ترغب في إخفائها عن هذا الدور. لن يتمكن المستخدمون المعينون لهذا الدور من رؤية الشركات المحددة أو الوصول إلى أي من بياناتها.",
            backToRoles: "العودة إلى الأدوار",
            editRole: "تحرير الدور",
            createRole: "إنشاء دور جديد",
            roleDetails: "تفاصيل الدور",
            roleName: "اسم الدور",
            description: "الوصف",
            setPermissions: "قم بتعيين الصلاحيات",
            setRestrictions: "تعيين القيود",
            seeAllCompanies: "عرض جميع الشركات",
            save: "حفظ",
            nextStep: "الخطوة التالية",
            enableAll: "تمكين الكل",
          },
          delete: {
            userRequired: "يرجى اختيار مستخدم واحد على الأقل",
            reassignUsers: "تعيين مستخدمين",
            reassignUsersDescription: ({ roleName, usersCount }) =>
              `${{ [1]: `مستخدما واحدا  معين لـ ${roleName}` }[usersCount] ?? `${usersCount} مستخدمون معينين لـ ${roleName}`}`,
            removeUserFromRole: "إزالة المستخدم من الدور",
            noUsersAssigned: "لا يوجد مستخدم معين لهذا الدور.",
            continueAndDelete: (roleName) => `يمكنك المتابعة وحذف ${roleName}.`,
            reassignUsersButton: (usersCount) =>
              `تعيين مستخدمين (${usersCount})`,
            deleteRoleButton: "حذف الدور",
            title: "منطقة الخطر",
            confirm: "حذف الدور بشكل دائم",
          },
          invite: {
            errors: {
              selectRole: "يرجى اختيار دور",
              selectCompany: "يرجى اختيار شركة",
            },
            selectPermissionsGroup: "اختر مجموعة الصلاحيات",
            platformPermissions: {
              hint: "سيكون لدى المستخدمين صلاحيات الوصول إلى جميع ميزات المنصة. يجب دعوة الأشخاص الذين تثق بهم فقط.",
              label: "صلاحيات المنصة",
            },
            companyPermissions: {
              hint: "سيكون لدى المستخدمين بصلاحيات الشركة وصول محدود إلى صلاحيات محددة بناءً على إعدادات الشركة.",
              label: "صلاحيات الشركة",
            },
            assignUsersToRole: "تعيين المستخدمين إلى دور",
            company: { label: "الشركة", placeholder: "اختر شركة" },
            role: { label: "الدور", placeholder: "اختر دورًا" },
          },
        },
        activity: {
          page: {
            allTypes: "كل الأنواع",
            columns: {
              status: "الحالة",
              type: "النوع",
              companyEmployee: "الشركة / الموظف",
              employee: "الموظف",
              date: "التاريخ",
            },
            companyIntro:
              "تتبع كل مرحلة من مراحل نشاط هذه الشركة، من وصول الأموال حتى بلوغها حسابات الموظفين.",
            empty: "لا يوجد ما يعرض بعد.",
            inProgress: "قيد التنفيذ",
            pastActivity: "النشاط السابق",
            platformIntro:
              "تتبع كل مرحلة من مراحل النشاط عبر جميع الشركات، من وصول الأموال حتى بلوغها حسابات الموظفين.",
            searchPlaceholder: "ابحث عن شركة أو موظف...",
            stageCompleted: "مكتملة",
            stageInProgress: "قيد التنفيذ",
            stageUpcoming: "قادمة",
            stepOf: ({ step, total }) => `الخطوة ${step} من ${total}`,
            viewActivity: "عرض النشاط",
          },
        },
      },
      translationsPanel: {
        platformText: "نص المنصة.",
        toEdit:
          "لتعديل محتوى إضافي مثل التنقل، الإعداد التمهيدي، أو صفحات منصة الموظف، انتقل إلى ",
      },
      translationMode: {
        editTextOnPage: "تعديل النص على الصفحة",
        finishEditing: "إنهاء التعديل",
        modal: {
          title: "تعديل النص",
          currentValue: "القيمة الحالية",
          affectedKey: "المفتاح المتأثر",
          affectedKeys: "المفاتيح المتأثرة",
          newValue: "القيمة الجديدة",
          newValuePlaceholder: "أدخل الترجمة الجديدة...",
          cancel: "إلغاء",
          saveChanges: "حفظ التغييرات",
          errorSaving: "فشل حفظ الترجمة",
          keyRequired: "مطلوب مفتاح ترجمة واحد على الأقل",
          valueRequired: "قيمة الترجمة مطلوبة",
        },
      },
      validation: {
        list: {
          intro: "يجب أن تحتوي كلمة المرور على:",
          capitalLetter: "حرف كبير",
          lowercaseLetter: "حرف صغير",
          number: "رقم",
          specialCharacter: "رمز خاص",
          minimumLength: (min) => `الحد الأدنى ${min} من الأحرف`,
        },
        date: {
          invalid: "التاريخ غير صالح",
          invalidFormat: "يجب أن يكون يوم/شهر/سنة",
          required: "التاريخ مطلوب",
        },
        email: {
          format: "البريد الإلكتروني غير صالح",
          required: "البريد الإلكتروني مطلوب",
        },
        employmentStatus: {
          invalid:
            "حالة التوظيف غير صالحة. يجب أن تكون دائمة أو بموجب عقد أو مؤقتة",
        },
        nationalId: {
          required: "رقم الهوية الإماراتية مطلوب",
          format: "يجب أن يكون رقم الهوية الإماراتية صالحاً",
        },
        endDate: { invalid: "يجب أن يكون تاريخ النهاية بعد تاريخ البداية" },
        gender: { invalid: "الجنس غير صالح. يجب أن يكون ذكرا أو أنثى" },
        iban: {
          invalid: "رقم الحساب المصرفي الدولي IBAN غير صالح",
          notUAE: "يُسمح فقط بأرقام الحساب المصرفي الدولية (IBAN) الإماراتية",
        },
        nationality: {
          invalid: "يجب أن تكون الجنسية موجودة",
          invalidWithHint: (hint) => `هل تقصد ${hint}?`,
        },
        number: {
          negativeOrInvalid:
            "يجب أن تكون الأرقام بالتنسيق 10000.00 باستخدام الأرقام فقط ويمكن أن تكون إلى 2 مراكز عشرية",
        },
        password: {
          minLength: "يجب أن  تكون على الأقل 8 أحرف",
          required: "كلمة المرور مطلوبة",
          weak: "كلمة المرور ضعيفة جدا. أضف المزيد من التعقيد لجعلها كلمة مرور أقوى",
          match: "كلمتا المرور غير متطابقتين",
        },
        fullName: {
          minLength: "يجب أن يتكون الاسم الكامل من 1 أحرف على الأقل",
        },
        preferredName: {
          minLength: "يجب أن يتكون الاسم المفضل من 1 أحرف على الأقل",
        },
      },
      chatAI: {
        suggestedQuestions: [
          "كم عدد الموظفين النشطين حاليًا في أول شركة تم إنشاؤها؟",
          "ما المزايا المتاحة للموظفين في جميع الشركات؟",
          "أرِني ملخصات الدفعات الأخيرة لجميع الشركات.",
          "ما هي أحدث اتجاهات السوق؟",
        ],
        reports: {
          platform: {
            onboardingStatus: "أنشئ تقريرًا يوضح حالة تأهيل جميع الشركات",
            contributions12m:
              "أنشئ تقريرًا يوضح إجمالي المساهمات خلال آخر 12 شهرًا",
            withdrawals12m:
              "أنشئ تقريرًا يوضح إجمالي عمليات السحب خلال آخر 12 شهرًا",
          },
          company: {
            employeeContributions3m:
              "أنشئ تقريرًا بجميع مساهمات الموظفين خلال آخر 3 أشهر",
            benefitsAssignments:
              "أنشئ تقريرًا يسرد جميع المزايا مع الموظفين المخصصين لها",
            pendingPayments: "أنشئ تقريرًا يسرد جميع المدفوعات المعلقة",
          },
        },
        reportTemplates: {
          contributions: {
            name: "المساهمات والتدفقات النقدية",
            description: "إنشاء تحليل شامل للمساهمات والتدفقات النقدية",
            prompt:
              "أنشئ تقريراً شاملاً لتحليل المساهمات والتدفقات النقدية يتضمن جميع أنواع المساهمات والمعاملات النقدية",
          },
          marketOrders: {
            name: "أوامر السوق",
            description: "إنشاء تقرير أوامر السوق وأنشطة التداول",
            prompt:
              "أنشئ تقريراً مفصلاً لأوامر السوق يتضمن أنشطة التداول، المراكز، وأداء السوق",
          },
          withdrawals: {
            name: "عمليات السحب",
            description: "إنشاء تقرير معاملات السحب ومعالجة الطلبات",
            prompt:
              "أنشئ تقريراً لعمليات السحب يتضمن جميع المعاملات، حالة المعالجة، وتفاصيل الامتثال",
          },
          benefitEmployees: {
            name: "مزايا الموظفين",
            description: "إنشاء تقرير تسجيل الموظفين في المزايا والأهلية",
            prompt:
              "أنشئ تقريراً لمزايا الموظفين يتضمن حالة التسجيل، الأهلية، وتفاصيل تغطية المزايا",
          },
        },
        ui: {
          assistantTitle: "مساعد الذكاء الاصطناعي",
          askQuestionsTitle: "اطرح سؤالاً",
          reportTemplatesTitle: "أنشئ تقارير",
          inputPlaceholder: "اسألني أي شيء...",
          stopResponse: "إيقاف الاستجابة",
          modeAuremAgent: "وكيل أورَم",
          modeGeneralInquiries: "استفسارات عامة",
          viewRawJSON: "عرض JSON",
          showingRows: ({ maxRows, total }) =>
            `عرض أول ${maxRows} من ${total} صفوف.`,
          close: "إغلاق",
          requestExportToViewAll: "طلب تصدير لعرض جميع السجلات",
          viewAllChat: "عرض كل المحادثات",
          emptyThreadTitle: "كيف يمكنني مساعدتك اليوم؟",
          emptyThreadSubtitle: "اطرح سؤالاً أو أنشئ تقريراً",
        },
        messages: {
          noReport: {
            summary: "لم يتم إنشاء تقرير",
            reasoning: "لم يتمكن المساعد من إنشاء تقرير لطلبك.",
          },
          errors: {
            executionLimit:
              "نفدت خطوات التنفيذ من المساعد الذكي أثناء معالجة طلبك.",
            llmValidation: "واجه المساعد الذكي مشكلة في التنسيق.",
            workflowState: "تمت معالجة هذا الطلب بالفعل.",
            dataProcessing: "حدث خطأ أثناء معالجة بياناتك.",
            timeout: "استغرق طلبك وقتًا طويلاً للمعالجة.",
            rateLimit:
              "خدمة الذكاء الاصطناعي مشغولة حالياً. يرجى الانتظار لحظة قبل إعادة المحاولة.",
            unexpected: "حدث خطأ غير متوقع.",
            cancel: {
              summary: "تم إلغاء الطلب",
              reasoning: "لقد أوقفت الطلب قبل أن يكتمل.",
            },
            retryPrompt: "هل تريد المحاولة مرة أخرى؟",
            retryCta: "نعم، حاول مرة أخرى",
            toast: {
              fetchFailed: "تعذّر جلب تحديثات المحادثة",
              sendFailed: "تعذّر إرسال الرسالة",
              cancelFailed: "تعذّر إلغاء الرسالة",
              loadingFailed: "تعذّر تحميل المحادثة",
            },
          },
          processStates: {
            analyzing: "جارٍ تحليل طلبك...",
            generating: "جارٍ إنشاء الاستجابة...",
            processing: "جارٍ المعالجة...",
            thinking: "جارٍ التفكير...",
            exportingResults: "جارٍ تحميل النتائج...",
          },
        },
      },
      marketOrderPriceConfirmation: {
        title: "تأكيد السعر",
        description:
          "راجع السعر الذي أدخلته مقابل آخر سعر مسجّل لدينا قبل التنفيذ.",
        fundIsin: "رقم الصندوق الدولي",
        entered: "السعر المُدخل",
        lastKnown: "آخر سعر معروف",
        difference: "الفرق",
        noPreviousPrice: "لا يوجد سعر سابق",
        unitPrice: "سعر الوحدة",
        soldPrice: "سعر البيع",
        boughtPrice: "سعر الشراء",
        confirm: "تأكيد وتنفيذ",
      },
    },
    employee: {
      common: {
        add: "إضافة",
        back: "العودة",
        continue: "المتابعة",
        confirm: "تأكيد",
        currency: "درهم إماراتي",
        date: (d) =>
          `${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
        monthYear: (d) =>
          `${d.toLocaleString(L, { month: "long", year: "numeric" })}`,
        dateFull: (d) =>
          `${d.toLocaleString(L, { day: "2-digit", month: "long", year: "numeric" })}`,
        dateShort: (d) =>
          `${d.toLocaleString(L, { day: "numeric", month: "short" })}`,
        dateMonthYear: (d) =>
          `${d.toLocaleString(L, { month: "long", year: "numeric" })}`,
        dateMonthShort: (d) => `${d.toLocaleString(L, { month: "short" })}`,
        next: "التالي",
        loading: "يجري التحميل",
        fullName: ({ first, last }) => `${first} ${last}`,
        money: (amount) =>
          `${amount.toLocaleString(L, { style: "currency", currency: "AED", minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        moneyUpDown: ({ amount, sign }) =>
          `${{ [1]: `زاد بمقدار ${amount.toLocaleString(L, { style: "currency", currency: "AED", signDisplay: "never", minimumFractionDigits: 2, maximumFractionDigits: 2 })}`, [-1]: `انخفض بمقدار ${amount.toLocaleString(L, { style: "currency", currency: "AED", signDisplay: "never", minimumFractionDigits: 2, maximumFractionDigits: 2 })}` }[sign] ?? ``}`,
        percentSign: (percent) =>
          `${percent.toLocaleString(L, { style: "percent", signDisplay: "exceptZero", minimumFractionDigits: 1, maximumFractionDigits: 1 })}`,
        unexpectedError: {
          title: "حدث خطأ غير متوقع",
          description:
            "حدث خطأ. يرجى التواصل معنا عبر البريد الإلكتروني لضمان عدم تكرار الخطأ",
        },
        saveSuccessful: "تم حفظ التغييرات بنجاح",
        moneySign: (amount) =>
          `${amount.toLocaleString(L, { style: "currency", currency: "AED", signDisplay: "exceptZero", minimumFractionDigits: 2, maximumFractionDigits: 2 })}`,
        percent: (percent) =>
          `${percent.toLocaleString(L, { style: "percent" })}`,
        fromName: (name) => `من ${name}`,
        remove: "إزالة",
        noDocuments: "لا توجد مستندات متاحة",
        voluntarySubscription: "الاشتراك الطوعي",
        requested: "مطلوب",
        dueBy: "مستحق بحلول",
        completed: "تم التنفيذ",
        rejected: "تم رفض المعاملة",
        pending: "قيد التنفيذ",
        save: "حفظ التغييرات",
        cancel: "إلغاء",
        withdraw: "سحب",
        accept: "قبول",
        reject: "رفض",
        supportEmail: "support@aurem.ae",
        needHelp: "هل تحتاج إلى مساعدة؟",
        contactSupport: "اتصل بالدعم",
        passwordHint: "يجب أن تتكون من 8 أحرف على الأقل",
        logIn: "تسجيل الدخول",
        optional: "اختياري",
        fieldIsRequired: "الحقل مطلوب",
      },
      navigation: {
        back: "العودة",
        LogOut: "تسجيل الخروج",
        dashboard: "لوحة التحكم",
        subscriptions: "الاشتراكات",
        transactions: "المعاملات",
        withdraw: "سحب",
        termsAndConditions: "الشروط والأحكام",
        confirmYourDetails: "تأكيد معلوماتك",
        inactiveCurrency:
          "تبديل العملة غير متاح في الوقت الحالي بسبب مشكلات فنية.",
        contributions: "المساهمات",
        settings: {
          title: "الإعدادات",
          accountDetails: "تفاصيل الحساب",
          security: "الأمان",
          verification: "التحقق",
          beneficiaries: "المستفيدون",
          biometrics: "البيومترية",
          documents: "الوثائق",
          dataAndPrivacy: "البيانات والخصوصية",
        },
        subFunds: "الصناديق الفرعية",
        avs: "مكافأة نهاية الخدمة",
        retirement: "التقاعد",
        benefit: "المزايا",
        funds: "الصناديق الفرعية",
        menu: "القائمة",
        overview: "نظرة عامة",
        statements: "الكشوفات",
        support: "الدعم",
      },
      components: {
        errorBoundary: {
          heading: "الرجاء المحاولة مجددا",
          description:
            "حدث خطأ غير متوقع. يرجى محاولة مسح ذاكرة التخزين المؤقت للمتصفح وإعادة تحميل الصفحة",
          reload: "حاول مرة أخرى",
        },
        postTerminationWithdrawal: {
          youNowLeft: "لقد غادرت الآن",
          theCompany: "الشركة",
          moveSubscription: (date) =>
            `يرجى ملاحظة أنه سيتم تلقائيًا نقل الاشتراكات الأساسية من صاحب العمل إلى اشتراكاتك الطوعية في ${date}. بدلاً من ذلك، يمكنك أيضًا سحب جميع الاشتراكات الأساسية الآن.`,
          withdrawBasicSubscriptions: "سحب الاشتراكات الأساسية",
          confirmWithdrawal: "تأكيد السحب",
          totalBasicSubscriptions: "إجمالي الاشتراكات الأساسية",
          pleaseConfirm:
            "يرجى تأكيد رغبتك في سحب جميع الاشتراكات الأساسية من صاحب العمل الآن.",
          amountWillBe:
            "سيتم تحويل هذا المبلغ إلى حساب بنكي من اختيارك بعد الانتهاء من عمليات التحقق.",
        },
        benefitNotAssigned: {
          title: "لا توجد مزايا مسندة إليك",
          description:
            "ليست هناك أي مزايا مرتبطة بك حاليًا، ولا يمكنك الوصول إلى المنصة في هذه المرحلة. تواصل مع صاحب العمل إذا كانت لديك أي أسئلة أو تحتاج إلى الدعم.",
        },
        noProductModal: {
          title: "ليس لديك أي منتجات نشطة في هذه الشركة",
          description:
            "أنت غير مُعيَّن حاليًا لأي منتجات ولا يمكنك اتخاذ أي إجراء داخل هذه الشركة. تواصل مع صاحب العمل إذا كانت لديك أي أسئلة أو تحتاج إلى الدعم.",
          cta: "العودة إلى الملخص",
        },
        verificationBanner: {
          success: {
            title: "تم التحقق من مستنداتك بنجاح.",
            description: "يمكنك الآن الوصول إلى جميع الميزات على المنصة.",
          },
          pending: {
            title: "يتم مراجعة مستنداتك.",
            description:
              "سيتم إعلامك عبر البريد الإلكتروني بمجرد التحقق من مستنداتك.",
          },
          rejected: {
            title: "فشل التحقق.",
            description:
              "لا يمكننا التحقق من هويتك في الوقت الحالي. يرجى الاتصال بفريق الدعم للحصول على المساعدة.",
            pageDescription:
              "لم تتم الموافقة على التحقق من هويتك. لمزيد من المعلومات حول سبب هذا القرار والخطوات التالية، يرجى التواصل مع المسؤول.",
          },
          required: {
            title: "التحقق مطلوب.",
            description:
              "نحتاج إلى تأكيد بعض التفاصيل عنك قبل أن تتمكن من استخدام جميع الميزات.",
          },
          retry: {
            title: "فشل التحقق.",
            description:
              "تأكد من أن مستنداتك واضحة وصالحة وتطابق معلومات حسابك.",
          },
          note: "يجب أن يتم الموافقة على مستندات التحقق الخاصة بك قبل أن تتمكن من تأكيد أو تعديل اشتراكك الطوعي.",
          cta: {
            procced: "الانتقال إلى التحقق",
            pending: "التحقق قيد المعالجة",
            dissmiss: "إغلاق",
            submit: "إرسال المستندات",
            resubmit: "إعادة تقديم المستندات",
          },
          confirm: {
            title: "هل تريد بدء التحقق الآن؟",
            cta: "نعم، ابدأ التحقق",
            cancel: "ليس الآن",
            contribution:
              "تحتاج إلى التحقق من مستنداتك فقط إذا كنت ترغب في تقديم اشتراك اختياري الآن. إذا لم تكن مستعدًا بعد، يمكنك العودة وبدء هذه العملية في أي وقت.",
            withdrawal:
              "تحتاج إلى التحقق من مستنداتك فقط إذا كنت ترغب في طلب سحب الآن. إذا لم تكن مستعدًا بعد، يمكنك العودة وبدء هذه العملية في أي وقت.",
            fundSwitch:
              "تحتاج إلى التحقق من مستنداتك فقط إذا كنت ترغب في تغيير الصندوق الفرعي الآن. إذا لم تكن مستعدًا بعد، يمكنك العودة وبدء هذه العملية في أي وقت.",
            default:
              "تحتاج إلى التحقق من مستنداتك فقط إذا كنت ترغب في متابعة هذا الطلب الآن. إذا لم تكن مستعدًا بعد، يمكنك العودة وبدء هذه العملية في أي وقت.",
          },
        },
        blockedBenefitsBanner: {
          description:
            "انتهت مشاركتك في هذه الميزة. لا يزال بإمكانك سحب مساهماتك الطوعية في أي وقت.",
        },
        oneTime: "دفعة لمرة واحدة",
        cookie: {
          description:
            "نحن نستخدم ملفات تعريف الارتباط لتحسين تجربتك في التصفح. من خلال الاستمرار في استخدام موقعنا، فإنك توافق على استخدامنا لملفات تعريف الارتباط.",
        },
      },
      form: {
        email: { label: "البريد الإلكتروني" },
        password: { label: "كلمة المرور" },
        passwordConfirm: { label: "تأكيد كلمة المرور" },
      },
      pages: {
        landing: {
          page: {
            welcome: (name) => `مرحبًا بك في ${name}`,
            description:
              "نُعيد تعريف التقاعد وبناء الثروة لنمنحك مستقبلاً ماليًا أكثر إشراقًا",
            getStarted: "ابدأ الآن",
            alreadyHaveAccount: "لدي حساب بالفعل",
          },
        },
        overView: {
          title: "مرحبًا",
          heading: "نظرة عامة",
          avs: "مكافأة نهاية الخدمة",
          depositCompany: "الاشتراكات الأساسية",
          depositSalary: "الاشتراكات الطوعية",
          depositSalaryLumpsum: "مبلغ مقطوع",
          depositUser: "إيداع",
          withdrawal: "السحوبات",
          fees: "الرسوم",
          moneyIn: "المبالغ الواردة",
          moneyOut: "المبالغ الصادرة",
          completedOn: "تم في",
          requestedOn: "تم الطلب في",
          allotted: "المبلغ المخصص",
          consumed: "المبلغ المستخدم",
          remaining: "المبلغ المتبقي",
          category: "الفئة",
          ipp: "الخطة الدولية للمعاشات",
          placeholder: "أدخل المبلغ الإجمالي",
          success: "تم تحديث مساهمتك بنجاح.",
          noEmployment: "لم يتم العثور على وظائف بها مزايا نشطة.",
          errorEmployment:
            "حدث خطأ أثناء تحميل الوظائف. الرجاء المحاولة مرة أخرى.",
          addMoney: {
            title: "إضافة المال",
            subtitle: "ما هي الميزة التي تريد تعديلها أو الإضافة إليها؟",
            addOrEdit: "تعديل أو إضافة اشتراكك",
            voluntary: "طوعي",
            onetime: "مرة واحدة",
            percent: " من راتبك",
            addingMoneyTo: "إضافة المال إلى",
            max: "الحد الأقصى",
            maxExceeded: ({ maxPercent, salaryAttributeLabel }) =>
              `المبلغ المُدخل يتجاوز الحد المسموح به. الحد الأقصى للمساهمة التطوعية هو ${maxPercent.toLocaleString(L, { style: "percent" })} من ${salaryAttributeLabel} الشهري.`,
            yourSalary: "حسابات الراتب الخاص بك",
            payrollImpact: "تأثير الراتب لهذا الشهر",
            salaryBeforeSubscriptions: "راتبك قبل الاشتراكات",
            salaryBeforeContribution: "راتبك قبل المساهمة",
            yourMonthlyContributions: "مساهماتك الشهرية",
            yourLumpSum: "المبلغ المقطوع الخاص بك",
            yourOneTimePayment: "راتبك المرة الواحدة",
            existingMonthlyContribution: "المساهمة الشهرية الحالية",
            existingLumpSum: "المبلغ المقطوع الحالي",
            netSalary: "الراتب الصافي",
            netSalaryTooltip: (ibanSuffix) =>
              `بعد مساهماتك، هذا هو المبلغ الذي ستتلقاه في حسابك المنتهي بـ ${ibanSuffix} هذا الشهر.`,
            netSalaryTooltipNoIban:
              "بعد مساهماتك، هذا هو المبلغ الذي ستتلقاه في حسابك هذا الشهر.",
            toBePainIntoYourAccountEndingWith: "سيتم دفعه إلى حسابك المنتهي ب",
            confirm: "تأكيد",
            confirmPayment: "تأكيد الدفع",
            info: "بالتأكيدك، تُقرّ بأنك تفهم طبيعة ومخاطر هذا الاستثمار، وتؤكد أنك قد راجعت وثائق الصندوق ذات الصلة التي أُتيحت لك.",
            monthly: "شهريًا",
            contributing: "المساهمة بـ",
            lumpsum: "مبلغ مقطوع",
            lumpSumPayment: "دفعة بمبلغ مقطوع",
            lumpSumMaxExceeded: (maxAmount) =>
              `المبلغ المُدخل يتجاوز الحد المسموح به. الحد الأقصى للمساهمة بالمبلغ المقطوع هو ${maxAmount}.`,
            limitProgressSummary: ({ percentage, remainingAmount }) =>
              `يوصلك هذا إلى ${percentage}% من حدك السنوي، مع بقاء ${remainingAmount}.`,
            limitProgressSummaryMonthly: ({ percentage, remainingAmount }) =>
              `يوصلك هذا إلى ${percentage}% من حدك الشهري، مع بقاء ${remainingAmount}.`,
            remainingOf: (totalAmount) => `من أصل ${totalAmount}`,
            annualLimitBanner: {
              title: "لقد بلغت حد مساهمتك السنوي",
              description: (annualCap) =>
                `بلغ إجمالي مساهماتك ${annualCap}، وهو الحد الأقصى المسموح به لهذا العام. لا يمكن إجراء أي مساهمات شهرية أو بمبلغ مقطوع إضافية حتى الدورة السنوية التالية.`,
              descriptionMonthlyOnly: (annualCap) =>
                `بلغ إجمالي مساهماتك ${annualCap}، وهو الحد الأقصى المسموح به لهذا العام. لا يمكن إجراء أي مساهمات شهرية إضافية حتى الدورة السنوية التالية.`,
              descriptionLumpSumOnly: (annualCap) =>
                `بلغ إجمالي مساهماتك ${annualCap}، وهو الحد الأقصى المسموح به لهذا العام. لا يمكن إجراء أي مساهمات بمبلغ مقطوع إضافية حتى الدورة السنوية التالية.`,
            },
            limitModal: {
              title: "حد مساهمتك السنوي",
              open: "افتح تفاصيل حد المساهمة السنوي",
              description:
                "تفصيلك الحالي الآن - هذا يعكس نفس قيم المساهمة المعروضة في هذه الصفحة، بما في ذلك التغييرات قيد التنفيذ.",
              sharedPoolInfo:
                "تُسحب المساهمات الشهرية والمبالغ المقطوعة من نفس الحصة السنوية. وهي تتنافس على نفس حد 25%. وسيؤدي مبلغ مقطوع كبير إلى تقليل المساحة المتاحة للمساهمات الشهرية المستقبلية.",
              annualCap: "حد المساهمة السنوي",
              annualVoluntaryCap: "الحد الأقصى لمساهمتك هذا العام",
              totalYtdSharedPool: "ما ساهمت به حتى الآن هذا العام",
              whatYouCanContributeNow: "ما يمكنك المساهمة به الآن",
              maxMonthlyContribution: "الحد الأقصى للمساهمة الشهرية",
              maxMonthlyContributionHint:
                "25% من الراتب الشهري، بحد أقصى من الحصة السنوية",
              maxLumpSumContribution:
                "الحد الأقصى للمبلغ المقطوع (هذه المعاملة)",
              maxLumpSumContributionHint: "محدود بسقف الراتب أو الحصة السنوية",
              salaryCeiling: "سقف الراتب",
            },
          },
          withdraw: { title: "سحب", subtitle: "من أي ميزة تريد السحب؟" },
          total: {
            overallBalance: "الرصيد الإجمالي",
            totalEarnings: "إجمالي الأرباح",
            withdrawals: "عمليات السحب",
            lastUpdated: "آخر تحديث في ",
          },
          products: {
            title: "منتجاتي",
            availableAmount: "المبلغ المتاح",
            segments: { all: "الكل", active: "نشط", inactive: "غير نشط" },
            activeSince: (date) => `نشط منذ ${date}`,
            inactiveSince: (date) => `غير نشط منذ ${date}`,
            noProducts: "لا توجد منتجات",
            noActiveProducts: "لا توجد منتجات مفعّلة",
            noInactiveProducts: "لا توجد منتجات غير مفعّلة",
          },
          recentActivity: {
            title: "النشاطات الأخيرة",
            emptyState: "لا توجد نشاطات حديثة",
            viewAll: "عرض جميع المعاملات",
            completed: "تم الإنجاز في",
          },
          recentTransactions: {
            title: "المعاملات الأخيرة",
            emptyState: "لا توجد معاملات حديثة",
            viewAll: "عرض جميع المعاملات",
            completed: "تم الإنجاز في",
            withdrawal: "سحب",
          },
          selectedFund: {
            title: "الصندوق المحدد",
            info: ({ days, d }) =>
              `يمكنك تبديل الصناديق في أي وقت خلال الأيام ${days} القادمة (حتى ${d.toLocaleString(L, { day: "2-digit", month: "long", year: "numeric" })}).`,
            viewFunds: "عرض الصناديق",
          },
          withdrawHistory: {
            title: "سجل السحب",
            inProgress: "قيد المعالجة",
            pastTransactions: "المعاملات السابقة",
            empty: "لا يوجد سجل للمعاملات",
          },
          funds: {
            disclaimer:
              "إذا كنت مؤهلاً، يمكنك تبديل الصندوق الفرعي في أي وقت. سيتم تبديل الوحدات المؤهلة لديك إلى وحدات الصندوق الفرعي المختار خلال 5 أيام عمل.",
            choose: "اختر",
            inProgress:
              "يتم تنفيذ تبديل الصندوق. ستتمكن من طلب تبديل جديد بمجرد إنهاء هذا التبديل.",
            cta: "تبديل الصندوق",
            switchSuccess: "تم تقديم طلب تحويل الصندوق الخاص بك",
            switchError: "فشل تبديل الصندوق. الرجاء المحاولة مرة أخرى.",
          },
        },
        nativeDownload: {
          page: {
            welcome: (name) => `مرحبا إلى ${name}`,
            headingMobile: "تحميل التطبيق",
            headingDesktop: "امسح لتحميل التطبيق",
            description: (name) =>
              `قم بتنزيل تطبيق ${name} اليوم وابدأ بالتحكم في مستقبلك المالي!`,
            instructions: [
              "افتح تطبيق الكاميرا أو ماسح رمز الاستجابة السريعة على هاتفك",
              "وجه الكاميرا نحو رمز الاستجابة السريعة",
              "انقر على الرابط الذي سيظهر على الشاشة لتحميل التطبيق",
            ],
            altAppStore: "قم بالتحميل من متجر App Store",
            altPlayStore: "قم بالتحميل من متجر Google Play",
          },
        },
        notFound: {
          page: {
            heading: "الصفحة غير موجودة",
            description: "هذه ليست الصفحات التي تبحث عنها...",
            back: "رجوع",
            home: "العودة إلى الصفحة الرئيسية",
          },
        },
        signIn: {
          page: {
            heading: (name) => `تسجيل الدخول إلى ${name}`,
            passwordReset: "هل نسيت كلمة المرور؟",
            mfa: {
              heading: "تحقق من هويتك",
              description:
                "أدخل رمز التحقق المكون من 6 أرقام من تطبيق المصادقة.",
              error: "تعذّر تسجيل الدخول. الرجاء المحاولة مرة أخرى.",
            },
          },
        },
        signUp: {
          page: {
            aboutYou: "معلومات عنك",
            title: (name) => `التسجيل في ${name}`,
            newPassword: "كلمة المرور الجديدة",
            personalEmail: "البريد الإلكتروني الشخصي",
            description:
              "يرجى تقديم بريد إلكتروني شخصي يمكنك الوصول إليه دائمًا، حتى إذا قمت بتغيير جهة العمل.",
            workEmail: "البريد الإلكتروني للعمل",
            alreadyHaveAnAccount: "هل لديك حساب بالفعل؟",
            repeat: "تكرار كلمة المرور الجديدة",
            cta: "إنشاء حساب",
            terms: {
              left: "باستمرارك في استخدام هذه المنصة، فإنك توافق على",
              center: "الشروط والأحكام",
              right: "وسياسة الخصوصية",
            },
          },
        },
        disclaimers: {
          page: {
            heading: "وثائقك",
            description: {
              text: "تتعلق هذه الوثائق ببعض منتجاتنا مثل الاستثمار والادخار والمزيد. للحصول على فهم كامل، يرجى قراءة الاتفاقيات المرفقة. يرجى قراءة جميع الوثائق بعناية.",
              question: "إذا كانت لديك أي أسئلة، يرجى الاتصال بنا على:",
              contact:
                "المكتب 402، الطابق الرابع عشر، برج السراب، مربعة سوق أبوظبي العالمي، جزيرة المارية، أبوظبي، دولة الإمارات العربية المتحدة",
              email: "البريد الإلكتروني: support@aurem.ae",
              phone: "،+971 2 499 6333",
            },
            disclaimers: {
              heading: "إخلاء المسؤولية",
              noticeDisclaimer: "إشعار إخلاء المسؤولية",
              noticePrivacy: "إشعار الخصوصية",
            },
            cookiePolicy: "سياسة الكوكيز",
            consent: "الموافقة والمتابعة",
          },
        },
        onboarding: {
          page: {
            flagDetails: {
              heading: "الإبلاغ عن أي معلومات خاطئة ",
              subheading: "ملفك الشخصي",
              description:
                "يرجى إبلاغنا في حال وجود أي أخطاء. سنقوم بالتحقق مع صاحب العمل.",
              ctaDefault: "كافة المعلومات صحيحة",
              ctaSubmit: "تقديم طلب لتحديث المعلومات",
              labels: {
                flag: "إبلاغ",
                fullName: "الاسم الكامل",
                salaryFull: "الراتب الإجمالي",
                salaryBasic: "الراتب الأساسي",
                iban: "رقم الحساب المصرفي الدولي IBAN",
                eid: "الهوية الإماراتية",
                phone: "رقم الهاتف",
                dob: "تاريخ الميلاد",
                address: "العنوان",
                passport: "رقم جواز السفر",
                update: "تحديث",
                cancel: "إلغاء",
                startDate: "تاريخ البدء",
              },
              successToast:
                "نحن قد حصلنا على طلبك. بعد أن يقوم صاحب العمل بمراجعته والموافقة عليه، سيتم عرض التغييرات في سجلاتك.",
            },
            personalDetails: {
              heading: "المعلومات الشخصية",
              subheading: "ملفك الشخصي",
              description: "أكمِل بياناتك الشخصية",
              form: {
                name: {
                  label: "الاسم المفضل",
                  placeholder: "أدخل اسمك",
                  hint: "يمكن أن يكون هذا اسمك الأول أو اسمًا مستعارًا — الاسم الذي تود أن يراه الآخرون ويستخدموه عند الإشارة إليك في المنصة.",
                },
                personalEmail: {
                  label: "البريد الإلكتروني الشخصي",
                  placeholder: "أدخل البريد الإلكتروني الشخصي",
                },
                placeOfBirth: {
                  label: "مكان الولادة",
                  placeholder: "أدخل البلدة أو المدينة",
                },
                anotherJuridisdiction: {
                  label: "هل أنت مقيم ضريبي في ولاية قضائية أخرى؟",
                  options: { yes: "نعم", no: "لا" },
                  countryOfResidence: "بلد الإقامة الضريبية",
                  taxNumber: "الرقم المرجعي الضريبي",
                  add: "إضافة بلد",
                  remove: "إزالة",
                  select: "اختر البلد",
                  empty: "لم يتم العثور على نتائج",
                  error: {
                    title: "خطأ",
                    duplicateCountry: "بلد مكرر",
                    missingCountry: "اختر بلدًا لكل رقم ضريبي مُعبأ.",
                    missingTaxNumber: "أدخل رقم ضريبي لكل بلد.",
                  },
                },
                submit: "المتابعة",
                back: "العودة",
              },
            },
          },
        },
        changePassword: {
          page: {
            heading: "تعيين كلمة مرور جديدة",
            email: "البريد الإلكتروني",
            form: {
              password: { label: "كلمة المرور الجديدة" },
              confirmPassword: { label: "تكرار كلمة المرور الجديدة" },
              submit: "تغيير كلمة المرور",
            },
          },
        },
        forgottenPassword: {
          page: {
            heading: "هل نسيت كلمة المرور؟",
            description:
              "أدخل بريدك الإلكتروني لتصلك رسالة تحتوي على رابط لإعادة تعيين كلمة المرور.",
            form: {
              email: { label: "أدخل بريدك الإلكتروني" },
              submit: "إرسال الرابط",
              cancel: "الرجوع",
            },
            success: {
              title: "تحقق من بريدك الإلكتروني",
              description:
                "إذا كان هناك حساب مرتبط بهذا البريد الإلكتروني، فستصلك رسالة منا قريبًا. بعد استلام الرسالة، انقر على الرابط الموجود فيها لإعداد كلمة مرور جديدة. الرابط صالح لمدة 24 ساعة.",
            },
          },
        },
        dashboard: {
          page: {
            bannerSwitchFund: {
              title: (fundName) =>
                `الصندوق الأساسي الخاص بك هو ${fundName}. يمكنك تغييره في أي وقت.`,
              description:
                "يمكنك تبديل الصندوق الأساسي قبل إجراء المساهمة الأولى.",
              cta: "تبديل الصندوق",
              dismiss: "إخفاء",
            },
            banner: (companyName) => `لقد غادرت ${companyName}. `,
            subscriptionStop:
              "ستتوقف اشتراكاتك في هذا الصندوق ويمكنك سحب أموالك في أي وقت.",
            withdraw: "سحب اشتراكات صاحب العمل",
            contributions: {
              title: "الاشتراكات",
              baseContibution: "الاشتراك الشهري الأساسي",
              tooltipInfo: "هذه المدفوعات إلزامية لصاحب العمل.",
              voluntaryContribution: "الاشتراك الشهري الطوعي",
              total: "إجمالي الاشتراكات:",
              fromName: (name) => `من ${name}`,
              fromYou: "منك",
              totalBenefitValue: "القيمة الإجمالية للاشتراك",
              thisMonth: "هذا الشهر",
              cta: {
                add: "إضافة اشتراكك الطوعي",
                edit: "تحديث الاشتراك الطوعي",
                view: "الاطلاع على المعاملات",
              },
              pending: {
                title: "اشتراكك قيد الانتظار",
                description: ({ amount, date }) =>
                  `المستندات الخاصة بك قيد المراجعة حاليًا. لقد قمت بتعديل هذا الاشتراك آخر مرة إلى ${amount} في ${date}.`,
              },
            },
            selectedFunds: {
              title: "الصندوق الفرعي المحدد",
              factSheet: "ورقة الميزات",
              note: "إذا كنت مؤهلاً، يمكنك تغيير الصندوق الفرعي في أي وقت. سيتم استبدال الوحدات المؤهلة لديك بوحدات من الصندوق الفرعي الذي اخترته خلال 5 أيام عمل.",
              cta: "تغيير الصندوق الفرعي",
            },
            pwaInstall: {
              card: {
                description:
                  "يمكنك تنزيل هذا التطبيق وإضافته إلى شاشتك الرئيسية. لن يستغرق الأمر سوى بضع ثوانٍ",
                later: "يرجى إعادة تذكيري لاحقاً",
                showMe: "يرجى التوضيح",
              },
              ios: [
                {
                  heading: "انقر على رمز المشاركة",
                  description:
                    "في أسفل شاشتك في شريط التنقل الخاص بمتصفحك، سترى رمز المشاركة الذي سيُظهر قائمة بالخيارات.",
                },
                {
                  heading: "ابحث عن 'إضافة إلى الشاشة الرئيسية'",
                  description:
                    "قم بالتمرير لأسفل القائمة وابحث عن 'إضافة إلى الشاشة الرئيسية'. سيطلب منك بعد ذلك تحديد اسم التطبيق.",
                },
              ],
              android: [
                {
                  heading: "انقر على رمز المزيد",
                  description:
                    "في أعلى شاشتك في شريط عنوان المتصفح، سترى رمز المزيد الذي سيُظهر قائمة بالخيارات.",
                },
                {
                  heading: "ابحث عن 'إضافة إلى الشاشة الرئيسية'",
                  description:
                    'قم بالتمرير لأسفل القائمة وابحث عن "إضافة إلى الشاشة الرئيسية". سيُطلب منك بعد ذلك تحديد اسم التطبيق.',
                },
              ],
              addToHomescreen: "إضافة إلى الشاشة الرئيسية",
            },
            statementHistory: {
              title: "سجل الكشوفات",
              emptyState: "لا توجد كشوفات",
              downloadButton: "تحميل",
              statementLabel: (month) => `كشف ${month}`,
              statementSuffix: "كشف",
              issuedOn: (date) => `صدر في ${date}`,
            },
            toast: { employmentNotFound: "لم يتم العثور على وظيفة" },
            feelingLostBanner: {
              title: "هل أنت في حيرة؟",
              cta: "احصل على مساعدة",
            },
            balance: {
              title: "القيمة الإجمالية لمساهماتك اليوم",
              growth: (percent) =>
                `نمو بنسبة ${percent.toLocaleString(L, { style: "percent", signDisplay: "exceptZero", minimumFractionDigits: 1, maximumFractionDigits: 1 })}`,
              updatedAt: "تم التحديث في",
              vested: "مكتسب",
              unvested: "غير مكتسب",
              availableNow: "متاح الآن",
              whenYouLeave: "عند ترك العمل",
              vestedInfo: "المبلغ المتاح لك للسحب في أي وقت.",
              unvestedInfo:
                "غير متاح للسحب: المبلغ متاح بعد انتهاء علاقتك الوظيفية وبمجرد استثماره",
              pendingInvestment: "قيد الاستثمار",
            },
            contribution: {
              title: "الأموال في هذا الشهر",
              basic: "الاشتراك الأساسي",
              voluntary: "الاشتراك الطوعي",
              from: "من ",
              fromYou: "منك",
              monthlyDeposit: "الإيداع الشهري",
              completedOn: "تم الإكمال في",
              onetime: "دفعة لمرة واحدة",
            },
            actions: {
              kycWarning:
                "يجب الموافقة على مستندات التحقق الخاصة بك قبل أن تتمكن من تأكيد أو تعديل اشتراكك الطوعي.",
              depositMoney: "إيداع",
              withdrawMoney: "سحب",
              switchFunds: "تبديل الصناديق",
            },
            manageContributions: "إدارة المساهمات",
            contributionOverview: {
              title: {
                threeMonths: "الأموال المدفوعة خلال الأشهر الثلاثة الماضية",
                sixMonths: "الأموال المدفوعة خلال الأشهر الستة الماضية",
                oneYear: "الأموال المدفوعة خلال الاثني عشر شهرًا الماضية",
                yearToDate: "الأموال المدفوعة منذ بداية العام",
              },
              ranges: {
                threeMonths: "3 أشهر",
                sixMonths: "6 أشهر",
                oneYear: "سنة",
                yearToDate: "منذ بداية العام",
              },
              series: {
                basic: "أساسية",
                additional: "أساسية إضافية",
                voluntary: "تطوعية",
                lumpSum: "مبلغ مقطوع",
                other: "أخرى",
              },
              seriesInfo: {
                basic: "المبلغ الذي ساهم به صاحب العمل نيابة عنك.",
                additional:
                  "مساهمات إضافية قدمها صاحب العمل تتجاوز المبلغ المطلوب.",
                voluntary: "المبلغ الإضافي الذي اخترت المساهمة به.",
                lumpSum: "مبالغ لمرة واحدة اخترت المساهمة بها.",
              },
              empty: {
                title: "لا توجد مساهمات بعد.",
                description: "تظهر مساهماتك هنا بمجرد تسوية أول دفعة.",
              },
            },
            voluntaryCap: {
              title: "حد المساهمة التطوعية",
              subtitle: (rate) =>
                `استخدامك منذ بداية العام من حد ${rate.toLocaleString(L, { style: "percent", minimumFractionDigits: 0, maximumFractionDigits: 2 })} من راتبك السنوي`,
              cap: (amount) => `من ${amount}`,
              used: (percent) =>
                `${percent.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })} مستخدم`,
              remaining: (amount) => `${amount} متبقٍ`,
              remainingLabel: "المتبقي",
              recurring: "اشتراك شهري",
              lumpSum: "مبلغ مقطوع",
            },
            fundPerformance: {
              title: "أداء الصندوق",
              subtitle: "صافي قيمة الأصول عبر الزمن",
              ranges: {
                allTime: "الكل",
                oneMonth: "شهر",
                threeMonths: "3 أشهر",
                sixMonths: "6 أشهر",
                oneYear: "سنة",
                yearToDate: "منذ بداية العام",
              },
              stats: {
                fundReturn: "عائد الصندوق",
                yourReturn: "عائدك",
                highLow: "الأعلى / الأدنى",
              },
              series: { blended: "جميع الصناديق" },
              empty: {
                title: "لا توجد بيانات أداء بعد.",
                description: "يظهر أداء الصندوق بمجرد استثمار أول مساهمة لك.",
              },
              historyNotice: (date) =>
                `يبدأ سجل الأداء في ${date} — لا تتوفر بيانات قبل هذا التاريخ.`,
            },
            upcomingContribution: {
              title: "مساهمتك القادمة",
              hint: "تقدير بناءً على راتبك واختياراتك الحالية، ويُؤكَّد المبلغ عند تنفيذ صاحب العمل لكشف الرواتب.",
              dueOn: (d) =>
                `في ${d.toLocaleString(L, { day: "2-digit", month: "long", year: "numeric" })}`,
              rows: {
                basic: "أساسية (صاحب العمل)",
                additional: "أساسية إضافية (صاحب العمل)",
                voluntary: "تطوعية (الموظف)",
                lumpSum: "مبلغ مقطوع",
              },
            },
            withdrawalProgress: {
              title: "حالة عملية السحب",
              description: "تستغرق المعالجة عادةً ما يصل إلى 3 أيام عمل.",
              descriptionDisbursed: "تم تحويل المبلغ إلى حسابك.",
              requestedOn: (d) =>
                `تم الطلب في ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
              disbursedOn: (d) =>
                `تم الصرف في ${d.toLocaleString(L, { day: "numeric", month: "short", year: "numeric" })}`,
              steps: {
                submitted: "تم إرسال الطلب",
                processing: "قيد التنفيذ",
                approved: "تمت الموافقة",
                disbursed: "تم صرف المبلغ",
              },
            },
            kycStatus: {
              title: "حالة التحقق من الهوية",
              badge: {
                pending: "قيد الانتظار",
                inReview: "قيد المراجعة",
                actionRequired: "مطلوب إجراء",
                rejected: "مرفوض",
                verified: "تم التحقق",
              },
              description: {
                verifying: "نحتاج إلى التحقق من هويتك قبل أن يكتمل هذا الطلب.",
                verified: "تم التحقق من هويتك.",
                rejected:
                  "تعذر التحقق من هويتك في الوقت الحالي. تواصل مع فريق الدعم للمساعدة.",
                additionalDocuments:
                  "نحتاج إلى مستندات إضافية للتحقق من هويتك.",
                resubmission:
                  "تأكد من أن مستنداتك واضحة وسارية ومطابقة لبيانات حسابك.",
              },
              steps: {
                submitted: "تم إرسال المستندات للمراجعة",
                reviewed: "تمت مراجعة المستندات",
                verified: "تم التحقق من الهوية",
              },
            },
            switchProgress: {
              title: "حالة تبديل الصندوق",
              description:
                "تستغرق إعادة التوزيع عادةً ما يصل إلى يومي عمل. يتم تحديث ممتلكاتك بمجرد تنفيذ التبديل.",
              from: "من",
              to: "إلى",
              buckets: { voluntary: "طوعي", employer: "بقيادة صاحب العمل" },
              steps: {
                submitted: "تم إرسال الطلب",
                processing: "قيد التنفيذ",
                executed: "تم تنفيذ التبديل",
              },
            },
            holdingsBreakdown: {
              title: "المخزونات حسب فئة الأسهم",
              subtitle: "أين يُستثمر كل جزء من رصيدك، مع العوائد حسب الفترة",
              ranges: {
                allTime: "الكل",
                oneMonth: "شهر",
                threeMonths: "3 أشهر",
                sixMonths: "6 أشهر",
                oneYear: "سنة",
                yearToDate: "منذ بداية العام",
              },
              columns: {
                fund: "فئة الأسهم / الصندوق",
                units: "الوحدات @ السعر",
                balance: "الرصيد",
                return: "العائد",
              },
              sections: {
                employer: "استثمارات بقيادة صاحب العمل",
                employee: "استثمارات بقيادة الموظف",
              },
              buckets: {
                employer: "بقيادة صاحب العمل",
                employee: "بقيادة الموظف",
              },
              types: {
                accrued: "مكافأة نهاية الخدمة المستحقة",
                basic: "أساسي",
                additional: "أساسي إضافي",
                voluntary: "طوعي",
              },
              units: (units) => `${units} وحدة`,
              price: (price) => `@ ${price}`,
              share: (percent) =>
                `${percent.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })}`,
              shareOfBalance: (percent) =>
                `${percent.toLocaleString(L, { style: "percent", minimumFractionDigits: 1, maximumFractionDigits: 1 })} من الرصيد`,
              returnLabel: "العائد",
              subtotal: "المجموع الفرعي",
              empty: {
                title: "لا توجد مخزونات بعد.",
                description: "تظهر مخزوناتك بمجرد استثمار أول مساهمة لك.",
              },
            },
          },
        },
        contributionsManage: {
          page: {
            pageHeader: "الاشتراكات",
            yourPensions: {
              heading: "صندوق اورم لمكافأة الخدمة الخاص بك",
              totalContributions: "إجمالي الاشتراكات :",
              cta: { add: "إضافة اشتراك طوعي", edit: "تعديل الاشتراكات" },
            },
            withdrawContribution: {
              title: "سحب الرصيد",
              total: "إجمالي الرصيد المتوفر",
              note: "يرجى الملاحظة:",
              warning:
                "قد يختلف المبلغ الذي تتلقاه قليلاً عن المبلغ الذي طلبته بسبب تقلبات أسعار الوحدات في وقت المعالجة.",
              cta: { title: "سحب الاشتراكات" },
            },
            pendingWithdrawal: {
              title: " عملية السحب الخاصة لك قيد المعالجة",
              description:
                "قد يستغرق استكمال عملية السحب ما يصل إلى 14 يوماً. يمكنك السحب مرة أخرى بعد انتهاء هذه المعاملة. ",
              cta: "عرض السحوبات السابقة",
            },
            recentTransactions: {
              title: "المعاملات الأخيرة",
              empty: {
                title: "لا توجد معاملات للعرض هنا",
                description: "سيتم عرض الاشتراكات ومعاملات السحب الخاصة بك هنا",
              },
              cta: "الاطلاع على المعاملات السابقة",
            },
          },
        },
        contributionsSetupOnboarding: {
          page: {
            heading: "اختر نوع الاشتراك الخاص بك",
            voluntary: {
              title: "اشتراك طوعي",
              description:
                "قم بإعداد دفعة شهرية متكررة. يمكنك تعديل هذا المبلغ حتى 7 أيام قبل تاريخ كشوف الرواتب الشهرية الخاصة بك.",
            },
            oneTime: {
              title: "دفعة لمرة واحدة",
              description:
                "قم بإعداد دفعة واحدة لهذا الشهر فقط. يمكنك أيضًا الإضافة إلى اشتراكك الطوعي",
            },
          },
        },
        contributionsSetUp: {
          page: {
            heading: "تأكيد الاشتراك الأساسي",
            description:
              "أنت تقوم بإعداد اشتراك تطوعي شهري سيتم خصمه من راتبك واستثماره في صندوق فرعي من صناديق مزايا نهاية الخدمة  من اورم المتاحة لك والتي تختارها.",
            details:
              "من خلال تأكيد اشتراكك، أنت تقر بأنك قرأت بعناية النشرة التوضيحية والملاحق ذات الصلة قبل اتخاذ قرار الاشتراك في وحدات الصندوق الفرعي المعني وتدرك المخاطر التي قد تترتب على ذلك.",
            yourContributions: "اشتراكك",
            yourOneTime: "دفعتك لمرة واحدة",
            salaryPercent: ({ amount, description }) =>
              `${amount} من ${description}`,
            showDetails: "التفاصيل",
            segmentedControl: {
              voluntary: "الاشتراك الطوعي",
              oneTime: "دفعة لمرة واحدة",
            },
            totalContribution: "القيمة الإجمالية للاشتراك الشهري",
            salary: "الراتب",
            toast: { success: "تم تحديث الاشتراك الطوعي بنجاح" },
            oneTime: {
              heading: "تأكيد الدفعة لمرة واحدة",
              description:
                "قم بإعداد دفعة واحدة فقط لهذا الشهر. يمكنك أيضًا الإضافة إلى اشتراكك الطوعي.",
              submit: "تأكيد الدفع",
            },
            setYourAmount: "حدد المبلغ الخاص بك",
            pending: {
              description:
                "تغيير مساهمتك في انتظار موافقة شركتك. لن يُخصم أي مبلغ من راتبك حتى تتم الموافقة عليه.",
            },
            yourSalary: {
              heading: "راتبك",
              salaryBeforeContribution: "الراتب قبل الاشتراك الطوعي",
              salaryBeforeOnetime: "الراتب قبل الدفعة لمرة واحدة",
              onetime: "دفعتك لمرة واحدة",
              voluntaryContribution: "اشتراكك الطوعي",
              netSalary: "صافي الراتب",
              cardPayment: (card) =>
                `سيتم إيداعه في حسابك الذي ينتهي بـ ${card}`,
              investmentInfo: ({ invested, max }) =>
                `لقد استثمرت ${invested}% من أصل ${max}% من راتبك السنوي.`,
              investmentInfoCont:
                "لا يمكن أن تتجاوز اشتراكاتك الطوعية والمدفوعات لمرة واحدة 25% من راتبك السنوي.",
              toolTip:
                "قد يتم تعديل اشتراكك الطوعي أو دفعتك لمرة واحدة إذا كان لديك خصومات قائمة على راتبك. لا يمكن أن يتجاوز إجمالي الخصومات 50% من راتبك وفقًا للحدود القانونية.",
            },
            selectFund: {
              title: "اختر الصندوق الفرعي",
              factSheet: "ملف الميزة",
              supplementSheet: "دليل نشرة الصندوق",
              supplement: "الملحق - ",
              keyInvestorInfo: "معلومات المستثمر الرئيسية",
              keyInvestor: "معلومات المستثمر الرئيسية - ",
              note: "إذا كنت مؤهَّلاً، يمكنك تغيير الصندوق الفرعي في أي وقت. سيتم استبدال وحداتك المؤهَّلة بوحدات من الصندوق الفرعي الذي اخترته في غضون 5 أيام عمل.",
            },
            submit: "تأكيد الاشتراك الطوعي",
            error: { employeeNotAssigned: "الموظف غير معين للمعاش التقاعدي" },
          },
        },
        contributionsVerification: {
          page: {
            heading: "التأكيد عبر البريد الإلكتروني",
            description: (email) => `أدخل الرمز المرسل إلى ${email}`,
            resendCode: (count) => `إعادة إرسال الرمز في ${count}`,
            cta: { submit: "التحقق", resend: "إعادة الإرسال" },
            toast: {
              error: "حدث خطأ",
              success: "نجاح",
              otpFailed: "فشل في إرسال كلمة المرور لمرة واحدة",
              otpSuccess: "تم إرسال كلمة المرور لمرة واحدة بنجاح",
              contributionsFailed: "حدث فشل في تحديث الاشتراك الطوعي",
            },
          },
        },
        contributionsPreview: {
          page: {
            heading: "جدولة الاشتراك",
            description: {
              youCan: "يمكنك",
              edit: "تعديل اشتراكك",
              yourContribution: "قبل تاريخ 21 من كل شهر",
            },
            yourPensions: {
              heading: "صندوق اورم لمكافأة الخدمة الخاص بك",
              baseContibution: "الاشتراك الأساسي",
              voluntaryContribution: "الاشتراك الطوعي",
              total: "إجمالي الاشتراكات:",
            },
          },
        },
        contributionsWithdraw: {
          page: {
            heading: "سحب الاشتراك",
            totalAvailableBalance: "الرصيد الإجمالي المتاح",
            totalBalance: "الرصيد المتاح الخاص بك",
          },
        },
        contributionsConfirmBankDetails: {
          page: {
            heading: "تأكيد تفاصيل حسابك المصرفي",
            description: "سنقوم بتحويل رصيدك إلى هذا الحساب المصرفي",
            edit: "تعديل",
            toast: { success: "تم تحديث رقم الحساب المصرفي الدولي بنجاح" },
          },
        },
        kycRequest: {
          page: {
            title: "لنقم بتوثيق حسابك",
            description: "نحتاج إلى التحقق من بعض المعلومات للتحقق من هويتك",
            documents: {
              identity: {
                title: "تحميل وثيقة الهوية",
                description:
                  "يمكنك تحميل نسخة مصدّقة من جواز سفرك، أو بطاقة الهوية الإماراتية، أو رخصة القيادة، أو بطاقة الإقامة.",
              },
              proofOfAddress: {
                title: "إثبات العنوان",
                description:
                  "يجب أن يكون المستند المقدّم نسخة مصدّقة بتاريخ لا يتجاوز الأشهر الستة الماضية، ويُظهر عنوانك السكني بالكامل (مثل فاتورة مرافق أو فاتورة هاتف سكني، أو مرجع بنكي أو كشف حساب بنكي أو عقد إيجار ساري المفعول).",
              },
              resubmission: "حدثت مشكلة في التحقق السابق الخاص بك.",
              resubmissionRequired: "مطلوب إعادة التقديم",
              resubmittedForReview: "أعيد تقديمه للمراجعة",
            },
            banner: {
              resubmissionRequired: "قام المراجع بطلب إعادة تقديم المستندات",
            },
            tabs: {
              uploadDocuments: "تحميل المستندات",
              activityAndComments: "النشاط والتعليقات",
            },
            upload: {
              noFileChosen: "لم يتم اختيار ملف",
              chooseFile: "اختر ملف",
              clickToUpload: "انقر للتحميل",
              orDragAndDrop: "أو قم بالسحب والإفلات",
              fileRequirements:
                "يجب أن يكون الملف بصيغة PDF أو JPG أو DOCS (حد أقصى 5 ميجابايت)",
            },
            submitForReview: "إرسال للمراجعة",
            cta: "متابعة",
            success: {
              title: "تم رفع المستندات بنجاح",
              description: "تم إرسال مستندات التحقق الخاصة بك للمراجعة.",
            },
            confirmSubmit: {
              title: "هل تريد إرسال المستندات للمراجعة؟",
              description:
                "سيتم إعلام المراجع وبعد الإرسال لن تتمكن من إجراء أي تعديلات على مستنداتك إلا إذا طلب المراجع ذلك.",
              cta: "إرسال مستندات التحقق للمراجعة",
            },
            uploadRequiredDocuments:
              "يرجى رفع جميع المستندات المطلوبة قبل الإرسال للمراجعة.",
            noCommentsYet: "لا توجد تعليقات بعد",
          },
        },
        citizenshipConfirmation: {
          button: "تأكيد الجنسية",
          modal: {
            title: "تأكيد الجنسية",
            placeholder: "اختر الجنسية...",
            checkbox: (citizenships) =>
              `يفهم ويقبل ويوافق الموظف على أن (أ) لا يتوفر منصة التقاعد والتوفير للموظفين ذوي جنسيات معينة (${citizenships})، و (ب) يجب عليهم الإبلاغ عن المنصة فورًا إذا أدركوا أنهم، أو أصبحوا، من الأشخاص المحظورين.`,
            acknowledge:
              "إدراك هذه التنويه مطلوب للوصول إلى الفائدة. وبخلاف ذلك، سيتم إعادة الأموال الأساسية إلى صاحب العمل وسيتم تجاهلك من النظام.",
          },
          toast: {
            success: {
              title: "تم تأكيد الجنسية بنجاح",
              text: "تم تأكيد الجنسية بنجاح.",
            },
            error: { title: "خطأ", text: "الجنسية غير صحيحة" },
          },
        },
        transactions: {
          table: {
            title: "المعاملات",
            columns: {
              status: "الحالة",
              type: "النوع",
              totalAmount: "المبلغ الإجمالي",
              dateCompleted: "تاريخ الاكتمال",
            },
            filters: {
              all: "الكل",
              moneyIn: "الوارد",
              moneyOut: "الصادر",
              export: (count) => `تصدير (${count}) فواتير`,
            },
            status: {
              pending: "قيد الانتظار",
              processing: "قيد المعالجة",
              completed: "مكتمل",
            },
            empty: {
              title: "لا توجد معاملات",
              text: "ستظهر سجلات المعاملات هنا عند معالجة المدفوعات.",
            },
          },
          list: {
            title: "المعاملات السابقة",
            contributions: "الاشتراكات",
            withdrawals: "عمليات السحب",
            states: {
              monthlyBasicSubscription: "الاشتراك الشهري الأساسي",
              monthlyVoluntarySubscription: "الاشتراك الطوعي الشهري",
              onetimeVoluntarySubscription: "دفعة لمرة واحدة",
              withdrawal: "السحب",
            },
            emptyContributions: {
              title: "لا توجد اشتراكات للعرض هنا",
              description: "سيتم عرض اشتراكاتك هنا مع حالة وتفاصيل الحساب",
            },
            emptyTransactions: {
              title: "لا توجد معاملات لعرضها هنا",
              description:
                "سيتم عرض المعاملات الخاصة بك هنا مع حالتها وتفاصيلها",
            },
            emptyWithdrawals: {
              title: "لا توجد سحوبات لعرضها هنا",
              description:
                "سيتم عرض السحوبات الخاصة بك هنا مع حالتها وتفاصيلها",
            },
            timeline: {
              documentsInReview: {
                title: "الوثائق قيد المراجعة",
                description:
                  "بمجرد الموافقة على مستنداتك، قد يستغرق الأمر مدة تصل إلى 14 يومًا حتى تتم معالجة عملية السحب بالكامل",
              },
              paymentProcessing: {
                title: "معالجة الدفع",
                description:
                  "قد يستغرق استكمال عملية السحب ما يصل إلى 14 يوماً.",
              },
            },
          },
        },
        settings: {
          navigation: {
            title: {
              account: "حسابي",
              language: "تفضيلات اللغة",
              currency: "تفضيلات العملة",
            },
            accountDetails: "تفاصيل الحساب",
            documents: "المستندات",
            beneficiaries: "المستفيدون",
            security: "الأمان",
            employmentDetails: "تفاصيل التوظيف",
            bankDetails: "التفاصيل البنكية",
            taxInformation: "المعلومات الضريبية",
            verification: "التحقق",
            overview: "نظرة عامة",
          },
          page: {
            accountDetails: {
              lastActive: "آخر نشاط",
              from: "من",
              joined: "انضم",
              cta: "حفظ التغييرات",
              missingEmployee: "بيانات الموظف مفقودة",
              validationError: "يرجى تصحيح أخطاء التحقق.",
              reported:
                "لقد حصلنا على طلبك. بعد أن يقوم صاحب العمل بمراجعته والموافقة عليه، سيتم عرض التغييرات في سجلاتك.",
              profileSuccess: "تم تحديث الملف الشخصي بنجاح",
              employeeSuccess: "تم تحديث سجل الموظف",
              unknownDevice: "جهاز غير معروف",
              unknownCity: "مدينة غير معروفة",
              unknownCountry: "دولة غير معروفة",
              personalDetails: {
                title: "التفاصيل الشخصية",
                name: "الاسم",
                firstName: "الاسم الأول",
                lastName: "الاسم الأخير",
                preferredName: "الاسم المفضل",
                gender: "الجنس",
                nationalId: "الرقم الموحد الإماراتي",
                nationality: "الجنسية",
                passportNumber: "رقم جواز السفر",
                iban: "رقم الحساب المصرفي الدولي (IBAN)",
              },
              contact: {
                title: "تفاصيل الاتصال",
                personalEmail: "البريد الإلكتروني الشخصي",
                phoneNumber: "رقم الهاتف",
                address: "العنوان",
              },
              employeeDetails: {
                title: "تفاصيل التوظيف",
                save: "إرسال التغييرات إلى صاحب العمل",
                cancel: "إلغاء",
                edit: "تعديل",
                fullName: "الاسم الكامل",
                firstName: "الاسم الأول",
                lastName: "اسم العائلة",
                dateOfBirth: "تاريخ الميلاد",
                phoneNumber: "رقم الهاتف",
                address: "العنوان",
                passportNumber: "رقم جواز السفر",
                nationalId: "الرقم الموحد الإماراتي",
                iban: "رقم الحساب المصرفي الدولي (IBAN)",
                startDate: "تاريخ البدء",
                search: "ابحث عن صاحب العمل...",
                segment: { active: "نشط", inactive: "غير نشط" },
                noActiveEmployment: "لا توجد وظائف نشطة.",
                noInactiveEmployment: "لا توجد وظائف غير نشطة.",
                employerDetail: "تفاصيل صاحب العمل",
                myEmployers: "جهات عملي",
                inAccurateFieldReported:
                  "لا يمكنك تعديل هذا الحقل حينما يتم تقديم التغييرات للمراجعة.",
                attributeInReview: "قيد المراجعة",
                errors: {
                  workEmail: { invalid: "البريد الإلكتروني غير صالح" },
                  fullSalary: {
                    required: "الراتب الكامل مطلوب",
                    invalid: "يجب أن يكون الراتب الكامل رقمًا موجبًا",
                  },
                  basicSalary: {
                    required: "الراتب الأساسي مطلوب",
                    invalid: "يجب أن يكون الراتب الأساسي رقمًا موجبًا",
                  },
                  startDate: {
                    required: "تاريخ البدء مطلوب",
                    invalid: "تاريخ البدء غير صالح",
                  },
                },
              },
            },
            bankDetails: {
              title: "التفاصيل البنكية",
              accountName: "اسم الحساب",
              iban: "رقم الآيبان",
              swiftCode: "رمز السويفت",
              branchName: "اسم الفرع",
              branchAddress: "عنوان الفرع",
              cta: "حفظ التغييرات",
              success: "تم تحديث التفاصيل البنكية بنجاح",
            },
            beneficiaries: {
              heading: "إضافة مستفيد",
              headingBeneficiariesAdded: "بعض التذكيرات",
              headingShariah: "التحقق من المستفيدين",
              description:
                "قم بتحديد أحد أفراد العائلة ليتمكن من الوصول إلى أموالك في حالة الوفاة.",
              descriptionShariah:
                "بموجب الشريعة الإسلامية، يتم توزيع مبلغ مكافأة نهاية الخدمة على الورثة الشرعيين للموظف بناءً على مبادئ الميراث الإسلامي. يحق للورثة الشرعيين (مثل الزوج/الزوجة، الأطفال، والوالدين) الحصول على مزايا الموظف بنسب محددة، يتم تحديدها وفقًا لقواعد الميراث الإسلامي.",
              accordions: {
                first: {
                  title: "أبلغ المستفيد",
                  description:
                    "يقع على عاتق صاحب الحساب إبلاغ مستفيديه بتعيينهم. لن يقوم صاحب العمل بالتواصل مع المستفيدين في أي مرحلة.",
                },
                second: {
                  title: "الوصول إلى أموالك",
                  description:
                    "يمكن للمستفيد الوصول إلى الأموال في حال وفاة صاحب الحساب. يمكنه المطالبة بالأموال المستحقة أو المتاحة للسحب، لكنه لن يتمكن من متابعة الاستثمار.",
                },
                third: {
                  title: "أبلغهم بالتواصل معنا",
                  description:
                    "في حال وفاة صاحب الحساب، يجب على المستفيد التواصل مع صاحب العمل لبدء الخطوات التالية. يجب تقديم المستندات اللازمة أثناء عملية بدء المطالبة.",
                },
              },
              warningOverAllotted:
                "لقد قمت بتخصيص أكثر من 100% من أموالك للمستفيدين. يرجى تعديل النسب المئوية.",
              warningUnderAllotted:
                "لقد قمت بتخصيص أقل من 100% من أموالك للمستفيدين.",
              form: {
                firstName: "الاسم الأول",
                lastName: "الاسم الأخير",
                relation: "صلة القرابة",
                dateOfBirth: "تاريخ الميلاد",
                mobileNumber: "رقم الهاتف",
                email: "البريد الإلكتروني الشخصي",
                passportNumber: "رقم جواز السفر",
                percentAllotted: "النسبة المئوية من الأموال المخصصة",
                new: "إضافة تفاصيل المستفيد",
                remove: "إزالة المستفيد",
                removeDescription: (name) =>
                  `هل أنت متأكد من أنك تريد إزالة ${name} كمستفيد؟ لا يمكنك التراجع عن هذا الإجراء لاحقًا.`,
                relationship: {
                  Spouse: "زوج/زوجة",
                  Child: "طفل",
                  Parent: "والد/والدة",
                  Sibling: "أخ/أخت",
                  Other: "آخر",
                },
                errors: {
                  firstName: { required: "الاسم الأول مطلوب" },
                  lastName: { required: "الاسم الأخير مطلوب" },
                  relation: { required: "صلة القرابة مطلوبة" },
                  dateOfBirth: {
                    required: "تاريخ الميلاد مطلوب",
                    future: "يجب أن يكون تاريخ الميلاد في الماضي",
                  },
                  mobileNumber: { required: "رقم الهاتف مطلوب" },
                  email: { format: "البريد الإلكتروني غير صالح" },
                  percentAllotted: {
                    required: "النسبة المئوية من الأموال المخصصة مطلوبة",
                    invalidRange: "يجب أن تكون النسبة المخصصة بين 1% و 100%",
                    totalExceeded: (value) =>
                      `إجمالي النسبة المئوية من الأموال المخصصة لا يمكن أن يتجاوز 100% (المتوفر ${value}%)`,
                  },
                },
              },
              add: "إضافة مستفيد",
              localWarning:
                "كن على علم بأن البلد الذي تعيش فيه قد يكون لديه قواعد تتجاوز هذا القرار بناءً على إدارة الصندوق.",
              shariah: {
                compliance: "أنا ألتزم بالشريعة الإسلامية",
                nonCompliance: "أنا أرشح مستفيدًا",
              },
              removedBeneficiarySuccess: "تمت إزالة المستفيد بنجاح",
            },
            security: {
              password: {
                minLength: "يجب أن تتكون من 8 أحرف على الأقل",
                required: "كلمة المرور مطلوبة",
                match: "كلمتا المرور غير متطابقتين",
                weak: "كلمة المرور هذه ضعيفة جدًا. أضف تعقيدًا لجعلها أقوى",
                currentPassword: "كلمة المرور الحالية",
                newPassword: "كلمة المرور الجديدة",
                confirmPassword: "أعد إدخال كلمة المرور الجديدة",
                changePassword: "تغيير كلمة المرور",
                success: "تم تغيير كلمة المرور بنجاح",
                lastUpdated: "آخر تحديث: ",
              },
              mfa: {
                heading: "تفعيل التحقق بخطوتين",
                headingDescription:
                  "احمِ حسابك من خلال استخدام رمز أمان بالإضافة إلى كلمة المرور عند تسجيل الدخول. ستحتاج إلى إعداد تطبيق للمصادقة.",
                codeRequest: {
                  description:
                    "امسح رمز QR وادخل الرمز المكوّن من 6 أرقام الظاهر في تطبيق المصادقة.",
                  heading: "إعداد التحقق بخطوتين",
                },
                codeRequestForDisable: {
                  description:
                    "أدخل الرمز من تطبيق المصادقة لتعطيل المصادقة متعددة العوامل.",
                  heading: "إيقاف التحقق بخطوتين",
                },
                passwordRequest: {
                  description: "أدخل كلمة المرور لتفعيل التحقق بخطوتين",
                  enterPassword: "أدخل كلمة المرور",
                  error: "كلمة المرور غير صحيحة",
                  heading: "إعداد التحقق بخطوتين",
                  password: "كلمة المرور",
                },
                successDisable: "تم إيقاف التحقق بخطوتين بنجاح",
                successEnable: "تم تفعيل التحقق بخطوتين بنجاح",
                invalidCode: "رمز التوثيق غير صحيح. يرجى المحاولة مرة أخرى.",
              },
            },
          },
        },
        withdrawals: {
          page: {
            title: "السحوبات",
            balanceAvailable: "الرصيد المتاح للسحب",
            withdrawalHistory: "سجل السحب",
            withdrawalInProgress: "1 عملية سحب قيد التنفيذ",
            inProgress: "قيد التنفيذ",
            pastWithdrawals: "سحوبات سابقة",
            withdrawFrom: "سحب من",
            withdrawTo: "سحب إلى",
            yourSubscriptions: "اشتراكاتك",
            updateBankDetails: "تحديث تفاصيل الحساب المصرفي",
            withdrawFunds: "سحب الأموال",
            fullWithdrawal: "سحب كامل",
            viewHistory: "عرض السجل",
            withdrawalInProgressBtn: "السحب قيد التنفيذ",
            timeline: {
              initiatedWithdrawal: "تم إنشاء عملية سحب",
              payoutInProgress: "الدفع قيد التنفيذ",
              payoutInProgressDesc: "سيتم إعلامك بإنجاز الدفع",
              paymentProcessed: "تم الدفع",
              paymentProcessedDesc: "يجب أن يظهر المبلغ في حسابك",
            },
            alert: {
              marketFluctuations:
                "يرجى ملاحظة أن المبلغ الذي تحصل عليه قد يختلف قليلاً عن طلبك بسبب التقلبات في الأسعار خلال المعالجة.",
              fundSwitchInProgress:
                "هناك عملية تبديل صندوق قيد التنفيذ حاليًا. لا يمكنك تقديم طلب سحب حتى يكتمل تبديل الصندوق.",
            },
            tooltip: {
              title: "يتكون الرصيد المتاح للسحب من الاشتراكات الطوعية فقط.",
              description: "لا يمكن سحب الاشتراكات المؤهلة.",
            },
            toast: {
              withdrawalSuccess: "تم إنشاء عملية سحب بنجاح",
              withdrawalError: "فشل معالجة عملية السحب",
              ibanSuccess: "تم تحديث رقم الحساب المصرفي الدولي بنجاح",
              ibanError: "فشل تحديث رقم الحساب المصرفي الدولي",
            },
            emptyState: {
              title: "لم يتم العثور على عمليات سحب",
              description: "سيتم عرض عمليات السحب هنا مع حالتها والتفاصيل",
            },
            validation: {
              exceedsBalance: (balance) =>
                `المبلغ يتجاوز الرصيد المتاح ${balance}`,
              ibanRequired:
                "رقم الحساب المصرفي الدولي مطلوب لإجراء عملية السحب",
            },
            iban: "رقم الحساب المصرفي الدولي (IBAN)",
            kycNote:
              "يجب الموافقة على مستندات التحقق الخاصة بك قبل أن تتمكن من إجراء عملية سحب.",
            ibanHint:
              "يجب أن يكون رقم الحساب المصرفي الدولي 23 رقمًا ويجب أن يبدأ بـ AE.",
            editIban: "تعديل رقم الحساب المصرفي الدولي",
            postTermination: {
              youHaveLeft: "لقد قمت بالفعل بالخروج",
              theCompany: "الشركة",
              stopSubscriptions: "سيتوقف اشتراكاتك في هذا الصندوق",
              withdrawSubscriptions: "يمكنك الآن سحب اشتراكات الشركة",
              withdrawSubscriptionsCta: "سحب اشتراكات الشركة",
              withdrawVoluntarySubscriptions: (date) =>
                `لا يمكنك سحب اشتراكاتك الطوعية الآن. سيتم إعلامك بإنجاز السحب بعد ${date}.`,
              employerSubscriptions: "اشتراكات الشركة",
              description: (date) =>
                `في ${date}، سيتم نقل اشتراكات الشركة إلى اشتراكاتك الطوعية. بدلاً من ذلك، يمكنك سحب جميع اشتراكات الشركة بالفعل.`,
            },
          },
        },
        subFunds: {
          page: {
            title: "اختر صندوقك الفرعي",
            description:
              "إذا كنت مؤهلاً، يمكنك تغيير الصندوق الفرعي في أي وقت. سيتم استبدال الوحدات المؤهلة لديك بوحدات من الصندوق الفرعي الذي اخترته خلال 5 أيام عمل.",
            cta: "تأكيد الصندوق الفرعي",
          },
        },
        statements: {
          page: {
            title: "الكشوفات",
            emptyTitle: "لا توجد كشوفات",
            emptyDescription: "ستظهر كشوفاتك هنا",
            loadError: "تعذر تحميل كشوفاتك. يرجى المحاولة مرة أخرى.",
            loadErrorDescription: "حدث خطأ ما أثناء تحميل كشوفاتك.",
          },
        },
      },
      reauthentication: {
        mfa: {
          heading: "تحقق من هويتك",
          description: "أدخل الرمز المكوّن من 6 أرقام من تطبيق المصادقة.",
        },
        password: {
          heading: "تأكيد كلمة المرور",
          description: "يرجى إدخال كلمة المرور لتنفيذ هذا الإجراء.",
          passwordLabel: "كلمة المرور",
          passwordPlaceholder: "أدخل كلمة المرور",
          error: "كلمة المرور غير صحيحة",
        },
      },
      emailOtp: {
        title: "ادخال رمز التحقق",
        description:
          ".يرجى إدخال رمز التحقق المكوّن من 6 أرقام المرسل إلى عنوان بريدك الإلكتروني المعتمد. تهدف هذه الخطوة إلى تأكيد هويتك وإتمام الطلب.",
        codeValidity:
          "هذا الرمز صالح لمدة ٥ دقائق. في حال طلب رمز جديد، يرجى إدخال أحدث رمز تم إرساله.",
        resendCode: "إعادة إرسال الرمز",
        resendCodePeriod: (period) => `إعادة إرسال الرمز في ${period}`,
        error: "رمز التحقق الذي أدخلته غير صالح. يرجى المحاولة مرة أخرى.",
      },
      validation: {
        passwordPolicy: {
          list: {
            intro: "يجب أن تحتوي كلمة المرور على:",
            capitalLetter: "حرف كبير",
            lowercaseLetter: "حرف صغير",
            number: "رقم",
            specialCharacter: "رمز خاص",
            minimumLength: (min) => `الحد الأدنى ${min} من الأحرف`,
          },
        },
        email: {
          required: "البريد الإلكتروني مطلوب",
          format: "يجب أن يكون عنوان بريد إلكتروني صالح",
        },
        password: {
          required: "كلمة المرور مطلوبة",
          weakPassword: "كلمة المرور ضعيفة ",
          passwordNotMatch: "كلمات المرور غير متطابقة",
          minLength: "يجب أن  تكون على الأقل 8 أحرف",
        },
        iban: {
          required: "مطلوب رقم الحساب المصرفي الدولي IBAN",
          format: "يجب أن يكون رقم الحساب المصرفي الدولي IBAN صالحاً",
          countryUAE:
            "يجب أن يكون رقماً لحساب مصرفي في دولة الإمارات العربية المتحدة",
        },
        tinUS: {
          required: "رقم التعريف الضريبي مطلوب",
          length: "رقم التعريف الضريبي يجب أن يتكون من 9 أرقام",
          format: "يجب أن يبدأ رقم التعريف الضريبي بالرقم '9'",
        },
        phone: {
          required: "رقم الهاتف مطلوب",
          format:
            "يجب أن يبدأ رقم الهاتف برمز الدولة وأن يكون طوله 8 أرقام على الأقل",
        },
        required: "مطلوب",
      },
      taxInformation: {
        submissionError:
          "غير قادر على الإرسال: لم يتم العثور على بيانات التوظيف",
        formSubmitted: "تم إرسال نموذج المعلومات الضريبية بنجاح",
        formResubmitInfo:
          "تم إرسال نموذج المعلومات الضريبية الخاص بك. قم بملء النموذج مرة أخرى لتحديث معلوماتك.",
        authRequired: "مطلوب المصادقة",
        authRequiredDescription:
          "يرجى تسجيل الدخول للوصول إلى معلوماتك الضريبية.",
        refreshPage: "تحديث الصفحة",
        errorLoadingForm: "خطأ في تحميل النموذج",
        formLoadingError: "لا يمكن تحميل قالب النموذج الضريبي.",
        formTemplateNotFound: "قالب النموذج غير موجود",
        formTemplateNotFoundDescription: "قالب النموذج الضريبي غير موجود.",
      },
    },
  },
  components: {
    fundSelector: { highRiskLabel: "عالي المخاطر" },
    formBuilder: {
      sidebar: { questions: "الأسئلة", layout: "تخطيط" },
      fieldTypes: {
        shortAnswer: "إجابة قصيرة",
        longAnswer: "إجابة طويلة",
        yesNo: "نعم/لا",
        number: "رقم",
        currency: "عملة",
        dropdown: "قائمة منسدلة",
        checkboxes: "مربعات اختيار",
        radios: "أزرار الاختيار",
        date: "تاريخ",
        schedule: "جدولة",
        fund: "صندوق",
        salaryContribution: "مساهمة الراتب",
        country: "الدولة",
        title: "عنوان",
        paragraph: "فقرة",
        divider: "فاصل",
      },
      wizard: {
        cancel: "إلغاء",
        addToForm: "إضافة إلى النموذج",
        preview: "معاينة",
      },
      properties: {
        title: "الخصائص",
        required: "إلزامي",
        requiredHint: "هل هذا السؤال إلزامي أم لا؟",
        label: "التسمية",
        labelHint: "السؤال الذي سيراه المستخدمون فوق حقل الإدخال.",
        placeholderText: "نص العنصر النائب",
        placeholderTextHint: "نص توضيحي داخل حقل الإدخال.",
        descriptionText: "نص الوصف",
        descriptionTextHint: "أضف تفاصيل مفيدة لسؤالك.",
        contentText: "نص المحتوى",
        contentTextHint: "النص الذي سيظهر للمستخدمين.",
        defaultLabel: "تسمية افتراضية",
      },
      options: { title: "خيارات", option: "خيار", addOption: "أضف خيارًا" },
      validation: {
        title: "التحقق",
        requiredMessageText: "رسالة مطلوبة",
        requiredMessageTextHint:
          "الرسالة التي يتم عرضها عندما يكون الحقل مطلوبًا ولكنه فارغ.",
        validator: "المتحقق",
        validatorHint: "اختر قاعدة التحقق لهذا الحقل",
        selectValidator: "اختر المتحقق",
        validators: {
          email: "عنوان البريد الإلكتروني",
          emiratesId: "الهوية الإماراتية (784-YYYY-XXXXXXX-X)",
          phoneNumber: "رقم الهاتف (صيغة محلية أو دولية)",
          url: "رابط الموقع",
          dateOfBirth: "تاريخ الميلاد (لا يمكن أن يكون مستقبليًا)",
          futureDate: "تاريخ مستقبلي فقط",
          number: "التحقق من الرقم",
          positiveInteger: "عدد صحيح موجب",
        },
        minMaxValidation: "التحقق من الحد الأدنى والأقصى",
        numberValidationMin: "الحد الأدنى",
        numberValidationMinPlaceholder: "أدخل الحد الأدنى (اختياري)",
        numberValidationMax: "الحد الأقصى",
        numberValidationMaxPlaceholder: "أدخل الحد الأقصى (اختياري)",
      },
      condition: {
        title: "اعرض هذا الحقل بشكل مشروط",
        hint: "اعرض هذا الحقل فقط عندما يستوفي حقل آخر معايير معينة",
        when: "متى",
        equals: "يساوي",
        notEquals: "لا يساوي",
        includes: "يتضمن",
        notIncludes: "لا يتضمن",
        selectField: "اختر الحقل",
        selectOption: "اختر الخيار",
      },
      schedule: {
        title: "خيارات التكرار",
        allowedFrequencies: "التكرارات المسموح بها",
        allowedFrequenciesHint:
          "اختر التكرارات التي يمكن للمستخدمين الاختيار من بينها. اختر واحدًا على الأقل.",
        defaultFrequency: "التكرار الافتراضي",
      },
      salaryContribution: {
        title: "مساهمة الراتب",
        type: "نوع المساهمة",
        typeRecurring: "متكررة",
        typeLumpSum: "دفعة واحدة",
        attributeName: "ربط الحقل الراتب",
        attributeNamePlaceholder: "اختر الحقل الراتب",
        contributionRange: "نطاق المساهمة (% من الراتب)",
        contributionRangeHintRecurring:
          "حدد الحد الأدنى والحد الأقصى للمساهمة الشهرية كنسبة مئوية من الراتب. سيتم تقريب القيم إلى أقرب عدد صحيح.",
        contributionRangeHintOneTime:
          "حدد الحد الأدنى والحد الأقصى للمساهمة السنوية كنسبة مئوية من الراتب السنوي. سيتم تقريب القيم إلى أقرب عدد صحيح.",
        minPercent: "الحد الأدنى للنسبة",
        maxPercent: "الحد الأقصى للنسبة",
      },
      actions: { delete: "حذف", moveUp: "نقل لأعلى", moveDown: "نقل لأسفل" },
    },
    queryToolbar: {
      search: "بحث...",
      filters: "الفلاتر",
      reset: "إعادة تعيين",
      cancel: "إلغاء",
      apply: "تطبيق",
      ariaQueryToolbar: "شريط أدوات الاستعلام",
      ariaSearchAndFilters: "البحث والفلاتر",
      ariaActions: "الإجراءات",
      ariaFilters: "الفلاتر",
      loadingControls: "جاري تحميل عناصر التحكم",
    },
    languageCurrencyPicker: {
      chooseDefaultLanguage: "اختر اللغة الافتراضية",
      chooseDefaultCurrency: "اختر العملة الافتراضية",
      language: {
        label: "اللغة",
        en: "English",
        enDescription: "United States",
        ar: "Arabic",
        arDescription: "العربية",
      },
      currency: {
        label: "العملة",
        aed: "درهم إماراتي",
        usd: "دولار أمريكي",
        gbp: "جنيه إسترليني",
        eur: "يورو",
      },
    },
    controls: {
      custom: {
        emiratesId: {
          label: "الهوية الإماراتية",
          invalidLength: "يجب أن تتكون الهوية الإماراتية من 15 رقمًا",
          invalidPrefix: "يجب أن تبدأ الهوية الإماراتية بالرقم 784",
          invalidYear: "جزء السنة غير صالح",
        },
        genders: { label: "الجنس", male: "ذكر", female: "أنثى" },
        dateOfBirth: { label: "تاريخ الميلاد" },
        nationality: { label: "الجنسية" },
        country: { label: "الدولة" },
      },
    },
    readOnlyField: { noProvided: "غير متوفر" },
    nestedCard: {
      expand: "توسيع محتوى البطاقة",
      collapse: "طي محتوى البطاقة",
      cancel: "إلغاء",
      edit: "تعديل",
    },
    scheduleControl: {
      placeholder: {
        day: "اختر الوقت (مثل 09:00 صباحاً)",
        week: "اختر اليوم (مثل الاثنين)",
        month: "اختر التاريخ (مثل 1 من الشهر)",
        year: "اختر التاريخ (مثل 1 من يناير)",
      },
      title: "تكوين الجدول",
      description: "قم بتكوين جدول متكرر لمهمتك",
      frequency: "التكرار",
      frequencyOptions: {
        daily: "يوميا",
        weekly: "أسبوعيا",
        monthly: "شهريا",
        yearly: "سنويا",
      },
      weekday: {
        monday: "الاثنين",
        tuesday: "الثلاثاء",
        wednesday: "الأربعاء",
        thursday: "الخميس",
        friday: "الجمعة",
        saturday: "السبت",
        sunday: "الأحد",
      },
      dayOfWeek: "يوم الأسبوع",
      dayOfMonth: "يوم الشهر",
      yearlyDate: "التاريخ السنوي",
      time: "الوقت",
      hour: "الساعة",
      minute: "الدقيقة",
      schedulePreview: "معاينة الجدول",
      technicalDetails: "التفاصيل الفنية",
      cronExpression: "التعبير المنظم",
      cronPattern: "النمط المنظم",
      descriptions: {
        daily: (time) => `كل يوم في ${time}`,
        weekly: ({ dayName, time }) => `كل ${dayName} في ${time}`,
        monthly: ({ dayNumber, time }) => `كل ${dayNumber} من الشهر في ${time}`,
        yearly: ({ date, time }) => `كل سنة في ${date} في ${time}`,
        yearlyNoDate: "يرجى اختيار تاريخ سنوي",
      },
      defaultScheduleConfig: {
        cronPattern: "0 9 * * 1",
        description: "كل يوم في 09:00",
        frequency: "يوميا",
        settings: { frequency: "يوميا", hour: "09", minute: "00" },
      },
    },
    fundControl: {
      choosesFund: "اختر صندوق",
      preview: "معاينة",
      configure: "تكوين",
      searchPlaceholder: "ابحث عن الصناديق...",
      noFundsFound: "لم يتم العثور على صناديق",
      availableFunds: (count) =>
        `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `لا توجد صناديق متاحة`, ["one"]: `صندوق واحد متاح` })[P.select(count)] ?? `${count} صناديق متاحة`}`,
      documentsCount: (count) =>
        `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `لا توجد مستندات`, ["one"]: `${count} مستند` })[P.select(count)] ?? `${count} مستندات`}`,
      defaultFunds: {
        conservativeGrowth: {
          label: { en: "Conservative Growth Fund", ar: "صندوق النمو المحافظ" },
          description: {
            en: "Low-risk investment option with steady returns",
            ar: "خيار استثمار منخفض المخاطر مع عوائد مستقرة",
          },
          riskLabel: { en: "Low", ar: "منخفض" },
        },
      },
      fundListView: {
        sectionTitle: "عنوان القسم",
        sectionDescription: "اسم هذا القسم مثل “اختر الصناديق”",
        english: "اللغة الإنجليزية",
        arabic: "اللغة العربية",
        filesUploaded: (count) =>
          `${/**@type{Record<string,unknown>}*/ ({ ["zero"]: `لا يوجد ملفات مرفوعة`, ["one"]: `${count} ملف مرفوع` })[P.select(count)] ?? `${count} ملفات مرفوعة`}`,
        addFund: "اضافة صندوق",
      },
      fundEditForm: {
        color: {
          default: "الافتراضي",
          success: "اخضر",
          warning: "برتقالي",
          danger: "احمر",
          primary: "ازرق",
          neutral: "رمادي",
        },
        fundName: "اسم الصندوق",
        fundNameDescription: "السؤال الذي سيرى المستخدمين فوق الحقل المدخل",
        english: "اللغة الإنجليزية",
        arabic: "اللغة العربية",
        description: "الوصف النصي",
        descriptionDescription: "السؤال الذي سيرى المستخدمين فوق الحقل المدخل.",
        riskCategory: "فئة المخاطر",
        riskCategoryDescription: "احدد مستوى المخاطر لهذا الصندوق.",
        riskLevel: "مستوى المخاطر",
        riskLevelDescription: "مثل “Low”, “Medium”, “High”",
        riskColor: "لون المخاطر",
        riskColorDescription: "احدد لون البطاقة. مثل “High” يمكن أن يكون احمر.",
        documents: "رفع ملف",
        documentsDescription: "رفع ملفات متعددة لهذا الصندوق.",
        uploadFile: "رفع ملف",
        uploadFileDescription:
          "يجب أن يكون الملف PDF, JPG أو DOCS (حد أقصى 5 ميجا)",
        uploading: "جاري رفع المستندات...",
        uploadSuccess: "تم رفع المستندات بنجاح",
        uploadError: "فشل رفع المستندات",
        uploadNotAvailable: "وظيفة الرفع غير متاحة",
      },
    },
    contributionControl: {
      currencySymbol: "د.إ",
      max: "الحد الأقصى",
      percentOfSalary: "من راتبك",
      percentOfBalance: "من رصيدك",
      maxExceeded: (maxPercent) =>
        `المبلغ المدخل يتجاوز الحد المسموح به. الحد الأقصى للمساهمة هو ${maxPercent.toLocaleString(L, { style: "percent" })}.`,
    },
    transferList: {
      availableItems: "المتاح",
      selectedItems: "المحدد",
      searchPlaceholder: "بحث...",
      noItemsAvailable: "لا توجد عناصر متاحة",
      noItemsSelected: "لم يتم تحديد أي عناصر",
      loading: "جار التحميل...",
      moveAll: (count) => `نقل الكل (${count})`,
      clearAll: "مسح الكل",
    },
    datePicker: { placeholder: "اختر تاريخ" },
    multipleFileUpload: {
      noFilesChosen: "لا يوجد ملفات مختارة",
      chooseFiles: "اختر ملفات",
      orDragAndDrop: "او سحب و وضع الملفات",
      fileTooLarge: ({ count, size }) =>
        `${{ [1]: `الملف يتجاوز` }[count] ?? `${count} ملفات تتجاوز`} الحد الأقصى للحجم ${size} ميجابايت`,
      invalidFileType: (count) =>
        `${{ [1]: `الملف له نوع` }[count] ?? `${count} ملفات لها نوع`} غير مدعوم`,
      tooManyFiles: (max) =>
        `يمكنك رفع حتى ${{ [1]: `ملف واحد` }[max] ?? `${max} ملفات`} في المرة الواحدة`,
    },
    collapsibleSection: { expand: "توسيع القسم", collapse: "طي القسم" },
    collapsibleCard: { expand: "توسيع", collapse: "طي" },
    innerSidebar: {
      expand: "توسيع الشريط الجانبي",
      collapse: "طي الشريط الجانبي",
    },
    dataEditor: {
      modal: { importTitle: "استيراد البيانات", editTitle: "تعديل البيانات" },
      dataSources: {
        title: "مصادر البيانات",
        addDataSource: "إضافة مصدر بيانات",
        importData: "استيراد البيانات",
        existingData: "البيانات الحالية",
        show: "إظهار",
        hide: "إخفاء",
        remove: "إزالة",
        addRow: "صف جديد",
        manuallyAdded: "مُضاف يدويًا",
        confirmRemove: {
          title: "إزالة مصدر البيانات",
          text: "هل أنت متأكد من إزالة مصدر البيانات هذا؟ لا يمكن التراجع عن هذا الإجراء.",
          action: "إزالة",
        },
      },
      filters: {
        title: "تصفية الجدول",
        rowsWithErrors: "صفوف بها أخطاء",
        newRows: "صفوف جديدة",
        rowsWithEmptyCells: "صفوف بها خلايا فارغة",
        editedRows: "الصفوف المُعدَّلة",
        changedRows: "الصفوف المُعدَّلة",
        searchMode: "وضع البحث",
        search: "بحث",
        findAndReplace: "بحث واستبدال",
        replace: "استبدال",
        replaceAll: "استبدال الكل",
        previousOccurrence: "التكرار السابق",
        nextOccurrence: "التكرار التالي",
        matchCase: "مطابقة حالة الأحرف",
        matchEntireCell: "مطابقة قيمة الخلية بالضبط",
        zeroResults: "0 نتائج",
        rows: "الصفوف",
        columns: "الأعمدة",
        allColumns: "جميع الأعمدة",
        searchInColumns: "البحث في الأعمدة",
        allValues: "جميع القيم",
        min: "الحد الأدنى",
        max: "الحد الأقصى",
        from: "من",
        to: "إلى",
      },
      grid: {
        loading: "جارٍ التحميل...",
        emptyTitle: "لا توجد بيانات للعرض",
        emptyText: "استورد البيانات أو غيّر عوامل التصفية لعرض البيانات",
        emptyCell: "فارغ",
        contextMenu: {
          cut: "قص",
          cutCells: (count) => `قص (${count} خلايا)`,
          copy: "نسخ",
          copyCells: (count) => `نسخ (${count} خلايا)`,
          paste: "لصق",
          deleteRow: "حذف الصف",
          deleteRows: (count) => `حذف ${count} صف`,
          sortAsc: "ترتيب تصاعدي",
          sortDesc: "ترتيب تنازلي",
          sortRemove: "إزالة الترتيب",
        },
      },
      footer: {
        cancel: "إلغاء",
        back: "رجوع",
        next: "التالي",
        import: "استيراد",
        submit: "إرسال",
        export: "تصدير",
        exportAll: "تصدير الكل",
        exportFiltered: "تصدير المُصفّى",
        csvFormat: "قيم مفصولة بفواصل (.csv)",
        excelFormat: "مايكروسوفت إكسل (.xlsx)",
      },
      uploader: {
        steps: {
          selectFiles: "اختيار الملفات",
          mapColumns: "مطابقة الأعمدة",
          primaryKey: "المفتاح الأساسي",
        },
        uploadFile: {
          title: "تحميل ملف",
          text: "حدد ملف CSV أو XLSX الذي ترغب في استيراد بيانات الموظفين منه.",
          clickToUpload: "اضغط للرفع",
          orDragAndDrop: "أو اسحب وافلت",
          formats: "CSV أو XLSX",
          parseError: "فشل في تحليل الملف المرفوع",
        },
        primaryKey: {
          title: "تعيين المفتاح الأساسي",
          text: "اختر العمود الذي يميز كل سجل في بياناتك بشكل فريد. يساعدنا ذلك في تحديد السجلات التي قد تكون موجودة مسبقًا.",
          footer: (field) =>
            `سيتم تحديث الصفوف التي تحتوي على ${field} موجود مسبقًا بالقيم الموجودة في الملف المستورد. أما الصفوف التي لا تحتوي على ${field} مطابق في السجلات الحالية فسيتم اعتبارها بيانات جديدة.`,
        },
        matchColumns: {
          title: "مطابقة الأعمدة",
          text: "طابق الأعمدة من ملفك المرفوع مع الأعمدة الموجودة. يساعد هذا في ضمان استيراد البيانات في الأماكن الصحيحة.",
          banner: "لن يتم استيراد البيانات من الأعمدة غير المُطابَقة.",
          importedColumns: "الأعمدة المستوردة",
          existingColumns: "الأعمدة الموجودة",
          selectColumnPlaceholder: "اختر عمودًا",
          unmatchedCount: (count) => `${count} غير مطابق`,
        },
      },
      undoRedo: { undo: "تراجع", redo: "إعادة" },
      validation: {
        required: "هذا الحقل مطلوب",
        invalidNumber: "يجب أن يكون رقمًا صالحًا",
        invalidPositiveInteger: "يجب أن يكون عددًا صحيحًا موجبًا",
        invalidEmail: "صيغة البريد الإلكتروني غير صالحة",
        invalidDate: "صيغة التاريخ غير صالحة",
        endDateBeforeStart: "يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء",
        invalidEmiratesId: "رقم الهوية الإماراتية غير صالح",
        invalidPhoneNumber: "رقم الهاتف غير صالح",
        invalidUrl: "رابط غير صالح",
        dateOfBirthInvalid: "يجب أن يكون تاريخ الميلاد في الماضي",
        dateMustBeFuture: "يجب أن يكون التاريخ في المستقبل",
        invalidOption: "قيمة غير صالحة",
      },
      confirmClose: {
        title: "هل أنت متأكد أنك تريد إغلاق المحرر؟",
        text: "بمجرد إغلاق المحرر، سيتم تجاهل جميع التغييرات التي أجريتها ولن تتمكن من التراجع عن هذا الإجراء.",
        action: "تأكيد الإغلاق",
      },
      confirmSubmit: {
        title: "هل أنت متأكد أنك تريد تحديث البيانات؟",
        text: "سيتم إجراء التغييرات التالية على بياناتك الحالية:",
        createRows: (count) =>
          `${{ [1]: `إنشاء صف واحد`, [2]: `إنشاء صفين` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `إنشاء ${count} صفوف`, ["many"]: `إنشاء ${count} صفًا` })[P.select(count)] ?? `إنشاء ${count} صف`}`,
        updateRows: (count) =>
          `${{ [1]: `تحديث صف واحد`, [2]: `تحديث صفين` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `تحديث ${count} صفوف`, ["many"]: `تحديث ${count} صفًا` })[P.select(count)] ?? `تحديث ${count} صف`}`,
        deleteRows: (count) =>
          `${{ [1]: `سيتم حذف صف واحد`, [2]: `سيتم حذف صفين` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `سيتم حذف ${count} صفوف`, ["many"]: `سيتم حذف ${count} صفًا` })[P.select(count)] ?? `سيتم حذف ${count} صف`}`,
        action: "تأكيد والتحديث",
        bannerTitle: (count) =>
          `${{ [1]: `يوجد صف واحد به أخطاء`, [2]: `يوجد صفان بهما أخطاء` }[count] ?? /**@type{Record<string,unknown>}*/ ({ ["few"]: `يوجد ${count} صفوف بها أخطاء`, ["many"]: `يوجد ${count} صفًا بها أخطاء` })[P.select(count)] ?? `يوجد ${count} صف بها أخطاء`}`,
      },
      errorState: {
        title: "حدث خطأ ما",
        text: "حدث خطأ غير متوقع في محرر البيانات. يرجى المحاولة مرة أخرى.",
      },
    },
    productCard: { moreActions: "المزيد من الإجراءات" },
  },
  validation: {
    fieldIsRequired: "الحقل مطلوب",
    invalidPhoneNumber:
      "صيغة رقم الهاتف غير صحيحة. يرجى إدخال رقم محلي أو دولي.",
    invalidEmailAddress: "عنوان البريد الإلكتروني غير صالح",
    invalidIban: "رقم الآيبان غير صالح",
    invalidEmail: "صيغة البريد الإلكتروني غير صالحة",
    invalidEmiratesId:
      "صيغة الهوية الإماراتية غير صالحة (المتوقع: 784XXXXXXXXXXXX أو 784-سنة-رقم-رقم)",
    invalidUrl:
      "صيغة الرابط غير صالحة. يرجى إدخال رابط صالح (مثال: https://example.com)",
    dateCannotBeFuture: "لا يمكن أن يكون التاريخ في المستقبل",
    dateMustBeFuture: "يجب أن يكون التاريخ في المستقبل",
    invalidNumber: "يجب أن يكون رقماً صالحاً",
    invalidPositiveInteger: "يجب أن يكون عددًا صحيحًا موجبًا",
    numberTooSmall: "الرقم صغير جداً",
    numberTooLarge: "الرقم كبير جداً",
    invalidDate: "صيغة التاريخ غير صالحة",
    maxLength: (max) => `يجب ألا يتجاوز ${max} حرفاً`,
    dateOfBirthMinAge: "يجب أن يكون تاريخ الميلاد قبل 15 سنة على الأقل",
  },
};
